// import React, { useState, useEffect, useRef } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import {
//     getAllRoutes,
//     getRouteById,
//     createRoute,
//     updateRoute,
//     deleteRoute,
//     toggleRouteStatus,
//     getAllMasterRoutes,
//     getMasterRouteByName,
//     searchRouteIntermediateStops,
//     getMasterRouteById,
//     searchMasterRoutesByCities,
//     getBusById,
//     activateBusWithPlatformFee,
//     getPendingRoutes,
//     approvePendingRoute,
//     rejectPendingRoute,
//     getPendingRouteById ,
//     updatePendingRoute
// } from '../../Services/Operations/ProductAPI';
// import { toast } from 'react-toastify';
// import '../../Styles/RouteManage.css';
// import { useNavigate } from 'react-router-dom';
// import { getPlacePredictions, getPlaceDetails, getDistanceMatrix } from '../../utilis/mapUtils';
// import PlatformFeeModal from './PlatformFeeModal';
// import TimeSlotManager from './TimeSlotManager';
// import StopTimingManager from './StopTimingManager';
// import {
//     toTitleCase,
//     toTitleCaseLive,
//     normalizeAndDeduplicateSuggestions,
// } from '../../utilis/normalizeUtils';
// import RouteActivityLogModal from './RouteActivityLogModal';

// const TimeDisplay = ({ time }) => {
//     if (!time) return '--:--';
//     if (time.includes(':')) {
//         const [hours, minutes] = time.split(':');
//         const hour = parseInt(hours);
//         const ampm = hour >= 12 ? 'PM' : 'AM';
//         const displayHour = hour % 12 || 12;
//         return `${displayHour}:${minutes} ${ampm}`;
//     }
//     return time;
// };

// const calculateManualDistFromPrev = (stops, index) => {
//     if (!stops || stops.length === 0 || index < 0 || index >= stops.length) return '';

//     const stop = stops[index];
//     if (!stop) return '';

//     if (stop.manualDistFromPrev && parseFloat(stop.manualDistFromPrev) > 0) {
//         return String(stop.manualDistFromPrev);
//     }

//     if (stop.distanceFromOrigin && parseFloat(stop.distanceFromOrigin) > 0) {
//         if (index === 0) {
//             return String(stop.distanceFromOrigin);
//         } else {
//             const prevStop = stops[index - 1];
//             if (prevStop && prevStop.distanceFromOrigin !== undefined) {
//                 const segmentDist = parseFloat((stop.distanceFromOrigin - prevStop.distanceFromOrigin).toFixed(1));
//                 if (segmentDist > 0) {
//                     return String(segmentDist);
//                 }
//             }
//         }
//     }

//     return '';
// };

// const SkeletonStatsCard = () => (
//     <div className="stat-card skeleton">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-value"></div>
//         <div className="skeleton-subtitle"></div>
//     </div>
// );

// const SkeletonTableRow = () => (
//     <tr className="skeleton-row">
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-badge"></div></td>
//         <td><div className="skeleton-badge"></div></td>
//         <td><div className="skeleton-actions"></div></td>
//     </tr>
// );

// const SkeletonTable = () => (
//     <div className="table-container skeleton">
//         <table className="data-table">
//             <thead>
//                 <tr>
//                     <th>No.</th>
//                     <th>Route Name</th>
//                     <th>Route No.</th>
//                     <th>Origin</th>
//                     <th>Destination</th>
//                     <th>Distance</th>
//                     <th>Stops</th>
//                     <th>Type</th>
//                     <th>Status</th>
//                     <th>Actions</th>
//                 </tr>
//             </thead>
//             <tbody>
//                 {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//                     <SkeletonTableRow key={i} />
//                 ))}
//             </tbody>
//         </table>
//     </div>
// );

// const SkeletonModal = () => (
//     <div className="modal-overlay">
//         <div className="modal-content add-route-content skeleton">
//             <div className="modal-header">
//                 <div className="skeleton-title"></div>
//                 <div className="skeleton-close"></div>
//             </div>
//             <div className="modal-body">
//                 <div className="skeleton-toggle"></div>
//                 <div className="skeleton-tabs"></div>
//                 <div className="form-sections">
//                     {[1, 2, 3].map((i) => (
//                         <div key={i} className="form-section">
//                             <div className="skeleton-section-title"></div>
//                             <div className="form-row">
//                                 <div className="form-group"><div className="skeleton-input"></div></div>
//                                 <div className="form-group"><div className="skeleton-input"></div></div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//             <div className="modal-footer">
//                 <div className="skeleton-button"></div>
//                 <div className="skeleton-button"></div>
//             </div>
//         </div>
//     </div>
// );

// const LocationInput = ({ value, onChange, placeholder, onLocationSelect, type = 'origin' }) => {
//     const [searchQuery, setSearchQuery] = useState(value || '');
//     const [suggestions, setSuggestions] = useState([]);
//     const [showSuggestions, setShowSuggestions] = useState(false);
//     const [isLoading, setIsLoading] = useState(false);
//     const timeoutRef = useRef(null);

//     useEffect(() => {
//         setSearchQuery(value || '');
//     }, [value]);

//     const searchLocations = async (query) => {
//         if (!query || query.trim().length < 2) {
//             setSuggestions([]);
//             return;
//         }

//         setIsLoading(true);
//         try {
//             const predictions = await getPlacePredictions(query);
//             setSuggestions(predictions);
//             setShowSuggestions(predictions.length > 0);
//         } catch (error) {
//             console.error('Search error:', error);
//             setSuggestions([]);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleSelect = async (prediction) => {
//         setIsLoading(true);
//         try {
//             const placeDetails = await getPlaceDetails(prediction.place_id);

//             if (placeDetails) {
//                 setSearchQuery(placeDetails.name || placeDetails.address);
//                 setShowSuggestions(false);

//                 if (onLocationSelect) {
//                     onLocationSelect({
//                         name: placeDetails.name,
//                         address: placeDetails.address,
//                         city: placeDetails.city || prediction.structured_formatting?.secondary_text?.split(',')[0] || '',
//                         state: placeDetails.state || prediction.structured_formatting?.secondary_text?.split(',')[1]?.trim() || '',
//                         coordinates: placeDetails.coordinates || { lat: 0, lng: 0 },
//                         placeId: prediction.place_id
//                     });
//                 }
//             }
//         } catch (error) {
//             console.error('Error getting place details:', error);
//             toast.error('Failed to get location details');
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleTextChange = (e) => {
//         const newValue = e.target.value;
//         setSearchQuery(newValue);
//         onChange(newValue);

//         if (timeoutRef.current) {
//             clearTimeout(timeoutRef.current);
//         }

//         timeoutRef.current = setTimeout(() => {
//             searchLocations(newValue);
//         }, 500);
//     };

//     useEffect(() => {
//         return () => {
//             if (timeoutRef.current) {
//                 clearTimeout(timeoutRef.current);
//             }
//         };
//     }, []);

//     return (
//         <div className="location-input-container">
//             <div className="location-input-wrapper">
//                 <input
//                     type="text"
//                     value={searchQuery}
//                     onChange={handleTextChange}
//                     onFocus={() => {
//                         if (suggestions.length > 0) {
//                             setShowSuggestions(true);
//                         }
//                     }}
//                     onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
//                     className="edit-input"
//                     placeholder={placeholder}
//                 />
//                 {isLoading && (
//                     <div className="location-loading">
//                         <div className="spinner"></div>
//                     </div>
//                 )}
//             </div>
//             {showSuggestions && suggestions.length > 0 && (
//                 <div className="location-suggestions">
//                     <div className="suggestions-header">
//                         <span>Search Results</span>
//                     </div>
//                     {suggestions.map((prediction, index) => (
//                         <div
//                             key={prediction.place_id || index}
//                             className="suggestion-item"
//                             onClick={() => handleSelect(prediction)}
//                         >
//                             <div className="suggestion-main">
//                                 {prediction.structured_formatting?.main_text || prediction.description}
//                             </div>
//                             <div className="suggestion-secondary">
//                                 {prediction.structured_formatting?.secondary_text}
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// };

// const TimePicker = ({ value, onChange, placeholder }) => {
//     return (
//         <div className="time-picker">
//             <input
//                 type="time"
//                 value={value || ''}
//                 onChange={(e) => onChange(e.target.value)}
//                 className="edit-input"
//                 placeholder={placeholder}
//             />
//         </div>
//     );
// };

// const Checkbox = ({ label, checked, onChange }) => (
//     <label className="checkbox-container">
//         <input
//             type="checkbox"
//             checked={checked}
//             onChange={onChange}
//             className="checkbox-input"
//         />
//         <span className="checkbox-label">{label}</span>
//     </label>
// );

// const StopTypeBadge = ({ type }) => {
//     const types = {
//         boarding: { label: '🟢 Boarding', className: 'boarding' },
//         dropping: { label: '🔴 Dropping', className: 'dropping' },
//         both: { label: '🟡 Both', className: 'both' },
//         none: { label: 'Pass-through', className: 'none' }
//     };
//     const info = types[type] || types.none;
//     return <span className={`stop-type-badge ${info.className}`}>{info.label}</span>;
// };

// const StatusBadge = ({ isActive }) => (
//     <span className={`status-badge ${isActive ? 'active' : 'inactive'}`}>
//         {isActive ? 'Active' : 'Inactive'}
//     </span>
// );

// const MasterRouteSelector = ({ value, onChange, onRouteNameChange, token, disabled }) => {
//     const [masterRoutes, setMasterRoutes] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [source, setSource] = useState('');
//     const [destination, setDestination] = useState('');
//     const [isManualEntry, setIsManualEntry] = useState(false);
//     const [routeNameValue, setRouteNameValue] = useState('');
//     const [selectedRouteValue, setSelectedRouteValue] = useState(null);
//     const [selectedRouteDetails, setSelectedRouteDetails] = useState(null);

//     const [sourceSuggestions, setSourceSuggestions] = useState([]);
//     const [destSuggestions, setDestSuggestions] = useState([]);
//     const [showSourceSuggestions, setShowSourceSuggestions] = useState(false);
//     const [showDestSuggestions, setShowDestSuggestions] = useState(false);
//     const [isLoadingSource, setIsLoadingSource] = useState(false);
//     const [isLoadingDest, setIsLoadingDest] = useState(false);

//     const sourceTimeoutRef = useRef(null);
//     const destTimeoutRef = useRef(null);
//     const searchTimeoutRef = useRef(null);

//     useEffect(() => {
//         if (value && value.masterRouteName) {
//             setRouteNameValue(value.masterRouteName);
//             setSelectedRouteValue(value);
//             if (value.origin?.city) setSource(value.origin.city);
//             if (value.destination?.city) setDestination(value.destination.city);
//         } else {
//             setRouteNameValue('');
//             setSelectedRouteValue(null);
//             setSource('');
//             setDestination('');
//             setMasterRoutes([]);
//             setShowDropdown(false);
//             setIsManualEntry(false);
//         }
//     }, [value]);

//     const toTitleCase = (str) =>
//         str
//             ? str.trim().replace(/\s+/g, ' ').replace(/[^\s-]+/g, (w) =>
//                 w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
//             )
//             : str;

//     const searchCities = async (query, type) => {
//         if (!query || query.length < 2) {
//             if (type === 'source') {
//                 setSourceSuggestions([]);
//                 setShowSourceSuggestions(false);
//             } else {
//                 setDestSuggestions([]);
//                 setShowDestSuggestions(false);
//             }
//             return;
//         }

//         try {
//             if (type === 'source') {
//                 setIsLoadingSource(true);
//             } else {
//                 setIsLoadingDest(true);
//             }

//             const response = await searchRouteIntermediateStops(token, query);

//             if (response.success && response.cities) {
//                 const deduped = normalizeAndDeduplicateSuggestions(response.cities);
//                 if (type === 'source') {
//                     setSourceSuggestions(deduped);
//                     setShowSourceSuggestions(deduped.length > 0);
//                 } else {
//                     setDestSuggestions(deduped);
//                     setShowDestSuggestions(deduped.length > 0);
//                 }
//             }
//         } catch (error) {
//             console.error('Error fetching city suggestions:', error);
//         } finally {
//             if (type === 'source') {
//                 setIsLoadingSource(false);
//             } else {
//                 setIsLoadingDest(false);
//             }
//         }
//     };

//     const searchMasterRoutes = async (sourceCity, destCity) => {
//         if (!sourceCity && !destCity) {
//             setMasterRoutes([]);
//             setShowDropdown(false);
//             return;
//         }

//         setIsLoading(true);
//         try {
//             const response = await searchMasterRoutesByCities(token, sourceCity, destCity);

//             if (response.success && response.data) {
//                 const routesData = response.data.routes || (Array.isArray(response.data) ? response.data : []);
//                 const mappedRoutes = routesData.map(route => ({
//                     _id: route._id,
//                     originCity: toTitleCase(route.origin?.city || ''),
//                     destinationCity: toTitleCase(route.destination?.city || ''),
//                     masterRouteName: toTitleCase(route.masterRouteName || ''),
//                     description: route.description || '',
//                     originState: route.origin?.state || '',
//                     originAddress: route.origin?.address || '',
//                     originTerminal: route.origin?.terminal || '',
//                     originCoords: route.origin?.coordinates || null,
//                     destinationState: route.destination?.state || '',
//                     destinationAddress: route.destination?.address || '',
//                     destinationTerminal: route.destination?.terminal || '',
//                     destinationCoords: route.destination?.coordinates || null,
//                     totalDistance: route.routeDetails?.totalDistance || 0,
//                     durationHours: route.routeDetails?.estimatedDuration?.hours || 0,
//                     durationMinutes: route.routeDetails?.estimatedDuration?.minutes || 0,
//                     intermediateStops: route.intermediateStops || [],
//                     isRoundTrip: route.isRoundTrip || false,
//                     returnJourney: route.returnJourney || null
//                 }));

//                 setMasterRoutes(mappedRoutes);
//                 setShowDropdown(mappedRoutes.length > 0);

//                 if (response.data.sourceSuggestions) {
//                     setSourceSuggestions(
//                         normalizeAndDeduplicateSuggestions(response.data.sourceSuggestions)
//                     );
//                 }
//                 if (response.data.destinationSuggestions) {
//                     setDestSuggestions(
//                         normalizeAndDeduplicateSuggestions(response.data.destinationSuggestions)
//                     );
//                 }
//             } else {
//                 setMasterRoutes([]);
//                 setShowDropdown(true);
//             }
//         } catch (error) {
//             console.error('Error fetching routes:', error);
//             setMasterRoutes([]);
//             setShowDropdown(true);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleSourceInputChange = (e) => {
//         const value = toTitleCaseLive(e.target.value);
//         setSource(value);
//         setShowDropdown(false);
//         setShowSourceSuggestions(false);

//         if (selectedRouteValue) {
//             setSelectedRouteValue(null);
//             onChange(null);
//         }

//         if (sourceTimeoutRef.current) {
//             clearTimeout(sourceTimeoutRef.current);
//         }

//         sourceTimeoutRef.current = setTimeout(() => {
//             searchCities(value, 'source');
//         }, 300);

//         if (searchTimeoutRef.current) {
//             clearTimeout(searchTimeoutRef.current);
//         }
//         searchTimeoutRef.current = setTimeout(() => {
//             if (value.length >= 2 || destination.length >= 2) {
//                 searchMasterRoutes(value, destination);
//             } else {
//                 setMasterRoutes([]);
//             }
//         }, 500);
//     };

//     const handleDestinationInputChange = (e) => {
//         const value = toTitleCaseLive(e.target.value);
//         setDestination(value);
//         setShowDropdown(false);
//         setShowDestSuggestions(false);

//         if (selectedRouteValue) {
//             setSelectedRouteValue(null);
//             onChange(null);
//         }

//         if (destTimeoutRef.current) {
//             clearTimeout(destTimeoutRef.current);
//         }

//         destTimeoutRef.current = setTimeout(() => {
//             searchCities(value, 'destination');
//         }, 300);

//         if (searchTimeoutRef.current) {
//             clearTimeout(searchTimeoutRef.current);
//         }
//         searchTimeoutRef.current = setTimeout(() => {
//             if (source.length >= 2 || value.length >= 2) {
//                 searchMasterRoutes(source, value);
//             } else {
//                 setMasterRoutes([]);
//             }
//         }, 500);
//     };

//     const handleSourceSelect = (selectedCity) => {
//         if (!selectedCity) return;
//         const cityName = toTitleCase(
//             typeof selectedCity === 'object'
//                 ? (selectedCity.city || selectedCity.name || '')
//                 : selectedCity
//         );
//         setSource(cityName);
//         setShowSourceSuggestions(false);
//         setSourceSuggestions([]);

//         if (selectedRouteValue) {
//             setSelectedRouteValue(null);
//             onChange(null);
//         }

//         if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
//         searchTimeoutRef.current = setTimeout(() => {
//             searchMasterRoutes(cityName, destination);
//         }, 100);
//     };

//     const handleDestinationSelect = (selectedCity) => {
//         if (!selectedCity) return;
//         const cityName = toTitleCase(
//             typeof selectedCity === 'object'
//                 ? (selectedCity.city || selectedCity.name || '')
//                 : selectedCity
//         );
//         setDestination(cityName);
//         setShowDestSuggestions(false);
//         setDestSuggestions([]);

//         if (selectedRouteValue) {
//             setSelectedRouteValue(null);
//             onChange(null);
//         }

//         if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
//         searchTimeoutRef.current = setTimeout(() => {
//             searchMasterRoutes(source, cityName);
//         }, 100);
//     };

//     const handleRouteSelect = async (route) => {
//         setSelectedRouteDetails(route);
//         setShowDropdown(false);

//         try {
//             setIsLoading(true);
//             const response = await getMasterRouteById(route._id, token);

//             if (response.success && response.data) {
//                 const fullRoute = response.data;
//                 setSource(fullRoute.origin?.city || '');
//                 setDestination(fullRoute.destination?.city || '');
//                 setRouteNameValue(fullRoute.masterRouteName);

//                 const selectedRouteObj = {
//                     _id: fullRoute._id,
//                     masterRouteName: fullRoute.masterRouteName,
//                     description: fullRoute.description || '',
//                     isManual: false,
//                     via: fullRoute.via || [],
//                     origin: {
//                         city: fullRoute.origin?.city || '',
//                         state: fullRoute.origin?.state || '',
//                         address: fullRoute.origin?.address || '',
//                         terminal: fullRoute.origin?.terminal || '',
//                         coordinates: fullRoute.origin?.coordinates || null
//                     },
//                     destination: {
//                         city: fullRoute.destination?.city || '',
//                         state: fullRoute.destination?.state || '',
//                         address: fullRoute.destination?.address || '',
//                         terminal: fullRoute.destination?.terminal || '',
//                         coordinates: fullRoute.destination?.coordinates || null
//                     },
//                     intermediateStops: fullRoute.intermediateStops || [],
//                     routeDetails: {
//                         totalDistance: fullRoute.routeDetails?.totalDistance || 0,
//                         estimatedDuration: {
//                             hours: fullRoute.routeDetails?.estimatedDuration?.hours || 0,
//                             minutes: fullRoute.routeDetails?.estimatedDuration?.minutes || 0
//                         }
//                     },
//                     isRoundTrip: fullRoute.isRoundTrip || false,
//                     returnJourney: fullRoute.returnJourney || null
//                 };

//                 onChange(selectedRouteObj);
//                 if (onRouteNameChange) onRouteNameChange(fullRoute.masterRouteName);
//             } else {
//                 toast.error('Failed to load complete route details');
//             }
//         } catch (error) {
//             console.error('Error fetching full route details:', error);
//             toast.error('Failed to load route details. Please try again.');
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleRouteNameChange = (e) => {
//         const newName = e.target.value;
//         setRouteNameValue(newName);
//         if (onRouteNameChange) onRouteNameChange(newName);
//         if (selectedRouteValue) onChange({ ...selectedRouteValue, masterRouteName: newName });
//     };

//     const handleClearSelection = () => {
//         setSelectedRouteValue(null);
//         setSelectedRouteDetails(null);
//         setRouteNameValue('');
//         setSource('');
//         setDestination('');
//         setMasterRoutes([]);
//         setShowDropdown(false);
//         setIsManualEntry(false);
//         onChange(null);
//         if (onRouteNameChange) onRouteNameChange('');
//     };

//     const handleOpenManualEntry = () => {
//         setIsManualEntry(true);
//         setShowDropdown(false);
//     };

//     const handleManualEntrySubmit = () => {
//         if (!routeNameValue.trim()) {
//             toast.error('Please enter a route name');
//             return;
//         }

//         const emptyRoute = {
//             _id: null,
//             masterRouteName: routeNameValue.trim(),
//             isManual: true,
//             origin: { city: source || '', state: '' },
//             destination: { city: destination || '', state: '' },
//             routeDetails: { totalDistance: 0 },
//             isRoundTrip: false
//         };

//         setIsManualEntry(false);
//         setSelectedRouteValue(emptyRoute);
//         onChange(emptyRoute);
//     };

//     const handleCancelManualEntry = () => {
//         setIsManualEntry(false);
//         setRouteNameValue('');
//     };

//     const showSearchFields = !selectedRouteValue && !isManualEntry;

//     useEffect(() => {
//         return () => {
//             if (sourceTimeoutRef.current) clearTimeout(sourceTimeoutRef.current);
//             if (destTimeoutRef.current) clearTimeout(destTimeoutRef.current);
//             if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
//         };
//     }, []);

//     const suggestionsDropdownStyle = {
//         position: 'absolute',
//         top: '100%',
//         left: 0,
//         right: 0,
//         backgroundColor: 'white',
//         border: '1px solid #ddd',
//         borderRadius: '4px',
//         maxHeight: '200px',
//         overflowY: 'auto',
//         zIndex: 10000,
//         boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
//         marginTop: '2px'
//     };

//     const suggestionItemStyle = {
//         padding: '10px 12px',
//         cursor: 'pointer',
//         borderBottom: '1px solid #f0f0f0',
//         transition: 'background-color 0.2s'
//     };

//     return (
//         <div className="master-route-selector" style={{ position: 'relative', width: '100%' }}>
//             {showSearchFields && (
//                 <>
//                     <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
//                         <div className="form-group" style={{ flex: 1, position: 'relative' }}>
//                             <label>Source City</label>
//                             <div style={{ position: 'relative' }}>
//                                 <input
//                                     type="text"
//                                     value={source}
//                                     onChange={handleSourceInputChange}
//                                     onFocus={() => {
//                                         if (sourceSuggestions.length > 0) {
//                                             setShowSourceSuggestions(true);
//                                         }
//                                     }}
//                                     onBlur={() => setTimeout(() => setShowSourceSuggestions(false), 200)}
//                                     placeholder="Enter source city (min 2 chars)..."
//                                     className="form-input"
//                                     disabled={disabled}
//                                 />
//                                 {isLoadingSource && (
//                                     <div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
//                                         <div className="spinner-small"></div>
//                                     </div>
//                                 )}
//                             </div>

//                             {showSourceSuggestions && sourceSuggestions.length > 0 && (
//                                 <div style={suggestionsDropdownStyle}>
//                                     {sourceSuggestions.map((city, idx) => (
//                                         <div
//                                             key={city.id || idx}
//                                             style={suggestionItemStyle}
//                                             onMouseDown={() => handleSourceSelect(city)}
//                                             onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
//                                             onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
//                                         >
//                                             <div style={{ fontWeight: '500' }}>
//                                                 {city.city || city.name || city}
//                                             </div>
//                                             <div style={{ fontSize: '12px', color: '#6c757d' }}>
//                                                 {city.state}
//                                                 {city.terminal && ` • ${city.terminal}`}
//                                             </div>
//                                             {city.address && city.address !== (city.city || city.name) && (
//                                                 <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>{city.address}</div>
//                                             )}
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>

//                         <div className="form-group" style={{ flex: 1, position: 'relative' }}>
//                             <label>Destination City</label>
//                             <div style={{ position: 'relative' }}>
//                                 <input
//                                     type="text"
//                                     value={destination}
//                                     onChange={handleDestinationInputChange}
//                                     onFocus={() => {
//                                         if (destSuggestions.length > 0) {
//                                             setShowDestSuggestions(true);
//                                         }
//                                     }}
//                                     onBlur={() => setTimeout(() => setShowDestSuggestions(false), 200)}
//                                     placeholder="Enter destination city (min 2 chars)..."
//                                     className="form-input"
//                                     disabled={disabled}
//                                 />
//                                 {isLoadingDest && (
//                                     <div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
//                                         <div className="spinner-small"></div>
//                                     </div>
//                                 )}
//                             </div>

//                             {showDestSuggestions && destSuggestions.length > 0 && (
//                                 <div style={suggestionsDropdownStyle}>
//                                     {destSuggestions.map((city, idx) => (
//                                         <div
//                                             key={city.id || idx}
//                                             style={suggestionItemStyle}
//                                             onMouseDown={() => handleDestinationSelect(city)}
//                                             onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
//                                             onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
//                                         >
//                                             <div style={{ fontWeight: '500' }}>
//                                                 {city.city || city.name || city}
//                                             </div>
//                                             <div style={{ fontSize: '12px', color: '#6c757d' }}>
//                                                 {city.state}
//                                                 {city.terminal && ` • ${city.terminal}`}
//                                             </div>
//                                             {city.address && city.address !== (city.city || city.name) && (
//                                                 <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>{city.address}</div>
//                                             )}
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>
//                     </div>

//                     {(showDropdown || isLoading) && (source || destination) && (
//                         <div style={{
//                             border: '1px solid #ddd',
//                             borderRadius: '4px',
//                             boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
//                             backgroundColor: 'white',
//                             maxHeight: '300px',
//                             overflowY: 'auto',
//                             marginBottom: '10px',
//                             zIndex: 1000,
//                             position: 'relative'
//                         }}>
//                             {isLoading ? (
//                                 <div style={{ padding: '12px', textAlign: 'center', color: '#666' }}>
//                                     <div className="spinner-small"></div> Searching routes...
//                                 </div>
//                             ) : masterRoutes.length > 0 ? (
//                                 <>
//                                     <div style={{ padding: '8px 12px', backgroundColor: '#f8f9fa', borderBottom: '1px solid #eee', fontSize: '12px', color: '#666' }}>
//                                         Found {masterRoutes.length} matching route(s)
//                                     </div>
//                                     {masterRoutes.map((route) => (
//                                         <div
//                                             key={route._id}
//                                             onClick={() => handleRouteSelect(route)}
//                                             style={{
//                                                 padding: '10px 12px',
//                                                 cursor: 'pointer',
//                                                 borderBottom: '1px solid #f0f0f0',
//                                                 transition: 'background-color 0.2s'
//                                             }}
//                                             onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
//                                             onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
//                                         >
//                                             <div style={{ fontWeight: '500', marginBottom: '3px' }}>{route.masterRouteName}</div>
//                                             <div style={{ fontSize: '12px', color: '#6c757d' }}>
//                                                 {route.originCity || route.origin?.city || 'N/A'} → {route.destinationCity || route.destination?.city || 'N/A'} &nbsp;•&nbsp;
//                                                 {route.isRoundTrip ? 'Round Trip' : 'One Way'} &nbsp;•&nbsp;
//                                                 {route.totalDistance || route.routeDetails?.totalDistance || 0} km
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </>
//                             ) : (
//                                 <div style={{ padding: '12px', textAlign: 'center', color: '#666' }}>
//                                     No routes found for this route.
//                                     <button
//                                         type="button"
//                                         onClick={handleOpenManualEntry}
//                                         style={{ color: '#007bff', background: 'none', border: 'none', cursor: 'pointer', padding: '0 0 0 5px' }}
//                                     >
//                                         Create new route instead
//                                     </button>
//                                 </div>
//                             )}
//                         </div>
//                     )}

//                     <div style={{ textAlign: 'right' }}>
//                         <button
//                             type="button"
//                             className="btn btn-secondary btn-sm"
//                             onClick={handleOpenManualEntry}
//                             style={{ padding: '5px 12px', fontSize: '12px' }}
//                         >
//                             + Create New Route (skip search)
//                         </button>
//                     </div>
//                 </>
//             )}

//             {isManualEntry && (
//                 <div className="selector-input-group" style={{ display: 'flex', gap: '10px', alignItems: 'center', flexDirection: 'column' }}>
//                     <div style={{ width: '100%' }}>
//                         <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
//                             <input
//                                 type="text"
//                                 value={routeNameValue}
//                                 onChange={handleRouteNameChange}
//                                 placeholder="Enter new master route name..."
//                                 className="form-input"
//                                 style={{ flex: 1 }}
//                                 disabled={disabled}
//                             />
//                             <button
//                                 type="button"
//                                 className="btn btn-primary"
//                                 onClick={handleManualEntrySubmit}
//                                 style={{ padding: '8px 16px', whiteSpace: 'nowrap' }}
//                             >
//                                 Save Manual
//                             </button>
//                             <button
//                                 type="button"
//                                 className="btn btn-secondary"
//                                 onClick={handleCancelManualEntry}
//                                 style={{ padding: '8px 16px' }}
//                             >
//                                 Cancel
//                             </button>
//                         </div>
//                     </div>
//                     <small className="helper-text" style={{ color: '#666' }}>
//                         You're creating a new master route. Fill in the details below.
//                     </small>
//                 </div>
//             )}

//             {selectedRouteValue && selectedRouteValue.masterRouteName && !isManualEntry && (
//                 <div style={{ marginBottom: '5px' }}>
//                     <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
//                         <input
//                             type="text"
//                             value={routeNameValue}
//                             onChange={handleRouteNameChange}
//                             placeholder="Enter master route name..."
//                             className="form-input"
//                             style={{ flex: 1 }}
//                             disabled={disabled}
//                         />
//                         <button
//                             type="button"
//                             className="btn btn-secondary btn-sm"
//                             onClick={handleClearSelection}
//                             style={{ padding: '8px 14px', whiteSpace: 'nowrap' }}
//                             title="Clear and search again"
//                         >
//                             ✕ Change
//                         </button>
//                     </div>
//                     <small style={{ color: selectedRouteValue.isManual ? '#007bff' : '#28a745', display: 'block', marginTop: '4px' }}>
//                         {selectedRouteValue.isManual
//                             ? 'ℹ️ New route — fill in details below'
//                             : `✓ Auto-filled from "${selectedRouteValue.masterRouteName}" — edit name above if needed`}
//                     </small>
//                 </div>
//             )}
//         </div>
//     );
// };

// const RouteManage = () => {
//     const { token } = useSelector(state => state.user);
//     const [viewMode, setViewMode] = useState('regular');
//     const [pendingRoutes, setPendingRoutes] = useState([]);
//     const [loadingPending, setLoadingPending] = useState(false);
//     const [error, setError] = useState(null);
//     const [logModal, setLogModal] = useState({ show: false, routeId: null, routeName: '' });
//     const [routes, setRoutes] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [editingRoute, setEditingRoute] = useState(null);
//     const [editForm, setEditForm] = useState({});
//     const [viewingRoute, setViewingRoute] = useState(null);
//     const [showAddModal, setShowAddModal] = useState(false);
//     const [isRoundTrip, setIsRoundTrip] = useState(false);
//     const [activeRouteTab, setActiveRouteTab] = useState('UP');
//     const [showEditModal, setShowEditModal] = useState(false);
//     const [isUpdatingRoute, setIsUpdatingRoute] = useState(false);
//     const [editUpIndex, setEditUpIndex] = useState(null);
//     const [editDownIndex, setEditDownIndex] = useState(null);
//     const [isManualStop, setIsManualStop] = useState(true);
//     const [isManualDistance, setIsManualDistance] = useState(false);
//     const [isOriginManual, setIsOriginManual] = useState(false);
//     const [isDestinationManual, setIsDestinationManual] = useState(false);

//     const [destinationTimeSlots, setDestinationTimeSlots] = useState([]);
//     const [destinationNumberOfTrips, setDestinationNumberOfTrips] = useState(1);

//     const [returnOriginTimeSlots, setReturnOriginTimeSlots] = useState([]);
//     const [returnDestTimeSlots, setReturnDestTimeSlots] = useState([]);

//     const [masterRouteSuggestions, setMasterRouteSuggestions] = useState([]);
//     const [showMasterRouteSuggestions, setShowMasterRouteSuggestions] = useState(false);
//     const [isLoadingMasterRoutes, setIsLoadingMasterRoutes] = useState(false);
//     const [masterRouteSearchTimeout, setMasterRouteSearchTimeout] = useState(null);
//     const [selectedMasterRoute, setSelectedMasterRoute] = useState(null);

//     const [filterOrigin, setFilterOrigin] = useState('');
//     const [filterDestination, setFilterDestination] = useState('');
//     const [originSuggestions, setOriginSuggestions] = useState([]);
//     const [destSuggestions, setDestSuggestions] = useState([]);
//     const [showOriginSuggestions, setShowOriginSuggestions] = useState(false);
//     const [showDestSuggestions, setShowDestSuggestions] = useState(false);

//     const [citySuggestions, setCitySuggestions] = useState([]);
//     const [showCityDropdown, setShowCityDropdown] = useState(false);
//     const [editCitySuggestions, setEditCitySuggestions] = useState([]);
//     const [showEditCityDropdown, setShowEditCityDropdown] = useState(false);

//     const [showStopInsertModal, setShowStopInsertModal] = useState(false);
//     const [insertStopForm, setInsertStopForm] = useState({
//         city: '', state: '', address: '', terminal: '',
//         arrivalTime: '', departureTime: '',
//         isBoarding: false, isDropping: false,
//         manualDistFromPrev: '', manualDistToNext: '',
//         isManualStop: true
//     });
//     const [insertCitySuggestions, setInsertCitySuggestions] = useState([]);
//     const [showInsertCityDropdown, setShowInsertCityDropdown] = useState(false);
//     const [pendingInsertIndex, setPendingInsertIndex] = useState(null);

//     const [timeSlots, setTimeSlots] = useState([]);
//     const [numberOfTrips, setNumberOfTrips] = useState(1);
//     const [isMultiTrip, setIsMultiTrip] = useState(false);

//     const [newRoute, setNewRoute] = useState({
//         routeName: '',
//         localRouteName: '',
//         upOriginCity: '', upOriginState: '', upOriginAddress: '', upOriginTerminal: '',
//         upOriginCoords: null, upOriginDepTime: '',
//         upDestCity: '', upDestState: '', upDestAddress: '', upDestTerminal: '',
//         upDestCoords: null, upDestArrTime: '',
//         upTotalDistance: '', upDurationHours: '', upDurationMinutes: '',
//         downOriginDepTime: '',
//         downDestArrTime: '',
//         downTotalDistance: '', downDurationHours: '', downDurationMinutes: '',
//         upManualFinalLeg: '',
//         downManualFinalLeg: '',
//         stopCity: '', stopState: '', stopAddress: '', stopTerminal: '',
//         stopCoords: null, stopArrivalTime: '', stopDepartureTime: '',
//         stopDistFromPrev: '', stopDistToNext: '',
//         isBoarding: false, isDropping: false
//     });

//     const [upStops, setUpStops] = useState([]);
//     const [downStops, setDownStops] = useState([]);
//     const [editingStopIndex, setEditingStopIndex] = useState(null);
//     const [insertIndex, setInsertIndex] = useState(null);
//     const [isCreatingRoute, setIsCreatingRoute] = useState(false);
//     const [isCalculatingDistances, setIsCalculatingDistances] = useState(false);
//     const [isDistanceCalculated, setIsDistanceCalculated] = useState({ up: false, down: false });
//     const [activeTab, setActiveTab] = useState('basic');

//     const [currentPage, setCurrentPage] = useState(1);
//     const [totalPages, setTotalPages] = useState(1);
//     const [totalRoutes, setTotalRoutes] = useState(0);
//     const [pageSize] = useState(10);

//     const [showStopEditModal, setShowStopEditModal] = useState(false);
//     const [stopBeingEdited, setStopBeingEdited] = useState(null);

//     const [editTimeSlots, setEditTimeSlots] = useState([]);
//     const [editDestinationTimeSlots, setEditDestinationTimeSlots] = useState([]);
//     const [editNumberOfTrips, setEditNumberOfTrips] = useState(1);
//     const [editIsMultiTrip, setEditIsMultiTrip] = useState(false);

//     const [isEditingPending, setIsEditingPending] = useState(false);
// const [editingPendingId, setEditingPendingId] = useState(null);

//     const [stopEditForm, setStopEditForm] = useState({
//         city: '',
//         state: '',
//         address: '',
//         terminal: '',
//         arrivalTime: '',
//         departureTime: '',
//         isBoarding: false,
//         isDropping: false,
//         isManualStop: false,
//         manualDistFromPrev: '',
//         manualDistToNext: '',
//         timings: [],
//         coordinates: null,
//         isMultiTrip: false,
//         tripCount: 1
//     });

//     const [inlineInsertIndex, setInlineInsertIndex] = useState(null);
//     const [inlineInsertForm, setInlineInsertForm] = useState({
//         city: '', state: '', address: '', terminal: '',
//         arrivalTime: '', departureTime: '',
//         isBoarding: false, isDropping: false,
//         manualDistFromPrev: '', manualDistToNext: '',
//         isManual: true
//     });
//     const [inlineInsertCitySuggestions, setInlineInsertCitySuggestions] = useState([]);
//     const [showInlineInsertDropdown, setShowInlineInsertDropdown] = useState(false);

//     const navigate = useNavigate();
//     const [selectedMasterRouteFromDropdown, setSelectedMasterRouteFromDropdown] = useState(null);
//     const [showPlatformFeeModal, setShowPlatformFeeModal] = useState(false);
//     const [selectedBusForActivation, setSelectedBusForActivation] = useState(null);

//     const sortTimings = (timings) => {
//         if (!timings || !Array.isArray(timings)) return [];
//         return [...timings].sort((a, b) =>
//             (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0)
//         );
//     };

//     const fetchPendingRoutes = async () => {
//         try {
//             setLoadingPending(true);
//             setError(null);

//             const response = await getPendingRoutes(token);

//             if (response && response.success) {
//                 const transformedRoutes = response.data.map((route, index) => {
//                     const getDepartureTime = (origin) => {
//                         if (origin?.departureTime) return origin.departureTime;
//                         if (origin?.timings && origin.timings.length > 0) {
//                             const firstTiming = origin.timings[0];
//                             if (firstTiming?.departureTime) return firstTiming.departureTime;
//                         }
//                         return 'N/A';
//                     };

//                     const getArrivalTime = (destination) => {
//                         if (destination?.arrivalTime) return destination.arrivalTime;
//                         if (destination?.timings && destination.timings.length > 0) {
//                             const firstTiming = destination.timings[0];
//                             if (firstTiming?.arrivalTime) return firstTiming.arrivalTime;
//                         }
//                         return 'N/A';
//                     };

//                     let departureTime = getDepartureTime(route.origin);
//                     let arrivalTime = getArrivalTime(route.destination);

//                     if (route.routeNumber?.includes('REV') && route.returnJourney) {
//                         departureTime = getDepartureTime(route.returnJourney.origin);
//                         arrivalTime = getArrivalTime(route.returnJourney.destination);
//                     }

//                     const formatDisplayTime = (timeStr) => {
//                         if (!timeStr || timeStr === 'N/A') return 'N/A';
//                         if (timeStr.includes(':')) {
//                             const [hours, minutes] = timeStr.split(':');
//                             const hour = parseInt(hours);
//                             const ampm = hour >= 12 ? 'PM' : 'AM';
//                             const displayHour = hour % 12 || 12;
//                             return `${displayHour}:${minutes} ${ampm}`;
//                         }
//                         return timeStr;
//                     };

//                     return {
//                         id: route._id,
//                         pendingId: route._id,
//                         serialNo: index + 1,
//                         routeNumber: route.routeNumber || 'N/A',
//                         routeName: route.routeName || 'N/A',
//                         localRouteName: route.localRouteName || null,
//                         originCity: route.origin?.city || 'N/A',
//                         destinationCity: route.destination?.city || 'N/A',
//                         distance: route.routeDetails?.totalDistance || 0,
//                         duration: formatDuration(
//                             route.routeDetails?.estimatedDuration?.hours,
//                             route.routeDetails?.estimatedDuration?.minutes
//                         ),
//                         stops: route.intermediateStops?.length || 0,
//                         status: 'Pending',
//                         departureTime: formatDisplayTime(departureTime),
//                         arrivalTime: formatDisplayTime(arrivalTime),
//                         isActive: false,
//                         isPending: true,
//                         source: 'pending',
//                         submittedBy: route.submittedBy,
//                         submittedByName: route.submittedByName,
//                         submittedByEmail: route.submittedByEmail,
//                         operationType: route.operationType,
//                         approvalStatus: route.approvalStatus,
//                         originalData: route.originalData,
//                         isRoundTrip: route.isRoundTrip || false,
//                         fullData: route
//                     };
//                 });

//                 setPendingRoutes(transformedRoutes);
//                 setTotalRoutes(transformedRoutes.length);
//                 setTotalPages(1);
//             } else {
//                 setPendingRoutes([]);
//                 setTotalRoutes(0);
//                 setTotalPages(1);
//             }
//         } catch (err) {
//             console.error('Error fetching pending routes:', err);
//             setError('Failed to fetch pending routes. Please try again.');
//             setPendingRoutes([]);
//         } finally {
//             setLoadingPending(false);
//         }
//     };

//     const handleApprovePendingRoute = async (pendingId) => {
//         try {
//             setError(null);
//             const response = await approvePendingRoute(pendingId, token);

//             if (response.success) {
//                 toast.success('Pending route approved successfully!');
//                 setPendingRoutes(prev => prev.filter(route => route.id !== pendingId));
//                 setTotalRoutes(prev => prev - 1);
//                 await fetchRoutes();
//             } else {
//                 throw new Error(response.message || 'Failed to approve pending route');
//             }
//         } catch (err) {
//             console.error('Error approving pending route:', err);
//             setError('Failed to approve pending route. Please try again.');
//             toast.error('Failed to approve pending route. Please try again.');
//         }
//     };

//     const handleRejectPendingRoute = async (pendingId) => {
//         if (!window.confirm('Are you sure you want to reject this pending route?')) return;

//         try {
//             setError(null);
//             const response = await rejectPendingRoute(pendingId, token);

//             if (response.success) {
//                 toast.success('Pending route rejected successfully!');
//                 setPendingRoutes(prev => prev.filter(route => route.id !== pendingId));
//                 setTotalRoutes(prev => prev - 1);
//             } else {
//                 throw new Error(response.message || 'Failed to reject pending route');
//             }
//         } catch (err) {
//             console.error('Error rejecting pending route:', err);
//             setError('Failed to reject pending route. Please try again.');
//             toast.error('Failed to reject pending route. Please try again.');
//         }
//     };

   

//     const refreshPendingRoutes = async () => {
//         await fetchPendingRoutes();
//     };

//     const getCurrentRoutes = () => {
//         return viewMode === 'regular' ? routes : pendingRoutes;
//     };

//     const getCurrentLoading = () => {
//         return viewMode === 'regular' ? loading : loadingPending;
//     };

//     const currentRoutes = getCurrentRoutes();
//     const isLoading = getCurrentLoading();

//     useEffect(() => {
//         const isMultiTripMode = editForm.isMultiTrip || editIsMultiTrip || isMultiTrip;

//         if (!isMultiTripMode)
//             return;

//         const originTimings = editForm.originTimings || [];
//         const destTimings = editForm.destTimings || [];

//         if (originTimings.length === 0 || destTimings.length === 0)
//             return;

//         const firstOrigin = originTimings[0];
//         const firstDest = destTimings[0];

//         const depTime = firstOrigin?.departureTime || editForm.originDepTime || '';
//         const arrTime = firstDest?.arrivalTime || editForm.destArrTime || '';

//         if (depTime && arrTime) {
//             const [depHour, depMin] = depTime.split(':').map(Number);
//             const [arrHour, arrMin] = arrTime.split(':').map(Number);

//             if (!isNaN(depHour) && !isNaN(depMin) && !isNaN(arrHour) && !isNaN(arrMin)) {
//                 let depTotalMins = depHour * 60 + depMin;
//                 let arrTotalMins = arrHour * 60 + arrMin;

//                 if (arrTotalMins < depTotalMins) {
//                     arrTotalMins += 24 * 60;
//                 }

//                 const durationMins = arrTotalMins - depTotalMins;
//                 const hours = Math.floor(durationMins / 60);
//                 const minutes = durationMins % 60;

//                 setEditForm(prev => ({
//                     ...prev,
//                     durationHours: hours.toString(),
//                     durationMinutes: minutes.toString()
//                 }));
//             }
//         }
//     }, [editForm.originTimings, editForm.destTimings, editForm.isMultiTrip, editIsMultiTrip, isMultiTrip, editForm.originDepTime, editForm.destArrTime]);

//     useEffect(() => {
//         const isMultiTripMode = editForm.isMultiTrip || editIsMultiTrip || isMultiTrip;

//         if (!isMultiTripMode) return;
//         if (!editForm.isRoundTrip)
//             return;

//         const returnOriginTimings = editForm.returnOriginTimings || [];
//         const returnDestTimings = editForm.returnDestTimings || [];

//         if (returnOriginTimings.length === 0 || returnDestTimings.length === 0)
//             return;

//         const firstReturnOrigin = returnOriginTimings[0];
//         const firstReturnDest = returnDestTimings[0];

//         const depTime = firstReturnOrigin?.departureTime || editForm.returnOriginDepTime || '';
//         const arrTime = firstReturnDest?.arrivalTime || editForm.returnDestArrTime || '';

//         if (depTime && arrTime) {
//             const [depHour, depMin] = depTime.split(':').map(Number);
//             const [arrHour, arrMin] = arrTime.split(':').map(Number);

//             if (!isNaN(depHour) && !isNaN(depMin) && !isNaN(arrHour) && !isNaN(arrMin)) {
//                 let depTotalMins = depHour * 60 + depMin;
//                 let arrTotalMins = arrHour * 60 + arrMin;

//                 if (arrTotalMins < depTotalMins) {
//                     arrTotalMins += 24 * 60;
//                 }

//                 const durationMins = arrTotalMins - depTotalMins;
//                 const hours = Math.floor(durationMins / 60);
//                 const minutes = durationMins % 60;

//                 setEditForm(prev => ({
//                     ...prev,
//                     returnDurationHours: hours.toString(),
//                     returnDurationMinutes: minutes.toString()
//                 }));
//             }
//         }
//     }, [editForm.returnOriginTimings, editForm.returnDestTimings, editForm.isRoundTrip, editForm.isMultiTrip, editIsMultiTrip, isMultiTrip, editForm.returnOriginDepTime, editForm.returnDestArrTime]);

//     useEffect(() => {
//         if (!isMultiTrip)
//             return;

//         if (timeSlots.length === 0 || destinationTimeSlots.length === 0)
//             return;

//         const firstOrigin = timeSlots[0];
//         const firstDest = destinationTimeSlots[0];

//         const depTime = firstOrigin?.departureTime || newRoute.upOriginDepTime || '';
//         const arrTime = firstDest?.arrivalTime || newRoute.upDestArrTime || '';

//         if (depTime && arrTime) {
//             const [depHour, depMin] = depTime.split(':').map(Number);
//             const [arrHour, arrMin] = arrTime.split(':').map(Number);

//             if (!isNaN(depHour) && !isNaN(depMin) && !isNaN(arrHour) && !isNaN(arrMin)) {
//                 let depTotalMins = depHour * 60 + depMin;
//                 let arrTotalMins = arrHour * 60 + arrMin;

//                 if (arrTotalMins < depTotalMins) {
//                     arrTotalMins += 24 * 60;
//                 }

//                 const durationMins = arrTotalMins - depTotalMins;
//                 const hours = Math.floor(durationMins / 60);
//                 const minutes = durationMins % 60;

//                 setNewRoute(prev => ({
//                     ...prev,
//                     upDurationHours: hours.toString(),
//                     upDurationMinutes: minutes.toString()
//                 }));
//             }
//         }
//     }, [timeSlots, destinationTimeSlots, isMultiTrip, newRoute.upOriginDepTime, newRoute.upDestArrTime]);

//     useEffect(() => {
//         if (!isMultiTrip) return;
//         if (!isRoundTrip)
//             return;

//         if (returnOriginTimeSlots.length === 0 || returnDestTimeSlots.length === 0)
//             return;

//         const firstReturnOrigin = returnOriginTimeSlots[0];
//         const firstReturnDest = returnDestTimeSlots[0];

//         const depTime = firstReturnOrigin?.departureTime || newRoute.downOriginDepTime || '';
//         const arrTime = firstReturnDest?.arrivalTime || newRoute.downDestArrTime || '';

//         if (depTime && arrTime) {
//             const [depHour, depMin] = depTime.split(':').map(Number);
//             const [arrHour, arrMin] = arrTime.split(':').map(Number);

//             if (!isNaN(depHour) && !isNaN(depMin) && !isNaN(arrHour) && !isNaN(arrMin)) {
//                 let depTotalMins = depHour * 60 + depMin;
//                 let arrTotalMins = arrHour * 60 + arrMin;

//                 if (arrTotalMins < depTotalMins) {
//                     arrTotalMins += 24 * 60;
//                 }

//                 const durationMins = arrTotalMins - depTotalMins;
//                 const hours = Math.floor(durationMins / 60);
//                 const minutes = durationMins % 60;

//                 setNewRoute(prev => ({
//                     ...prev,
//                     downDurationHours: hours.toString(),
//                     downDurationMinutes: minutes.toString()
//                 }));
//             }
//         }
//     }, [returnOriginTimeSlots, returnDestTimeSlots, isMultiTrip, isRoundTrip, newRoute.downOriginDepTime, newRoute.downDestArrTime]);
//     const addEditReturnOriginTrip = () => {
//         const currentTimings = editForm.returnOriginTimings || [];
//         const newSequence = currentTimings.length + 1;
//         const newTiming = {
//             timeSlotSequence: newSequence,
//             departureTime: '',
//             arrivalTime: ''
//         };
//         setEditForm(prev => ({
//             ...prev,
//             returnOriginTimings: [...currentTimings, newTiming]
//         }));
//         setEditNumberOfTrips(newSequence);

//         const updatedStops = downStops.map(stop => {
//             const existingTimings = stop.timings || [];
//             const existing = existingTimings.find(t => t.timeSlotSequence === newSequence);
//             if (existing) {
//                 return stop;
//             }
//             const newTimings = [...existingTimings];
//             newTimings.push({
//                 timeSlotSequence: newSequence,
//                 arrivalTime: '',
//                 departureTime: ''
//             });
//             newTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
//             return { ...stop, timings: newTimings };
//         });
//         setDownStops(updatedStops);

//         toast.info(`Added Return Trip #${newSequence}. Please set timings for this trip in each return stop.`);
//     };

//     const addEditReturnDestinationTrip = () => {
//         const currentTimings = editForm.returnDestTimings || [];
//         const newSequence = currentTimings.length + 1;
//         const newTiming = {
//             timeSlotSequence: newSequence,
//             arrivalTime: '',
//             departureTime: ''
//         };
//         setEditForm(prev => ({
//             ...prev,
//             returnDestTimings: [...currentTimings, newTiming]
//         }));
//         setEditNumberOfTrips(newSequence);
//     };

//     const removeEditReturnOriginTrip = (index) => {
//         const currentTimings = editForm.returnOriginTimings || [];
//         if (currentTimings.length <= 1) {
//             toast.warning('At least one trip is required');
//             return;
//         }
//         const updatedTimings = currentTimings.filter((_, i) => i !== index);
//         updatedTimings.forEach((t, i) => t.timeSlotSequence = i + 1);
//         setEditForm(prev => ({
//             ...prev,
//             returnOriginTimings: updatedTimings
//         }));
//         setEditNumberOfTrips(updatedTimings.length);

//         const tripToRemove = index + 1;
//         const updatedStops = downStops.map(stop => {
//             const existingTimings = stop.timings || [];
//             const filteredTimings = existingTimings
//                 .filter(t => t.timeSlotSequence !== tripToRemove)
//                 .map((t, i) => ({ ...t, timeSlotSequence: i + 1 }));
//             filteredTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
//             return { ...stop, timings: filteredTimings };
//         });
//         setDownStops(updatedStops);

//         toast.info(`Removed Return Trip #${tripToRemove}.`);
//     };


//     const removeEditReturnDestinationTrip = (index) => {
//         const currentTimings = editForm.returnDestTimings || [];
//         if (currentTimings.length <= 1) {
//             toast.warning('At least one trip is required');
//             return;
//         }
//         const updatedTimings = currentTimings.filter((_, i) => i !== index);
//         updatedTimings.forEach((t, i) => t.timeSlotSequence = i + 1);
//         setEditForm(prev => ({
//             ...prev,
//             returnDestTimings: updatedTimings
//         }));
//         setEditNumberOfTrips(updatedTimings.length);
//     };

//     const addEditOriginTrip = () => {
//         const currentTimings = editForm.originTimings || [];
//         const newSequence = currentTimings.length + 1;
//         const newTiming = {
//             timeSlotSequence: newSequence,
//             departureTime: '',
//             arrivalTime: ''
//         };
//         setEditForm(prev => ({
//             ...prev,
//             originTimings: [...currentTimings, newTiming],
//             numberOfTrips: newSequence
//         }));
//         setEditNumberOfTrips(newSequence);

//         const updatedStops = upStops.map(stop => {
//             const existingTimings = stop.timings || [];
//             const existing = existingTimings.find(t => t.timeSlotSequence === newSequence);
//             if (existing) {
//                 return stop;
//             }
//             const newTimings = [...existingTimings];
//             newTimings.push({
//                 timeSlotSequence: newSequence,
//                 arrivalTime: '',
//                 departureTime: ''
//             });
//             newTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
//             return { ...stop, timings: newTimings };
//         });
//         setUpStops(updatedStops);

//         toast.info(`Added Trip #${newSequence}. Please set timings for this trip in each stop.`);
//     };

//     const removeEditOriginTrip = (index) => {
//         const currentTimings = editForm.originTimings || [];
//         if (currentTimings.length <= 1) {
//             toast.warning('At least one trip is required');
//             return;
//         }
//         const updatedTimings = currentTimings.filter((_, i) => i !== index);
//         updatedTimings.forEach((t, i) => t.timeSlotSequence = i + 1);
//         setEditForm(prev => ({
//             ...prev,
//             originTimings: updatedTimings,
//             numberOfTrips: updatedTimings.length
//         }));
//         setEditNumberOfTrips(updatedTimings.length);

//         const tripToRemove = index + 1;
//         const updatedStops = upStops.map(stop => {
//             const existingTimings = stop.timings || [];
//             const filteredTimings = existingTimings
//                 .filter(t => t.timeSlotSequence !== tripToRemove)
//                 .map((t, i) => ({ ...t, timeSlotSequence: i + 1 }));
//             filteredTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
//             return { ...stop, timings: filteredTimings };
//         });
//         setUpStops(updatedStops);

//         toast.info(`Removed Trip #${tripToRemove}.`);
//     };

//     const addEditDestinationTrip = () => {
//         const currentTimings = editForm.destTimings || [];
//         const newSequence = currentTimings.length + 1;
//         const newTiming = {
//             timeSlotSequence: newSequence,
//             arrivalTime: '',
//             departureTime: ''
//         };
//         setEditForm(prev => ({
//             ...prev,
//             destTimings: [...currentTimings, newTiming],
//             numberOfTrips: newSequence
//         }));
//         setEditNumberOfTrips(newSequence);
//     };

//     const removeEditDestinationTrip = (index) => {
//         const currentTimings = editForm.destTimings || [];
//         if (currentTimings.length <= 1) {
//             toast.warning('At least one trip is required');
//             return;
//         }
//         const updatedTimings = currentTimings.filter((_, i) => i !== index);
//         updatedTimings.forEach((t, i) => t.timeSlotSequence = i + 1);
//         setEditForm(prev => ({
//             ...prev,
//             destTimings: updatedTimings,
//             numberOfTrips: updatedTimings.length
//         }));
//         setEditNumberOfTrips(updatedTimings.length);
//     };

//     const renderStopsWithInlineInsert = (stops) => {
//         if (!stops || stops.length === 0) {
//             return (
//                 <div className="stops-empty-state">
//                     <p>No intermediate stops added yet.</p>
//                     <button
//                         className="btn btn-sm btn-add-stop"
//                         onClick={() => {
//                             setEditingStopIndex(null);
//                             setInsertIndex(null);
//                             setIsManualStop(true);
//                             clearStopForm();
//                         }}
//                     >
//                         + Add First Stop
//                     </button>
//                 </div>
//             );
//         }

//         const renderInsertButton = (index) => (
//             <div className="insert-stop-wrapper">
//                 <div className="insert-line"></div>
//                 <button
//                     className="insert-stop-btn"
//                     onClick={() => {
//                         setInsertIndex(index);
//                         setIsManualStop(true);
//                         clearStopForm();
//                     }}
//                 >
//                     <span className="insert-icon">+</span> Insert stop here
//                 </button>
//                 <div className="insert-line"></div>
//             </div>
//         );

//         return (
//             <div className="stops-list-container">
//                 {renderInsertButton(0)}

//                 {stops.map((stop, index) => {
//                     const displayManualDist = calculateManualDistFromPrev(stops, index);
//                     const distanceDisplay = displayManualDist ||
//                         (typeof stop.distanceFromOrigin === 'number'
//                             ? stop.distanceFromOrigin.toFixed(2)
//                             : parseFloat(stop.distanceFromOrigin || 0).toFixed(2));

//                     const hasMultiTimings = stop.timings && stop.timings.length > 0;
//                     const sortedTimings = hasMultiTimings ? sortTimings(stop.timings) : [];

//                     return (
//                         <React.Fragment key={stop._id || index}>
//                             <div className="stop-item-card">
//                                 <div className="stop-item-header">
//                                     <div className="stop-item-left">
//                                         <span className="stop-item-number">{index + 1}.</span>
//                                         <span className="stop-item-name">{stop.city}</span>
//                                         <span className="stop-item-distance">
//                                             ({distanceDisplay} km)
//                                         </span>
//                                         <StopTypeBadge type={stop.stopType} />
//                                         <StatusBadge isActive={stop.isEnabled !== false} />
//                                     </div>
//                                     <div className="stop-item-actions">
//                                         <button
//                                             className="stop-action-btn edit"
//                                             onClick={() => {
//                                                 setEditingStopIndex(index);
//                                                 handleEditStop(index, activeRouteTab === 'UP' ? 'up' : 'down');
//                                             }}
//                                         >
//                                             Edit
//                                         </button>
//                                         <button
//                                             className="stop-action-btn delete"
//                                             onClick={() => handleDeleteStop(index)}
//                                         >
//                                             Delete
//                                         </button>
//                                     </div>
//                                 </div>


//                                 {hasMultiTimings && sortedTimings.length > 0 ? (
//                                     <div className="stop-timings-grid">
//                                         {sortedTimings.map((timing, idx) => (
//                                             <div key={timing.timeSlotSequence || idx} className="stop-timing-row">
//                                                 <span className="trip-badge">Trip {timing.timeSlotSequence || idx + 1}:</span>
//                                                 <span className="timing-arrival">Arr {TimeDisplay({ time: timing.arrivalTime })}</span>
//                                                 <span className="timing-arrow">→</span>
//                                                 <span className="timing-departure">Dep {TimeDisplay({ time: timing.departureTime })}</span>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 ) : (stop.arrivalTime || stop.departureTime) ? (
//                                     <div className="stop-timing-row">
//                                         <span className="timing-arrival">Arr {TimeDisplay({ time: stop.arrivalTime })}</span>
//                                         <span className="timing-arrow">→</span>
//                                         <span className="timing-departure">Dep {TimeDisplay({ time: stop.departureTime })}</span>
//                                     </div>
//                                 ) : (
//                                     <div className="stop-timing-row" style={{ color: '#999', fontStyle: 'italic' }}>
//                                         No timings set
//                                     </div>
//                                 )}
//                             </div>

//                             {renderInsertButton(index + 1)}
//                         </React.Fragment>
//                     );
//                 })}
//             </div>
//         );
//     };

//     const clearCurrentRoute = () => {
//         if (!window.confirm(`Are you sure you want to clear all data for the ${activeRouteTab} route? This will remove origin, destination, and all intermediate stops.`)) {
//             return;
//         }

//         if (activeRouteTab === 'UP') {
//             setNewRoute(prev => ({
//                 ...prev,
//                 upOriginCity: '',
//                 upOriginState: '',
//                 upOriginAddress: '',
//                 upOriginTerminal: '',
//                 upOriginCoords: null,
//                 upOriginDepTime: '',
//                 upDestCity: '',
//                 upDestState: '',
//                 upDestAddress: '',
//                 upDestTerminal: '',
//                 upDestCoords: null,
//                 upDestArrTime: '',
//                 upTotalDistance: '',
//                 upDurationHours: '',
//                 upDurationMinutes: '',
//                 upManualFinalLeg: '',
//                 upManualFirstLeg: ''
//             }));
//             setUpStops([]);
//             setIsDistanceCalculated(prev => ({ ...prev, up: false }));

//             if (isMultiTrip) {
//                 setTimeSlots([]);
//                 setDestinationTimeSlots([]);
//                 setNumberOfTrips(1);
//             }

//             toast.info('UP route cleared successfully');
//         } else {
//             setNewRoute(prev => ({
//                 ...prev,
//                 downOriginDepTime: '',
//                 downDestArrTime: '',
//                 downTotalDistance: '',
//                 downDurationHours: '',
//                 downDurationMinutes: '',
//                 downManualFinalLeg: '',
//                 downManualFirstLeg: ''
//             }));
//             setDownStops([]);
//             setIsDistanceCalculated(prev => ({ ...prev, down: false }));

//             if (isMultiTrip) {
//                 setReturnOriginTimeSlots([]);
//                 setReturnDestTimeSlots([]);
//             }

//             toast.info('DOWN route cleared successfully');
//         }
//     };

//     const copyScheduleToDestination = (slots) => {
//         setDestinationTimeSlots(slots.map(slot => ({
//             ...slot,
//             arrivalTime: slot.arrivalTime || '',
//             departureTime: ''
//         })));
//         setDestinationNumberOfTrips(slots.length);
//     };

// useEffect(() => {
//     if (searchTerm || filterOrigin || filterDestination) {
//         setCurrentPage(1);
//     }

//     const timer = setTimeout(() => {
//         if (viewMode === 'regular') {
//             fetchRoutes();
//         } else {
//             fetchPendingRoutes();
//         }
//     }, 500);

//     return () => clearTimeout(timer);
// }, [viewMode, currentPage, searchTerm, filterOrigin, filterDestination]);
//  const restorePromptShown = useRef(false);
//     const isMounted = useRef(true);
//   useEffect(() => {
//         if (restorePromptShown.current) return;

//         const savedData = localStorage.getItem('pendingRouteFormData');

//         if (savedData) {
//             try {
//                 const formData = JSON.parse(savedData);

//                 if (!formData || typeof formData !== 'object') {
//                     throw new Error('Invalid form data structure');
//                 }

//                 const hasContent = formData.routeName ||
//                     formData.upOriginCity ||
//                     formData.upDestCity ||
//                     (formData.upStops && formData.upStops.length > 0);

//                 if (!hasContent) {
//                     localStorage.removeItem('pendingRouteFormData');
//                     return;
//                 }

//                 restorePromptShown.current = true;

//                 setTimeout(() => {
//                     if (!isMounted.current) return;

//                     if (window.confirm('You have unsaved route data. Would you like to restore it?')) {
//                         setNewRoute(prev => ({
//                             ...prev,
//                             routeName: formData.routeName || '',
//                             localRouteName: formData.localRouteName || '',
//                             upOriginCity: formData.upOriginCity || '',
//                             upOriginState: formData.upOriginState || '',
//                             upOriginAddress: formData.upOriginAddress || '',
//                             upOriginTerminal: formData.upOriginTerminal || '',
//                             upOriginCoords: formData.upOriginCoords || null,
//                             upOriginDepTime: formData.upOriginDepTime || '',
//                             upDestCity: formData.upDestCity || '',
//                             upDestState: formData.upDestState || '',
//                             upDestAddress: formData.upDestAddress || '',
//                             upDestTerminal: formData.upDestTerminal || '',
//                             upDestCoords: formData.upDestCoords || null,
//                             upDestArrTime: formData.upDestArrTime || '',
//                             upTotalDistance: formData.upTotalDistance || '',
//                             upDurationHours: formData.upDurationHours || '',
//                             upDurationMinutes: formData.upDurationMinutes || '',
//                             downOriginDepTime: formData.downOriginDepTime || '',
//                             downDestArrTime: formData.downDestArrTime || '',
//                             downTotalDistance: formData.downTotalDistance || '',
//                             downDurationHours: formData.downDurationHours || '',
//                             downDurationMinutes: formData.downDurationMinutes || '',
//                             upManualFinalLeg: formData.upManualFinalLeg || '',
//                             downManualFinalLeg: formData.downManualFinalLeg || '',
//                             stopCity: formData.stopCity || '',
//                             stopState: formData.stopState || '',
//                             stopAddress: formData.stopAddress || '',
//                             stopTerminal: formData.stopTerminal || '',
//                             stopCoords: formData.stopCoords || null,
//                             stopArrivalTime: formData.stopArrivalTime || '',
//                             stopDepartureTime: formData.stopDepartureTime || '',
//                             stopDistFromPrev: formData.stopDistFromPrev || '',
//                             stopDistToNext: formData.stopDistToNext || '',
//                             isBoarding: formData.isBoarding || false,
//                             isDropping: formData.isDropping || false
//                         }));

//                         if (formData.isMultiTrip !== undefined) {
//                             setIsMultiTrip(formData.isMultiTrip);
//                         }
//                         if (formData.numberOfTrips !== undefined) {
//                             setNumberOfTrips(formData.numberOfTrips);
//                         }
//                         if (formData.timeSlots) {
//                             setTimeSlots(formData.timeSlots);
//                         }
//                         if (formData.destinationTimeSlots) {
//                             setDestinationTimeSlots(formData.destinationTimeSlots);
//                         }
//                         if (formData.destinationNumberOfTrips !== undefined) {
//                             setDestinationNumberOfTrips(formData.destinationNumberOfTrips);
//                         }
//                         if (formData.returnOriginTimeSlots) {
//                             setReturnOriginTimeSlots(formData.returnOriginTimeSlots);
//                         }
//                         if (formData.returnDestTimeSlots) {
//                             setReturnDestTimeSlots(formData.returnDestTimeSlots);
//                         }

//                         if (formData.isRoundTrip !== undefined) {
//                             setIsRoundTrip(formData.isRoundTrip);
//                         }

//                         if (formData.upStops && Array.isArray(formData.upStops)) {
//                             setUpStops(formData.upStops);
//                         }
//                         if (formData.downStops && Array.isArray(formData.downStops)) {
//                             setDownStops(formData.downStops);
//                         }

//                         if (formData.activeRouteTab) {
//                             setActiveRouteTab(formData.activeRouteTab);
//                         }

//                         if (formData.isDistanceCalculated) {
//                             setIsDistanceCalculated(prev => ({
//                                 ...prev,
//                                 ...formData.isDistanceCalculated
//                             }));
//                         }

//                         toast.success('Route data restored successfully!');
//                     }

//                     localStorage.removeItem('pendingRouteFormData');
//                 }, 100);

//             } catch (error) {
//                 console.error('Failed to parse saved route data:', error);
//                 console.error('Corrupted data:', savedData);

//                 try {
//                     localStorage.removeItem('pendingRouteFormData');
//                     console.log('Removed corrupted route data from localStorage');
//                 } catch (removeError) {
//                     console.error('Failed to remove corrupted data:', removeError);
//                 }

//                 toast.warning('Saved route data was corrupted and has been cleared. Please fill in the form again.');
//             }
//         }
//     }, []);
//  useEffect(() => {
//         return () => {
//             isMounted.current = false;
//         };
//     }, []);

//     useEffect(() => {
//         if (isRoundTrip && activeRouteTab === 'DOWN' && downStops.length > 0) {
//             const missingDistances = downStops.some(stop =>
//                 stop.distanceFromOrigin === undefined || stop.distanceFromOrigin === 0
//             );

//             if (missingDistances && upStops.length > 0 && isDistanceCalculated.up) {
//                 const upTotalDist = parseFloat(newRoute.upTotalDistance) || 0;
//                 const downTotalDist = parseFloat(newRoute.downTotalDistance) || 0;

//                 if (downTotalDist === 0 && upTotalDist > 0) {
//                     syncDownStopsWithUpStops(false);
//                 }
//             }
//         }
//     }, [downStops, upStops, isRoundTrip, activeRouteTab, isDistanceCalculated.up]);

//     const handleActivateBusFromRoute = (route) => {
//         const pendingBuses = route.associatedBuses?.filter(bus => !bus.isActive && (bus.approvalStatus === 'pending' || !bus.approvalStatus));

//         if (pendingBuses && pendingBuses.length > 0) {
//             if (pendingBuses.length === 1) {
//                 handleActivateSingleBus(pendingBuses[0]);
//             } else {
//                 const busList = pendingBuses.map((bus, idx) =>
//                     `${idx + 1}. ${bus.busName} (${bus.busNumber})`
//                 ).join('\n');

//                 const selectedIndex = window.prompt(
//                     `Multiple pending buses found on this route:\n${busList}\n\nEnter the number of the bus to activate (1-${pendingBuses.length}):`
//                 );

//                 const index = parseInt(selectedIndex) - 1;
//                 if (index >= 0 && index < pendingBuses.length) {
//                     handleActivateSingleBus(pendingBuses[index]);
//                 } else {
//                     toast.error('Invalid selection');
//                 }
//             }
//         } else {
//             toast.info('No pending buses found on this route');
//         }
//     };

//     const fetchBusDetails = async (busId) => {
//         try {
//             const response = await getBusById(busId, token);
//             if (response.success) {
//                 setSelectedBusForActivation(response.data);
//                 setShowPlatformFeeModal(true);
//             } else {
//                 toast.error('Failed to fetch bus details');
//             }
//         } catch (error) {
//             console.error('Error fetching bus details:', error);
//             toast.error(error.response?.data?.message || 'Failed to fetch bus details');
//         }
//     };

//     const handleActivateSingleBus = async (bus) => {
//         const busId = bus._id || bus.busId;

//         if (!busId) {
//             toast.error('Invalid bus ID');
//             return;
//         }

//         try {
//             const response = await getBusById(busId, token);

//             if (response && response.success) {
//                 const busData = response.data || response.bus;
//                 if (busData) {
//                     setSelectedBusForActivation(busData);
//                     setShowPlatformFeeModal(true);
//                     return;
//                 }
//             }

//             const busWithId = {
//                 ...bus,
//                 _id: busId
//             };
//             setSelectedBusForActivation(busWithId);
//             setShowPlatformFeeModal(true);
//             toast.info('Using existing bus data for activation');

//         } catch (error) {
//             console.error('Error fetching bus details:', error);

//             const busWithId = {
//                 ...bus,
//                 _id: busId
//             };
//             setSelectedBusForActivation(busWithId);
//             setShowPlatformFeeModal(true);
//             toast.info('Using existing bus data for activation');
//         }
//     };

//     const getDefaultStateForStop = (activeRouteTab, upStops, downStops, newRoute) => {
//         if (activeRouteTab === 'UP') {
//             if (upStops.length > 0) {
//                 const lastStop = upStops[upStops.length - 1];
//                 if (lastStop.state && lastStop.state.trim()) {
//                     return lastStop.state;
//                 }
//             }
//             if (newRoute.upOriginState && newRoute.upOriginState.trim()) {
//                 return newRoute.upOriginState;
//             }
//             if (newRoute.upDestState && newRoute.upDestState.trim()) {
//                 return newRoute.upDestState;
//             }
//         } else if (activeRouteTab === 'DOWN') {
//             if (downStops.length > 0) {
//                 const lastStop = downStops[downStops.length - 1];
//                 if (lastStop.state && lastStop.state.trim()) {
//                     return lastStop.state;
//                 }
//             }
//             if (newRoute.upOriginState && newRoute.upOriginState.trim()) {
//                 return newRoute.upOriginState;
//             }
//             if (newRoute.upDestState && newRoute.upDestState.trim()) {
//                 return newRoute.upDestState;
//             }
//         }
//         return '';
//     };

//     const renderInlineInsertPanel = (idx) => {
//         const stops = getActiveStops();
//         const prevStop = idx > 0 ? stops[idx - 1] : null;
//         const nextStop = stops[idx] || null;
//         const nextHasGPS = nextStop?.coordinates?.lat && nextStop.coordinates.lat !== 0;
//         const cityOk = inlineInsertForm.city.trim().length > 0;
//         const timeOk = inlineInsertForm.arrivalTime.trim().length > 0;
//         const distOk = parseFloat(inlineInsertForm.manualDistFromPrev) > 0;
//         const canInsert = cityOk && timeOk && (!inlineInsertForm.isManual || distOk);

//         const searchCitiesForInsert = async (query) => {
//             if (!query || query.trim().length < 2) {
//                 setInlineInsertCitySuggestions([]);
//                 setShowInlineInsertDropdown(false);
//                 return;
//             }

//             try {
//                 const response = await searchRouteIntermediateStops(token, query);
//                 if (response.success && response.cities && response.cities.length > 0) {
//                     const deduped = normalizeAndDeduplicateSuggestions(response.cities);
//                     setInlineInsertCitySuggestions(deduped);
//                     setShowInlineInsertDropdown(deduped.length > 0);
//                 } else {
//                     setInlineInsertCitySuggestions([]);
//                     setShowInlineInsertDropdown(false);
//                 }
//             } catch (error) {
//                 console.error('Error searching cities:', error);
//                 setInlineInsertCitySuggestions([]);
//                 setShowInlineInsertDropdown(false);
//             }
//         };

//         const fieldStyle = {
//             display: 'flex', flexDirection: 'column', gap: 5
//         };
//         const labelStyle = {
//             fontSize: 11, fontWeight: 500,
//             color: 'var(--color-text-secondary, #777)', letterSpacing: '.2px'
//         };
//         const inputStyle = (hasErr = false) => ({
//             width: '100%', height: 38, padding: '0 12px',
//             border: `1px solid ${hasErr ? '#e24b4a' : 'var(--color-border-secondary, rgba(0,0,0,.2))'}`,
//             borderRadius: 8, fontSize: 13,
//             background: hasErr ? 'rgba(252,235,235,.05)' : 'var(--color-background-primary, #fff)',
//             color: 'var(--color-text-primary, #333)', outline: 'none',
//             boxSizing: 'border-box'
//         });
//         const sectionHead = (label) => (
//             <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '18px 0 12px' }}>
//                 <span style={{ fontSize: 11, fontWeight: 500, color: 'var(--color-text-secondary, #888)', letterSpacing: '.4px', whiteSpace: 'nowrap' }}>{label}</span>
//                 <div style={{ flex: 1, height: 1, background: 'var(--color-border-tertiary, rgba(0,0,0,.1))' }} />
//             </div>
//         );

//         return (
//             <div style={{
//                 width: '100%', background: 'var(--color-background-primary, #fff)',
//                 border: '1.5px solid #378add', borderRadius: 14,
//                 overflow: 'hidden', margin: '6px 0', alignSelf: 'stretch'
//             }}>
//                 <div style={{
//                     background: 'linear-gradient(135deg, #185fa5 0%, #378add 100%)',
//                     padding: '14px 18px', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'
//                 }}>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//                         <div style={{
//                             width: 34, height: 34, borderRadius: 8,
//                             background: 'rgba(255,255,255,.18)', display: 'flex',
//                             alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0
//                         }}>📍</div>
//                         <div>
//                             <div style={{ fontSize: 14, fontWeight: 500, color: '#fff' }}>
//                                 Insert stop at position {idx + 1}
//                             </div>
//                         </div>
//                     </div>
//                     <button onClick={() => { setInlineInsertIndex(null); setInlineInsertCitySuggestions([]); setShowInlineInsertDropdown(false); }}
//                         style={{ width: 26, height: 26, borderRadius: 6, border: '1px solid rgba(255,255,255,.3)', background: 'transparent', color: '#fff', cursor: 'pointer', fontSize: 15, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
//                         ×
//                     </button>
//                 </div>

//                 <div style={{ padding: 18 }}>
//                     <label style={{
//                         display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px',
//                         background: 'var(--color-background-secondary, #f7f7f5)',
//                         border: '0.5px solid var(--color-border-tertiary, rgba(0,0,0,.1))',
//                         borderRadius: 8, cursor: 'pointer', userSelect: 'none'
//                     }}>
//                         <input type="checkbox" checked={inlineInsertForm.isManual}
//                             onChange={() => setInlineInsertForm(prev => ({
//                                 ...prev, isManual: !prev.isManual,
//                                 city: '', address: '', state: '', terminal: '', manualDistFromPrev: '', manualDistToNext: ''
//                             }))}
//                             style={{ width: 16, height: 16, accentColor: '#378add', cursor: 'pointer' }} />
//                         <span style={{ fontSize: 13, color: 'var(--color-text-primary, #333)' }}>
//                             Manually typed stop (no map suggestions)
//                         </span>
//                     </label>

//                     {sectionHead('Stop details')}

//                     <div style={{ marginBottom: 12 }}>
//                         <div style={fieldStyle}>
//                             <label style={labelStyle}>City / stop name <span style={{ color: '#e24b4a' }}>*</span></label>
//                             {!inlineInsertForm.isManual ? (
//                                 <LocationInput
//                                     value={inlineInsertForm.city}
//                                     onChange={(v) => setInlineInsertForm(prev => ({ ...prev, city: v }))}
//                                     onLocationSelect={(loc) => setInlineInsertForm(prev => ({
//                                         ...prev,
//                                         city: loc.city || loc.name || '',
//                                         state: loc.state || prev.state,
//                                         address: loc.address || ''
//                                     }))}
//                                     placeholder="Search stop city or address…"
//                                 />
//                             ) : (
//                                 <div style={{ position: 'relative' }}>
//                                     <input
//                                         type="text"
//                                         value={inlineInsertForm.city}
//                                         onChange={async (e) => {
//                                             const value = toTitleCase(e.target.value);
//                                             setInlineInsertForm(prev => ({
//                                                 ...prev,
//                                                 city: value,
//                                                 address: '',
//                                                 state: '',
//                                                 terminal: ''
//                                             }));
//                                             await searchCitiesForInsert(value);
//                                         }}
//                                         onFocus={() => {
//                                             if (inlineInsertCitySuggestions.length > 0) {
//                                                 setShowInlineInsertDropdown(true);
//                                             }
//                                         }}
//                                         onBlur={() => setTimeout(() => setShowInlineInsertDropdown(false), 200)}
//                                         placeholder="Type city name (min 2 chars)…"
//                                         style={inputStyle()}
//                                     />
//                                     {showInlineInsertDropdown && inlineInsertCitySuggestions.length > 0 && (
//                                         <div style={{
//                                             position: 'absolute',
//                                             top: '100%',
//                                             left: 0,
//                                             right: 0,
//                                             background: 'white',
//                                             border: '1px solid #ddd',
//                                             borderRadius: 8,
//                                             maxHeight: 200,
//                                             overflowY: 'auto',
//                                             zIndex: 10000,
//                                             boxShadow: '0 4px 12px rgba(0,0,0,.12)'
//                                         }}>
//                                             {inlineInsertCitySuggestions.map((city, i) => (
//                                                 <div key={city.id || i}
//                                                     onMouseDown={() => {
//                                                         setInlineInsertForm(prev => ({
//                                                             ...prev,
//                                                             city: city.name,
//                                                             address: city.address || city.name,
//                                                             state: city.state || '',
//                                                             terminal: city.terminal || `${city.name} Bus Stand`
//                                                         }));
//                                                         setShowInlineInsertDropdown(false);
//                                                         setInlineInsertCitySuggestions([]);
//                                                     }}
//                                                     style={{
//                                                         padding: '9px 12px',
//                                                         cursor: 'pointer',
//                                                         borderBottom: '0.5px solid #f0f0f0'
//                                                     }}
//                                                     onMouseEnter={e => e.currentTarget.style.background = '#f0f7ff'}
//                                                     onMouseLeave={e => e.currentTarget.style.background = 'white'}>
//                                                     <div style={{ fontWeight: 500, fontSize: 13 }}>{city.name}</div>
//                                                     <div style={{ fontSize: 11, color: '#888' }}>{city.state}{city.terminal ? ` · ${city.terminal}` : ''}</div>
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     )}
//                                 </div>
//                             )}
//                         </div>
//                     </div>


//                     <div style={{ marginBottom: 12 }}>
//                         <div style={fieldStyle}>
//                             <label style={labelStyle}>Address</label>
//                             <input type="text" value={inlineInsertForm.address}
//                                 onChange={e => setInlineInsertForm(prev => ({ ...prev, address: e.target.value }))}
//                                 placeholder="e.g. NH-19, Near Bus Stand" style={inputStyle()} />
//                         </div>
//                     </div>

//                     <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 4 }}>
//                         <div style={fieldStyle}>
//                             <label style={labelStyle}>State</label>
//                             <input type="text" value={inlineInsertForm.state}
//                                 onChange={e => setInlineInsertForm(prev => ({ ...prev, state: e.target.value }))}
//                                 placeholder="State" style={inputStyle()} />
//                         </div>
//                         <div style={fieldStyle}>
//                             <label style={labelStyle}>Terminal</label>
//                             <input type="text" value={inlineInsertForm.terminal}
//                                 onChange={e => setInlineInsertForm(prev => ({ ...prev, terminal: e.target.value }))}
//                                 placeholder="Terminal name" style={inputStyle()} />
//                         </div>
//                     </div>

//                     {sectionHead('Schedule')}

//                     <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 4 }}>
//                         <div style={fieldStyle}>
//                             <label style={labelStyle}>Arrival Time <span style={{ color: '#e24b4a' }}>*</span></label>
//                             <TimePicker
//                                 value={inlineInsertForm.arrivalTime}
//                                 onChange={(value) => setInlineInsertForm(prev => ({ ...prev, arrivalTime: value }))}
//                                 placeholder="Select time"
//                             />
//                         </div>
//                         <div style={fieldStyle}>
//                             <label style={labelStyle}>Departure Time (Opt)</label>
//                             <TimePicker
//                                 value={inlineInsertForm.departureTime}
//                                 onChange={(value) => setInlineInsertForm(prev => ({ ...prev, departureTime: value }))}
//                                 placeholder="Select time"
//                             />
//                         </div>
//                     </div>

//                     {sectionHead('Distance')}

//                     <div style={{ display: 'grid', gridTemplateColumns: nextHasGPS ? '1fr 1fr' : '1fr', gap: 12, marginBottom: 4 }}>
//                         <div style={{ border: '1px solid rgba(226,75,74,.4)', borderRadius: 10, padding: 14, background: 'rgba(252,235,235,.04)' }}>
//                             <div style={{ fontSize: 11, fontWeight: 500, color: '#a32d2d', marginBottom: 6 }}>
//                                 From previous stop <span style={{ color: '#e24b4a' }}>*</span>
//                             </div>
//                             <input type="number" value={inlineInsertForm.manualDistFromPrev}
//                                 onChange={e => setInlineInsertForm(prev => ({ ...prev, manualDistFromPrev: e.target.value }))}
//                                 placeholder="0" min="0" step="0.1"
//                                 style={{ ...inputStyle(true), border: '1px solid #e24b4a' }} />
//                             <div style={{ fontSize: 11, color: '#a32d2d', marginTop: 5, display: 'flex', alignItems: 'center', gap: 4 }}>
//                                 ⚠ Required for manual stops
//                             </div>
//                             <div style={{ fontSize: 11, color: 'var(--color-text-secondary, #888)', marginTop: 2 }}>km</div>
//                         </div>

//                         {nextHasGPS && (
//                             <div style={{ border: '1px solid rgba(55,138,221,.3)', borderRadius: 10, padding: 14, background: 'rgba(230,241,251,.04)' }}>
//                                 <div style={{ fontSize: 11, fontWeight: 500, color: '#185fa5', marginBottom: 6 }}>
//                                     To next stop — {nextStop.city}
//                                 </div>
//                                 <input type="number" value={inlineInsertForm.manualDistToNext}
//                                     onChange={e => setInlineInsertForm(prev => ({ ...prev, manualDistToNext: e.target.value }))}
//                                     placeholder="0" min="0" step="0.1"
//                                     style={{ ...inputStyle(), border: '1px solid rgba(55,138,221,.5)' }} />
//                                 <div style={{ fontSize: 11, color: '#185fa5', marginTop: 5, display: 'flex', alignItems: 'center', gap: 4 }}>
//                                     ℹ Next stop has GPS — helps accuracy
//                                 </div>
//                                 <div style={{ fontSize: 11, color: 'var(--color-text-secondary, #888)', marginTop: 2 }}>km</div>
//                             </div>
//                         )}
//                     </div>

//                     {sectionHead('Stop type')}

//                     <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
//                         {[
//                             { val: 'none', label: 'Pass-through', bg: '#f1efe8', color: '#5f5e5a', border: '#888' },
//                             { val: 'boarding', label: 'Boarding only', bg: '#eaf3de', color: '#3b6d11', border: '#3b6d11' },
//                             { val: 'dropping', label: 'Dropping only', bg: '#fcebeb', color: '#a32d2d', border: '#a32d2d' },
//                             { val: 'both', label: 'Both boarding & dropping', bg: '#e6f1fb', color: '#185fa5', border: '#378add' },
//                         ].map(opt => {
//                             const sel = inlineInsertForm.stopType === opt.val;
//                             return (
//                                 <button key={opt.val}
//                                     type="button"
//                                     onClick={() => setInlineInsertForm(prev => ({ ...prev, stopType: opt.val }))}
//                                     style={{
//                                         padding: '6px 14px', borderRadius: 999, fontSize: 12, cursor: 'pointer',
//                                         border: `1px solid ${sel ? opt.border : 'rgba(0,0,0,.2)'}`,
//                                         background: sel ? opt.bg : 'transparent',
//                                         color: sel ? opt.color : 'var(--color-text-secondary, #666)',
//                                         fontWeight: sel ? 500 : 400, transition: 'all .12s'
//                                     }}>
//                                     {opt.label}
//                                 </button>
//                             );
//                         })}
//                     </div>

//                     <div style={{ display: 'flex', gap: 16, marginTop: 16 }}>
//                         <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12 }}>
//                             <input type="checkbox" checked={inlineInsertForm.isBoarding}
//                                 onChange={e => setInlineInsertForm(prev => ({ ...prev, isBoarding: e.target.checked }))} />
//                             Boarding Point
//                         </label>
//                         <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12 }}>
//                             <input type="checkbox" checked={inlineInsertForm.isDropping}
//                                 onChange={e => setInlineInsertForm(prev => ({ ...prev, isDropping: e.target.checked }))} />
//                             Dropping Point
//                         </label>
//                     </div>
//                 </div>

//                 <div style={{
//                     display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8,
//                     padding: '12px 18px',
//                     borderTop: '1px solid var(--color-border-tertiary, rgba(0,0,0,.08))',
//                     background: 'var(--color-background-secondary, #fafafa)'
//                 }}>
//                     <button type="button"
//                         onClick={() => { setInlineInsertIndex(null); setInlineInsertCitySuggestions([]); setShowInlineInsertDropdown(false); }}
//                         style={{ padding: '8px 18px', fontSize: 13, borderRadius: 8, border: '1px solid var(--color-border-secondary, rgba(0,0,0,.2))', background: 'transparent', cursor: 'pointer', color: 'var(--color-text-secondary, #666)' }}>
//                         Cancel
//                     </button>
//                     <button type="button"
//                         onClick={saveInlineInsert}
//                         disabled={!canInsert}
//                         style={{ padding: '8px 22px', fontSize: 13, borderRadius: 8, border: 'none', background: '#378add', color: '#fff', fontWeight: 500, cursor: canInsert ? 'pointer' : 'not-allowed', opacity: canInsert ? 1 : 0.45, display: 'flex', alignItems: 'center', gap: 6 }}>
//                         ✓ Insert stop
//                     </button>
//                 </div>
//             </div>
//         );
//     };

//     const saveInlineInsert = () => {
//         if (!inlineInsertForm.city) {
//             toast.error('City is required');
//             return;
//         }
//         if (!inlineInsertForm.arrivalTime) {
//             toast.error('Arrival time is required');
//             return;
//         }
//         if (!inlineInsertForm.state || inlineInsertForm.state.trim() === '') {
//             toast.error('State is required');
//             return;
//         }

//         if (!inlineInsertForm.address || inlineInsertForm.address.trim() === '') {
//             toast.error('Address is required');
//             return;
//         }

//         if (!inlineInsertForm.terminal || inlineInsertForm.terminal.trim() === '') {
//             toast.error('Terminal is required');
//             return;
//         }

//         if (inlineInsertForm.isManual && (!inlineInsertForm.manualDistFromPrev || parseFloat(inlineInsertForm.manualDistFromPrev) <= 0)) {
//             toast.error('For manual stops, please provide distance from previous stop');
//             return;
//         }

//         const type = activeRouteTab === 'UP' ? 'up' : 'down';
//         let currentStops = type === 'up' ? [...upStops] : [...downStops];

//         let coordinates = null;
//         let manualDistFromPrev = null;
//         let manualDistToNext = null;
//         let distanceFromOrigin = 0;

//         if (inlineInsertForm.isManual) {
//             coordinates = { lat: 0, lng: 0 };
//             manualDistFromPrev = parseFloat(inlineInsertForm.manualDistFromPrev);
//             manualDistToNext = inlineInsertForm.manualDistToNext ? parseFloat(inlineInsertForm.manualDistToNext) : null;

//             if (inlineInsertIndex > 0 && currentStops[inlineInsertIndex - 1]) {
//                 distanceFromOrigin = parseFloat(((currentStops[inlineInsertIndex - 1].distanceFromOrigin || 0) + manualDistFromPrev).toFixed(2));
//             } else {
//                 distanceFromOrigin = manualDistFromPrev || 0;
//             }
//         }

//         let stopType = inlineInsertForm.stopType || 'none';
//         if (stopType === 'none') {
//             if (inlineInsertForm.isBoarding && inlineInsertForm.isDropping) stopType = 'both';
//             else if (inlineInsertForm.isBoarding) stopType = 'boarding';
//             else if (inlineInsertForm.isDropping) stopType = 'dropping';
//         }

//         const newStop = {
//             city: inlineInsertForm.city,
//             state: inlineInsertForm.state || '',
//             address: inlineInsertForm.address || `${inlineInsertForm.city}, ${inlineInsertForm.state || 'India'}`,
//             terminal: inlineInsertForm.terminal || `${inlineInsertForm.city} Bus Stand`,
//             arrivalTime: inlineInsertForm.arrivalTime,
//             departureTime: inlineInsertForm.departureTime || inlineInsertForm.arrivalTime,
//             stopType: stopType,
//             coordinates: coordinates,
//             manualDistFromPrev: manualDistFromPrev,
//             manualDistToNext: manualDistToNext,
//             distanceFromOrigin: distanceFromOrigin,
//             isManualStop: inlineInsertForm.isManual
//         };

//         currentStops.splice(inlineInsertIndex, 0, newStop);
//         setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));

//         if (type === 'up') {
//             setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//         } else {
//             setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//         }

//         toast.success(`Stop "${inlineInsertForm.city}" inserted at position ${inlineInsertIndex + 1}`);

//         setInlineInsertIndex(null);
//         setInlineInsertCitySuggestions([]);
//         setShowInlineInsertDropdown(false);
//     };

//     const searchCitySuggestions = async (query, type) => {
//         if (!query || query.trim().length < 2) {
//             if (type === 'origin') {
//                 setOriginSuggestions([]);
//             } else {
//                 setDestSuggestions([]);
//             }
//             return;
//         }

//         try {
//             const allRoutes = await getAllRoutes(token, 1, 100, '');
//             if (allRoutes.success && allRoutes.data?.routes) {
//                 const cities = new Set();
//                 allRoutes.data.routes.forEach(route => {
//                     if (type === 'origin' && route.origin?.city) {
//                         if (route.origin.city.toLowerCase().includes(query.toLowerCase())) {
//                             cities.add(route.origin.city);
//                         }
//                     } else if (type === 'destination' && route.destination?.city) {
//                         if (route.destination.city.toLowerCase().includes(query.toLowerCase())) {
//                             cities.add(route.destination.city);
//                         }
//                     }
//                 });

//                 const suggestions = Array.from(cities).map(city => ({ city }));
//                 if (type === 'origin') {
//                     setOriginSuggestions(suggestions);
//                     setShowOriginSuggestions(true);
//                 } else {
//                     setDestSuggestions(suggestions);
//                     setShowDestSuggestions(true);
//                 }
//             }
//         } catch (error) {
//             console.error('Error fetching city suggestions:', error);
//         }
//     };

//     const formatTime = (time) => {
//         if (!time) return 'N/A';
//         if (time.includes(':')) {
//             const [hours, minutes] = time.split(':');
//             const hour = parseInt(hours);
//             const ampm = hour >= 12 ? 'pm' : 'am';
//             const displayHour = hour % 12 || 12;
//             return `${displayHour}:${minutes} ${ampm}`;
//         }
//         return time;
//     };

//     const formatDuration = (hours, minutes) => {
//         if (!hours && !minutes) return 'N/A';
//         const parts = [];
//         if (hours) parts.push(`${hours}h`);
//         if (minutes) parts.push(`${minutes}m`);
//         return parts.join(' ');
//     };

// const getDuration = (start, end) => {
//     if (!start || !end) return { hours: '0', minutes: '0' };

//     if (!start.includes(':') || !end.includes(':')) {
//         return { hours: '0', minutes: '0' };
//     }
    
//     const [sh, sm] = start.split(':').map(Number);
//     const [eh, em] = end.split(':').map(Number);

//     if (isNaN(sh) || isNaN(sm) || isNaN(eh) || isNaN(em)) {
//         console.warn('Invalid time format in getDuration:', { start, end });
//         return { hours: '0', minutes: '0' };
//     }
    
//     let sMins = sh * 60 + sm;
//     let eMins = eh * 60 + em;
    
//     if (eMins < sMins) eMins += 24 * 60;
    
//     const diff = eMins - sMins;
//     return { 
//         hours: String(Math.floor(diff / 60)), 
//         minutes: String(diff % 60) 
//     };
// };

//     const isLastStopManual = () => {
//         const stops = activeRouteTab === 'UP' ? upStops : downStops;

//         if (stops.length === 0) return false;

//         const lastStop = stops[stops.length - 1];

//         const isManual =
//             lastStop.isManualStop === true ||
//             (lastStop.manualDistFromPrev !== null && lastStop.manualDistFromPrev !== undefined && lastStop.manualDistFromPrev > 0) ||
//             (lastStop.manualDistToNext !== null && lastStop.manualDistToNext !== undefined && lastStop.manualDistToNext > 0) ||
//             !lastStop.coordinates ||
//             (lastStop.coordinates.lat === 0 && lastStop.coordinates.lng === 0);

//         return isManual;
//     };

//     const isNextStopAuto = (currentIndex) => {
//         const stops = getActiveStops();
//         const nextStop = stops[currentIndex + 1];
//         return nextStop && nextStop.coordinates &&
//             (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);
//     };

//     const handleSelectOrigin = (location) => {
//         setNewRoute(prev => ({
//             ...prev,
//             upOriginCity: location.city || location.name || '',
//             upOriginState: location.state || '',
//             upOriginAddress: location.address || '',
//             upOriginCoords: location.coordinates || { lat: 0, lng: 0 }
//         }));
//         setIsDistanceCalculated(prev => ({ ...prev, up: false }));
//     };

//     const handleSelectDest = (location) => {
//         setNewRoute(prev => ({
//             ...prev,
//             upDestCity: location.city || location.name || '',
//             upDestState: location.state || '',
//             upDestAddress: location.address || '',
//             upDestCoords: location.coordinates || { lat: 0, lng: 0 }
//         }));
//         setIsDistanceCalculated(prev => ({ ...prev, up: false }));
//     };

//     const handleSelectStop = (location) => {
//         let autoState = location.state || '';

//         if (!autoState && activeRouteTab === 'UP') {
//             if (upStops.length > 0) {
//                 const lastStop = upStops[upStops.length - 1];
//                 if (lastStop.state && lastStop.state.trim()) {
//                     autoState = lastStop.state;
//                 }
//             }
//             if (!autoState && newRoute.upOriginState && newRoute.upOriginState.trim()) {
//                 autoState = newRoute.upOriginState;
//             }
//         } else if (!autoState && activeRouteTab === 'DOWN') {
//             if (downStops.length > 0) {
//                 const lastStop = downStops[downStops.length - 1];
//                 if (lastStop.state && lastStop.state.trim()) {
//                     autoState = lastStop.state;
//                 }
//             }
//             if (!autoState && newRoute.upOriginState && newRoute.upOriginState.trim()) {
//                 autoState = newRoute.upOriginState;
//             }
//         }

//         setNewRoute(prev => ({
//             ...prev,
//             stopCity: location.city || location.name || '',
//             stopState: autoState,
//             stopAddress: location.address || '',
//             stopCoords: location.coordinates || { lat: 0, lng: 0 }
//         }));
//         setIsManualStop(false);
//         setIsManualDistance(false);
//     };

//     const syncDownStopsWithUpStops = (forcePrompt = false) => {
//         if (upStops.length === 0) {
//             toast.warning("No UP route stops to sync from.");
//             return;
//         }

//         const upTotalDist = parseFloat(editForm.totalDistance || newRoute.upTotalDistance || 0);
//         let downTotalDist = parseFloat(editForm.returnTotalDistance || newRoute.downTotalDistance || 0);

//         if (downTotalDist === 0 && upTotalDist > 0) {
//             downTotalDist = upTotalDist;
//         }

//         const numTrips = editForm.numberOfTrips || editNumberOfTrips || numberOfTrips || 1;
//         const isMultiTripMode = editForm.isMultiTrip || editIsMultiTrip || isMultiTrip || false;

//         const doSync = () => {
//             const newDownStops = [];
//             const upDistances = upStops.map(stop => stop.distanceFromOrigin || 0);
//             const maxUpDistance = upDistances[upDistances.length - 1] || 0;

//             for (let i = 0; i < upStops.length; i++) {
//                 const originalIndex = upStops.length - 1 - i;
//                 const originalStop = upStops[originalIndex];

//                 const upDistance = originalStop.distanceFromOrigin || 0;
//                 let downDistance = downTotalDist - upDistance;

//                 if (downDistance <= 0 && i === 0) {
//                     downDistance = downTotalDist - maxUpDistance;
//                 }
//                 if (downDistance <= 0) downDistance = (downTotalDist / (upStops.length + 1)) * (i + 1);

//                 let manualDistFromPrev = null;
//                 if (i === 0) {
//                     manualDistFromPrev = downDistance;
//                 } else {
//                     const prevDownDist = newDownStops[i - 1]?.distanceFromOrigin || 0;
//                     manualDistFromPrev = downDistance - prevDownDist;
//                 }
//                 if (manualDistFromPrev <= 0) manualDistFromPrev = originalStop.manualDistFromPrev || downDistance / (i + 1);

//                 let newStopType = originalStop.stopType;
//                 if (originalStop.stopType === 'boarding')
//                     newStopType = 'dropping';
//                 else
//                     if (originalStop.stopType === 'dropping') newStopType = 'boarding';

//                 let stopTimings = [];
//                 if (isMultiTripMode) {
//                     if (editForm.originTimings && editForm.originTimings.length > 0) {
//                         stopTimings = editForm.originTimings.map(t => ({
//                             timeSlotSequence: t.timeSlotSequence || t.sequence || 1,
//                             arrivalTime: '',
//                             departureTime: ''
//                         }));
//                     } else if (editForm.destTimings && editForm.destTimings.length > 0) {
//                         stopTimings = editForm.destTimings.map(t => ({
//                             timeSlotSequence: t.timeSlotSequence || t.sequence || 1,
//                             arrivalTime: '',
//                             departureTime: ''
//                         }));
//                     } else if (originalStop.timings && originalStop.timings.length > 0) {
//                         stopTimings = originalStop.timings.map(t => ({
//                             timeSlotSequence: t.timeSlotSequence || 1,
//                             arrivalTime: '',
//                             departureTime: ''
//                         }));
//                     } else {
//                         stopTimings = Array.from({ length: numTrips }, (_, idx) => ({
//                             timeSlotSequence: idx + 1,
//                             arrivalTime: '',
//                             departureTime: ''
//                         }));
//                     }

//                     while (stopTimings.length < numTrips) {
//                         stopTimings.push({
//                             timeSlotSequence: stopTimings.length + 1,
//                             arrivalTime: '',
//                             departureTime: ''
//                         });
//                     }
//                     stopTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
//                 }

//                 newDownStops.push({
//                     ...originalStop,
//                     sequence: i + 1,
//                     stopType: newStopType,
//                     distanceFromOrigin: parseFloat(downDistance.toFixed(1)),
//                     manualDistFromPrev: parseFloat(manualDistFromPrev.toFixed(1)),
//                     manualDistToNext: originalStop.manualDistFromPrev || null,
//                     arrivalTime: isMultiTripMode ? '' : '',
//                     departureTime: isMultiTripMode ? '' : '',
//                     timings: stopTimings
//                 });
//             }

//             if (newDownStops.length > 0) {
//                 const lastDownDist = newDownStops[newDownStops.length - 1].distanceFromOrigin || 0;
//                 const finalSegment = downTotalDist - lastDownDist;
//                 if (finalSegment > 0) {
//                     newDownStops[newDownStops.length - 1] = {
//                         ...newDownStops[newDownStops.length - 1],
//                         manualDistToNext: parseFloat(finalSegment.toFixed(1))
//                     };
//                 }
//             }

//             setDownStops(newDownStops);

//             if (isMultiTripMode) {
//                 if (editForm.originTimings && editForm.originTimings.length > 0) {
//                     const returnOriginTimings = editForm.originTimings.map(t => ({
//                         timeSlotSequence: t.timeSlotSequence || 1,
//                         departureTime: '',
//                         arrivalTime: ''
//                     }));
//                     setEditForm(prev => ({
//                         ...prev,
//                         returnOriginTimings: returnOriginTimings
//                     }));
//                 } else {
//                     const returnOriginTimings = Array.from({ length: numTrips }, (_, idx) => ({
//                         timeSlotSequence: idx + 1,
//                         departureTime: '',
//                         arrivalTime: ''
//                     }));
//                     setEditForm(prev => ({
//                         ...prev,
//                         returnOriginTimings: returnOriginTimings
//                     }));
//                 }

//                 if (editForm.destTimings && editForm.destTimings.length > 0) {
//                     const returnDestTimings = editForm.destTimings.map(t => ({
//                         timeSlotSequence: t.timeSlotSequence || 1,
//                         arrivalTime: '',
//                         departureTime: ''
//                     }));
//                     setEditForm(prev => ({
//                         ...prev,
//                         returnDestTimings: returnDestTimings
//                     }));
//                 } else {
//                     const returnDestTimings = Array.from({ length: numTrips }, (_, idx) => ({
//                         timeSlotSequence: idx + 1,
//                         arrivalTime: '',
//                         departureTime: ''
//                     }));
//                     setEditForm(prev => ({
//                         ...prev,
//                         returnDestTimings: returnDestTimings
//                     }));
//                 }

//                 setEditNumberOfTrips(numTrips);
//             }

//             setEditForm(prev => ({
//                 ...prev,
//                 returnTotalDistance: downTotalDist.toFixed(1),
//                 returnDurationHours: prev.durationHours,
//                 returnDurationMinutes: prev.durationMinutes,
//                 isMultiTrip: isMultiTripMode,
//                 numberOfTrips: numTrips
//             }));
//             setNewRoute(prev => ({
//                 ...prev,
//                 downTotalDistance: downTotalDist.toFixed(1)
//             }));

//             setIsDistanceCalculated(prev => ({ ...prev, down: false }));

//             if (isMultiTripMode) {
//                 toast.success(`DOWN route populated with ${newDownStops.length} stops. Total distance: ${downTotalDist.toFixed(1)} km with ${numTrips} trip(s). Each stop has timings for ${numTrips} trip(s).`);
//             } else {
//                 toast.success(`DOWN route populated with ${newDownStops.length} stops. Total distance: ${downTotalDist.toFixed(1)} km`);
//             }
//         };

//         if (forcePrompt && downStops.length > 0) {
//             if (window.confirm("This will update your Return Route stops based on your Main Route. Any existing DOWN route data will be replaced. Proceed?")) {
//                 doSync();
//             }
//         } else {
//             doSync();
//         }
//     };

//     const toggleRoundTrip = (newVal) => {
//         setIsRoundTrip(newVal);

//         if (newVal) {
//             if (isMultiTrip) {
//                 if (destinationTimeSlots && destinationTimeSlots.length > 0) {
//                     setReturnOriginTimeSlots(destinationTimeSlots.map(slot => ({
//                         sequence: slot.sequence,
//                         departureTime: slot.arrivalTime || '',
//                         arrivalTime: '',
//                         fareMultiplier: slot.fareMultiplier || 1.0,
//                         isActive: true
//                     })));
//                 } else if (timeSlots && timeSlots.length > 0) {
//                     setReturnOriginTimeSlots(timeSlots.map(slot => ({
//                         sequence: slot.sequence,
//                         departureTime: slot.departureTime || '',
//                         arrivalTime: '',
//                         fareMultiplier: slot.fareMultiplier || 1.0,
//                         isActive: true
//                     })));
//                 }

//                 if (timeSlots && timeSlots.length > 0) {
//                     setReturnDestTimeSlots(timeSlots.map(slot => ({
//                         sequence: slot.sequence,
//                         arrivalTime: slot.departureTime || '',
//                         departureTime: '',
//                         fareMultiplier: slot.fareMultiplier || 1.0,
//                         isActive: true
//                     })));
//                 }
//             }

//             if (newRoute.upOriginCity) {
//                 setNewRoute(prev => ({
//                     ...prev,
//                     downDestCity: prev.upOriginCity,
//                     downDestState: prev.upOriginState,
//                     downDestAddress: prev.upOriginAddress,
//                     downDestTerminal: prev.upOriginTerminal,
//                     downTotalDistance: prev.upTotalDistance || '',
//                     downDurationHours: prev.upDurationHours || '',
//                     downDurationMinutes: prev.upDurationMinutes || '',
//                     downOriginDepTime: prev.upDestArrTime || '',
//                     downDestArrTime: prev.upOriginDepTime || '',
//                 }));
//             }

//             if (upStops.length > 0 && downStops.length === 0) {
//                 const upTotalDist = parseFloat(newRoute.upTotalDistance || 0);
//                 const reversedStops = [...upStops].reverse();
//                 let downTotalDistance = upTotalDist || 0;

//                 const upSegmentDistances = [];
//                 let prevDist = 0;
//                 for (let i = 0; i < upStops.length; i++) {
//                     const currentDist = upStops[i].distanceFromOrigin || 0;
//                     let segment = currentDist - prevDist;
//                     if (segment <= 0 && upStops[i].manualDistFromPrev) {
//                         segment = parseFloat(upStops[i].manualDistFromPrev);
//                     }
//                     if (segment <= 0 && i === 0 && upTotalDist > 0) {
//                         segment = upTotalDist / (upStops.length + 1);
//                     }
//                     if (segment <= 0) segment = 5;
//                     upSegmentDistances.push(segment);
//                     prevDist = currentDist;
//                 }

//                 const lastUpStopDist = upStops.length > 0 ? (upStops[upStops.length - 1].distanceFromOrigin || 0) : 0;
//                 let finalUpSegment = upTotalDist - lastUpStopDist;
//                 if (finalUpSegment <= 0 && newRoute.upManualFinalLeg) {
//                     finalUpSegment = parseFloat(newRoute.upManualFinalLeg);
//                 }
//                 if (finalUpSegment <= 0)
//                     finalUpSegment = upTotalDist / (upStops.length + 1);

//                 const downSegmentDistances = [finalUpSegment, ...upSegmentDistances.reverse()];
//                 let cumulativeDist = 0;
//                 const newDownStops = [];

//                 for (let i = 0; i < reversedStops.length; i++) {
//                     const originalStop = reversedStops[i];
//                     let segmentDist = downSegmentDistances[i] || 5;

//                     if (originalStop.manualDistFromPrev && originalStop.manualDistFromPrev > 0) {
//                         segmentDist = parseFloat(originalStop.manualDistFromPrev);
//                     } else if (originalStop.manualDistToNext && originalStop.manualDistToNext > 0) {
//                         segmentDist = parseFloat(originalStop.manualDistToNext);
//                     }

//                     cumulativeDist += segmentDist;

//                     let newStopType = originalStop.stopType;
//                     if (originalStop.stopType === 'boarding') {
//                         newStopType = 'dropping';
//                     } else if (originalStop.stopType === 'dropping') {
//                         newStopType = 'boarding';
//                     }

//                     let stopTimings = [];
//                     if (isMultiTrip && originalStop.timings && originalStop.timings.length > 0) {
//                         stopTimings = originalStop.timings.map(t => ({
//                             timeSlotSequence: t.timeSlotSequence,
//                             arrivalTime: '',
//                             departureTime: ''
//                         }));
//                     } else if (isMultiTrip && timeSlots && timeSlots.length > 0) {
//                         stopTimings = timeSlots.map(slot => ({
//                             timeSlotSequence: slot.sequence,
//                             arrivalTime: '',
//                             departureTime: ''
//                         }));
//                     }

//                     newDownStops.push({
//                         ...originalStop,
//                         sequence: i + 1,
//                         stopType: newStopType,
//                         distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//                         manualDistFromPrev: parseFloat(segmentDist.toFixed(1)),
//                         manualDistToNext: originalStop.manualDistFromPrev || null,
//                         arrivalTime: isMultiTrip ? '' : originalStop.arrivalTime || '',
//                         departureTime: isMultiTrip ? '' : originalStop.departureTime || '',
//                         timings: stopTimings
//                     });
//                 }

//                 let finalSegment = downTotalDistance - cumulativeDist;
//                 if (finalSegment <= 0) {
//                     const lastUpFirstSegment = upSegmentDistances[0] || 5;
//                     finalSegment = lastUpFirstSegment;
//                 }

//                 if (newDownStops.length > 0 && finalSegment > 0) {
//                     newDownStops[newDownStops.length - 1] = {
//                         ...newDownStops[newDownStops.length - 1],
//                         manualDistToNext: parseFloat(finalSegment.toFixed(1))
//                     };
//                 }

//                 const calculatedTotal = cumulativeDist + finalSegment;
//                 if (Math.abs(calculatedTotal - downTotalDistance) > 0.1) {
//                     downTotalDistance = calculatedTotal;
//                 }

//                 setDownStops(newDownStops);
//                 setNewRoute(prev => ({
//                     ...prev,
//                     downTotalDistance: downTotalDistance.toFixed(1),
//                     downManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.downManualFinalLeg,
//                     downDurationHours: prev.upDurationHours || '',
//                     downDurationMinutes: prev.upDurationMinutes || ''
//                 }));

//                 setIsDistanceCalculated(prev => ({ ...prev, down: false }));
//                 toast.success(`Return route populated with ${newDownStops.length} stops. Total distance: ${downTotalDistance.toFixed(1)} km`);
//             } else if (upStops.length === 0) {
//                 toast.info('Add stops to the UP route first, then enable round trip to auto-populate the return route.');
//             }

//             setActiveRouteTab('DOWN');
//         } else {
//             setDownStops([]);
//             setReturnOriginTimeSlots([]);
//             setReturnDestTimeSlots([]);
//             setIsDistanceCalculated(prev => ({ ...prev, down: false }));
//             setNewRoute(prev => ({
//                 ...prev,
//                 downTotalDistance: '',
//                 downDurationHours: '',
//                 downDurationMinutes: '',
//                 downOriginDepTime: '',
//                 downDestArrTime: '',
//                 downManualFinalLeg: '',
//                 downManualFirstLeg: ''
//             }));
//             setActiveRouteTab('UP');
//             toast.info('Return route disabled');
//         }
//     };

//     const handleTabSwitch = (tab) => {
//         if (tab === 'DOWN' && upStops.length > 0 && isRoundTrip) {
//             if (isMultiTrip) {
//                 if (returnOriginTimeSlots.length === 0 && destinationTimeSlots.length > 0) {
//                     setReturnOriginTimeSlots(destinationTimeSlots.map(slot => ({
//                         sequence: slot.sequence,
//                         departureTime: slot.arrivalTime || '',
//                         arrivalTime: '',
//                         fareMultiplier: slot.fareMultiplier || 1.0,
//                         isActive: true
//                     })));
//                 }
//                 if (returnDestTimeSlots.length === 0 && timeSlots.length > 0) {
//                     setReturnDestTimeSlots(timeSlots.map(slot => ({
//                         sequence: slot.sequence,
//                         arrivalTime: slot.departureTime || '',
//                         departureTime: '',
//                         fareMultiplier: slot.fareMultiplier || 1.0,
//                         isActive: true
//                     })));
//                 }
//             }

//             if (downStops.length === 0) {
//                 syncDownStopsWithUpStops(false);
//             } else if (downStops.length > 0) {
//                 const hasStaleData = downStops.some(stop => {
//                     if (isMultiTrip) {
//                         return !stop.timings || stop.timings.length === 0;
//                     }
//                     return !stop.arrivalTime;
//                 });

//                 if (hasStaleData && window.confirm("Return route stops are missing timing information. Would you like to sync with UP route?")) {
//                     syncDownStopsWithUpStops(false);
//                 }
//             }
//         }
//         setActiveRouteTab(tab);
//         clearStopForm();
//     };

//     const getActiveStops = () => activeRouteTab === 'UP' ? upStops : downStops;
//     const setActiveStops = (stops) => {
//         if (activeRouteTab === 'UP') {
//             setUpStops(stops);
//         } else {
//             setDownStops(stops);
//         }
//     };

//     const clearStopForm = () => {
//         let defaultState = '';

//         if (activeRouteTab === 'UP') {
//             if (upStops.length > 0) {
//                 const lastStop = upStops[upStops.length - 1];
//                 if (lastStop.state && lastStop.state.trim()) {
//                     defaultState = lastStop.state;
//                 }
//             }
//             if (!defaultState && newRoute.upOriginState && newRoute.upOriginState.trim()) {
//                 defaultState = newRoute.upOriginState;
//             }
//             if (!defaultState && newRoute.upDestState && newRoute.upDestState.trim()) {
//                 defaultState = newRoute.upDestState;
//             }
//         } else if (activeRouteTab === 'DOWN') {
//             if (downStops.length > 0) {
//                 const lastStop = downStops[downStops.length - 1];
//                 if (lastStop.state && lastStop.state.trim()) {
//                     defaultState = lastStop.state;
//                 }
//             }
//             if (!defaultState && newRoute.upOriginState && newRoute.upOriginState.trim()) {
//                 defaultState = newRoute.upOriginState;
//             }
//             if (!defaultState && newRoute.upDestState && newRoute.upDestState.trim()) {
//                 defaultState = newRoute.upDestState;
//             }
//         }

//         setNewRoute(prev => ({
//             ...prev,
//             stopCity: '',
//             stopState: defaultState,
//             stopAddress: '',
//             stopTerminal: '',
//             stopArrivalTime: '',
//             stopDepartureTime: '',
//             stopCoords: null,
//             stopDistFromPrev: '',
//             stopDistToNext: '',
//             isBoarding: false,
//             isDropping: false,
//             stopTimings: []
//         }));
//         setIsManualDistance(false);
//         setEditingStopIndex(null);
//         setInsertIndex(null);
//         setIsManualStop(true);
//     };

//     const addIntermediateStop = (type = 'up') => {
//         if (!newRoute.stopCity) {
//             toast.error('City is required.');
//             return;
//         }

//         if (isMultiTrip && (!newRoute.stopTimings || newRoute.stopTimings.length === 0)) {
//             toast.warning('Please add at least one trip timing for this stop');
//             return;
//         }

//         if (!isMultiTrip && !newRoute.stopArrivalTime) {
//             toast.error('Arrival Time is required.');
//             return;
//         }

//         let coordinates = newRoute.stopCoords;
//         let manualDistFromPrev = null;
//         let manualDistToNext = null;
//         let distanceFromOrigin = 0;

//         const stops = getActiveStops();
//         const isManualLocation = isManualStop || !newRoute.stopCoords || (newRoute.stopCoords.lat === 0 && newRoute.stopCoords.lng === 0);

//         if (isManualLocation) {
//             if (!newRoute.stopDistFromPrev || parseFloat(newRoute.stopDistFromPrev) <= 0) {
//                 toast.error('For manual stops, please provide distance from previous stop');
//                 return;
//             }
//             coordinates = { lat: 0, lng: 0 };
//             manualDistFromPrev = parseFloat(newRoute.stopDistFromPrev);

//             if (stops.length > 0) {
//                 const lastStop = stops[stops.length - 1];
//                 distanceFromOrigin = parseFloat(((lastStop.distanceFromOrigin || 0) + manualDistFromPrev).toFixed(2));
//             } else {
//                 distanceFromOrigin = manualDistFromPrev;
//             }

//             const currentIndex = editingStopIndex !== null ? editingStopIndex :
//                 (insertIndex !== null ? insertIndex : stops.length);
//             const nextStop = stops[currentIndex];
//             const isNextAuto = nextStop && nextStop.coordinates &&
//                 (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);

//             if (isNextAuto && newRoute.stopDistToNext && parseFloat(newRoute.stopDistToNext) > 0) {
//                 manualDistToNext = parseFloat(newRoute.stopDistToNext);
//             }
//         } else if (newRoute.stopCoords && (newRoute.stopCoords.lat !== 0 || newRoute.stopCoords.lng !== 0)) {
//             distanceFromOrigin = 0;
//         }

//         let stopType = 'none';
//         if (newRoute.isBoarding && newRoute.isDropping) stopType = 'both';
//         else if (newRoute.isBoarding) stopType = 'boarding';
//         else if (newRoute.isDropping) stopType = 'dropping';

//         let autoState = newRoute.stopState;
//         if (!autoState || !autoState.trim()) {
//             if (type === 'up' && upStops.length > 0) {
//                 const lastStop = upStops[upStops.length - 1];
//                 if (lastStop.state && lastStop.state.trim()) autoState = lastStop.state;
//             } else if (type === 'down' && downStops.length > 0) {
//                 const lastStop = downStops[downStops.length - 1];
//                 if (lastStop.state && lastStop.state.trim()) autoState = lastStop.state;
//             }
//             if (!autoState && newRoute.upOriginState) autoState = newRoute.upOriginState;
//             if (!autoState && newRoute.upDestState) autoState = newRoute.upDestState;
//         }

//         const newStop = {
//             city: newRoute.stopCity,
//             state: autoState || newRoute.stopState || '',
//             address: newRoute.stopAddress || `${newRoute.stopCity}, ${autoState || 'India'}`,
//             terminal: newRoute.stopTerminal || `${newRoute.stopCity} Bus Stand`,
//             arrivalTime: isMultiTrip ? '' : newRoute.stopArrivalTime,
//             departureTime: isMultiTrip ? '' : (newRoute.stopDepartureTime || newRoute.stopArrivalTime),
//             timings: isMultiTrip ? (newRoute.stopTimings || []).map(t => ({
//                 timeSlotSequence: t.timeSlotSequence,
//                 arrivalTime: t.arrivalTime,
//                 departureTime: t.departureTime || t.arrivalTime
//             })) : [],
//             stopType: stopType,
//             coordinates: coordinates,
//             manualDistFromPrev: manualDistFromPrev,
//             manualDistToNext: manualDistToNext,
//             distanceFromOrigin: distanceFromOrigin,
//             isManualStop: isManualLocation
//         };

//         setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));

//         let currentStops = type === 'up' ? [...upStops] : [...downStops];
//         let editingIndex = null;

//         if (type === 'up' && editUpIndex !== null) {
//             editingIndex = editUpIndex;
//         } else if (type === 'down' && editDownIndex !== null) {
//             editingIndex = editDownIndex;
//         }

//         if (editingIndex !== null) {
//             currentStops[editingIndex] = { ...currentStops[editingIndex], ...newStop, sequence: editingIndex + 1 };
//             if (type === 'up') setEditUpIndex(null);
//             else setEditDownIndex(null);
//             setEditingStopIndex(null);
//             toast.success(`Stop "${newRoute.stopCity}" updated successfully`);
//         } else if (insertIndex !== null) {
//             currentStops.splice(insertIndex, 0, newStop);
//             setInsertIndex(null);
//             toast.success(`Stop inserted at position ${insertIndex + 1}`);
//         } else {
//             currentStops.push(newStop);
//             toast.success(`Stop "${newRoute.stopCity}" added successfully`);
//         }

//         if (type === 'up') {
//             setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//         } else {
//             setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//         }

//         clearStopForm();
//     };

//     useEffect(() => {
//         if (stopEditForm.timings && stopEditForm.timings.length > 0) {
//             setStopEditForm(prev => ({
//                 ...prev,
//                 tripCount: stopEditForm.timings.length
//             }));
//         }
//     }, [stopEditForm.timings]);

//     const handleEditPendingRoute = async (route) => {
//     try {
//         const response = await getPendingRouteById(route.id, token);
//         const routeData = response.success ? response.data : route.fullData;

//         if (!routeData) {
//             toast.error('Failed to load pending route for editing');
//             return;
//         }

//         setIsEditingPending(true);
//         setEditingPendingId(route.pendingId || route.id);

//         setEditingRoute(routeData);

//         const resolvedIsMultiTrip = routeData.isMultiTrip ||
//             (routeData.origin?.timings && routeData.origin.timings.length > 0) ||
//             (routeData.intermediateStops && routeData.intermediateStops.some(
//                 stop => stop.timings && stop.timings.length > 0
//             )) ||
//             (routeData.numberOfTrips && routeData.numberOfTrips > 1);

//         setEditIsMultiTrip(resolvedIsMultiTrip);

//         let resolvedNumberOfTrips = 1;
//         if (resolvedIsMultiTrip) {
//             resolvedNumberOfTrips = routeData.numberOfTrips ||
//                 routeData.origin?.timings?.length ||
//                 (routeData.intermediateStops && routeData.intermediateStops.length > 0 ?
//                     routeData.intermediateStops[0]?.timings?.length || 1 : 1);
//             setEditNumberOfTrips(resolvedNumberOfTrips);
//         } else {
//             setEditNumberOfTrips(1);
//         }

//         const origin = routeData.origin || {};
//         const destination = routeData.destination || {};
//         const routeDetails = routeData.routeDetails || {};
//         const estimatedDuration = routeDetails.estimatedDuration || {};

//         const transformStops = (stops) => {
//             return (stops || []).map((stop, index, array) => {
//                 const actualDist = stop.distanceFromOrigin || 0;
//                 const prevStop = index > 0 ? array[index - 1] : null;
//                 const prevDist = prevStop ? (prevStop.distanceFromOrigin || 0) : 0;

//                 let manualDistFromPrev = stop.manualDistFromPrev
//                     ? parseFloat(stop.manualDistFromPrev)
//                     : null;

//                 if (!manualDistFromPrev && actualDist > 0) {
//                     const calculated = parseFloat((actualDist - prevDist).toFixed(1));
//                     if (calculated > 0) manualDistFromPrev = calculated;
//                 }

//                 const sortedTimings = sortTimings(stop.timings || []);
//                 const hasMultiTimings = sortedTimings.length > 0;

//                 let finalTimings = sortedTimings;
//                 if (resolvedIsMultiTrip && sortedTimings.length < resolvedNumberOfTrips) {
//                     const existingSequences = sortedTimings.map(t => t.timeSlotSequence);
//                     finalTimings = [...sortedTimings];
//                     for (let i = 1; i <= resolvedNumberOfTrips; i++) {
//                         if (!existingSequences.includes(i)) {
//                             finalTimings.push({ timeSlotSequence: i, arrivalTime: '', departureTime: '' });
//                         }
//                     }
//                     finalTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
//                 } else if (resolvedIsMultiTrip && sortedTimings.length > resolvedNumberOfTrips) {
//                     finalTimings = sortedTimings
//                         .filter(t => t.timeSlotSequence <= resolvedNumberOfTrips)
//                         .map((t, i) => ({ ...t, timeSlotSequence: i + 1 }));
//                 }

//                 return {
//                     city: stop.city,
//                     state: stop.state || '',
//                     address: stop.address || '',
//                     terminal: stop.terminal || '',
//                     arrivalTime: hasMultiTimings ? '' : (stop.arrivalTime || ''),
//                     departureTime: hasMultiTimings ? '' : (stop.departureTime || ''),
//                     timings: finalTimings,
//                     stopType: stop.stopType || 'none',
//                     coordinates: stop.coordinates || { lat: 0, lng: 0 },
//                     distanceFromOrigin: actualDist,
//                     manualDistFromPrev: manualDistFromPrev,
//                     manualDistToNext: stop.manualDistToNext ? parseFloat(stop.manualDistToNext) : null,
//                     isManualStop: stop.isManualStop === true ||
//                         !stop.coordinates ||
//                         (stop.coordinates.lat === 0 && stop.coordinates.lng === 0)
//                 };
//             });
//         };

//         const transformedStops = transformStops(routeData.intermediateStops);

//         let forwardManualFinalLeg = '';
//         if (routeDetails.totalDistance && transformedStops.length > 0) {
//             const lastStopDist = transformedStops[transformedStops.length - 1].distanceFromOrigin || 0;
//             const calculated = routeDetails.totalDistance - lastStopDist;
//             if (calculated > 0) forwardManualFinalLeg = calculated.toFixed(1);
//         }

//         const originTimings = sortTimings(origin.timings || []);
//         const destTimings = sortTimings(destination.timings || []);

//         let finalOriginTimings = [...originTimings];
//         if (resolvedIsMultiTrip && originTimings.length < resolvedNumberOfTrips) {
//             const existingSequences = originTimings.map(t => t.timeSlotSequence);
//             for (let i = 1; i <= resolvedNumberOfTrips; i++) {
//                 if (!existingSequences.includes(i)) {
//                     finalOriginTimings.push({ timeSlotSequence: i, departureTime: '', arrivalTime: '' });
//                 }
//             }
//             finalOriginTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
//         }

//         let finalDestTimings = [...destTimings];
//         if (resolvedIsMultiTrip && destTimings.length < resolvedNumberOfTrips) {
//             const existingSequences = destTimings.map(t => t.timeSlotSequence);
//             for (let i = 1; i <= resolvedNumberOfTrips; i++) {
//                 if (!existingSequences.includes(i)) {
//                     finalDestTimings.push({ timeSlotSequence: i, arrivalTime: '', departureTime: '' });
//                 }
//             }
//             finalDestTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
//         }

//         setEditForm({
//             routeNumber: routeData.routeNumber || '',
//             routeName: routeData.routeName || '',
//             localRouteName: routeData.localRouteName || '',
//             isMultiTrip: resolvedIsMultiTrip,
//             numberOfTrips: resolvedNumberOfTrips,
//             timeSlots: routeData.timeSlots || [],
//             originCity: origin.city || '',
//             originState: origin.state || '',
//             originAddress: origin.address || '',
//             originTerminal: origin.terminal || '',
//             originDepTime: origin.departureTime || '',
//             originCoords: origin.coordinates || { lat: 0, lng: 0 },
//             originTimings: finalOriginTimings,
//             destCity: destination.city || '',
//             destState: destination.state || '',
//             destAddress: destination.address || '',
//             destTerminal: destination.terminal || '',
//             destArrTime: destination.arrivalTime || '',
//             destCoords: destination.coordinates || { lat: 0, lng: 0 },
//             destTimings: finalDestTimings,
//             totalDistance: routeDetails.totalDistance || '',
//             durationHours: estimatedDuration.hours || '',
//             durationMinutes: estimatedDuration.minutes || '',
//             intermediateStops: transformedStops,
//             isActive: false,
//             isRoundTrip: routeData.isRoundTrip || false,
//             returnJourney: routeData.returnJourney || null,
//             upManualFinalLeg: forwardManualFinalLeg,
//             upManualFirstLeg: transformedStops.length > 0 && transformedStops[0].manualDistFromPrev
//                 ? String(transformedStops[0].manualDistFromPrev)
//                 : ''
//         });

//         if (transformedStops.length > 0) {
//             setUpStops(transformedStops);
//             if (transformedStops.every(stop => stop.distanceFromOrigin > 0)) {
//                 setIsDistanceCalculated(prev => ({ ...prev, up: true }));
//             }
//         } else {
//             setUpStops([]);
//         }

//         if (routeData.isRoundTrip && routeData.returnJourney) {
//             const returnJourney = routeData.returnJourney;
//             const returnOrigin = returnJourney.origin || {};
//             const returnDestination = returnJourney.destination || {};
//             const returnRouteDetails = returnJourney.routeDetails || {};
//             const returnEstimatedDuration = returnRouteDetails.estimatedDuration || {};

//             const transformedReturnStops = transformStops(returnJourney.intermediateStops);

//             let returnManualFinalLeg = '';
//             if (returnRouteDetails.totalDistance && transformedReturnStops.length > 0) {
//                 const lastStopDist = transformedReturnStops[transformedReturnStops.length - 1].distanceFromOrigin || 0;
//                 const calculated = returnRouteDetails.totalDistance - lastStopDist;
//                 if (calculated > 0) returnManualFinalLeg = calculated.toFixed(1);
//             }

//             let returnOriginTimings = sortTimings(returnOrigin.timings || []);
//             let returnDestTimings = sortTimings(returnDestination.timings || []);

//             setEditForm(prev => ({
//                 ...prev,
//                 returnOriginCity: returnOrigin.city || destination.city || '',
//                 returnOriginState: returnOrigin.state || destination.state || '',
//                 returnOriginAddress: returnOrigin.address || destination.address || '',
//                 returnOriginTerminal: returnOrigin.terminal || destination.terminal || '',
//                 returnOriginDepTime: returnOrigin.departureTime || '',
//                 returnOriginCoords: returnOrigin.coordinates || destination.coordinates || { lat: 0, lng: 0 },
//                 returnOriginTimings,
//                 returnDestCity: returnDestination.city || origin.city || '',
//                 returnDestState: returnDestination.state || origin.state || '',
//                 returnDestAddress: returnDestination.address || origin.address || '',
//                 returnDestTerminal: returnDestination.terminal || origin.terminal || '',
//                 returnDestArrTime: returnDestination.arrivalTime || '',
//                 returnDestCoords: returnDestination.coordinates || origin.coordinates || { lat: 0, lng: 0 },
//                 returnDestTimings,
//                 returnTotalDistance: returnRouteDetails.totalDistance || routeDetails.totalDistance || '',
//                 returnDurationHours: returnEstimatedDuration.hours || estimatedDuration.hours || '',
//                 returnDurationMinutes: returnEstimatedDuration.minutes || estimatedDuration.minutes || '',
//                 returnIntermediateStops: transformedReturnStops,
//                 returnManualFinalLeg,
//                 returnManualFirstLeg: transformedReturnStops.length > 0 && transformedReturnStops[0].manualDistFromPrev
//                     ? String(transformedReturnStops[0].manualDistFromPrev)
//                     : ''
//             }));

//             setDownStops(transformedReturnStops);
//             if (transformedReturnStops.length > 0 && transformedReturnStops.every(s => s.distanceFromOrigin > 0)) {
//                 setIsDistanceCalculated(prev => ({ ...prev, down: true }));
//             }
//         } else {
//             setDownStops([]);
//         }

//         setIsRoundTrip(routeData.isRoundTrip || false);
//         setActiveRouteTab('UP');
//         setShowEditModal(true);

//     } catch (err) {
//         console.error('Error fetching pending route for edit:', err);
//         toast.error('Failed to load pending route for editing');
//     }
// };

//     const handleEditStop = (index, type) => {
//         const stops = type === 'up' ? upStops : downStops;
//         const stop = stops[index];

//         if (!stop) {
//             console.error('Stop not found at index:', index);
//             return;
//         }

//         console.log('🛑 Editing stop:', stop);
//         console.log('📋 Original stop timings:', stop.timings);

//         let numTrips = 1;

//         if (stop.timings && stop.timings.length > 0) {
//             numTrips = stop.timings.length;
//             console.log('📊 Number of trips from stop.timings:', numTrips);
//         } else if (editForm.numberOfTrips && editForm.numberOfTrips > 1) {
//             numTrips = editForm.numberOfTrips;
//             console.log('📊 Number of trips from editForm.numberOfTrips:', numTrips);
//         }
//         else if (editNumberOfTrips && editNumberOfTrips > 1) {
//             numTrips = editNumberOfTrips;
//             console.log('📊 Number of trips from editNumberOfTrips:', numTrips);
//         }
//         else if (timeSlots && timeSlots.length > 0) {
//             numTrips = timeSlots.length;
//             console.log('📊 Number of trips from timeSlots:', numTrips);
//         }
//         else if (numberOfTrips && numberOfTrips > 1) {
//             numTrips = numberOfTrips;
//             console.log('📊 Number of trips from numberOfTrips:', numTrips);
//         }

//         console.log('📊 Final number of trips:', numTrips);

//         let stopTimings = stop.timings || [];

//         if (stopTimings.length > 0) {
//             numTrips = stopTimings.length;
//             console.log('📊 Using stop.timings length as numTrips:', numTrips);
//         }

//         const existingTimingsMap = new Map();
//         stopTimings.forEach(t => {
//             const seq = t.timeSlotSequence || 1;
//             existingTimingsMap.set(seq, t);
//         });

//         const allTimings = [];
//         for (let i = 1; i <= numTrips; i++) {
//             if (existingTimingsMap.has(i)) {
//                 allTimings.push({
//                     timeSlotSequence: i,
//                     arrivalTime: existingTimingsMap.get(i).arrivalTime || '',
//                     departureTime: existingTimingsMap.get(i).departureTime || ''
//                 });
//             } else {
//                 allTimings.push({
//                     timeSlotSequence: i,
//                     arrivalTime: '',
//                     departureTime: ''
//                 });
//             }
//         }

//         allTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));

//         console.log('✅ Final timings for edit form (ALL TRIPS):', allTimings);
//         console.log('✅ Number of trips in edit form:', allTimings.length);

//         let isBoarding = false;
//         let isDropping = false;

//         if (stop.stopType === 'boarding' || stop.stopType === 'both') {
//             isBoarding = true;
//         }
//         if (stop.stopType === 'dropping' || stop.stopType === 'both') {
//             isDropping = true;
//         }

//         if (stop.isBoarding !== undefined) {
//             isBoarding = stop.isBoarding || isBoarding;
//         }
//         if (stop.isDropping !== undefined) {
//             isDropping = stop.isDropping || isDropping;
//         }

//         console.log('📋 Boarding:', isBoarding, 'Dropping:', isDropping);

//         setStopBeingEdited({
//             index,
//             originalStop: stop,
//             type
//         });

//         setStopEditForm({
//             city: stop.city || '',
//             state: stop.state || '',
//             address: stop.address || '',
//             terminal: stop.terminal || '',
//             arrivalTime: stop.arrivalTime || '',
//             departureTime: stop.departureTime || '',
//             isBoarding: isBoarding,
//             isDropping: isDropping,
//             isManualStop: stop.isManualStop || false,
//             manualDistFromPrev: stop.manualDistFromPrev || '',
//             manualDistToNext: stop.manualDistToNext || '',
//             timings: allTimings,
//             coordinates: stop.coordinates || null,
//             isMultiTrip: editForm.isMultiTrip || editIsMultiTrip || true,
//             tripCount: allTimings.length || numTrips
//         });

//         setShowStopEditModal(true);
//     };

//     const saveEditedStop = () => {
//         console.log("stopEditForm ::::::::::: s ", stopEditForm);

//         if (!stopEditForm.city || stopEditForm.city.trim() === '') {
//             toast.error('City is required');
//             return;
//         }

//         if (!stopEditForm.state || stopEditForm.state.trim() === '') {
//             toast.error('State is required');
//             return;
//         }

//         if (!stopEditForm.address || stopEditForm.address.trim() === '') {
//             toast.error('Address is required');
//             return;
//         }

//         if (!stopEditForm.terminal || stopEditForm.terminal.trim() === '') {
//             toast.error('Terminal is required');
//             return;
//         }

//         const totalTrips = editForm.numberOfTrips || editNumberOfTrips || numberOfTrips || 1;

//         const hasTimings = stopEditForm.timings && stopEditForm.timings.length > 0;
//         const hasArrivalInTimings = hasTimings && stopEditForm.timings.some(t => t.arrivalTime && t.arrivalTime.trim() !== '');
//         const hasTopLevelArrival = stopEditForm.arrivalTime && stopEditForm.arrivalTime.trim() !== '';

//         const isMultiTripStop = stopEditForm.isMultiTrip ||
//             (stopEditForm.timings && stopEditForm.timings.length > 0) ||
//             (editForm.isMultiTrip || editIsMultiTrip || isMultiTrip) ||
//             totalTrips > 1 ||
//             hasArrivalInTimings ||
//             hasTopLevelArrival;

//         let finalTimings = [];

//         const isActuallyMultiTrip = (editForm.isMultiTrip || editIsMultiTrip || isMultiTrip) || totalTrips > 1;

//         if (isActuallyMultiTrip) {
//             if (hasTimings) {
//                 const hasAnyArrivalInTimings = stopEditForm.timings.some(t => t.arrivalTime && t.arrivalTime.trim() !== '');

//                 if (hasAnyArrivalInTimings) {
//                     finalTimings = stopEditForm.timings.map(t => ({
//                         timeSlotSequence: t.timeSlotSequence || 1,
//                         arrivalTime: t.arrivalTime || '',
//                         departureTime: t.departureTime || t.arrivalTime || ''
//                     }));
//                 } else if (hasTopLevelArrival) {
//                     finalTimings = stopEditForm.timings.map((t, index) => ({
//                         timeSlotSequence: t.timeSlotSequence || (index + 1),
//                         arrivalTime: stopEditForm.arrivalTime || '',
//                         departureTime: stopEditForm.departureTime || stopEditForm.arrivalTime || ''
//                     }));
//                 } else {
//                     for (let i = 1; i <= totalTrips; i++) {
//                         finalTimings.push({
//                             timeSlotSequence: i,
//                             arrivalTime: stopEditForm.arrivalTime || '',
//                             departureTime: stopEditForm.departureTime || stopEditForm.arrivalTime || ''
//                         });
//                     }
//                 }
//             } else {
//                 for (let i = 1; i <= totalTrips; i++) {
//                     finalTimings.push({
//                         timeSlotSequence: i,
//                         arrivalTime: stopEditForm.arrivalTime || '',
//                         departureTime: stopEditForm.departureTime || stopEditForm.arrivalTime || ''
//                     });
//                 }
//             }

//             const missingArrival = finalTimings.some(t => !t.arrivalTime || t.arrivalTime.trim() === '');
//             if (missingArrival) {
//                 toast.error('Please provide arrival time for all trips');
//                 return;
//             }
//         } else {
//             if (!stopEditForm.arrivalTime || stopEditForm.arrivalTime.trim() === '') {
//                 toast.error('Arrival time is required');
//                 return;
//             }

//             finalTimings = [{
//                 timeSlotSequence: 1,
//                 arrivalTime: stopEditForm.arrivalTime,
//                 departureTime: stopEditForm.departureTime || stopEditForm.arrivalTime
//             }];
//         }

//         finalTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));

//         const isManualLocation = stopEditForm.isManualStop;

//         let manualDistFromPrev = null;
//         let manualDistToNext = null;

//         if (stopEditForm.manualDistFromPrev && parseFloat(stopEditForm.manualDistFromPrev) > 0) {
//             manualDistFromPrev = parseFloat(stopEditForm.manualDistFromPrev);
//         }

//         if (stopEditForm.manualDistToNext && parseFloat(stopEditForm.manualDistToNext) > 0) {
//             manualDistToNext = parseFloat(stopEditForm.manualDistToNext);
//         }

//         let distanceFromOrigin = stopBeingEdited.originalStop.distanceFromOrigin || 0;

//         if (manualDistFromPrev && manualDistFromPrev > 0) {
//             const stops = stopBeingEdited.type === 'up' ? upStops : downStops;
//             if (stopBeingEdited.index === 0) {
//                 distanceFromOrigin = manualDistFromPrev;
//             } else {
//                 const prevStop = stops[stopBeingEdited.index - 1];
//                 const prevDistance = prevStop?.distanceFromOrigin || 0;
//                 distanceFromOrigin = parseFloat((prevDistance + manualDistFromPrev).toFixed(2));
//             }
//         }

//         let stopType = 'none';
//         if (stopEditForm.isBoarding && stopEditForm.isDropping)
//             stopType = 'both';
//         else if (stopEditForm.isBoarding) stopType = 'boarding';
//         else if (stopEditForm.isDropping) stopType = 'dropping';

//         const updatedStop = {
//             ...stopBeingEdited.originalStop,
//             city: stopEditForm.city,
//             state: stopEditForm.state || '',
//             address: stopEditForm.address || `${stopEditForm.city}, ${stopEditForm.state || 'India'}`,
//             terminal: stopEditForm.terminal || `${stopEditForm.city} Bus Stand`,
//             stopType,
//             coordinates: isManualLocation ? { lat: 0, lng: 0 } : stopBeingEdited.originalStop.coordinates,
//             manualDistFromPrev: manualDistFromPrev,
//             manualDistToNext: manualDistToNext,
//             distanceFromOrigin: distanceFromOrigin,
//             isManualStop: isManualLocation,
//             timings: finalTimings,
//             arrivalTime: finalTimings.length > 0 ? finalTimings[0].arrivalTime || '' : '',
//             departureTime: finalTimings.length > 0 ? finalTimings[0].departureTime || finalTimings[0].arrivalTime || '' : ''
//         };

//         const { index, type } = stopBeingEdited;
//         setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));

//         if (type === 'up') {
//             const updated = [...upStops];
//             updated[index] = { ...updatedStop, sequence: index + 1 };
//             setUpStops(updated);
//             if (isRoundTrip) {
//                 toast.info('UP route updated. Use "Auto-Fill / Sync Reversed Stops" to update DOWN route if needed.');
//             }
//         } else {
//             const updated = [...downStops];
//             updated[index] = { ...updatedStop, sequence: index + 1 };
//             setDownStops(updated);
//         }

//         setShowStopEditModal(false);
//         setStopBeingEdited(null);
//         toast.success('Stop updated successfully');
//     };

//     const handleDeleteStop = (index) => {
//         const isUp = activeRouteTab === 'UP';
//         setIsDistanceCalculated(prev => ({ ...prev, [isUp ? 'up' : 'down']: false }));

//         if (isUp) {
//             const updated = upStops.filter((_, i) => i !== index);
//             setUpStops(updated.map((s, i) => ({ ...s, sequence: i + 1 })));
//             if (editingStopIndex === index && editUpIndex === index) clearStopForm();
//         } else {
//             const updated = downStops.filter((_, i) => i !== index);
//             setDownStops(updated.map((s, i) => ({ ...s, sequence: i + 1 })));
//             if (editingStopIndex === index && editDownIndex === index) clearStopForm();
//         }
//     };

//     const checkOriginManual = () => {
//         return isOriginManual || !newRoute.upOriginCoords || (newRoute.upOriginCoords.lat === 0 && newRoute.upOriginCoords.lng === 0);
//     };

//     const checkDestinationManual = () => {
//         return isDestinationManual || !newRoute.upDestCoords || (newRoute.upDestCoords.lat === 0 && newRoute.upDestCoords.lng === 0);
//     };

//     const handleCalculateDistances = async () => {
//         const isUp = activeRouteTab === 'UP';
//         const stops = isUp ? upStops : downStops;

//         if (!newRoute.upOriginCity || !newRoute.upDestCity) {
//             toast.error("Main Route Origin and Destination required.");
//             return;
//         }

//         if (!newRoute.upOriginCoords) {
//             toast.error('Please select Origin from suggestions to get coordinates');
//             return;
//         }

//         if (!newRoute.upDestCoords) {
//             toast.error('Please select Destination from suggestions to get coordinates');
//             return;
//         }

//         let originNode, destNode;
//         if (isUp) {
//             originNode = {
//                 id: 'origin',
//                 name: newRoute.upOriginCity,
//                 lat: newRoute.upOriginCoords?.lat || 0,
//                 lng: newRoute.upOriginCoords?.lng || 0
//             };
//             destNode = {
//                 id: 'destination',
//                 name: newRoute.upDestCity,
//                 lat: newRoute.upDestCoords?.lat || 0,
//                 lng: newRoute.upDestCoords?.lng || 0
//             };
//         } else {
//             originNode = {
//                 id: 'origin',
//                 name: newRoute.upDestCity,
//                 lat: newRoute.upDestCoords?.lat || 0,
//                 lng: newRoute.upDestCoords?.lng || 0
//             };
//             destNode = {
//                 id: 'destination',
//                 name: newRoute.upOriginCity,
//                 lat: newRoute.upOriginCoords?.lat || 0,
//                 lng: newRoute.upOriginCoords?.lng || 0
//             };
//         }

//         setIsCalculatingDistances(true);
//         toast.info(`Calculating ${activeRouteTab} route distances...`);

//         let departureTimeForDuration = '';
//         let arrivalTimeForDuration = '';

//         if (isUp) {
//             if (isMultiTrip) {
//                 if (timeSlots && timeSlots.length > 0) {
//                     departureTimeForDuration = timeSlots[0]?.departureTime || '';
//                 }
//                 if (destinationTimeSlots && destinationTimeSlots.length > 0) {
//                     arrivalTimeForDuration = destinationTimeSlots[0]?.arrivalTime || '';
//                 }
//             } else {
//                 departureTimeForDuration = newRoute.upOriginDepTime;
//                 arrivalTimeForDuration = newRoute.upDestArrTime;
//             }
//         } else {
//             if (isMultiTrip) {
//                 if (returnOriginTimeSlots && returnOriginTimeSlots.length > 0) {
//                     departureTimeForDuration = returnOriginTimeSlots[0]?.departureTime || '';
//                 }
//                 if (returnDestTimeSlots && returnDestTimeSlots.length > 0) {
//                     arrivalTimeForDuration = returnDestTimeSlots[0]?.arrivalTime || '';
//                 }
//             } else {
//                 departureTimeForDuration = newRoute.downOriginDepTime;
//                 arrivalTimeForDuration = newRoute.downDestArrTime;
//             }
//         }

//         try {
//             const stopNodes = stops.map((s, i) => ({
//                 id: `stop_${i}`,
//                 name: s.city,
//                 lat: s.coordinates?.lat,
//                 lng: s.coordinates?.lng,
//                 manualFromPrev: s.manualDistFromPrev,
//                 manualToNext: s.manualDistToNext,
//                 isManual: s.isManualStop === true || !s.coordinates || (s.coordinates.lat === 0 && s.coordinates.lng === 0),
//                 originalStop: s
//             }));

//             const fullPath = [originNode, ...stopNodes, destNode];
//             const validNodes = fullPath.filter(s => s.lat && s.lng && s.lat !== 0 && s.lng !== 0 && !s.isManual);

//             let matrixResponse = null;
//             if (validNodes.length >= 2) {
//                 matrixResponse = await getDistanceMatrix(validNodes, validNodes);
//             }

//             let cumulativeDist = 0;
//             let lastAutoNodeIndex = -1;
//             let sumManualSinceLastAuto = 0;
//             const updatedStops = [];
//             let validNodeCounter = -1;
//             let prevCumulativeDist = 0;
//             let firstStopAlreadyCounted = false;

//             if (stops.length > 0 && stops[0]) {
//                 const isFirstStopManual = stopNodes[0].isManual;

//                 if (isFirstStopManual && stopNodes[0].manualFromPrev && parseFloat(stopNodes[0].manualFromPrev) > 0) {
//                     const firstLeg = parseFloat(stopNodes[0].manualFromPrev);
//                     cumulativeDist = firstLeg;
//                     sumManualSinceLastAuto = firstLeg;
//                     prevCumulativeDist = cumulativeDist;
//                     firstStopAlreadyCounted = true;
//                 } else if ((checkOriginManual() && !isFirstStopManual) || (!checkOriginManual() && isFirstStopManual)) {
//                     const firstLeg = parseFloat(isUp ? newRoute.upManualFirstLeg : newRoute.downManualFirstLeg);
//                     if (!firstLeg || parseFloat(firstLeg) <= 0) {
//                         toast.error('Please provide distance from origin to first stop.');
//                         setIsCalculatingDistances(false);
//                         return;
//                     }
//                     cumulativeDist = parseFloat(firstLeg);
//                     sumManualSinceLastAuto = cumulativeDist;
//                     prevCumulativeDist = cumulativeDist;
//                     firstStopAlreadyCounted = true;
//                 } else if (!checkOriginManual() && !isFirstStopManual) {
//                     lastAutoNodeIndex = 0;
//                     validNodeCounter = 0;
//                 } else if (checkOriginManual() && isFirstStopManual) {
//                     if (stopNodes[0].manualFromPrev && parseFloat(stopNodes[0].manualFromPrev) > 0) {
//                         cumulativeDist = parseFloat(stopNodes[0].manualFromPrev);
//                         prevCumulativeDist = cumulativeDist;
//                         firstStopAlreadyCounted = true;
//                     } else {
//                         cumulativeDist = 0;
//                         prevCumulativeDist = 0;
//                     }
//                 }
//             }

//             for (let i = 0; i < stopNodes.length; i++) {
//                 const currNode = stopNodes[i];
//                 const isManual = currNode.isManual;
//                 let segment = 0;

//                 if (isManual) {
//                     if (currNode.manualFromPrev === null || currNode.manualFromPrev === undefined || currNode.manualFromPrev === '') {
//                         toast.error(`Manual stop '${currNode.name}' is missing distance from previous stop. Please edit and provide the distance.`);
//                         setIsCalculatingDistances(false);
//                         return;
//                     }

//                     segment = parseFloat(currNode.manualFromPrev) || 0;

//                     if (i === 0 && firstStopAlreadyCounted) {} else {
//                         if (segment <= 0 && i > 0) {
//                             toast.warning(`Manual stop '${currNode.name}' has distance 0 from previous stop.`);
//                         }
//                         cumulativeDist += segment;
//                         sumManualSinceLastAuto += segment;
//                     }

//                     prevCumulativeDist = i === 0 && firstStopAlreadyCounted ? segment : cumulativeDist;

//                     updatedStops.push({
//                         ...stops[i],
//                         distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//                         manualDistFromPrev: parseFloat(segment.toFixed(1)),
//                         manualDistToNext: currNode.manualToNext ? parseFloat(currNode.manualToNext) : null
//                     });

//                     if (currNode.manualToNext && parseFloat(currNode.manualToNext) > 0) {
//                         sumManualSinceLastAuto = parseFloat(currNode.manualToNext);
//                     }

//                 } else {
//                     validNodeCounter++;
//                     let apiDistance = 0;

//                     let matrixOriginIndex = lastAutoNodeIndex;
//                     let matrixDestIndex = validNodeCounter;

//                     if (checkOriginManual() && lastAutoNodeIndex === -1 && i === 0) {
//                         matrixOriginIndex = 0;
//                         matrixDestIndex = validNodeCounter;
//                     } else if (checkOriginManual() && lastAutoNodeIndex !== -1) {
//                         matrixOriginIndex = lastAutoNodeIndex;
//                         matrixDestIndex = validNodeCounter;
//                     } else if (!checkOriginManual() && lastAutoNodeIndex === -1) {
//                         matrixOriginIndex = 0;
//                         matrixDestIndex = validNodeCounter;
//                     }

//                     if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
//                         const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
//                         if (element?.status === 'OK') {
//                             apiDistance = element.distance.value / 1000;
//                         }
//                     }

//                     if (i > 0 && stopNodes[i - 1]?.manualToNext && parseFloat(stopNodes[i - 1].manualToNext) > 0) {
//                         segment = parseFloat(stopNodes[i - 1].manualToNext);
//                         sumManualSinceLastAuto = 0;
//                     } else {
//                         segment = apiDistance - sumManualSinceLastAuto;
//                         if (segment < 0) segment = 0;
//                         sumManualSinceLastAuto = 0;
//                     }

//                     cumulativeDist += segment;

//                     if (lastAutoNodeIndex === -1) {
//                         lastAutoNodeIndex = validNodeCounter;
//                     }
//                     if (matrixOriginIndex >= 0) {
//                         lastAutoNodeIndex = validNodeCounter;
//                     }

//                     const distanceFromPrev = cumulativeDist - prevCumulativeDist;
//                     prevCumulativeDist = cumulativeDist;

//                     updatedStops.push({
//                         ...stops[i],
//                         distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//                         manualDistFromPrev: parseFloat(distanceFromPrev.toFixed(1)),
//                         manualDistToNext: currNode.manualToNext ? parseFloat(currNode.manualToNext) : null
//                     });
//                 }
//             }

//             validNodeCounter++;
//             let finalSegment = 0;
//             const lastStop = stopNodes[stopNodes.length - 1];
//             const isLastStopManualFlag = lastStop && lastStop.isManual;
//             const isDestManual = checkDestinationManual();

//             if (isDestManual) {
//                 const finalLeg = parseFloat(isUp ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg);
//                 if (isNaN(finalLeg) || finalLeg <= 0) {
//                     toast.error(`Destination is manual. Please provide distance from last stop to destination in the Summary section.`);
//                     setIsCalculatingDistances(false);
//                     return;
//                 }
//                 finalSegment = finalLeg;
//             } else if (!isDestManual && isLastStopManualFlag) {
//                 if (lastStop.manualToNext && parseFloat(lastStop.manualToNext) > 0) {
//                     finalSegment = parseFloat(lastStop.manualToNext);
//                 } else {
//                     const finalLeg = parseFloat(isUp ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg);
//                     if (!isNaN(finalLeg) && finalLeg > 0) {
//                         finalSegment = finalLeg;
//                     } else {
//                         const totalDist = parseFloat(isUp ? newRoute.upTotalDistance : newRoute.downTotalDistance) || 0;
//                         const lastStopDist = updatedStops.length > 0
//                             ? (updatedStops[updatedStops.length - 1].distanceFromOrigin || 0)
//                             : 0;
//                         const derived = parseFloat((totalDist - lastStopDist).toFixed(1));
//                         if (derived > 0) {
//                             finalSegment = derived;
//                         } else {
//                             toast.error(`Last stop is manual and destination has GPS. Please enter the distance to destination in the Summary section, or set "Distance to Next Stop" on the last stop.`);
//                             setIsCalculatingDistances(false);
//                             return;
//                         }
//                     }
//                 }
//             } else if (!isDestManual && !isLastStopManualFlag && stopNodes.length > 0) {
//                 let apiDistance = 0;
//                 let matrixOriginIndex = lastAutoNodeIndex;
//                 let matrixDestIndex = validNodeCounter;

//                 if (checkOriginManual() && lastAutoNodeIndex === -1) {
//                     matrixOriginIndex = 0;
//                     matrixDestIndex = validNodeCounter;
//                 } else if (checkOriginManual() && lastAutoNodeIndex !== -1) {
//                     matrixOriginIndex = lastAutoNodeIndex;
//                     matrixDestIndex = validNodeCounter;
//                 }

//                 if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
//                     const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
//                     if (element?.status === 'OK') {
//                         apiDistance = element.distance.value / 1000;
//                     }
//                 }
//                 finalSegment = apiDistance - sumManualSinceLastAuto;
//                 if (finalSegment < 0) finalSegment = 0;
//             } else if (stopNodes.length === 0) {
//                 if (checkOriginManual() && isDestManual) {
//                     const totalDistance = parseFloat(newRoute.upTotalDistance);
//                     if (isNaN(totalDistance) || totalDistance <= 0) {
//                         toast.error('Both origin and destination are manual. Please provide total distance.');
//                         setIsCalculatingDistances(false);
//                         return;
//                     }
//                     finalSegment = totalDistance;
//                 } else if (!checkOriginManual() && !isDestManual && matrixResponse) {
//                     const element = matrixResponse.rows[0]?.elements[1];
//                     if (element?.status === 'OK') {
//                         finalSegment = element.distance.value / 1000;
//                     } else {
//                         toast.error('Could not calculate distance. Please check addresses or enter manually.');
//                         setIsCalculatingDistances(false);
//                         return;
//                     }
//                 } else {
//                     toast.error('Cannot calculate distance. Please ensure both origin and destination have coordinates or provide manual total distance.');
//                     setIsCalculatingDistances(false);
//                     return;
//                 }
//             }

//             cumulativeDist += finalSegment;

//             if (updatedStops.length > 0 && finalSegment > 0) {
//                 const lastIndex = updatedStops.length - 1;
//                 updatedStops[lastIndex] = {
//                     ...updatedStops[lastIndex],
//                     manualDistToNext: parseFloat(finalSegment.toFixed(1))
//                 };
//             }

//             setActiveStops(updatedStops);

//             let calculatedHours = 0;
//             let calculatedMinutes = 0;

//             if (departureTimeForDuration && departureTimeForDuration.trim() !== '' &&
//                 arrivalTimeForDuration && arrivalTimeForDuration.trim() !== '') {

//                 const [depHour, depMin] = departureTimeForDuration.split(':').map(Number);
//                 const [arrHour, arrMin] = arrivalTimeForDuration.split(':').map(Number);

//                 let depTotalMins = depHour * 60 + depMin;
//                 let arrTotalMins = arrHour * 60 + arrMin;

//                 if (arrTotalMins < depTotalMins) {
//                     arrTotalMins += 24 * 60;
//                 }

//                 const durationMins = arrTotalMins - depTotalMins;
//                 calculatedHours = Math.floor(durationMins / 60);
//                 calculatedMinutes = durationMins % 60;
//             } else {
//                 const avgSpeed = 40;
//                 const durationMins = Math.round((cumulativeDist / avgSpeed) * 60);
//                 calculatedHours = Math.floor(durationMins / 60);
//                 calculatedMinutes = durationMins % 60;
//             }

//             if (isUp) {
//                 setNewRoute(prev => ({
//                     ...prev,
//                     upTotalDistance: cumulativeDist.toFixed(1),
//                     upManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.upManualFinalLeg,
//                     upDurationHours: calculatedHours.toString(),
//                     upDurationMinutes: calculatedMinutes.toString()
//                 }));

//                 if (editingRoute) {
//                     setEditForm(prev => ({
//                         ...prev,
//                         totalDistance: cumulativeDist.toFixed(1),
//                         durationHours: calculatedHours.toString(),
//                         durationMinutes: calculatedMinutes.toString()
//                     }));
//                 }
//             } else {
//                 setNewRoute(prev => ({
//                     ...prev,
//                     downTotalDistance: cumulativeDist.toFixed(1),
//                     downManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.downManualFinalLeg,
//                     downDurationHours: calculatedHours.toString(),
//                     downDurationMinutes: calculatedMinutes.toString()
//                 }));

//                 if (editingRoute) {
//                     setEditForm(prev => ({
//                         ...prev,
//                         returnTotalDistance: cumulativeDist.toFixed(1),
//                         returnDurationHours: calculatedHours.toString(),
//                         returnDurationMinutes: calculatedMinutes.toString()
//                     }));
//                 }
//             }

//             setIsDistanceCalculated(prev => ({ ...prev, [activeRouteTab.toLowerCase()]: true }));

//             toast.success(`${activeRouteTab} route distances calculated! Total: ${cumulativeDist.toFixed(1)} km, Duration: ${calculatedHours}h ${calculatedMinutes}m`);

//         } catch (error) {
//             console.error('Distance calculation error:', error);
//             toast.error("Calculation failed. Please enter distances manually.");
//         } finally {
//             setIsCalculatingDistances(false);
//         }
//     };

//     const handleEditCalculateDistances = async (type = 'up') => {
//         const isUp = type === 'up';
//         const stops = isUp ? upStops : downStops;

//         if (isUp) {
//             if (!editForm.originCity || !editForm.destCity) {
//                 toast.error("Origin and Destination required for UP route.");
//                 return;
//             }
//             if (!editForm.originCoords) {
//                 toast.error('Please select Origin from suggestions');
//                 return;
//             }
//             if (!editForm.destCoords) {
//                 toast.error('Please select Destination from suggestions');
//                 return;
//             }
//         } else {
//             if (!editForm.returnOriginCity || !editForm.returnDestCity) {
//                 toast.error("Return Origin and Destination required for DOWN route.");
//                 return;
//             }
//             if (!editForm.returnOriginCoords) {
//                 toast.error('Please select Return Origin from suggestions');
//                 return;
//             }
//             if (!editForm.returnDestCoords) {
//                 toast.error('Please select Return Destination from suggestions');
//                 return;
//             }
//         }

//         let originNode, destNode;
//         if (isUp) {
//             originNode = {
//                 id: 'origin',
//                 name: editForm.originCity,
//                 lat: editForm.originCoords?.lat || 0,
//                 lng: editForm.originCoords?.lng || 0,
//                 isManual: !editForm.originCoords?.lat || editForm.originCoords.lat === 0
//             };
//             destNode = {
//                 id: 'destination',
//                 name: editForm.destCity,
//                 lat: editForm.destCoords?.lat || 0,
//                 lng: editForm.destCoords?.lng || 0,
//                 isManual: !editForm.destCoords?.lat || editForm.destCoords.lat === 0
//             };
//         } else {
//             originNode = {
//                 id: 'origin',
//                 name: editForm.returnOriginCity,
//                 lat: editForm.returnOriginCoords?.lat || 0,
//                 lng: editForm.returnOriginCoords?.lng || 0,
//                 isManual: !editForm.returnOriginCoords?.lat || editForm.returnOriginCoords.lat === 0
//             };
//             destNode = {
//                 id: 'destination',
//                 name: editForm.returnDestCity,
//                 lat: editForm.returnDestCoords?.lat || 0,
//                 lng: editForm.returnDestCoords?.lng || 0,
//                 isManual: !editForm.returnDestCoords?.lat || editForm.returnDestCoords.lat === 0
//             };
//         }

//         setIsCalculatingDistances(true);
//         toast.info(`Calculating ${type === 'up' ? 'UP' : 'DOWN'} route distances...`);

//         try {
//             const enrichedStops = [...stops];

//             for (let i = 0; i < enrichedStops.length; i++) {
//                 const stop = enrichedStops[i];
//                 const isManual = stop.isManualStop === true || !stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0);

//                 if (isManual && (!stop.manualDistFromPrev || stop.manualDistFromPrev === 0) && stop.distanceFromOrigin > 0) {
//                     const prevStop = i > 0 ? enrichedStops[i - 1] : null;
//                     const prevDistance = prevStop?.distanceFromOrigin || 0;
//                     const calculatedDist = stop.distanceFromOrigin - prevDistance;

//                     if (calculatedDist > 0) {
//                         enrichedStops[i] = {
//                             ...stop,
//                             manualDistFromPrev: parseFloat(calculatedDist.toFixed(1))
//                         };
//                     }
//                 }
//             }

//             const stopNodes = enrichedStops.map((s, i) => {
//                 const hasValidCoords = s.coordinates?.lat && s.coordinates.lat !== 0;
//                 const hasManualDist = s.manualDistFromPrev && s.manualDistFromPrev > 0;
//                 const hasDistanceFromOrigin = s.distanceFromOrigin && s.distanceFromOrigin > 0;

//                 const isManual = s.isManualStop === true || !hasValidCoords || hasManualDist;

//                 return {
//                     id: `stop_${i}`,
//                     name: s.city,
//                     lat: s.coordinates?.lat,
//                     lng: s.coordinates?.lng,
//                     manualFromPrev: s.manualDistFromPrev ? parseFloat(s.manualDistFromPrev) : null,
//                     manualToNext: s.manualDistToNext ? parseFloat(s.manualDistToNext) : null,
//                     existingDistance: s.distanceFromOrigin || 0,
//                     isManual: isManual,
//                     originalStop: s
//                 };
//             });

//             const fullPath = [originNode, ...stopNodes, destNode];
//             const validNodes = fullPath.filter(s => s.lat && s.lng && s.lat !== 0 && s.lng !== 0 && !s.isManual);

//             let matrixResponse = null;
//             if (validNodes.length >= 2) {
//                 matrixResponse = await getDistanceMatrix(fullPath, fullPath);
//             }

//             let cumulativeDist = 0;
//             let prevCumulativeDist = 0;
//             const updatedStops = [];
//             let lastAutoNodeIndex = 0;
//             let sumManualSinceLastAuto = 0;
//             let validNodeCounter = -1;

//             if (stops.length > 0) {
//                 const firstStop = stopNodes[0];
//                 const hasFirstStopDistance = firstStop && (firstStop.existingDistance > 0 || (firstStop.manualFromPrev && firstStop.manualFromPrev > 0));

//                 if (hasFirstStopDistance) {
//                     cumulativeDist = firstStop.existingDistance > 0 ? firstStop.existingDistance : firstStop.manualFromPrev;
//                     sumManualSinceLastAuto = cumulativeDist;
//                     prevCumulativeDist = cumulativeDist;
//                 } else if (originNode.isManual) {
//                     const firstLeg = isUp ? editForm.upManualFirstLeg : editForm.returnManualFirstLeg;
//                     if (!firstLeg || parseFloat(firstLeg) <= 0) {
//                         toast.error('Please provide distance from origin to first stop in the Summary section.');
//                         setIsCalculatingDistances(false);
//                         return;
//                     }
//                     cumulativeDist = parseFloat(firstLeg);
//                     sumManualSinceLastAuto = cumulativeDist;
//                     prevCumulativeDist = cumulativeDist;
//                 } else {
//                     lastAutoNodeIndex = 0;
//                     validNodeCounter = 0;
//                 }
//             }

//             for (let i = 0; i < stopNodes.length; i++) {
//                 const currNode = stopNodes[i];
//                 const isManual = currNode.isManual;
//                 let segment = 0;

//                 if (i === 0 && cumulativeDist > 0 && (currNode.existingDistance > 0 || currNode.manualFromPrev > 0)) {
//                     updatedStops.push({
//                         ...enrichedStops[i],
//                         distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//                         manualDistFromPrev: currNode.manualFromPrev || cumulativeDist,
//                         manualDistToNext: currNode.manualToNext || null
//                     });
//                     continue;
//                 }

//                 if (isManual) {
//                     let manualDist = currNode.manualFromPrev;

//                     if ((!manualDist || manualDist === 0) && currNode.existingDistance > 0) {
//                         const prevDistance = i > 0 ? updatedStops[i - 1]?.distanceFromOrigin || 0 : cumulativeDist;
//                         manualDist = currNode.existingDistance - prevDistance;
//                         if (manualDist > 0) {}
//                     }

//                     if (!manualDist || manualDist === 0) {
//                         toast.error(`Manual stop '${currNode.name}' is missing distance from previous stop. Please edit and provide the distance.`);
//                         setIsCalculatingDistances(false);
//                         return;
//                     }

//                     segment = manualDist;
//                     cumulativeDist += segment;
//                     sumManualSinceLastAuto += segment;

//                     const distanceFromPrev = cumulativeDist - prevCumulativeDist;
//                     prevCumulativeDist = cumulativeDist;

//                     updatedStops.push({
//                         ...enrichedStops[i],
//                         distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//                         manualDistFromPrev: segment,
//                         manualDistToNext: currNode.manualToNext || null
//                     });
//                 } else {
//                     validNodeCounter++;
//                     let apiDistance = 0;

//                     let matrixOriginIndex = lastAutoNodeIndex;
//                     let matrixDestIndex = validNodeCounter;

//                     if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
//                         const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
//                         if (element?.status === 'OK') {
//                             apiDistance = element.distance.value / 1000;
//                         }
//                     }

//                     if (i > 0 && stopNodes[i - 1].manualToNext && stopNodes[i - 1].manualToNext > 0) {
//                         segment = stopNodes[i - 1].manualToNext;
//                         sumManualSinceLastAuto = 0;
//                     } else {
//                         segment = apiDistance - sumManualSinceLastAuto;
//                         if (segment < 0) segment = 0;
//                         sumManualSinceLastAuto = 0;
//                     }

//                     cumulativeDist += segment;

//                     if (lastAutoNodeIndex === -1 || matrixOriginIndex >= 0) {
//                         lastAutoNodeIndex = validNodeCounter;
//                     }

//                     const distanceFromPrev = cumulativeDist - prevCumulativeDist;
//                     prevCumulativeDist = cumulativeDist;

//                     updatedStops.push({
//                         ...enrichedStops[i],
//                         distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//                         manualDistFromPrev: parseFloat(distanceFromPrev.toFixed(1)),
//                         manualDistToNext: currNode.manualToNext || null
//                     });
//                 }
//             }

//             let finalSegment = 0;
//             const lastStop = stopNodes[stopNodes.length - 1];
//             const isLastStopManual = lastStop && lastStop.isManual;
//             const hasLastStopDistanceToDest = lastStop && lastStop.manualToNext && lastStop.manualToNext > 0;

//             const totalDistance = isUp ? parseFloat(editForm.totalDistance) : parseFloat(editForm.returnTotalDistance);
//             const lastStopDistance = updatedStops.length > 0 ? updatedStops[updatedStops.length - 1].distanceFromOrigin : 0;

//             if (totalDistance > 0 && lastStopDistance > 0 && !hasLastStopDistanceToDest) {
//                 const calculatedFinalSegment = totalDistance - lastStopDistance;
//                 if (calculatedFinalSegment > 0) {
//                     finalSegment = parseFloat(calculatedFinalSegment.toFixed(1));
//                     if (isUp) {
//                         setEditForm(prev => ({ ...prev, upManualFinalLeg: finalSegment.toString() }));
//                     } else {
//                         setEditForm(prev => ({ ...prev, returnManualFinalLeg: finalSegment.toString() }));
//                     }
//                 }
//             }

//             if (finalSegment === 0) {
//                 if (hasLastStopDistanceToDest) {
//                     finalSegment = lastStop.manualToNext;
//                 } else if (destNode.isManual) {
//                     const finalLeg = isUp ? editForm.upManualFinalLeg : editForm.returnManualFinalLeg;
//                     if (!finalLeg || parseFloat(finalLeg) <= 0) {
//                         if (totalDistance > 0 && lastStopDistance > 0) {
//                             finalSegment = totalDistance - lastStopDistance;
//                             if (finalSegment > 0) {
//                                 if (isUp) {
//                                     setEditForm(prev => ({ ...prev, upManualFinalLeg: finalSegment.toString() }));
//                                 } else {
//                                     setEditForm(prev => ({ ...prev, returnManualFinalLeg: finalSegment.toString() }));
//                                 }
//                             } else {
//                                 toast.error('Destination is manual. Please provide distance from last stop to destination in Summary section.');
//                                 setIsCalculatingDistances(false);
//                                 return;
//                             }
//                         } else {
//                             toast.error('Destination is manual. Please provide distance from last stop to destination in Summary section.');
//                             setIsCalculatingDistances(false);
//                             return;
//                         }
//                     } else {
//                         finalSegment = parseFloat(finalLeg);
//                     }
//                 } else if (!destNode.isManual && isLastStopManual) {
//                     const finalLeg = isUp ? editForm.destManualDistFromLastStop : editForm.returnDestManualDistFromLastStop;
//                     if (!finalLeg || parseFloat(finalLeg) <= 0) {
//                         if (totalDistance > 0 && lastStopDistance > 0) {
//                             finalSegment = totalDistance - lastStopDistance;
//                             if (finalSegment > 0) {} else {
//                                 toast.error('Last stop is manual. Please provide distance to destination in Summary section.');
//                                 setIsCalculatingDistances(false);
//                                 return;
//                             }
//                         } else {
//                             toast.error('Last stop is manual. Please provide distance to destination in Summary section.');
//                             setIsCalculatingDistances(false);
//                             return;
//                         }
//                     } else {
//                         finalSegment = parseFloat(finalLeg);
//                     }
//                 } else if (!destNode.isManual && !isLastStopManual && matrixResponse) {
//                     validNodeCounter++;
//                     let matrixOriginIndex = lastAutoNodeIndex;
//                     let matrixDestIndex = validNodeCounter;

//                     const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
//                     if (element?.status === 'OK') {
//                         finalSegment = element.distance.value / 1000 - sumManualSinceLastAuto;
//                         if (finalSegment < 0) finalSegment = 0;
//                     }
//                 } else if (stopNodes.length === 0) {
//                     if (originNode.isManual && destNode.isManual) {
//                         const totalDist = isUp ? editForm.totalDistance : editForm.returnTotalDistance;
//                         if (!totalDist || parseFloat(totalDist) <= 0) {
//                             toast.error('Both origin and destination are manual. Please provide total distance.');
//                             setIsCalculatingDistances(false);
//                             return;
//                         }
//                         finalSegment = parseFloat(totalDist);
//                     } else if (matrixResponse) {
//                         const element = matrixResponse.rows[0]?.elements[1];
//                         if (element?.status === 'OK') {
//                             finalSegment = element.distance.value / 1000;
//                         }
//                     }
//                 }
//             }

//             cumulativeDist += finalSegment;

//             if (updatedStops.length > 0 && finalSegment > 0) {
//                 const lastIndex = updatedStops.length - 1;
//                 updatedStops[lastIndex] = {
//                     ...updatedStops[lastIndex],
//                     manualDistToNext: parseFloat(finalSegment.toFixed(1))
//                 };
//             }

//             if (type === 'up') {
//                 setUpStops(updatedStops);
//                 setEditForm(prev => ({
//                     ...prev,
//                     totalDistance: cumulativeDist.toFixed(1),
//                     upManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.upManualFinalLeg
//                 }));
//             } else {
//                 setDownStops(updatedStops);
//                 setEditForm(prev => ({
//                     ...prev,
//                     returnTotalDistance: cumulativeDist.toFixed(1),
//                     returnManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.returnManualFinalLeg
//                 }));
//             }

//             setIsDistanceCalculated(prev => ({ ...prev, [type]: true }));
//             toast.success(`${type === 'up' ? 'UP' : 'DOWN'} route distances calculated! Total: ${cumulativeDist.toFixed(1)} km`);

//         } catch (error) {
//             console.error('Distance calculation error:', error);
//             toast.error("Calculation failed. Please enter distances manually.");
//         } finally {
//             setIsCalculatingDistances(false);
//         }
//     };

//     const fetchRoutes = async () => {
//         try {
//             setLoading(true);
//             const response = await getAllRoutes(
//                 token,
//                 currentPage,
//                 pageSize,
//                 searchTerm,
//                 filterOrigin,
//                 filterDestination
//             );

//             if (response && response.success) {
//                 const routesData = response.data?.routes || [];

//                 const transformedRoutes = routesData.map((route, index) => {
//                     const getDepartureTime = (origin) => {
//                         if (origin?.departureTime) return origin.departureTime;
//                         if (origin?.timings && origin.timings.length > 0) {
//                             const firstTiming = origin.timings[0];
//                             if (firstTiming?.departureTime) return firstTiming.departureTime;
//                         }
//                         return 'N/A';
//                     };

//                     const getArrivalTime = (destination) => {
//                         if (destination?.arrivalTime) return destination.arrivalTime;
//                         if (destination?.timings && destination.timings.length > 0) {
//                             const firstTiming = destination.timings[0];
//                             if (firstTiming?.arrivalTime) return firstTiming.arrivalTime;
//                         }
//                         return 'N/A';
//                     };

//                     let departureTime = getDepartureTime(route.origin);
//                     let arrivalTime = getArrivalTime(route.destination);

//                     if (route.routeNumber?.includes('REV') && route.returnJourney) {
//                         departureTime = getDepartureTime(route.returnJourney.origin);
//                         arrivalTime = getArrivalTime(route.returnJourney.destination);
//                     }

//                     const formatDisplayTime = (timeStr) => {
//                         if (!timeStr || timeStr === 'N/A') return 'N/A';
//                         if (timeStr.includes(':')) {
//                             const [hours, minutes] = timeStr.split(':');
//                             const hour = parseInt(hours);
//                             const ampm = hour >= 12 ? 'pm' : 'am';
//                             const displayHour = hour % 12 || 12;
//                             return `${displayHour}:${minutes} ${ampm}`;
//                         }
//                         return timeStr;
//                     };

//                     return {
//                         id: route._id || route.id,
//                         serialNo: (currentPage - 1) * pageSize + index + 1,
//                         routeNumber: route.routeNumber || 'N/A',
//                         routeName: route.routeName || 'N/A',
//                         localRouteName: route.localRouteName || null,
//                         originCity: route.origin?.city || 'N/A',
//                         destinationCity: route.destination?.city || 'N/A',
//                         distance: route.routeDetails?.totalDistance || 0,
//                         duration: formatDuration(
//                             route.routeDetails?.estimatedDuration?.hours,
//                             route.routeDetails?.estimatedDuration?.minutes
//                         ),
//                         stops: route.intermediateStops?.length || 0,
//                         status: route.isActive ? 'Active' : 'Inactive',
//                         departureTime: formatDisplayTime(departureTime),
//                         arrivalTime: formatDisplayTime(arrivalTime),
//                         isActive: route.isActive,
//                         createdAt: route.createdAt,
//                         updatedAt: route.updatedAt,
//                         creatorType: route.creatorType || 'Admin',
//                         creatorName: route.creatorName || 'Admin',
//                         isRoundTrip: route.isRoundTrip || false,
//                         associatedBuses: (route.associatedBuses || []).map(bus => ({
//                             ...bus,
//                             _id: bus.busId || bus._id,
//                             busId: bus.busId || bus._id,
//                             approvalStatus: bus.approvalStatus || (bus.isActive ? 'approved' : 'pending')
//                         })),
//                         busCount: route.busCount || 0,
//                         activeBusCount: route.activeBusCount || 0,
//                         hasActiveBuses: route.hasActiveBuses || false,
//                         hasPendingBuses: (route.associatedBuses || []).some(bus => !bus.isActive && bus.approvalStatus === 'pending'),
//                         fullData: route
//                     };
//                 });

//                 setRoutes(transformedRoutes);

//                 if (response.data?.pagination) {
//                     setTotalPages(response.data.pagination.totalPages || 1);
//                     setTotalRoutes(response.data.pagination.total || 0);
//                 }
//             }
//         } catch (err) {
//             console.error('Error fetching routes:', err);
//             toast.error('Failed to fetch routes');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleSaveRoute = async () => {
//         if (!selectedMasterRouteFromDropdown) {
//             toast.error('Please select a Master Route first');
//             return;
//         }

//         if (!newRoute.routeName) {
//             toast.error('Route Name is required. Please select a Master Route.');
//             return;
//         }

//         if (!newRoute.upOriginCoords) {
//             toast.error('Please select Origin from suggestions to get coordinates');
//             return;
//         }

//         if (!newRoute.upDestCoords) {
//             toast.error('Please select Destination from suggestions to get coordinates');
//             return;
//         }

//         const invalidStops = upStops.filter(stop => {
//             const missingFields = [];
//             if (!stop.city?.trim()) missingFields.push('city');
//             if (!stop.coordinates) missingFields.push('coordinates');

//             if (isMultiTrip) {
//                 if (!stop.timings || stop.timings.length === 0) {
//                     missingFields.push('timings');
//                 } else {
//                     const missingTimings = stop.timings.filter(t => !t.arrivalTime);
//                     if (missingTimings.length > 0) {
//                         missingFields.push(`timings for ${missingTimings.length} trip(s)`);
//                     }
//                 }
//             } else if (!stop.arrivalTime) {
//                 missingFields.push('arrivalTime');
//             }

//             if (missingFields.length > 0) {
//                 return true;
//             }
//             return false;
//         });

//         if (invalidStops.length > 0) {
//             toast.error(`Stop(s) missing required fields: ${invalidStops.map(s => s.city || 'Unknown').join(', ')}`);
//             return;
//         }

//         if (!isDistanceCalculated.up) {
//             toast.error('Please calculate UP route distances first');
//             return;
//         }

//         if (isRoundTrip && !isDistanceCalculated.down) {
//             toast.error('Please calculate DOWN route distances first');
//             return;
//         }

//         if (isRoundTrip && !isMultiTrip && (!newRoute.downOriginDepTime || !newRoute.downDestArrTime)) {
//             toast.error("Please provide Departure and Arrival times for the Return Route");
//             return;
//         }

//         setIsCreatingRoute(true);

//         try {
//             const originData = {
//                 city: newRoute.upOriginCity,
//                 state: newRoute.upOriginState || '',
//                 address: newRoute.upOriginAddress || '',
//                 terminal: newRoute.upOriginTerminal || newRoute.upOriginCity + ' Terminal',
//                 coordinates: newRoute.upOriginCoords || { lat: 0, lng: 0 }
//             };

//             if (isMultiTrip) {
//                 originData.timings = timeSlots.map(slot => ({
//                     timeSlotSequence: slot.sequence,
//                     departureTime: slot.departureTime,
//                     arrivalTime: ''
//                 }));
//             } else {
//                 originData.departureTime = newRoute.upOriginDepTime;
//             }

//             const destData = {
//                 city: newRoute.upDestCity,
//                 state: newRoute.upDestState || '',
//                 address: newRoute.upDestAddress || '',
//                 terminal: newRoute.upDestTerminal || newRoute.upDestCity + ' Terminal',
//                 coordinates: newRoute.upDestCoords || { lat: 0, lng: 0 },
//                 distanceFromOrigin: parseFloat(newRoute.upTotalDistance || 0)
//             };

//             if (isMultiTrip) {
//                 destData.timings = destinationTimeSlots.map(slot => ({
//                     timeSlotSequence: slot.sequence,
//                     arrivalTime: slot.arrivalTime,
//                     departureTime: ''
//                 }));
//             } else {
//                 destData.arrivalTime = newRoute.upDestArrTime;
//             }

//             const cleanStops = (list) => list.map((s, index) => {
//                 const stopCoords = s.coordinates || { lat: 0, lng: 0 };
//                 const city = s.city?.trim();
//                 if (!city) {
//                     throw new Error(`Stop ${index + 1} is missing city name`);
//                 }

//                 const state = s.state?.trim() || 'West Bengal';
//                 const address = s.address?.trim() || `${city}, ${state}, India`;
//                 const terminal = s.terminal?.trim() || `${city} Terminal`;

//                 const stopPayload = {
//                     sequence: index + 1,
//                     city: city,
//                     state: state,
//                     address: address,
//                     terminal: terminal,
//                     stopType: s.stopType || 'none',
//                     coordinates: stopCoords,
//                     distanceFromOrigin: s.distanceFromOrigin || 0
//                 };

//                 if (isMultiTrip) {
//                     if (s.timings && s.timings.length > 0) {
//                         stopPayload.timings = s.timings.map(timing => ({
//                             timeSlotSequence: timing.timeSlotSequence,
//                             arrivalTime: timing.arrivalTime,
//                             departureTime: timing.departureTime || timing.arrivalTime
//                         }));
//                     } else {
//                         stopPayload.timings = timeSlots.map(slot => ({
//                             timeSlotSequence: slot.sequence,
//                             arrivalTime: '',
//                             departureTime: ''
//                         }));
//                     }
//                 } else {
//                     if (!s.arrivalTime) {
//                         throw new Error(`Stop ${index + 1} (${city}) is missing arrival time`);
//                     }
//                     stopPayload.arrivalTime = s.arrivalTime;
//                     stopPayload.departureTime = s.departureTime?.trim() || s.arrivalTime;
//                 }

//                 if (s.manualDistFromPrev) stopPayload.manualDistFromPrev = s.manualDistFromPrev;
//                 if (s.manualDistToNext) stopPayload.manualDistToNext = s.manualDistToNext;
//                 if (s.isManualStop) stopPayload.isManualStop = s.isManualStop;

//                 return stopPayload;
//             });

//             const generateNullPoints = (stops, origin, destination) => {
//                 const nullPoints = [];
//                 nullPoints.push({
//                     name: origin.terminal,
//                     address: origin.address,
//                     city: origin.city,
//                     state: origin.state,
//                     landmark: origin.terminal,
//                     referenceTime: origin.departureTime
//                 });
//                 nullPoints.push({
//                     name: destination.terminal,
//                     address: destination.address,
//                     city: destination.city,
//                     state: destination.state,
//                     landmark: destination.terminal,
//                     referenceTime: destination.arrivalTime
//                 });
//                 stops.forEach(stop => {
//                     if (stop.stopType === 'none') {
//                         nullPoints.push({
//                             name: stop.terminal,
//                             address: stop.address,
//                             city: stop.city,
//                             state: stop.state,
//                             landmark: stop.terminal,
//                             referenceTime: stop.arrivalTime
//                         });
//                     }
//                 });
//                 return nullPoints;
//             };

//             const generateBoardingPoints = (stops, origin) => {
//                 const boardingPoints = [];
//                 boardingPoints.push({
//                     name: origin.terminal,
//                     address: origin.address,
//                     city: origin.city,
//                     state: origin.state,
//                     landmark: origin.terminal,
//                     pickupTime: origin.departureTime
//                 });
//                 stops.forEach(stop => {
//                     if (stop.stopType === 'boarding' || stop.stopType === 'both') {
//                         boardingPoints.push({
//                             name: stop.terminal,
//                             address: stop.address,
//                             city: stop.city,
//                             state: stop.state,
//                             landmark: stop.terminal,
//                             pickupTime: stop.departureTime || stop.arrivalTime
//                         });
//                     }
//                 });
//                 return boardingPoints;
//             };

//             const generateDroppingPoints = (stops, destination) => {
//                 const droppingPoints = [];
//                 droppingPoints.push({
//                     name: destination.terminal,
//                     address: destination.address,
//                     city: destination.city,
//                     state: destination.state,
//                     landmark: destination.terminal,
//                     dropTime: destination.arrivalTime
//                 });
//                 stops.forEach(stop => {
//                     if (stop.stopType === 'dropping' || stop.stopType === 'both') {
//                         droppingPoints.push({
//                             name: stop.terminal,
//                             address: stop.address,
//                             city: stop.city,
//                             state: stop.state,
//                             landmark: stop.terminal,
//                             dropTime: stop.arrivalTime
//                         });
//                     }
//                 });
//                 return droppingPoints;
//             };

//             const boardingPoints = generateBoardingPoints(upStops, originData);
//             const droppingPoints = generateDroppingPoints(upStops, destData);
//             const nullPoints = generateNullPoints(upStops, originData, destData);

//             const finalPayload = {
//                 routeName: newRoute.routeName.trim(),
//                 via: selectedMasterRouteFromDropdown?.via || [],
//                 localRouteName: newRoute.localRouteName?.trim() || null,
//                 isMultiTrip: isMultiTrip,
//                 numberOfTrips: isMultiTrip ? numberOfTrips : 1,
//                 timeSlots: isMultiTrip ? timeSlots : [],
//                 origin: originData,
//                 destination: destData,
//                 intermediateStops: cleanStops(upStops),
//                 additionalBoardingPoints: boardingPoints,
//                 additionalDroppingPoints: droppingPoints,
//                 additionalNullPoints: nullPoints,
//                 routeDetails: {
//                     totalDistance: parseFloat(newRoute.upTotalDistance || 0),
//                     estimatedDuration: {
//                         hours: parseInt(newRoute.upDurationHours || 0, 10),
//                         minutes: parseInt(newRoute.upDurationMinutes || 0, 10)
//                     }
//                 },
//                 isRoundTrip: isRoundTrip
//             };

//             if (isRoundTrip) {
//                 const invalidReturnStops = downStops.filter(stop => !stop.coordinates);

//                 if (invalidReturnStops.length > 0) {
//                     toast.error('All return stops must have coordinates. Please select from suggestions or add manually with distances.');
//                     setIsCreatingRoute(false);
//                     return;
//                 }

//                 const returnOriginData = {
//                     city: destData.city,
//                     state: destData.state,
//                     address: destData.address,
//                     terminal: destData.terminal,
//                     coordinates: destData.coordinates
//                 };

//                 if (isMultiTrip) {
//                     if (returnOriginTimeSlots && returnOriginTimeSlots.length > 0) {
//                         returnOriginData.timings = returnOriginTimeSlots.map(slot => ({
//                             timeSlotSequence: slot.sequence,
//                             departureTime: slot.departureTime || slot.arrivalTime || '',
//                             arrivalTime: ''
//                         }));
//                     } else if (destinationTimeSlots && destinationTimeSlots.length > 0) {
//                         returnOriginData.timings = destinationTimeSlots.map(slot => ({
//                             timeSlotSequence: slot.sequence,
//                             departureTime: slot.arrivalTime || '',
//                             arrivalTime: ''
//                         }));
//                     } else {
//                         returnOriginData.timings = timeSlots.map(slot => ({
//                             timeSlotSequence: slot.sequence,
//                             departureTime: slot.departureTime || '',
//                             arrivalTime: ''
//                         }));
//                     }
//                 } else {
//                     returnOriginData.departureTime = newRoute.downOriginDepTime;
//                 }

//                 const returnDestData = {
//                     city: originData.city,
//                     state: originData.state,
//                     address: originData.address,
//                     terminal: originData.terminal,
//                     coordinates: originData.coordinates,
//                     distanceFromOrigin: parseFloat(newRoute.downTotalDistance || 0)
//                 };

//                 if (isMultiTrip) {
//                     if (returnDestTimeSlots && returnDestTimeSlots.length > 0) {
//                         returnDestData.timings = returnDestTimeSlots.map(slot => ({
//                             timeSlotSequence: slot.sequence,
//                             arrivalTime: slot.arrivalTime || slot.departureTime || '',
//                             departureTime: ''
//                         }));
//                     } else if (timeSlots && timeSlots.length > 0) {
//                         returnDestData.timings = timeSlots.map(slot => ({
//                             timeSlotSequence: slot.sequence,
//                             arrivalTime: slot.departureTime || '',
//                             departureTime: ''
//                         }));
//                     } else {
//                         returnDestData.timings = Array.from({ length: numberOfTrips || 1 }, (_, i) => ({
//                             timeSlotSequence: i + 1,
//                             arrivalTime: '',
//                             departureTime: ''
//                         }));
//                     }
//                 } else {
//                     returnDestData.arrivalTime = newRoute.downDestArrTime;
//                 }

//                 if (isMultiTrip && returnOriginData.timings) {
//                     const missingDepartures = returnOriginData.timings.filter(t => !t.departureTime);
//                     if (missingDepartures.length > 0) {
//                         toast.error(`Return origin is missing departure times for ${missingDepartures.length} trip(s). Please set them in the DOWN route section.`);
//                         setIsCreatingRoute(false);
//                         return;
//                     }
//                 }

//                 if (isMultiTrip && returnDestData.timings) {
//                     const missingArrivals = returnDestData.timings.filter(t => !t.arrivalTime);
//                     if (missingArrivals.length > 0) {
//                         toast.error(`Return destination is missing arrival times for ${missingArrivals.length} trip(s). Please set them in the DOWN route section.`);
//                         setIsCreatingRoute(false);
//                         return;
//                     }
//                 }

//                 const cleanedReturnStops = downStops.map((stop, index) => {
//                     const stopCoords = stop.coordinates || { lat: 0, lng: 0 };
//                     const city = stop.city?.trim();
//                     if (!city) {
//                         throw new Error(`Return stop ${index + 1} is missing city name`);
//                     }

//                     const state = stop.state?.trim() || 'West Bengal';
//                     const address = stop.address?.trim() || `${city}, ${state}, India`;
//                     const terminal = stop.terminal?.trim() || `${city} Terminal`;

//                     const stopPayload = {
//                         sequence: index + 1,
//                         city: city,
//                         state: state,
//                         address: address,
//                         terminal: terminal,
//                         stopType: stop.stopType || 'none',
//                         coordinates: stopCoords,
//                         distanceFromOrigin: stop.distanceFromOrigin || 0
//                     };

//                     if (isMultiTrip) {
//                         if (stop.timings && stop.timings.length > 0) {
//                             stopPayload.timings = stop.timings.map(timing => ({
//                                 timeSlotSequence: timing.timeSlotSequence,
//                                 arrivalTime: timing.arrivalTime || '',
//                                 departureTime: timing.departureTime || timing.arrivalTime || ''
//                             }));
//                         } else {
//                             const numTrips = returnOriginTimeSlots.length || numberOfTrips || 1;
//                             stopPayload.timings = Array.from({ length: numTrips }, (_, i) => ({
//                                 timeSlotSequence: i + 1,
//                                 arrivalTime: '',
//                                 departureTime: ''
//                             }));
//                         }
//                     } else {
//                         if (!stop.arrivalTime) {
//                             throw new Error(`Return stop ${index + 1} (${city}) is missing arrival time`);
//                         }
//                         stopPayload.arrivalTime = stop.arrivalTime;
//                         stopPayload.departureTime = stop.departureTime?.trim() || stop.arrivalTime;
//                     }

//                     if (stop.manualDistFromPrev) stopPayload.manualDistFromPrev = stop.manualDistFromPrev;
//                     if (stop.manualDistToNext) stopPayload.manualDistToNext = stop.manualDistToNext;
//                     if (stop.isManualStop) stopPayload.isManualStop = stop.isManualStop;

//                     return stopPayload;
//                 });

//                 const returnBoardingPoints = generateBoardingPoints(downStops, returnOriginData);
//                 const returnDroppingPoints = generateDroppingPoints(downStops, returnDestData);
//                 const returnNullPoints = generateNullPoints(downStops, returnOriginData, returnDestData);

//                 finalPayload.returnOrigin = returnOriginData;
//                 finalPayload.returnDestination = returnDestData;
//                 finalPayload.returnIntermediateStops = cleanedReturnStops;
//                 finalPayload.returnAdditionalBoardingPoints = returnBoardingPoints;
//                 finalPayload.returnAdditionalDroppingPoints = returnDroppingPoints;
//                 finalPayload.returnAdditionalNullPoints = returnNullPoints;
//                 finalPayload.returnRouteDetails = {
//                     totalDistance: parseFloat(newRoute.downTotalDistance || 0),
//                     estimatedDuration: {
//                         hours: parseInt(newRoute.downDurationHours || 0, 10),
//                         minutes: parseInt(newRoute.downDurationMinutes || 0, 10)
//                     }
//                 };
//             }

//             const response = await createRoute(finalPayload, token);
//             if (response.success) {
//                 toast.success(isRoundTrip ? 'Round trip route created successfully!' : 'Route created successfully!');
//                 setShowAddModal(false);
//                 resetNewRouteForm();
//                 fetchRoutes();
//             } else {
//                 toast.error(response.message || 'Failed to create route');
//             }
//         } catch (err) {
//             console.error('Error creating route:', err);
//             if (err.response) {
//                 const serverError = err.response.data?.message || err.response.data || err.message;
//                 toast.error(serverError);
//             } else if (err.request) {
//                 toast.error('No response from server. Please check your connection.');
//             } else {
//                 toast.error(err.message || 'Failed to create route');
//             }
//         } finally {
//             setIsCreatingRoute(false);
//         }
//     };

//     const resetNewRouteForm = () => {
//         setNewRoute({
//             routeName: '',
//             localRouteName: '',
//             upOriginCity: '', upOriginState: '', upOriginAddress: '', upOriginTerminal: '',
//             upOriginCoords: null, upOriginDepTime: '',
//             upDestCity: '', upDestState: '', upDestAddress: '', upDestTerminal: '',
//             upDestCoords: null, upDestArrTime: '',
//             upTotalDistance: '', upDurationHours: '', upDurationMinutes: '',
//             downOriginDepTime: '', downDestArrTime: '',
//             downTotalDistance: '', downDurationHours: '', downDurationMinutes: '',
//             upManualFinalLeg: '',
//             downManualFinalLeg: '',
//             stopCity: '', stopState: '', stopAddress: '', stopTerminal: '',
//             stopCoords: null, stopArrivalTime: '', stopDepartureTime: '',
//             stopDistFromPrev: '', stopDistToNext: '',
//             isBoarding: false, isDropping: false
//         });
//         setUpStops([]);
//         setDownStops([]);
//         setIsRoundTrip(false);
//         setActiveRouteTab('UP');
//         setIsDistanceCalculated({ up: false, down: false });
//         setActiveTab('basic');
//         setSelectedMasterRoute(null);
//         setSelectedMasterRouteFromDropdown(null);
//         setMasterRouteSuggestions([]);
//     };

//     const handleViewRoute = async (route) => {
//   try {
//     setError(null);

//     let routeData;
    
//     if (route.isPending) {
//       const response = await getPendingRouteById(route.id, token);
//       if (response.success) {
//         routeData = response.data;
//         setViewingRoute({
//           ...routeData,
//           id: routeData._id,
//           routeName: routeData.routeName || 'N/A',
//           localRouteName: routeData.localRouteName || null,
//           origin: routeData.origin,
//           destination: routeData.destination,
//           intermediateStops: routeData.intermediateStops || [],
//           routeDetails: routeData.routeDetails || {},
//           isActive: false,
//           isRoundTrip: routeData.isRoundTrip || false,
//           isMultiTrip: routeData.isMultiTrip || false,
//           numberOfTrips: routeData.numberOfTrips || 1,
//           returnJourney: routeData.returnJourney || null,
//           createdAt: routeData.createdAt,
//           updatedAt: routeData.updatedAt,
//           isPending: true,
//           submittedBy: routeData.submittedBy,
//           submittedByName: routeData.submittedByName,
//           submittedByEmail: routeData.submittedByEmail,
//           operationType: routeData.operationType
//         });
//       }
//     } else {
//       routeData = await getRouteById(route.id, token);
//       setViewingRoute(routeData.data || routeData);
//     }
//   } catch (err) {
//     console.error('Error fetching route details:', err);
//     setError('Failed to fetch route details.');
//     toast.error('Failed to fetch route details. Please try again.');
//     if (route.fullData) {
//       setViewingRoute(route.fullData);
//     } else {
//       setViewingRoute(route);
//     }
//   }
// };

//     const handleAddNewMasterRoute = () => {
//         const currentFormData = {
//             routeName: newRoute.routeName,
//             upOriginCity: newRoute.upOriginCity,
//             upOriginState: newRoute.upOriginState,
//             upOriginAddress: newRoute.upOriginAddress,
//             upOriginTerminal: newRoute.upOriginTerminal,
//             upOriginCoords: newRoute.upOriginCoords,
//             upOriginDepTime: newRoute.upOriginDepTime,
//             upDestCity: newRoute.upDestCity,
//             upDestState: newRoute.upDestState,
//             upDestAddress: newRoute.upDestAddress,
//             upDestTerminal: newRoute.upDestTerminal,
//             upDestCoords: newRoute.upDestCoords,
//             upDestArrTime: newRoute.upDestArrTime,
//             isRoundTrip: isRoundTrip,
//             upStops: upStops,
//             downStops: downStops,
//             via: upStops.map(stop => ({
//                 city: stop.city,
//                 state: stop.state,
//                 sequence: stop.sequence
//             }))
//         };
//         localStorage.setItem('pendingRouteFormData', JSON.stringify(currentFormData));

//         toast.info('Redirecting to create master route. Your current form data has been saved.');

//         navigate('/masterroutes', {
//             state: {
//                 returnTo: 'routes',
//                 formData: currentFormData
//             }
//         });
//     };

//     const autoFillFromMasterRoute = (masterRoute) => {
//         if (!masterRoute) return;

//         setSelectedMasterRouteFromDropdown(masterRoute);

//         const isMultiTripRoute = masterRoute.isMultiTrip ||
//             (masterRoute.origin?.timings && masterRoute.origin.timings.length > 0) ||
//             (masterRoute.intermediateStops && masterRoute.intermediateStops.some(stop => stop.timings && stop.timings.length > 0));

//         setIsMultiTrip(isMultiTripRoute);

//         setNewRoute(prev => ({
//             ...prev,
//             routeName: masterRoute.masterRouteName,
//             localRouteName: masterRoute.localRouteName || prev.localRouteName
//         }));

//         if (masterRoute.origin) {
//             setNewRoute(prev => ({
//                 ...prev,
//                 upOriginCity: masterRoute.origin.city || '',
//                 upOriginState: masterRoute.origin.state || '',
//                 upOriginAddress: masterRoute.origin.address || `${masterRoute.origin.city || ''}, ${masterRoute.origin.state || 'India'}`,
//                 upOriginTerminal: masterRoute.origin.terminal || `${masterRoute.origin.city || ''} Terminal`,
//                 upOriginCoords: masterRoute.origin.coordinates || null,
//                 upOriginDepTime: masterRoute.origin.departureTime || ''
//             }));

//             if (isMultiTripRoute && masterRoute.origin.timings && masterRoute.origin.timings.length > 0) {
//                 const numTrips = masterRoute.numberOfTrips || masterRoute.origin.timings.length;
//                 setNumberOfTrips(numTrips);
//                 setTimeSlots(masterRoute.origin.timings.map(timing => ({
//                     sequence: timing.timeSlotSequence,
//                     departureTime: timing.departureTime,
//                     arrivalTime: '',
//                     fareMultiplier: timing.fareMultiplier || 1.0,
//                     isActive: timing.isActive !== undefined ? timing.isActive : true
//                 })));
//             }
//         }

//         if (masterRoute.destination) {
//             setNewRoute(prev => ({
//                 ...prev,
//                 upDestCity: masterRoute.destination.city || '',
//                 upDestState: masterRoute.destination.state || '',
//                 upDestAddress: masterRoute.destination.address || `${masterRoute.destination.city || ''}, ${masterRoute.destination.state || 'India'}`,
//                 upDestTerminal: masterRoute.destination.terminal || `${masterRoute.destination.city || ''} Terminal`,
//                 upDestCoords: masterRoute.destination.coordinates || null,
//                 upDestArrTime: masterRoute.destination.arrivalTime || '',
//                 upTotalDistance: masterRoute.routeDetails?.totalDistance || '',
//                 upDurationHours: masterRoute.routeDetails?.estimatedDuration?.hours || '',
//                 upDurationMinutes: masterRoute.routeDetails?.estimatedDuration?.minutes || ''
//             }));

//             if (isMultiTripRoute && masterRoute.destination.timings && masterRoute.destination.timings.length > 0) {
//                 setDestinationTimeSlots(masterRoute.destination.timings.map(timing => ({
//                     sequence: timing.timeSlotSequence,
//                     arrivalTime: timing.arrivalTime,
//                     departureTime: '',
//                     fareMultiplier: timing.fareMultiplier || 1.0
//                 })));
//                 setDestinationNumberOfTrips(masterRoute.destination.timings.length);
//             }
//         }

//         const existingIntermediateStops = masterRoute.intermediateStops || [];
//         const sortedStops = [...existingIntermediateStops].sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

//         if (sortedStops.length > 0) {
//             const upTotalDist = parseFloat(masterRoute.routeDetails?.totalDistance) || 0;

//             const transformedUpStops = sortedStops.map((stop, index) => {
//                 const actualDist = stop.distanceFromOrigin || 0;
//                 const prevStop = index > 0 ? sortedStops[index - 1] : null;
//                 const prevDist = prevStop ? (prevStop.distanceFromOrigin || 0) : 0;

//                 let segmentDist = 0;
//                 if (stop.manualDistFromPrev && parseFloat(stop.manualDistFromPrev) > 0) {
//                     segmentDist = parseFloat(stop.manualDistFromPrev);
//                 } else if (actualDist > 0) {
//                     segmentDist = parseFloat((actualDist - prevDist).toFixed(1));
//                 }

//                 if (segmentDist <= 0 && upTotalDist > 0 && sortedStops.length > 0) {
//                     segmentDist = parseFloat((upTotalDist / (sortedStops.length + 1)).toFixed(1));
//                 }
//                 if (segmentDist <= 0) segmentDist = 5;

//                 const existingTimings = stop.timings || [];
//                 let stopTimings = existingTimings;
//                 if (isMultiTripRoute && existingTimings.length === 0) {
//                     const numTrips = masterRoute.numberOfTrips || 1;
//                     stopTimings = Array.from({ length: numTrips }, (_, i) => ({
//                         timeSlotSequence: i + 1,
//                         arrivalTime: '',
//                         departureTime: ''
//                     }));
//                 }

//                 return {
//                     sequence: index + 1,
//                     city: stop.city || '',
//                     state: stop.state || masterRoute.origin?.state || '',
//                     address: stop.address || `${stop.city || ''}, ${stop.state || masterRoute.origin?.state || 'India'}`,
//                     terminal: stop.terminal || `${stop.city || ''} Bus Stand`,
//                     stopType: stop.stopType || 'none',
//                     coordinates: stop.coordinates || { lat: 0, lng: 0 },
//                     distanceFromOrigin: actualDist,
//                     manualDistFromPrev: segmentDist > 0 ? segmentDist : null,
//                     manualDistToNext: stop.manualDistToNext ? parseFloat(stop.manualDistToNext) : null,
//                     isManualStop: stop.isManualStop !== undefined
//                         ? stop.isManualStop
//                         : (!stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0)),
//                     arrivalTime: stop.arrivalTime || '',
//                     departureTime: stop.departureTime || '',
//                     timings: stopTimings
//                 };
//             });

//             setUpStops(transformedUpStops);
//             setIsDistanceCalculated(prev => ({ ...prev, up: true }));

//             const firstStopDist = transformedUpStops[0].distanceFromOrigin || 0;
//             const firstSegment = transformedUpStops[0].manualDistFromPrev || firstStopDist;
//             if (firstSegment > 0) {
//                 setNewRoute(prev => ({ ...prev, upManualFirstLeg: String(firstSegment) }));
//             }

//             const lastStopDist = transformedUpStops[transformedUpStops.length - 1].distanceFromOrigin || 0;
//             const finalLeg = parseFloat((upTotalDist - lastStopDist).toFixed(1));
//             if (finalLeg > 0) {
//                 setNewRoute(prev => ({ ...prev, upManualFinalLeg: String(finalLeg) }));
//             }
//         } else {
//             setUpStops([]);
//         }

//         if (masterRoute.isRoundTrip && masterRoute.returnJourney) {
//             setIsRoundTrip(true);

//             const returnJourney = masterRoute.returnJourney;
//             const returnTotalDist = parseFloat(returnJourney.routeDetails?.totalDistance) || 0;

//             if (returnJourney.origin) {
//                 setNewRoute(prev => ({
//                     ...prev,
//                     downOriginCity: returnJourney.origin.city || masterRoute.destination?.city || '',
//                     downOriginState: returnJourney.origin.state || masterRoute.destination?.state || '',
//                     downOriginAddress: returnJourney.origin.address || `${masterRoute.destination?.city || ''}, ${masterRoute.destination?.state || 'India'}`,
//                     downOriginTerminal: returnJourney.origin.terminal || `${masterRoute.destination?.city || ''} Terminal`,
//                     downOriginCoords: returnJourney.origin.coordinates || masterRoute.destination?.coordinates || null,
//                     downOriginDepTime: returnJourney.origin.departureTime || ''
//                 }));

//                 if (isMultiTripRoute && returnJourney.origin.timings && returnJourney.origin.timings.length > 0) {
//                     setReturnOriginTimeSlots(returnJourney.origin.timings.map(timing => ({
//                         sequence: timing.timeSlotSequence,
//                         departureTime: timing.departureTime,
//                         arrivalTime: '',
//                         fareMultiplier: timing.fareMultiplier || 1.0
//                     })));
//                 } else if (isMultiTripRoute && destinationTimeSlots.length > 0) {
//                     setReturnOriginTimeSlots(destinationTimeSlots.map(slot => ({
//                         sequence: slot.sequence,
//                         departureTime: slot.arrivalTime,
//                         arrivalTime: ''
//                     })));
//                 }
//             }

//             if (returnJourney.destination) {
//                 setNewRoute(prev => ({
//                     ...prev,
//                     downDestCity: returnJourney.destination.city || masterRoute.origin?.city || '',
//                     downDestState: returnJourney.destination.state || masterRoute.origin?.state || '',
//                     downDestAddress: returnJourney.destination.address || `${masterRoute.origin?.city || ''}, ${masterRoute.origin?.state || 'India'}`,
//                     downDestTerminal: returnJourney.destination.terminal || `${masterRoute.origin?.city || ''} Terminal`,
//                     downDestCoords: returnJourney.destination.coordinates || masterRoute.origin?.coordinates || null,
//                     downDestArrTime: returnJourney.destination.arrivalTime || '',
//                     downTotalDistance: returnTotalDist,
//                     downDurationHours: returnJourney.routeDetails?.estimatedDuration?.hours || '',
//                     downDurationMinutes: returnJourney.routeDetails?.estimatedDuration?.minutes || ''
//                 }));

//                 if (isMultiTripRoute && returnJourney.destination.timings && returnJourney.destination.timings.length > 0) {
//                     setReturnDestTimeSlots(returnJourney.destination.timings.map(timing => ({
//                         sequence: timing.timeSlotSequence,
//                         arrivalTime: timing.arrivalTime,
//                         departureTime: '',
//                         fareMultiplier: timing.fareMultiplier || 1.0
//                     })));
//                 } else if (isMultiTripRoute && timeSlots.length > 0) {
//                     setReturnDestTimeSlots(timeSlots.map(slot => ({
//                         sequence: slot.sequence,
//                         arrivalTime: slot.departureTime,
//                         departureTime: ''
//                     })));
//                 }
//             }

//             const returnExistingStops = returnJourney.intermediateStops || [];
//             const sortedReturnStops = [...returnExistingStops].sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

//             if (sortedReturnStops.length > 0) {
//                 const transformedDownStops = sortedReturnStops.map((stop, index) => {
//                     const actualDist = stop.distanceFromOrigin || 0;
//                     const prevStop = index > 0 ? sortedReturnStops[index - 1] : null;
//                     const prevDist = prevStop ? (prevStop.distanceFromOrigin || 0) : 0;

//                     let segmentDist = 0;
//                     if (stop.manualDistFromPrev && parseFloat(stop.manualDistFromPrev) > 0) {
//                         segmentDist = parseFloat(stop.manualDistFromPrev);
//                     } else if (actualDist > 0) {
//                         segmentDist = parseFloat((actualDist - prevDist).toFixed(1));
//                     }

//                     if (segmentDist <= 0 && returnTotalDist > 0 && sortedReturnStops.length > 0) {
//                         segmentDist = parseFloat((returnTotalDist / (sortedReturnStops.length + 1)).toFixed(1));
//                     }
//                     if (segmentDist <= 0) segmentDist = 5;

//                     const existingTimings = stop.timings || [];
//                     let stopTimings = existingTimings;
//                     if (isMultiTripRoute && existingTimings.length === 0) {
//                         const numTrips = masterRoute.numberOfTrips || 1;
//                         stopTimings = Array.from({ length: numTrips }, (_, i) => ({
//                             timeSlotSequence: i + 1,
//                             arrivalTime: '',
//                             departureTime: ''
//                         }));
//                     }

//                     let newStopType = stop.stopType || 'none';
//                     if (newStopType === 'boarding') newStopType = 'dropping';
//                     else if (newStopType === 'dropping') newStopType = 'boarding';

//                     return {
//                         sequence: index + 1,
//                         city: stop.city || '',
//                         state: stop.state || masterRoute.destination?.state || '',
//                         address: stop.address || `${stop.city || ''}, ${stop.state || masterRoute.destination?.state || 'India'}`,
//                         terminal: stop.terminal || `${stop.city || ''} Bus Stand`,
//                         arrivalTime: stop.arrivalTime || '',
//                         departureTime: stop.departureTime || '',
//                         stopType: newStopType,
//                         coordinates: stop.coordinates || { lat: 0, lng: 0 },
//                         distanceFromOrigin: actualDist,
//                         manualDistFromPrev: segmentDist > 0 ? segmentDist : null,
//                         manualDistToNext: stop.manualDistToNext ? parseFloat(stop.manualDistToNext) : null,
//                         isManualStop: stop.isManualStop !== undefined
//                             ? stop.isManualStop
//                             : (!stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0)),
//                         timings: stopTimings
//                     };
//                 });

//                 setDownStops(transformedDownStops);
//                 setIsDistanceCalculated(prev => ({ ...prev, down: true }));

//                 const returnFirstSegment = transformedDownStops[0].manualDistFromPrev ||
//                     transformedDownStops[0].distanceFromOrigin || 0;
//                 if (returnFirstSegment > 0) {
//                     setNewRoute(prev => ({ ...prev, downManualFirstLeg: String(returnFirstSegment) }));
//                 }

//                 const returnLastStopDist = transformedDownStops[transformedDownStops.length - 1].distanceFromOrigin || 0;
//                 const returnFinalLeg = parseFloat((returnTotalDist - returnLastStopDist).toFixed(1));
//                 if (returnFinalLeg > 0) {
//                     setNewRoute(prev => ({ ...prev, downManualFinalLeg: String(returnFinalLeg) }));
//                 }
//             } else {
//                 setDownStops([]);
//             }
//         } else {
//             setIsRoundTrip(false);
//             setDownStops([]);
//             setReturnOriginTimeSlots([]);
//             setReturnDestTimeSlots([]);
//         }

//         toast.success(`Master route "${masterRoute.masterRouteName}" loaded successfully! Please verify and fill in the timings.`);
//     };

//     const handleEditRoute = async (route) => {
//         try {
//             const response = await getRouteById(route.id, token);
//             const routeData = response.data || route.fullData;

//             setEditingRoute(routeData);

//             const resolvedIsMultiTrip = routeData.isMultiTrip ||
//                 (routeData.origin?.timings && routeData.origin.timings.length > 0) ||
//                 (routeData.intermediateStops && routeData.intermediateStops.some(
//                     stop => stop.timings && stop.timings.length > 0
//                 )) ||
//                 (routeData.numberOfTrips && routeData.numberOfTrips > 1);

//             setEditIsMultiTrip(resolvedIsMultiTrip);

//             let resolvedNumberOfTrips = 1;
//             if (resolvedIsMultiTrip) {
//                 resolvedNumberOfTrips = routeData.numberOfTrips ||
//                     routeData.origin?.timings?.length ||
//                     (routeData.intermediateStops && routeData.intermediateStops.length > 0 ?
//                         routeData.intermediateStops[0]?.timings?.length || 1 : 1);
//                 setEditNumberOfTrips(resolvedNumberOfTrips);
//             } else {
//                 setEditNumberOfTrips(1);
//             }

//             const origin = routeData.origin || {};
//             const destination = routeData.destination || {};
//             const routeDetails = routeData.routeDetails || {};
//             const estimatedDuration = routeDetails.estimatedDuration || {};

//             const transformStops = (stops) => {
//                 return (stops || []).map((stop, index, array) => {
//                     const actualDist = stop.distanceFromOrigin || 0;
//                     const prevStop = index > 0 ? array[index - 1] : null;
//                     const prevDist = prevStop ? (prevStop.distanceFromOrigin || 0) : 0;

//                     let manualDistFromPrev = stop.manualDistFromPrev
//                         ? parseFloat(stop.manualDistFromPrev)
//                         : null;

//                     if (!manualDistFromPrev && actualDist > 0) {
//                         const calculated = parseFloat((actualDist - prevDist).toFixed(1));
//                         if (calculated > 0) manualDistFromPrev = calculated;
//                     }

//                     const sortedTimings = sortTimings(stop.timings || []);
//                     const hasMultiTimings = sortedTimings.length > 0;

//                     let finalTimings = sortedTimings;
//                     if (resolvedIsMultiTrip && sortedTimings.length < resolvedNumberOfTrips) {
//                         const existingSequences = sortedTimings.map(t => t.timeSlotSequence);
//                         finalTimings = [...sortedTimings];
//                         for (let i = 1; i <= resolvedNumberOfTrips; i++) {
//                             if (!existingSequences.includes(i)) {
//                                 finalTimings.push({
//                                     timeSlotSequence: i,
//                                     arrivalTime: '',
//                                     departureTime: ''
//                                 });
//                             }
//                         }
//                         finalTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
//                     } else if (resolvedIsMultiTrip && sortedTimings.length > resolvedNumberOfTrips) {
//                         finalTimings = sortedTimings
//                             .filter(t => t.timeSlotSequence <= resolvedNumberOfTrips)
//                             .map((t, i) => ({ ...t, timeSlotSequence: i + 1 }));
//                     }

//                     return {
//                         city: stop.city,
//                         state: stop.state || '',
//                         address: stop.address || '',
//                         terminal: stop.terminal || '',
//                         arrivalTime: hasMultiTimings ? '' : (stop.arrivalTime || ''),
//                         departureTime: hasMultiTimings ? '' : (stop.departureTime || ''),
//                         timings: finalTimings,
//                         stopType: stop.stopType || 'none',
//                         coordinates: stop.coordinates || { lat: 0, lng: 0 },
//                         distanceFromOrigin: actualDist,
//                         manualDistFromPrev: manualDistFromPrev,
//                         manualDistToNext: stop.manualDistToNext
//                             ? parseFloat(stop.manualDistToNext)
//                             : null,
//                         isManualStop: stop.isManualStop === true ||
//                             !stop.coordinates ||
//                             (stop.coordinates.lat === 0 && stop.coordinates.lng === 0)
//                     };
//                 });
//             };

//             const transformedStops = transformStops(routeData.intermediateStops);

//             let forwardManualFinalLeg = '';
//             if (routeDetails.totalDistance && transformedStops.length > 0) {
//                 const lastStopDist = transformedStops[transformedStops.length - 1].distanceFromOrigin || 0;
//                 const calculated = routeDetails.totalDistance - lastStopDist;
//                 if (calculated > 0) {
//                     forwardManualFinalLeg = calculated.toFixed(1);
//                 }
//             }

//             const originTimings = sortTimings(origin.timings || []);
//             const destTimings = sortTimings(destination.timings || []);

//             let finalOriginTimings = [...originTimings];
//             if (resolvedIsMultiTrip && originTimings.length < resolvedNumberOfTrips) {
//                 const existingSequences = originTimings.map(t => t.timeSlotSequence);
//                 for (let i = 1; i <= resolvedNumberOfTrips; i++) {
//                     if (!existingSequences.includes(i)) {
//                         finalOriginTimings.push({
//                             timeSlotSequence: i,
//                             departureTime: '',
//                             arrivalTime: ''
//                         });
//                     }
//                 }
//                 finalOriginTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
//             }

//             let finalDestTimings = [...destTimings];
//             if (resolvedIsMultiTrip && destTimings.length < resolvedNumberOfTrips) {
//                 const existingSequences = destTimings.map(t => t.timeSlotSequence);
//                 for (let i = 1; i <= resolvedNumberOfTrips; i++) {
//                     if (!existingSequences.includes(i)) {
//                         finalDestTimings.push({
//                             timeSlotSequence: i,
//                             arrivalTime: '',
//                             departureTime: ''
//                         });
//                     }
//                 }
//                 finalDestTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
//             }

//             setEditForm({
//                 routeNumber: routeData.routeNumber || '',
//                 routeName: routeData.routeName || '',
//                 localRouteName: routeData.localRouteName || '',
//                 isMultiTrip: resolvedIsMultiTrip,
//                 numberOfTrips: resolvedNumberOfTrips,
//                 timeSlots: routeData.timeSlots || [],
//                 originCity: origin.city || '',
//                 originState: origin.state || '',
//                 originAddress: origin.address || '',
//                 originTerminal: origin.terminal || '',
//                 originDepTime: origin.departureTime || '',
//                 originCoords: origin.coordinates || { lat: 0, lng: 0 },
//                 originTimings: finalOriginTimings,
//                 destCity: destination.city || '',
//                 destState: destination.state || '',
//                 destAddress: destination.address || '',
//                 destTerminal: destination.terminal || '',
//                 destArrTime: destination.arrivalTime || '',
//                 destCoords: destination.coordinates || { lat: 0, lng: 0 },
//                 destTimings: finalDestTimings,
//                 totalDistance: routeDetails.totalDistance || '',
//                 durationHours: estimatedDuration.hours || '',
//                 durationMinutes: estimatedDuration.minutes || '',
//                 intermediateStops: transformedStops,
//                 isActive: routeData.isActive !== undefined ? routeData.isActive : true,
//                 isRoundTrip: routeData.isRoundTrip || false,
//                 returnJourney: routeData.returnJourney || null,
//                 upManualFinalLeg: forwardManualFinalLeg,
//                 upManualFirstLeg: transformedStops.length > 0 && transformedStops[0].manualDistFromPrev
//                     ? String(transformedStops[0].manualDistFromPrev)
//                     : ''
//             });

//             if (transformedStops.length > 0) {
//                 setUpStops(transformedStops);
//                 if (transformedStops.every(stop => stop.distanceFromOrigin > 0)) {
//                     setIsDistanceCalculated(prev => ({ ...prev, up: true }));
//                 }
//             } else {
//                 setUpStops([]);
//             }

//             if (routeData.isRoundTrip && routeData.returnJourney) {
//                 const returnJourney = routeData.returnJourney;
//                 const returnOrigin = returnJourney.origin || {};
//                 const returnDestination = returnJourney.destination || {};
//                 const returnRouteDetails = returnJourney.routeDetails || {};
//                 const returnEstimatedDuration = returnRouteDetails.estimatedDuration || {};

//                 const transformedReturnStops = transformStops(returnJourney.intermediateStops);

//                 let returnManualFinalLeg = '';
//                 if (returnRouteDetails.totalDistance && transformedReturnStops.length > 0) {
//                     const lastStopDist = transformedReturnStops[transformedReturnStops.length - 1].distanceFromOrigin || 0;
//                     const calculated = returnRouteDetails.totalDistance - lastStopDist;
//                     if (calculated > 0) {
//                         returnManualFinalLeg = calculated.toFixed(1);
//                     }
//                 }

//                 let returnOriginTimings = sortTimings(returnOrigin.timings || []);
//                 let returnDestTimings = sortTimings(returnDestination.timings || []);

//                 if (resolvedIsMultiTrip && returnOriginTimings.length < resolvedNumberOfTrips) {
//                     const existingSequences = returnOriginTimings.map(t => t.timeSlotSequence);
//                     for (let i = 1; i <= resolvedNumberOfTrips; i++) {
//                         if (!existingSequences.includes(i)) {
//                             returnOriginTimings.push({
//                                 timeSlotSequence: i,
//                                 departureTime: '',
//                                 arrivalTime: ''
//                             });
//                         }
//                     }
//                     returnOriginTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
//                 } else if (resolvedIsMultiTrip && returnOriginTimings.length === 0) {
//                     returnOriginTimings = finalOriginTimings.map(t => ({
//                         timeSlotSequence: t.timeSlotSequence,
//                         departureTime: '',
//                         arrivalTime: ''
//                     }));
//                 }

//                 if (resolvedIsMultiTrip && returnDestTimings.length < resolvedNumberOfTrips) {
//                     const existingSequences = returnDestTimings.map(t => t.timeSlotSequence);
//                     for (let i = 1; i <= resolvedNumberOfTrips; i++) {
//                         if (!existingSequences.includes(i)) {
//                             returnDestTimings.push({
//                                 timeSlotSequence: i,
//                                 arrivalTime: '',
//                                 departureTime: ''
//                             });
//                         }
//                     }
//                     returnDestTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
//                 } else if (resolvedIsMultiTrip && returnDestTimings.length === 0) {
//                     returnDestTimings = finalDestTimings.map(t => ({
//                         timeSlotSequence: t.timeSlotSequence,
//                         arrivalTime: '',
//                         departureTime: ''
//                     }));
//                 }

//                 setEditForm(prev => ({
//                     ...prev,
//                     returnOriginCity: returnOrigin.city || destination.city || '',
//                     returnOriginState: returnOrigin.state || destination.state || '',
//                     returnOriginAddress: returnOrigin.address || destination.address || '',
//                     returnOriginTerminal: returnOrigin.terminal || destination.terminal || '',
//                     returnOriginDepTime: returnOrigin.departureTime || '',
//                     returnOriginCoords: returnOrigin.coordinates || destination.coordinates || { lat: 0, lng: 0 },
//                     returnOriginTimings: returnOriginTimings,
//                     returnDestCity: returnDestination.city || origin.city || '',
//                     returnDestState: returnDestination.state || origin.state || '',
//                     returnDestAddress: returnDestination.address || origin.address || '',
//                     returnDestTerminal: returnDestination.terminal || origin.terminal || '',
//                     returnDestArrTime: returnDestination.arrivalTime || '',
//                     returnDestCoords: returnDestination.coordinates || origin.coordinates || { lat: 0, lng: 0 },
//                     returnDestTimings: returnDestTimings,
//                     returnTotalDistance: returnRouteDetails.totalDistance || routeDetails.totalDistance || '',
//                     returnDurationHours: returnEstimatedDuration.hours || estimatedDuration.hours || '',
//                     returnDurationMinutes: returnEstimatedDuration.minutes || estimatedDuration.minutes || '',
//                     returnIntermediateStops: transformedReturnStops,
//                     returnManualFinalLeg: returnManualFinalLeg,
//                     returnManualFirstLeg: transformedReturnStops.length > 0 && transformedReturnStops[0].manualDistFromPrev
//                         ? String(transformedReturnStops[0].manualDistFromPrev)
//                         : ''
//                 }));

//                 if (transformedReturnStops.length > 0) {
//                     setDownStops(transformedReturnStops);
//                     if (transformedReturnStops.every(stop => stop.distanceFromOrigin > 0)) {
//                         setIsDistanceCalculated(prev => ({ ...prev, down: true }));
//                     }
//                 } else {
//                     setDownStops([]);
//                 }
//             } else {
//                 setDownStops([]);
//                 setEditForm(prev => ({
//                     ...prev,
//                     returnOriginCity: destination.city || '',
//                     returnOriginState: destination.state || '',
//                     returnOriginAddress: destination.address || '',
//                     returnOriginTerminal: destination.terminal || '',
//                     returnOriginDepTime: '',
//                     returnOriginCoords: destination.coordinates || { lat: 0, lng: 0 },
//                     returnDestCity: origin.city || '',
//                     returnDestState: origin.state || '',
//                     returnDestAddress: origin.address || '',
//                     returnDestTerminal: origin.terminal || '',
//                     returnDestArrTime: '',
//                     returnDestCoords: origin.coordinates || { lat: 0, lng: 0 },
//                     returnTotalDistance: routeDetails.totalDistance || '',
//                     returnDurationHours: estimatedDuration.hours || '',
//                     returnDurationMinutes: estimatedDuration.minutes || '',
//                     returnIntermediateStops: [],
//                     returnManualFinalLeg: '',
//                     returnManualFirstLeg: ''
//                 }));
//             }

//             if (routeData.isRoundTrip) {
//                 setIsRoundTrip(true);
//                 setActiveRouteTab('UP');
//             } else {
//                 setIsRoundTrip(false);
//                 setActiveRouteTab('UP');
//             }

//             setShowEditModal(true);

//         } catch (err) {
//             console.error('Error fetching route for edit:', err);
//             toast.error('Failed to load route for editing');
//         }
//     };

//     const handleEditRoundTripToggle = (checked) => {
//         if (checked) {
//             const originCity = editForm.originCity || newRoute.upOriginCity || '';
//             const originState = editForm.originState || newRoute.upOriginState || '';
//             const originAddress = editForm.originAddress || newRoute.upOriginAddress || '';
//             const originTerminal = editForm.originTerminal || newRoute.upOriginTerminal || '';
//             const originCoords = editForm.originCoords || newRoute.upOriginCoords || { lat: 0, lng: 0 };
//             const originDepTime = editForm.originDepTime || newRoute.upOriginDepTime || '';

//             const destCity = editForm.destCity || newRoute.upDestCity || '';
//             const destState = editForm.destState || newRoute.upDestState || '';
//             const destAddress = editForm.destAddress || newRoute.upDestAddress || '';
//             const destTerminal = editForm.destTerminal || newRoute.upDestTerminal || '';
//             const destCoords = editForm.destCoords || newRoute.upDestCoords || { lat: 0, lng: 0 };
//             const destArrTime = editForm.destArrTime || newRoute.upDestArrTime || '';

//             const totalDist = editForm.totalDistance || newRoute.upTotalDistance || '';
//             const durationH = editForm.durationHours || newRoute.upDurationHours || '';
//             const durationM = editForm.durationMinutes || newRoute.upDurationMinutes || '';

//             const numTrips = editForm.numberOfTrips || editNumberOfTrips || 1;
//             const isMultiTripMode = editForm.isMultiTrip || editIsMultiTrip || false;

//             let returnOriginTimings = [];
//             let returnDestTimings = [];

//             if (isMultiTripMode) {
//                 if (editForm.originTimings && editForm.originTimings.length > 0) {
//                     returnOriginTimings = editForm.originTimings.map(t => ({
//                         timeSlotSequence: t.timeSlotSequence,
//                         departureTime: '',
//                         arrivalTime: ''
//                     }));
//                 } else {
//                     returnOriginTimings = Array.from({ length: numTrips }, (_, i) => ({
//                         timeSlotSequence: i + 1,
//                         departureTime: '',
//                         arrivalTime: ''
//                     }));
//                 }

//                 if (editForm.destTimings && editForm.destTimings.length > 0) {
//                     returnDestTimings = editForm.destTimings.map(t => ({
//                         timeSlotSequence: t.timeSlotSequence,
//                         arrivalTime: '',
//                         departureTime: ''
//                     }));
//                 } else {
//                     returnDestTimings = Array.from({ length: numTrips }, (_, i) => ({
//                         timeSlotSequence: i + 1,
//                         arrivalTime: '',
//                         departureTime: ''
//                     }));
//                 }
//             }

//             setEditForm(prev => ({
//                 ...prev,
//                 returnOriginCity: destCity,
//                 returnOriginState: destState,
//                 returnOriginAddress: destAddress,
//                 returnOriginTerminal: destTerminal,
//                 returnOriginCoords: destCoords,
//                 returnOriginDepTime: isMultiTripMode ? '' : destArrTime,
//                 returnOriginTimings: returnOriginTimings,

//                 returnDestCity: originCity,
//                 returnDestState: originState,
//                 returnDestAddress: originAddress,
//                 returnDestTerminal: originTerminal,
//                 returnDestCoords: originCoords,
//                 returnDestArrTime: isMultiTripMode ? '' : originDepTime,
//                 returnDestTimings: returnDestTimings,

//                 returnTotalDistance: totalDist,
//                 returnDurationHours: durationH,
//                 returnDurationMinutes: durationM,

//                 isMultiTrip: isMultiTripMode,
//                 numberOfTrips: numTrips,
//                 isRoundTrip: true
//             }));

//             if (upStops.length > 0) {
//                 const upTotalDist = parseFloat(editForm.totalDistance || newRoute.upTotalDistance || 0);
//                 const reversedStops = [...upStops].reverse();

//                 const upDistances = upStops.map(stop => stop.distanceFromOrigin || 0);
//                 const upSegments = [];
//                 let prevDist = 0;
//                 for (let i = 0; i < upDistances.length; i++) {
//                     const segment = upDistances[i] - prevDist;
//                     upSegments.push(segment > 0 ? segment : 5);
//                     prevDist = upDistances[i];
//                 }
//                 const lastSegment = upTotalDist - (upDistances[upDistances.length - 1] || 0);
//                 upSegments.push(lastSegment > 0 ? lastSegment : 5);

//                 const downSegments = [...upSegments].reverse();

//                 const newDownStops = [];
//                 let cumulativeDist = 0;

//                 for (let i = 0; i < reversedStops.length; i++) {
//                     const stop = reversedStops[i];
//                     let newStopType = stop.stopType;
//                     if (stop.stopType === 'boarding') newStopType = 'dropping';
//                     else if (stop.stopType === 'dropping') newStopType = 'boarding';

//                     const segmentDist = downSegments[i] || 5;
//                     cumulativeDist += segmentDist;

//                     let stopTimings = [];
//                     if (isMultiTripMode) {
//                         if (stop.timings && stop.timings.length > 0) {
//                             stopTimings = stop.timings.map(t => ({
//                                 timeSlotSequence: t.timeSlotSequence,
//                                 arrivalTime: '',
//                                 departureTime: ''
//                             }));
//                         } else {
//                             stopTimings = Array.from({ length: numTrips }, (_, idx) => ({
//                                 timeSlotSequence: idx + 1,
//                                 arrivalTime: '',
//                                 departureTime: ''
//                             }));
//                         }
//                     }

//                     let arrivalTime = '';
//                     let departureTime = '';
//                     if (!isMultiTripMode) {
//                         if (stop.departureTime) {
//                             departureTime = stop.departureTime;
//                         }
//                         if (stop.arrivalTime) {
//                             arrivalTime = stop.arrivalTime;
//                         }
//                     }

//                     newDownStops.push({
//                         ...stop,
//                         sequence: i + 1,
//                         stopType: newStopType,
//                         distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//                         manualDistFromPrev: parseFloat(segmentDist.toFixed(1)),
//                         manualDistToNext: i < reversedStops.length - 1 ? parseFloat(downSegments[i + 1]?.toFixed(1) || 0) : null,
//                         arrivalTime: isMultiTripMode ? '' : arrivalTime,
//                         departureTime: isMultiTripMode ? '' : departureTime,
//                         timings: stopTimings
//                     });
//                 }

//                 const finalSegment = downSegments[downSegments.length - 1] || 5;
//                 if (newDownStops.length > 0 && finalSegment > 0) {
//                     const lastIndex = newDownStops.length - 1;
//                     newDownStops[lastIndex] = {
//                         ...newDownStops[lastIndex],
//                         manualDistToNext: parseFloat(finalSegment.toFixed(1))
//                     };
//                 }

//                 setDownStops(newDownStops);
//                 setIsDistanceCalculated(prev => ({ ...prev, down: false }));

//                 if (isMultiTripMode) {
//                     toast.info(`Return route populated with ${newDownStops.length} reversed stops. Each stop has ${numTrips} trip timings to set.`);
//                 } else {
//                     toast.info(`Return route populated with ${newDownStops.length} reversed stops.`);
//                 }
//             } else {
//                 toast.info('Return route enabled. Add stops for the return journey or use the "Auto-Fill" button.');
//             }

//             setActiveRouteTab('DOWN');
//         } else {
//             setDownStops([]);
//             setIsDistanceCalculated(prev => ({ ...prev, down: false }));
//             setEditForm(prev => ({
//                 ...prev,
//                 returnOriginCity: '',
//                 returnOriginState: '',
//                 returnOriginAddress: '',
//                 returnOriginTerminal: '',
//                 returnOriginDepTime: '',
//                 returnOriginCoords: null,
//                 returnOriginTimings: [],
//                 returnDestCity: '',
//                 returnDestState: '',
//                 returnDestAddress: '',
//                 returnDestTerminal: '',
//                 returnDestArrTime: '',
//                 returnDestCoords: null,
//                 returnDestTimings: [],
//                 returnTotalDistance: '',
//                 returnDurationHours: '',
//                 returnDurationMinutes: '',
//                 returnIntermediateStops: [],
//                 returnManualFinalLeg: '',
//                 returnManualFirstLeg: '',
//                 isRoundTrip: false
//             }));
//             setActiveRouteTab('UP');
//             toast.info('Return route disabled');
//         }
//     };

//     const handleUpdateRoute = async () => {
//         if (!editForm.routeName) {
//             toast.error('Route Name is required');
//             return;
//         }

//         setIsUpdatingRoute(true);

//         try {
//             const isMultiTripMode = editForm.isMultiTrip || isMultiTrip;

//             const cleanStops = (list, stopType = 'forward') => {
//                 if (!list || !Array.isArray(list)) return [];

//                 return list.map((s, index) => {
//                     if (!s.city) {
//                         throw new Error(`Stop ${index + 1} is missing city name`);
//                     }

//                     const stopObj = {
//                         sequence: index + 1,
//                         city: s.city,
//                         state: s.state || '',
//                         address: s.address || `${s.city}, ${s.state || 'India'}`,
//                         terminal: s.terminal || `${s.city} Bus Stand`,
//                         stopType: s.stopType || 'none',
//                         coordinates: s.coordinates || { lat: 0, lng: 0 },
//                         distanceFromOrigin: s.distanceFromOrigin || 0,
//                     };

//                     if (s.manualDistFromPrev) stopObj.manualDistFromPrev = s.manualDistFromPrev;
//                     if (s.manualDistToNext) stopObj.manualDistToNext = s.manualDistToNext;
//                     if (s.isManualStop) stopObj.isManualStop = s.isManualStop;

//                     if (isMultiTripMode) {
//                         if (s.timings && s.timings.length > 0) {
//                             stopObj.timings = sortTimings(s.timings).map(timing => ({
//                                 timeSlotSequence: timing.timeSlotSequence,
//                                 arrivalTime: timing.arrivalTime || '',
//                                 departureTime: timing.departureTime || timing.arrivalTime || ''
//                             }));
//                         } else {
//                             const numTrips = editForm.numberOfTrips || 1;
//                             stopObj.timings = Array.from({ length: numTrips }, (_, i) => ({
//                                 timeSlotSequence: i + 1,
//                                 arrivalTime: s.arrivalTime || '',
//                                 departureTime: s.departureTime || s.arrivalTime || ''
//                             }));
//                         }
//                         stopObj.arrivalTime = s.arrivalTime || (stopObj.timings[0]?.arrivalTime) || '';
//                         stopObj.departureTime = s.departureTime || (stopObj.timings[0]?.departureTime) || stopObj.arrivalTime;
//                     } else {
//                         if (!s.arrivalTime) {
//                             throw new Error(`Stop ${index + 1} (${s.city}) is missing arrival time`);
//                         }
//                         stopObj.arrivalTime = s.arrivalTime;
//                         stopObj.departureTime = s.departureTime || s.arrivalTime;
//                         stopObj.timings = [];
//                     }

//                     return stopObj;
//                 });
//             };

//             const originData = {
//                 city: editForm.originCity,
//                 state: editForm.originState || '',
//                 address: editForm.originAddress || '',
//                 terminal: editForm.originTerminal || editForm.originCity + ' Terminal',
//                 coordinates: editForm.originCoords || { lat: 0, lng: 0 }
//             };

//             if (isMultiTripMode && editForm.originTimings && editForm.originTimings.length > 0) {
//                 originData.timings = sortTimings(editForm.originTimings).map(t => ({
//                     timeSlotSequence: t.timeSlotSequence,
//                     departureTime: t.departureTime,
//                     arrivalTime: t.arrivalTime || ''
//                 }));
//             } else {
//                 originData.departureTime = editForm.originDepTime;
//                 originData.timings = [];
//             }

//             const destData = {
//                 city: editForm.destCity,
//                 state: editForm.destState || '',
//                 address: editForm.destAddress || '',
//                 terminal: editForm.destTerminal || editForm.destCity + ' Terminal',
//                 coordinates: editForm.destCoords || { lat: 0, lng: 0 },
//                 distanceFromOrigin: parseFloat(editForm.totalDistance || 0)
//             };

//             if (isMultiTripMode && editForm.destTimings && editForm.destTimings.length > 0) {
//                 destData.timings = sortTimings(editForm.destTimings).map(t => ({
//                     timeSlotSequence: t.timeSlotSequence,
//                     arrivalTime: t.arrivalTime,
//                     departureTime: t.departureTime || ''
//                 }));
//             } else {
//                 destData.arrivalTime = editForm.destArrTime;
//                 destData.timings = [];
//             }

//             const updatePayload = {
//                 routeName: editForm.routeName.trim(),
//                 localRouteName: editForm.localRouteName?.trim() || null,
//                 isMultiTrip: isMultiTripMode,
//                 numberOfTrips: editForm.numberOfTrips || 1,
//                 timeSlots: editForm.timeSlots || [],
//                 origin: originData,
//                 destination: destData,
//                 intermediateStops: cleanStops(upStops, 'forward'),
//                 routeDetails: {
//                     totalDistance: parseFloat(editForm.totalDistance || 0),
//                     estimatedDuration: {
//                         hours: parseInt(editForm.durationHours || 0, 10),
//                         minutes: parseInt(editForm.durationMinutes || 0, 10)
//                     }
//                 },
//                 isActive: editForm.isActive,
//                 isRoundTrip: editForm.isRoundTrip
//             };

//             if (editForm.isRoundTrip) {
//                 const returnOriginData = {
//                     city: editForm.returnOriginCity || editForm.destCity,
//                     state: editForm.returnOriginState || editForm.destState,
//                     address: editForm.returnOriginAddress || editForm.destAddress,
//                     terminal: editForm.returnOriginTerminal || editForm.destTerminal,
//                     coordinates: editForm.returnOriginCoords || editForm.destCoords || { lat: 0, lng: 0 }
//                 };

//                 if (isMultiTripMode && editForm.returnOriginTimings && editForm.returnOriginTimings.length > 0) {
//                     returnOriginData.timings = sortTimings(editForm.returnOriginTimings).map(t => ({
//                         timeSlotSequence: t.timeSlotSequence,
//                         departureTime: t.departureTime || '',
//                         arrivalTime: t.arrivalTime || ''
//                     }));
//                 } else if (isMultiTripMode && originData.timings && originData.timings.length > 0) {
//                     returnOriginData.timings = originData.timings.map(t => ({
//                         timeSlotSequence: t.timeSlotSequence,
//                         departureTime: '',
//                         arrivalTime: ''
//                     }));
//                 } else {
//                     returnOriginData.departureTime = editForm.returnOriginDepTime;
//                     returnOriginData.timings = [];
//                 }

//                 const returnDestData = {
//                     city: editForm.returnDestCity || editForm.originCity,
//                     state: editForm.returnDestState || editForm.originState,
//                     address: editForm.returnDestAddress || editForm.originAddress,
//                     terminal: editForm.returnDestTerminal || editForm.originTerminal,
//                     coordinates: editForm.returnDestCoords || editForm.originCoords || { lat: 0, lng: 0 },
//                     distanceFromOrigin: parseFloat(editForm.returnTotalDistance || 0)
//                 };

//                 if (isMultiTripMode && editForm.returnDestTimings && editForm.returnDestTimings.length > 0) {
//                     returnDestData.timings = sortTimings(editForm.returnDestTimings).map(t => ({
//                         timeSlotSequence: t.timeSlotSequence,
//                         arrivalTime: t.arrivalTime || '',
//                         departureTime: t.departureTime || ''
//                     }));
//                 } else if (isMultiTripMode && destData.timings && destData.timings.length > 0) {
//                     returnDestData.timings = destData.timings.map(t => ({
//                         timeSlotSequence: t.timeSlotSequence,
//                         arrivalTime: '',
//                         departureTime: ''
//                     }));
//                 } else {
//                     returnDestData.arrivalTime = editForm.returnDestArrTime;
//                     returnDestData.timings = [];
//                 }

//                 const cleanedReturnStops = downStops.map((stop, index) => {
//                     const stopObj = {
//                         sequence: index + 1,
//                         city: stop.city,
//                         state: stop.state || '',
//                         address: stop.address || `${stop.city}, ${stop.state || 'India'}`,
//                         terminal: stop.terminal || `${stop.city} Bus Stand`,
//                         stopType: stop.stopType || 'none',
//                         coordinates: stop.coordinates || { lat: 0, lng: 0 },
//                         distanceFromOrigin: stop.distanceFromOrigin || 0,
//                     };

//                     if (stop.manualDistFromPrev) stopObj.manualDistFromPrev = stop.manualDistFromPrev;
//                     if (stop.manualDistToNext) stopObj.manualDistToNext = stop.manualDistToNext;
//                     if (stop.isManualStop) stopObj.isManualStop = stop.isManualStop;

//                     if (isMultiTripMode) {
//                         if (stop.timings && stop.timings.length > 0) {
//                             stopObj.timings = sortTimings(stop.timings).map(timing => ({
//                                 timeSlotSequence: timing.timeSlotSequence,
//                                 arrivalTime: timing.arrivalTime || '',
//                                 departureTime: timing.departureTime || timing.arrivalTime || ''
//                             }));
//                         } else {
//                             const numTrips = editForm.numberOfTrips || 1;
//                             stopObj.timings = Array.from({ length: numTrips }, (_, i) => ({
//                                 timeSlotSequence: i + 1,
//                                 arrivalTime: stop.arrivalTime || '',
//                                 departureTime: stop.departureTime || stop.arrivalTime || ''
//                             }));
//                         }
//                         stopObj.arrivalTime = stop.arrivalTime || (stopObj.timings[0]?.arrivalTime) || '';
//                         stopObj.departureTime = stop.departureTime || (stopObj.timings[0]?.departureTime) || stopObj.arrivalTime;
//                     } else {
//                         if (!stop.arrivalTime) {
//                             throw new Error(`Return stop ${index + 1} (${stop.city}) is missing arrival time`);
//                         }
//                         stopObj.arrivalTime = stop.arrivalTime;
//                         stopObj.departureTime = stop.departureTime || stop.arrivalTime;
//                         stopObj.timings = [];
//                     }

//                     return stopObj;
//                 });

//                 updatePayload.returnOrigin = returnOriginData;
//                 updatePayload.returnDestination = returnDestData;
//                 updatePayload.returnIntermediateStops = cleanedReturnStops;
//                 updatePayload.returnRouteDetails = {
//                     totalDistance: parseFloat(editForm.returnTotalDistance || 0),
//                     estimatedDuration: {
//                         hours: parseInt(editForm.returnDurationHours || 0, 10),
//                         minutes: parseInt(editForm.returnDurationMinutes || 0, 10)
//                     }
//                 };
//             }

//             const response = isEditingPending
//     ? await updatePendingRoute(editingPendingId, updatePayload, token)
//     : await updateRoute(editingRoute._id, updatePayload, token);

// if (response.success) {
//     toast.success(isEditingPending ? 'Pending route updated successfully!' : 'Route updated successfully!');
//     setShowEditModal(false);
//     setEditingRoute(null);
//     setEditForm({});
//     setIsEditingPending(false);
//     setEditingPendingId(null);

//     if (isEditingPending) {
//         await fetchPendingRoutes();
//     } else {
//         fetchRoutes();
//     }
// } else {
//     throw new Error(response.message || 'Failed to update route');
// }
//         } catch (err) {
//             console.error('Error updating route:', err);
//             toast.error(err.message || 'Failed to update route');
//         } finally {
//             setIsUpdatingRoute(false);
//         }
//     };

//     const handleEditOriginSelect = (location) => {
//         setEditForm(prev => ({
//             ...prev,
//             originCity: location.city || location.name || '',
//             originState: location.state || '',
//             originAddress: location.address || '',
//             originCoords: location.coordinates || { lat: 0, lng: 0 }
//         }));
//     };

//     const handleEditDestSelect = (location) => {
//         setEditForm(prev => ({
//             ...prev,
//             destCity: location.city || location.name || '',
//             destState: location.state || '',
//             destAddress: location.address || '',
//             destCoords: location.coordinates || { lat: 0, lng: 0 }
//         }));
//     };

//     const handleToggleStatus = async (routeId, currentStatus) => {
//         const newStatus = !currentStatus;
//         const action = newStatus ? 'activate' : 'deactivate';

//         if (window.confirm(`Are you sure you want to ${action} this route?`)) {
//             try {
//                 const response = await toggleRouteStatus(routeId, newStatus, token);

//                 if (response.success) {
//                     setRoutes(prevRoutes =>
//                         prevRoutes.map(route =>
//                             route.id === routeId ? {
//                                 ...route,
//                                 isActive: newStatus,
//                                 status: newStatus ? 'Active' : 'Inactive'
//                             } : route
//                         )
//                     );
//                     toast.success(`Route ${action}d successfully!`);
//                 } else {
//                     throw new Error(response.message || `Failed to ${action} route`);
//                 }
//             } catch (err) {
//                 console.error(`Error ${action}ing route:`, err);
//                 toast.error(`Failed to ${action} route`);
//             }
//         }
//     };

//     const saveInsertedStop = () => {
//         if (!insertStopForm.city) {
//             toast.error('City is required');
//             return;
//         }
//         if (!insertStopForm.state || insertStopForm.state.trim() === '') {
//             toast.error('State is required');
//             return;
//         }

//         if (!insertStopForm.address || insertStopForm.address.trim() === '') {
//             toast.error('Address is required');
//             return;
//         }

//         if (!insertStopForm.terminal || insertStopForm.terminal.trim() === '') {
//             toast.error('Terminal is required');
//             return;
//         }
//         if (!insertStopForm.arrivalTime) {
//             toast.error('Arrival time is required');
//             return;
//         }
//         const isManualLocation = insertStopForm.isManualStop;
//         if (isManualLocation && (!insertStopForm.manualDistFromPrev || parseFloat(insertStopForm.manualDistFromPrev) <= 0)) {
//             toast.error('For manual stops, please provide distance from previous stop');
//             return;
//         }

//         let stopType = 'none';
//         if (insertStopForm.isBoarding && insertStopForm.isDropping) stopType = 'both';
//         else if (insertStopForm.isBoarding) stopType = 'boarding';
//         else if (insertStopForm.isDropping) stopType = 'dropping';

//         const type = activeRouteTab === 'UP' ? 'up' : 'down';
//         const currentStops = type === 'up' ? [...upStops] : [...downStops];

//         let manualDistFromPrev = isManualLocation ? parseFloat(insertStopForm.manualDistFromPrev) : null;
//         let manualDistToNext = insertStopForm.manualDistToNext ? parseFloat(insertStopForm.manualDistToNext) : null;

//         let distanceFromOrigin = 0;
//         if (pendingInsertIndex > 0 && currentStops[pendingInsertIndex - 1]) {
//             distanceFromOrigin = (currentStops[pendingInsertIndex - 1].distanceFromOrigin || 0) + (manualDistFromPrev || 0);
//         } else {
//             distanceFromOrigin = manualDistFromPrev || 0;
//         }

//         const newStop = {
//             city: insertStopForm.city,
//             state: insertStopForm.state || '',
//             address: insertStopForm.address || `${insertStopForm.city}, ${insertStopForm.state || 'India'}`,
//             terminal: insertStopForm.terminal || `${insertStopForm.city} Bus Stand`,
//             arrivalTime: insertStopForm.arrivalTime,
//             departureTime: insertStopForm.departureTime || insertStopForm.arrivalTime,
//             stopType,
//             coordinates: isManualLocation ? { lat: 0, lng: 0 } : null,
//             manualDistFromPrev,
//             manualDistToNext,
//             distanceFromOrigin,
//             isManualStop: isManualLocation
//         };

//         currentStops.splice(pendingInsertIndex, 0, newStop);
//         setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));

//         if (type === 'up') {
//             setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//         } else {
//             setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//         }

//         toast.success(`Stop "${insertStopForm.city}" inserted at position ${pendingInsertIndex + 1}`);
//         setShowStopInsertModal(false);
//         setPendingInsertIndex(null);
//         setInsertCitySuggestions([]);
//         setShowInsertCityDropdown(false);
//     };

//     const handleDeleteRoute = async (routeId) => {
//         if (window.confirm('Are you sure you want to delete this route?')) {
//             try {
//                 const response = await deleteRoute(routeId, token);

//                 if (response.success) {
//                     setRoutes(prevRoutes => prevRoutes.filter(route => route.id !== routeId));
//                     setTotalRoutes(prev => prev - 1);
//                     toast.success('Route deleted successfully!');
//                 } else {
//                     throw new Error(response.message || 'Failed to delete route');
//                 }
//             } catch (err) {
//                 console.error('Error deleting route:', err);
//                 toast.error('Failed to delete route');
//             }
//         }
//     };

//     const renderInsertButton = (idx, type = 'up') => {
//         const isOpen = inlineInsertIndex === idx;
//         const stops = getActiveStops();

//         return (
//             <div key={`insert-wrap-${idx}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '8px 0' }}>
//                 <div style={{ width: 2, height: 16, background: 'rgba(0,0,0,.12)', flexShrink: 0 }} />

//                 <button
//                     onClick={() => {
//                         if (isOpen) {
//                             setInlineInsertIndex(null);
//                             setInlineInsertCitySuggestions([]);
//                             setShowInlineInsertDropdown(false);
//                         } else {
//                             let defaultState = '';
//                             const currentStops = type === 'up' ? upStops : downStops;
//                             if (idx > 0 && currentStops[idx - 1]?.state) {
//                                 defaultState = currentStops[idx - 1].state;
//                             } else if (newRoute.upOriginState) {
//                                 defaultState = newRoute.upOriginState;
//                             }

//                             setInlineInsertForm({
//                                 city: '', state: defaultState, address: '', terminal: '',
//                                 arrivalTime: '', departureTime: '',
//                                 isBoarding: false, isDropping: false,
//                                 manualDistFromPrev: '', manualDistToNext: '',
//                                 isManual: true,
//                                 stopType: 'none'
//                             });
//                             setInlineInsertCitySuggestions([]);
//                             setShowInlineInsertDropdown(false);
//                             setInlineInsertIndex(idx);
//                         }
//                     }}
//                     style={{
//                         display: 'flex', alignItems: 'center', gap: 6,
//                         padding: '5px 14px', borderRadius: 999,
//                         border: `1.5px ${isOpen ? 'solid' : 'dashed'} ${isOpen ? '#378add' : 'rgba(0,0,0,.25)'}`,
//                         background: isOpen ? '#e6f1fb' : 'var(--color-background-primary, #fff)',
//                         fontSize: 12, fontWeight: 500,
//                         color: isOpen ? '#185fa5' : 'var(--color-text-secondary, #666)',
//                         cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all .15s'
//                     }}
//                 >
//                     <span style={{ fontSize: 15 }}>{isOpen ? '✕' : '+'}</span>
//                     {isOpen ? 'Cancel insert' : 'Insert stop here'}
//                 </button>

//                 <div style={{ width: 2, height: isOpen ? 0 : 16, background: 'rgba(0,0,0,.12)', flexShrink: 0 }} />

//                 {isOpen && renderInlineInsertPanel(idx)}
//             </div>
//         );
//     };

//     const activeRoutes = currentRoutes.filter(r => r.isActive).length;
//     const totalDistance = currentRoutes.reduce((sum, route) => sum + (parseInt(route.distance) || 0), 0);
//     const totalStops = currentRoutes.reduce((sum, route) => sum + (parseInt(route.stops) || 0), 0);

//     if (isLoading) {
//         return (
//             <div className="management-page">
//                 <div className="page-header">
//                     <div className="skeleton-header-title"></div>
//                     <div className="header-actions">
//                         <div className="skeleton-search"></div>
//                         <div className="skeleton-button"></div>
//                         <div className="skeleton-button"></div>
//                     </div>
//                 </div>

//                 <div className="stats-cards">
//                     {[1, 2, 3, 4].map((i) => (
//                         <SkeletonStatsCard key={i} />
//                     ))}
//                 </div>

//                 <SkeletonTable />

//                 <div className="pagination-container">
//                     <div className="skeleton-pagination-info"></div>
//                     <div className="skeleton-pagination-controls"></div>
//                 </div>
//             </div>
//         );
//     }


//     return (
//         <div className="management-page">
//             <div className="page-header">
//                 <h1>Route Management</h1>
//                 <div className="header-actions">
//                     <div className="filter-group">
//                         <input
//                             type="text"
//                             placeholder="Search routes by name..."
//                             className="search-input"
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                         />
//                     </div>
//                     <div className="filter-group">
//                         <div className="location-input-container" style={{ minWidth: '200px' }}>
//                             <input
//                                 type="text"
//                                 placeholder="Filter by Origin City"
//                                 className="search-input"
//                                 value={filterOrigin}
//                                 onChange={(e) => {
//                                     setFilterOrigin(e.target.value);
//                                     searchCitySuggestions(e.target.value, 'origin');
//                                 }}
//                                 onFocus={() => filterOrigin && setShowOriginSuggestions(true)}
//                                 onBlur={() => setTimeout(() => setShowOriginSuggestions(false), 200)}
//                             />
//                             {showOriginSuggestions && originSuggestions.length > 0 && (
//                                 <div className="location-suggestions" style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 1000 }}>
//                                     {originSuggestions.map((suggestion, idx) => (
//                                         <div
//                                             key={idx}
//                                             className="suggestion-item"
//                                             onClick={() => {
//                                                 setFilterOrigin(suggestion.city);
//                                                 setShowOriginSuggestions(false);
//                                                 setCurrentPage(1);
//                                             }}
//                                         >
//                                             {suggestion.city}
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                     <div className="filter-group">
//                         <div className="location-input-container" style={{ minWidth: '200px' }}>
//                             <input
//                                 type="text"
//                                 placeholder="Filter by Destination City"
//                                 className="search-input"
//                                 value={filterDestination}
//                                 onChange={(e) => {
//                                     setFilterDestination(e.target.value);
//                                     searchCitySuggestions(e.target.value, 'destination');
//                                 }}
//                                 onFocus={() => filterDestination && setShowDestSuggestions(true)}
//                                 onBlur={() => setTimeout(() => setShowDestSuggestions(false), 200)}
//                             />
//                             {showDestSuggestions && destSuggestions.length > 0 && (
//                                 <div className="location-suggestions" style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 1000 }}>
//                                     {destSuggestions.map((suggestion, idx) => (
//                                         <div
//                                             key={idx}
//                                             className="suggestion-item"
//                                             onClick={() => {
//                                                 setFilterDestination(suggestion.city);
//                                                 setShowDestSuggestions(false);
//                                                 setCurrentPage(1);
//                                             }}
//                                         >
//                                             {suggestion.city}
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                     <button className="refresh-btn" onClick={() => {
//                         if (viewMode === 'regular') {
//                             fetchRoutes();
//                         } else {
//                             fetchPendingRoutes();
//                         }
//                     }}>
//                         Refresh
//                     </button>
//                     {viewMode === 'regular' && (
//                         <button className="add-btn" onClick={() => setShowAddModal(true)}>
//                             + Add Route
//                         </button>
//                     )}
//                 </div>
//             </div>

//             <div className="stats-cards">
//                 <div className="stat-card">
//                     <h3>Total Routes</h3>
//                     <p>{totalRoutes}</p>
//                     <span>All registered routes</span>
//                 </div>
//                 <div className="stat-card">
//                     <h3>Active Routes</h3>
//                     <p>{activeRoutes}</p>
//                     <span>Currently active</span>
//                 </div>
//                 <div className="stat-card">
//                     <h3>Total Stops</h3>
//                     <p>{totalStops}</p>
//                     <span>Across all routes</span>
//                 </div>
//                 <div className="stat-card">
//                     <h3>Total Distance</h3>
//                     <p>{totalDistance} km</p>
//                     <span>Covered by all routes</span>
//                 </div>
//             </div>


//             <div className="view-toggle-group" style={{ display: 'flex', gap: '10px', alignItems: 'center', margin: '0 15px' }}>
//                 <button
//                     className={`toggle-btn ${viewMode === 'regular' ? 'active' : ''}`}
//                     onClick={() => {
//                         setViewMode('regular');
//                         setCurrentPage(1);
//                         setSearchTerm('');
//                     }}
//                     style={{
//                         padding: '8px 20px',
//                         borderRadius: '20px',
//                         border: '2px solid #007bff',
//                         backgroundColor: viewMode === 'regular' ? '#007bff' : 'transparent',
//                         color: viewMode === 'regular' ? 'white' : '#007bff',
//                         cursor: 'pointer',
//                         fontWeight: '500',
//                         transition: 'all 0.3s'
//                     }}
//                 >
//                     🗺️ Regular
//                 </button>
//                 <button
//                     className={`toggle-btn ${viewMode === 'pending' ? 'active' : ''}`}
//                     onClick={() => {
//                         setViewMode('pending');
//                         setCurrentPage(1);
//                         setSearchTerm('');
//                     }}
//                     style={{
//                         padding: '8px 20px',
//                         borderRadius: '20px',
//                         border: '2px solid #ff9800',
//                         backgroundColor: viewMode === 'pending' ? '#ff9800' : 'transparent',
//                         color: viewMode === 'pending' ? 'white' : '#ff9800',
//                         cursor: 'pointer',
//                         fontWeight: '500',
//                         transition: 'all 0.3s',
//                         position: 'relative'
//                     }}
//                 >
//                     📋 Executive Submitted
//                     {viewMode === 'pending' && pendingRoutes.length > 0 && (
//                         <span style={{
//                             position: 'absolute',
//                             top: '-8px',
//                             right: '-8px',
//                             backgroundColor: 'red',
//                             color: 'white',
//                             borderRadius: '50%',
//                             width: '20px',
//                             height: '20px',
//                             fontSize: '10px',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             fontWeight: 'bold'
//                         }}>
//                             {pendingRoutes.length}
//                         </span>
//                     )}
//                 </button>
//             </div>

//             <div className="table-container">
//                 <table className="data-table">
//                     <thead>
//                         <tr>
//                             <th>No.</th>
//                             <th>Route Name</th>
//                           <th>Local Route Name</th>
//                             <th>Origin</th>
//                             <th>Destination</th>
//                             <th>Distance</th>
//                             <th>Stops</th>
//                             <th>Type</th>
//                             <th>Logs</th>
//                             <th>Status</th>
//                             <th>Actions</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {currentRoutes.map(route => (
//                             <tr key={route.id} className={route.isPending ? 'pending-row' : ''}>
//                                 <td>{route.serialNo}</td>
//                                 <td>
//                                     {route.routeName}
//                                 </td>
//                                <td>                                
//                 {route.localRouteName || '—'}      
//             </td> 
//                                 <td>
//                                     <div>
//                                         <div>{route.originCity}</div>
//                                         <div style={{ fontSize: '12px', color: '#666' }}>
//                                             {route.departureTime}
//                                         </div>
//                                     </div>
//                                 </td>
//                                 <td>
//                                     <div>
//                                         <div>{route.destinationCity}</div>
//                                         <div style={{ fontSize: '12px', color: '#666' }}>
//                                             {route.arrivalTime}
//                                         </div>
//                                     </div>
//                                 </td>
//                                 <td>{route.distance} km</td>
//                                 <td>{route.stops}</td>
//                                 <td>
//                                     <span className={`route-type-badge ${route.isRoundTrip ? 'roundtrip' : 'oneway'}`}>
//                                         {route.isRoundTrip ? 'Round Trip' : 'One Way'}
//                                     </span>
//                                 </td>
//                                 <td>
//                                     {!route.isPending && (
//                                         <button
//                                             className="action-btn log-btn"
//                                             onClick={() => setLogModal({
//                                                 show: true,
//                                                 routeId: route.id,
//                                                 routeName: route.routeName
//                                             })}
//                                             style={{
//                                                 backgroundColor: '#6f42c1',
//                                                 color: 'white',
//                                                 padding: '4px 12px',
//                                                 borderRadius: '4px',
//                                                 border: 'none',
//                                                 cursor: 'pointer',
//                                                 fontSize: '12px',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 gap: '4px',
//                                                 transition: 'all 0.2s'
//                                             }}
//                                             onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#5a32a3'}
//                                             onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#6f42c1'}
//                                         >
//                                             Logs
//                                         </button>
//                                     )}
//                                 </td>
//                                 <td>
//                                     {!route.isPending ? (
//                                         <span className={`status-badge ${route.status.toLowerCase()}`}>
//                                             {route.status}
//                                         </span>
//                                     ) : (
//                                         <span className={`status-badge pending`}>
//                                             Pending Approval
//                                         </span>
//                                     )}
//                                 </td>
//                                 <td>
//                                     {!route.isPending ? (
//                                         <div className="action-buttons">
//                                             <button
//                                                 className="action-btn view"
//                                                 onClick={() => handleViewRoute(route)}
//                                             >
//                                                 View
//                                             </button>
//                                             <button
//                                                 className="action-btn edit"
//                                                 onClick={() => handleEditRoute(route)}
//                                                 style={{ backgroundColor: '#17a2b8', color: 'white' }}
//                                             >
//                                                 Edit
//                                             </button>
//                                             <button
//                                                 className={`action-btn ${route.isActive ? 'deactivate' : 'activate'}`}
//                                                 onClick={() => handleToggleStatus(route.id, route.isActive)}
//                                                 style={{
//                                                     backgroundColor: route.isActive ? '#ffc107' : '#28a745',
//                                                     color: route.isActive ? '#000' : 'white'
//                                                 }}
//                                             >
//                                                 {route.isActive ? 'Deactivate' : 'Activate'}
//                                             </button>
//                                             <button
//                                                 className="action-btn delete"
//                                                 onClick={() => handleDeleteRoute(route.id)}
//                                             >
//                                                 Delete
//                                             </button>
//                                         </div>
//                                     ) : (
//                                         <div className="action-buttons">
//                                             <button
//                                                 className="action-btn view"
//                                                 onClick={() => handleViewRoute(route)}
//                                                 style={{ backgroundColor: '#17a2b8' }}
//                                             >
//                                                 View
//                                             </button>
//                                              <button
//             className="action-btn edit"
//             onClick={() => handleEditPendingRoute(route)}
//             style={{ backgroundColor: '#6f42c1', color: 'white' }}
//         >
//             Edit
//         </button>
//                                             <button
//                                                 className="action-btn approve"
//                                                 onClick={() => handleApprovePendingRoute(route.id)}
//                                                 style={{ backgroundColor: '#28a745' }}
//                                             >
//                                                 Approve
//                                             </button>
//                                             <button
//                                                 className="action-btn reject"
//                                                 onClick={() => handleRejectPendingRoute(route.id)}
//                                                 style={{ backgroundColor: '#dc3545' }}
//                                             >
//                                                 Reject
//                                             </button>
//                                             {route.submittedByName && (
//                                                 <div style={{
//                                                     fontSize: '10px',
//                                                     color: '#666',
//                                                     marginTop: '4px',
//                                                     display: 'block'
//                                                 }}>
//                                                     By: {route.submittedByName}
//                                                 </div>
//                                             )}
//                                         </div>
//                                     )}
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>


//             {viewMode === 'regular' && (
//                 <div className="pagination-container">
//                     <div className="pagination-info">
//                         Showing {Math.min(pageSize, routes.length)} of {totalRoutes} routes
//                         (Page {currentPage} of {totalPages})
//                     </div>
//                     <div className="pagination-controls">
//                         <button
//                             className="pagination-btn"
//                             onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
//                             disabled={currentPage === 1}
//                         >
//                             Previous
//                         </button>

//                         <div className="page-numbers">
//                             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                                 let pageNumber;
//                                 if (totalPages <= 5) {
//                                     pageNumber = i + 1;
//                                 } else if (currentPage <= 3) {
//                                     pageNumber = i + 1;
//                                 } else if (currentPage >= totalPages - 2) {
//                                     pageNumber = totalPages - 4 + i;
//                                 } else {
//                                     pageNumber = currentPage - 2 + i;
//                                 }

//                                 return (
//                                     <button
//                                         key={pageNumber}
//                                         className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                                         onClick={() => setCurrentPage(pageNumber)}
//                                     >
//                                         {pageNumber}
//                                     </button>
//                                 );
//                             })}
//                         </div>

//                         <button
//                             className="pagination-btn"
//                             onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
//                             disabled={currentPage === totalPages || totalPages === 0}
//                         >
//                             Next
//                         </button>
//                     </div>
//                 </div>
//             )}


//             {showAddModal && (
//                 <div className="modal-overlay add-route-modal" onClick={() => setShowAddModal(false)}>
//                     <div className="modal-content add-route-content" onClick={(e) => e.stopPropagation()}>
//                         <div className="modal-header">
//                             <h3>Create New Route</h3>
//                             <button className="modal-close-btn" onClick={() => setShowAddModal(false)}>×</button>
//                         </div>

//                         <div className="modal-body">


//                             <div className="round-trip-toggle">
//                                 <label className="checkbox-container">
//                                     <input
//                                         type="checkbox"
//                                         checked={isRoundTrip}
//                                         onChange={(e) => toggleRoundTrip(e.target.checked)}
//                                         className="checkbox-input"
//                                     />
//                                     <span className="checkbox-label">Round Trip (Main + Return Routes)</span>
//                                 </label>
//                             </div>


//                             {isRoundTrip && (
//                                 <div className="route-tabs">
//                                     <button
//                                         className={`route-tab ${activeRouteTab === 'UP' ? 'active' : ''}`}
//                                         onClick={() => handleTabSwitch('UP')}
//                                     >
//                                         UP (Main) Route
//                                     </button>
//                                     <button
//                                         className={`route-tab ${activeRouteTab === 'DOWN' ? 'active' : ''}`}
//                                         onClick={() => handleTabSwitch('DOWN')}
//                                     >
//                                         DOWN (Return) Route
//                                     </button>
//                                     <button
//                                         className="route-tab clear-tab"
//                                         onClick={clearCurrentRoute}
//                                         style={{
//                                             marginLeft: 'auto',
//                                             backgroundColor: '#dc3545',
//                                             color: 'white',
//                                             border: 'none',
//                                             padding: '6px 16px',
//                                             borderRadius: '4px',
//                                             fontSize: '13px',
//                                             fontWeight: '500',
//                                             cursor: 'pointer',
//                                             transition: 'background-color 0.2s'
//                                         }}
//                                         onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#c82333'}
//                                         onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#dc3545'}
//                                         title={`Clear all data for ${activeRouteTab} route`}
//                                     >
//                                         ✕ Clear {activeRouteTab} Route
//                                     </button>
//                                 </div>
//                             )}

//                             <div className="form-sections">
//                                 <div className="form-section">
//                                     <h4>Route Identity</h4>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Select Master Route *</label>
//                                             <MasterRouteSelector
//                                                 token={token}
//                                                 value={selectedMasterRouteFromDropdown}
//                                                 onChange={(masterRoute) => {
//                                                     setSelectedMasterRouteFromDropdown(masterRoute);
//                                                     if (masterRoute) {
//                                                         autoFillFromMasterRoute(masterRoute);
//                                                     } else {
//                                                         setNewRoute(prev => ({ ...prev, routeName: '' }));
//                                                     }
//                                                 }}
//                                                 onAddNew={handleAddNewMasterRoute}
//                                             />
//                                             <small className="helper-text">
//                                                 {selectedMasterRouteFromDropdown
//                                                     ? `✓ Route name set to: "${selectedMasterRouteFromDropdown.masterRouteName}"`
//                                                     : 'Select a master route to auto-fill all route details, or click + New Master Route to create one first'}
//                                             </small>
//                                         </div>
//                                     </div>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Local Route Name</label>
//                                             <input
//                                                 type="text"
//                                                 value={newRoute.localRouteName}
//                                                 onChange={(e) => setNewRoute(prev => ({ ...prev, localRouteName: e.target.value }))}
//                                                 placeholder="Enter local/regional name for this route (e.g., 'City Express', 'Night Special')"
//                                                 className="form-input"
//                                             />
//                                             <small className="helper-text">This name will be displayed to passengers as the local route identifier</small>
//                                         </div>
//                                     </div>
//                                 </div>


//                                 <div className="form-section">
//                                     <h4>{activeRouteTab === 'UP' ? 'Origin *' : 'Return Origin (Locked to Main Dest)'}</h4>

//                                     {activeRouteTab === 'UP' ? (
//                                         <>
//                                             <div className="form-row">
//                                                 <div className="form-group full-width">
//                                                     <label>Search Location</label>
//                                                     <LocationInput
//                                                         value={newRoute.upOriginCity}
//                                                         onChange={(value) => setNewRoute(prev => ({ ...prev, upOriginCity: value }))}
//                                                         onLocationSelect={handleSelectOrigin}
//                                                         placeholder="Search origin city or address..."
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>Address</label>
//                                                     <input
//                                                         type="text"
//                                                         value={newRoute.upOriginAddress}
//                                                         onChange={(e) => setNewRoute(prev => ({ ...prev, upOriginAddress: e.target.value }))}
//                                                         placeholder="Full address"
//                                                         className="form-input"
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>State</label>
//                                                     <input
//                                                         type="text"
//                                                         value={newRoute.upOriginState}
//                                                         onChange={(e) => setNewRoute(prev => ({ ...prev, upOriginState: e.target.value }))}
//                                                         placeholder="State"
//                                                         className="form-input"
//                                                     />
//                                                 </div>
//                                                 <div className="form-group">
//                                                     <label>Terminal</label>
//                                                     <input
//                                                         type="text"
//                                                         value={newRoute.upOriginTerminal}
//                                                         onChange={(e) => setNewRoute(prev => ({ ...prev, upOriginTerminal: e.target.value }))}
//                                                         placeholder="Terminal name"
//                                                         className="form-input"
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div className="form-row">
//                                                 <Checkbox
//                                                     label="Multi-Trip Route (Multiple departures per day)"
//                                                     checked={isMultiTrip}
//                                                     onChange={() => {
//                                                         setIsMultiTrip(!isMultiTrip);
//                                                         if (!isMultiTrip && timeSlots.length === 0) {
//                                                             setTimeSlots([{
//                                                                 sequence: 1,
//                                                                 departureTime: newRoute.upOriginDepTime || '',
//                                                                 arrivalTime: '',
//                                                                 fareMultiplier: 1.0,
//                                                                 isActive: true
//                                                             }]);
//                                                             setNumberOfTrips(1);
//                                                         }
//                                                     }}
//                                                 />
//                                             </div>

//                                             {isMultiTrip ? (
//                                                 <TimeSlotManager
//                                                     timeSlots={timeSlots}
//                                                     onTimeSlotsChange={setTimeSlots}
//                                                     numberOfTrips={numberOfTrips}
//                                                     onNumberOfTripsChange={setNumberOfTrips}
//                                                     disabled={false}
//                                                     showDeparture={true}
//                                                     showArrival={false}
//                                                     labelPrefix="Trip"
//                                                 />
//                                             ) : (
//                                                 <div className="form-row">
//                                                     <div className="form-group">
//                                                         <label>Departure Time *</label>
//                                                         <TimePicker
//                                                             value={newRoute.upOriginDepTime}
//                                                             onChange={(value) => {
//                                                                 setNewRoute(prev => ({ ...prev, upOriginDepTime: value }));
//                                                             }}
//                                                             placeholder="Select time"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </>
//                                     ) : (
//                                         <div className="locked-fields">
//                                             <div className="form-row">
//                                                 <div className="form-group full-width">
//                                                     <input
//                                                         type="text"
//                                                         value={newRoute.upDestCity || 'Auto-filled from Main Destination'}
//                                                         className="form-input locked"
//                                                         disabled
//                                                     />
//                                                 </div>
//                                             </div>
//                                             {isMultiTrip ? (
//                                                 <TimeSlotManager
//                                                     timeSlots={returnOriginTimeSlots}
//                                                     onTimeSlotsChange={(slots) => {
//                                                         setReturnOriginTimeSlots(slots);
//                                                     }}
//                                                     numberOfTrips={returnOriginTimeSlots.length || numberOfTrips}
//                                                     onNumberOfTripsChange={(count) => {
//                                                         const newSlots = Array.from({ length: count }, (_, i) => ({
//                                                             sequence: i + 1,
//                                                             departureTime: returnOriginTimeSlots[i]?.departureTime || '',
//                                                             arrivalTime: '',
//                                                             fareMultiplier: 1.0,
//                                                             isActive: true
//                                                         }));
//                                                         setReturnOriginTimeSlots(newSlots);
//                                                     }}
//                                                     disabled={false}
//                                                     showDeparture={true}
//                                                     showArrival={false}
//                                                     labelPrefix="Return Trip"
//                                                 />
//                                             ) : null}
//                                         </div>
//                                     )}
//                                 </div>


//                                 <div className="form-section">
//                                     <h4>{activeRouteTab === 'UP' ? 'Destination *' : 'Return Destination (Locked to Main Origin)'}</h4>

//                                     {activeRouteTab === 'UP' ? (
//                                         <>
//                                             <div className="form-row">
//                                                 <div className="form-group full-width">
//                                                     <label>Search Location</label>
//                                                     <LocationInput
//                                                         value={newRoute.upDestCity}
//                                                         onChange={(value) => setNewRoute(prev => ({ ...prev, upDestCity: value }))}
//                                                         onLocationSelect={handleSelectDest}
//                                                         placeholder="Search destination city or address..."
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>Address</label>
//                                                     <input
//                                                         type="text"
//                                                         value={newRoute.upDestAddress}
//                                                         onChange={(e) => setNewRoute(prev => ({ ...prev, upDestAddress: e.target.value }))}
//                                                         placeholder="Full address"
//                                                         className="form-input"
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>State</label>
//                                                     <input
//                                                         type="text"
//                                                         value={newRoute.upDestState}
//                                                         onChange={(e) => setNewRoute(prev => ({ ...prev, upDestState: e.target.value }))}
//                                                         placeholder="State"
//                                                         className="form-input"
//                                                     />
//                                                 </div>
//                                                 <div className="form-group">
//                                                     <label>Terminal</label>
//                                                     <input
//                                                         type="text"
//                                                         value={newRoute.upDestTerminal}
//                                                         onChange={(e) => setNewRoute(prev => ({ ...prev, upDestTerminal: e.target.value }))}
//                                                         placeholder="Terminal name"
//                                                         className="form-input"
//                                                     />
//                                                 </div>
//                                             </div>
//                                             {isMultiTrip ? (
//                                                 <TimeSlotManager
//                                                     timeSlots={destinationTimeSlots}
//                                                     onTimeSlotsChange={setDestinationTimeSlots}
//                                                     numberOfTrips={destinationNumberOfTrips}
//                                                     onNumberOfTripsChange={setDestinationNumberOfTrips}
//                                                     disabled={false}
//                                                     showDeparture={false}
//                                                     showArrival={true}
//                                                     labelPrefix="Trip"
//                                                 />
//                                             ) : (
//                                                 <div className="form-row">
//                                                     <div className="form-group">
//                                                         <label>Arrival Time *</label>
//                                                         <TimePicker
//                                                             value={newRoute.upDestArrTime}
//                                                             onChange={(value) => {
//                                                                 setNewRoute(prev => ({ ...prev, upDestArrTime: value }));
//                                                             }}
//                                                             placeholder="Select time"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </>
//                                     ) : (
//                                         <div className="locked-fields">
//                                             <div className="form-row">
//                                                 <div className="form-group full-width">
//                                                     <input
//                                                         type="text"
//                                                         value={newRoute.upOriginCity || 'Auto-filled from Main Origin'}
//                                                         className="form-input locked"
//                                                         disabled
//                                                     />
//                                                 </div>
//                                             </div>
//                                             {isMultiTrip ? (
//                                                 <TimeSlotManager
//                                                     timeSlots={returnDestTimeSlots}
//                                                     onTimeSlotsChange={(slots) => {
//                                                         setReturnDestTimeSlots(slots);
//                                                     }}
//                                                     numberOfTrips={returnDestTimeSlots.length || numberOfTrips}
//                                                     onNumberOfTripsChange={(count) => {
//                                                         const newSlots = Array.from({ length: count }, (_, i) => ({
//                                                             sequence: i + 1,
//                                                             arrivalTime: returnDestTimeSlots[i]?.arrivalTime || '',
//                                                             departureTime: '',
//                                                             fareMultiplier: 1.0,
//                                                             isActive: true
//                                                         }));
//                                                         setReturnDestTimeSlots(newSlots);
//                                                     }}
//                                                     disabled={false}
//                                                     showDeparture={false}
//                                                     showArrival={true}
//                                                     labelPrefix="Return Trip"
//                                                 />
//                                             ) : null}
//                                         </div>
//                                     )}
//                                 </div>


//                                 <div className="form-section stops-section">
//                                     <h4>Intermediate Stops ({activeRouteTab})</h4>

//                                     {isMultiTrip && (
//                                         <div style={{
//                                             marginBottom: '16px',
//                                             padding: '12px 16px',
//                                             backgroundColor: '#e3f2fd',
//                                             borderRadius: '8px',
//                                             border: '1px solid #90caf9',
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             justifyContent: 'space-between',
//                                             flexWrap: 'wrap',
//                                             gap: '10px'
//                                         }}>
//                                             <div>
//                                                 <span style={{ fontSize: '13px', fontWeight: '500', color: '#0d47a1' }}>
//                                                     🚍 Number of Trips per Day:
//                                                 </span>
//                                                 <span style={{
//                                                     marginLeft: '8px',
//                                                     fontSize: '16px',
//                                                     fontWeight: 'bold',
//                                                     color: '#1565c0',
//                                                     backgroundColor: '#bbdefb',
//                                                     padding: '4px 12px',
//                                                     borderRadius: '20px',
//                                                     display: 'inline-block'
//                                                 }}>
//                                                     {numberOfTrips} trip{numberOfTrips !== 1 ? 's' : ''}
//                                                 </span>
//                                             </div>
//                                             <div style={{ fontSize: '12px', color: '#1565c0' }}>
//                                                 ⏰ Each stop needs timings for all {numberOfTrips} trip{numberOfTrips !== 1 ? 's' : ''}
//                                             </div>
//                                             <button
//                                                 type="button"
//                                                 onClick={() => {
//                                                     if (window.confirm(`This will set default timings (00:00) for all ${numberOfTrips} trips at all stops. Continue?`)) {
//                                                         const currentStops = getActiveStops();
//                                                         const updatedStops = currentStops.map(stop => ({
//                                                             ...stop,
//                                                             timings: timeSlots.map(slot => ({
//                                                                 timeSlotSequence: slot.sequence,
//                                                                 sequence: stop.sequence,
//                                                                 arrivalTime: '',
//                                                                 departureTime: ''
//                                                             }))
//                                                         }));
//                                                         setActiveStops(updatedStops);
//                                                         toast.info(`Timings initialized for all ${currentStops.length} stops`);
//                                                     }
//                                                 }}
//                                                 style={{
//                                                     padding: '4px 12px',
//                                                     fontSize: '11px',
//                                                     backgroundColor: '#1565c0',
//                                                     color: 'white',
//                                                     border: 'none',
//                                                     borderRadius: '4px',
//                                                     cursor: 'pointer'
//                                                 }}
//                                             >
//                                                 Initialize All Stops
//                                             </button>
//                                         </div>
//                                     )}

//                                     {activeRouteTab === 'DOWN' && (
//                                         <button
//                                             className="sync-btn"
//                                             onClick={() => syncDownStopsWithUpStops(true)}
//                                         >
//                                             🔄 Auto-Fill / Sync Reversed Stops from UP Route
//                                         </button>
//                                     )}

//                                     <div className="stops-list">
//                                         {getActiveStops().length > 0 && renderInsertButton(0, activeRouteTab === 'UP' ? 'up' : 'down')}

//                                         {getActiveStops().map((stop, index) => {
//                                             const displayManualDist = calculateManualDistFromPrev(getActiveStops(), index);
//                                             const distanceDisplay = displayManualDist ||
//                                                 (typeof stop.distanceFromOrigin === 'number'
//                                                     ? stop.distanceFromOrigin.toFixed(2)
//                                                     : parseFloat(stop.distanceFromOrigin || 0).toFixed(2));

//                                             const hasMultiTimings = stop.timings && stop.timings.length > 0;
//                                             const sortedTimings = hasMultiTimings ? sortTimings(stop.timings) : [];

//                                             return (
//                                                 <React.Fragment key={index}>
//                                                     <div className={`stop-list-item ${(activeRouteTab === 'UP' ? editUpIndex : editDownIndex) === index ? 'editing-highlight' : ''}`}>
//                                                         <div className="stop-info">
//                                                             <div className="stop-name">
//                                                                 {index + 1}. {stop.city}
//                                                                 <span className="stop-distance">
//                                                                     ({distanceDisplay} km)
//                                                                 </span>
//                                                             </div>


//                                                             {hasMultiTimings && sortedTimings.length > 0 ? (
//                                                                 <div className="stop-multi-times" style={{ marginTop: '8px', marginBottom: '8px' }}>
//                                                                     {sortedTimings.map((timing, idx) => (
//                                                                         <div key={timing.timeSlotSequence || idx} style={{
//                                                                             display: 'inline-flex', alignItems: 'center', gap: '8px',
//                                                                             backgroundColor: '#e9ecef', padding: '4px 10px',
//                                                                             borderRadius: '16px', margin: '2px 4px', fontSize: '11px'
//                                                                         }}>
//                                                                             <span style={{ fontWeight: '500' }}>Trip {timing.timeSlotSequence || idx + 1}:</span>
//                                                                             <span>Arr {TimeDisplay({ time: timing.arrivalTime })}</span>
//                                                                             <span>→</span>
//                                                                             <span>Dep {TimeDisplay({ time: timing.departureTime })}</span>
//                                                                         </div>
//                                                                     ))}
//                                                                     {stop.stopType && stop.stopType !== 'none' && (
//                                                                         <span style={{
//                                                                             display: 'inline-flex', alignItems: 'center',
//                                                                             marginLeft: '8px', fontSize: '11px', fontWeight: '500',
//                                                                             padding: '2px 8px', borderRadius: '12px',
//                                                                             backgroundColor: stop.stopType === 'boarding' ? '#e3f2fd'
//                                                                                 : stop.stopType === 'dropping' ? '#fce4ec' : '#e8f5e9',
//                                                                             color: stop.stopType === 'boarding' ? '#1565c0'
//                                                                                 : stop.stopType === 'dropping' ? '#c62828' : '#2e7d32',
//                                                                             border: `1px solid ${stop.stopType === 'boarding' ? '#90caf9'
//                                                                                 : stop.stopType === 'dropping' ? '#f48fb1' : '#a5d6a7'}`
//                                                                         }}>
//                                                                             {stop.stopType === 'boarding' ? '🟢 Boarding'
//                                                                                 : stop.stopType === 'dropping' ? '🔴 Dropping' : '🟡 Both'}
//                                                                         </span>
//                                                                     )}
//                                                                 </div>
//                                                             ) : (
//                                                                 <div className="stop-times" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
//                                                                     <span>Arr: {stop.arrivalTime || 'TBD'} • Dep: {stop.departureTime || 'N/A'}</span>
//                                                                     {stop.stopType && stop.stopType !== 'none' && (
//                                                                         <span style={{
//                                                                             fontSize: '11px', fontWeight: '500',
//                                                                             padding: '2px 8px', borderRadius: '12px',
//                                                                             backgroundColor: stop.stopType === 'boarding' ? '#e3f2fd'
//                                                                                 : stop.stopType === 'dropping' ? '#fce4ec' : '#e8f5e9',
//                                                                             color: stop.stopType === 'boarding' ? '#1565c0'
//                                                                                 : stop.stopType === 'dropping' ? '#c62828' : '#2e7d32',
//                                                                             border: `1px solid ${stop.stopType === 'boarding' ? '#90caf9'
//                                                                                 : stop.stopType === 'dropping' ? '#f48fb1' : '#a5d6a7'}`
//                                                                         }}>
//                                                                             {stop.stopType === 'boarding' ? '🟢 Boarding'
//                                                                                 : stop.stopType === 'dropping' ? '🔴 Dropping' : '🟡 Both'}
//                                                                         </span>
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                         </div>
//                                                         <div className="stop-actions">
//                                                             <button
//                                                                 className="stop-action-btn edit"
//                                                                 onClick={() => {
//                                                                     setEditingStopIndex(index);
//                                                                     handleEditStop(index, activeRouteTab === 'UP' ? 'up' : 'down');
//                                                                 }}
//                                                             >
//                                                                 Edit
//                                                             </button>
//                                                             <button
//                                                                 className="stop-action-btn delete"
//                                                                 onClick={() => handleDeleteStop(index)}
//                                                             >
//                                                                 Delete
//                                                             </button>
//                                                         </div>
//                                                     </div>
//                                                     {renderInsertButton(index + 1, activeRouteTab === 'UP' ? 'up' : 'down')}
//                                                 </React.Fragment>
//                                             );
//                                         })}
//                                     </div>


//                                     <div className="stop-form">
//                                         <h5>
//                                             {editingStopIndex !== null ? `Edit Stop #${editingStopIndex + 1}` :
//                                                 insertIndex !== null ? `Insert Stop at #${insertIndex + 1}` :
//                                                     'Add Stop at End'}
//                                         </h5>

//                                         {insertIndex !== null && (
//                                             <button className="cancel-insert-btn" onClick={() => setInsertIndex(null)}>
//                                                 Cancel Insert
//                                             </button>
//                                         )}

//                                         {isMultiTrip && editingStopIndex !== null && (
//                                             <div style={{
//                                                 marginBottom: '16px',
//                                                 padding: '8px 12px',
//                                                 backgroundColor: '#fff3cd',
//                                                 borderRadius: '6px',
//                                                 fontSize: '12px',
//                                                 color: '#856404'
//                                             }}>
//                                                 💡 This stop has {numberOfTrips} trip{numberOfTrips !== 1 ? 's' : ''}. Set timings for each trip below.
//                                             </div>
//                                         )}

//                                         <div className="form-row">
//                                             <Checkbox
//                                                 label="Manually Typed Stop (No Map Suggestions)"
//                                                 checked={!isManualStop}
//                                                 onChange={() => {
//                                                     setIsManualStop(!isManualStop);
//                                                     if (!isManualStop) {
//                                                         setNewRoute(prev => ({
//                                                             ...prev,
//                                                             stopCity: '',
//                                                             stopCoords: null,
//                                                             stopDistFromPrev: '',
//                                                             stopDistToNext: '',
//                                                             stopAddress: '',
//                                                             stopState: '',
//                                                             stopTerminal: ''
//                                                         }));
//                                                         setCitySuggestions([]);
//                                                         setShowCityDropdown(false);
//                                                     }
//                                                 }}
//                                             />
//                                         </div>

//                                         {isManualStop ? (
//                                             <>
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <label>Search Location</label>
//                                                         <LocationInput
//                                                             value={newRoute.stopCity}
//                                                             onChange={(value) => setNewRoute(prev => ({ ...prev, stopCity: value }))}
//                                                             onLocationSelect={handleSelectStop}
//                                                             placeholder="Search stop city or address..."
//                                                         />
//                                                     </div>
//                                                 </div>
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <label>Address</label>
//                                                         <input
//                                                             type="text"
//                                                             value={newRoute.stopAddress}
//                                                             onChange={(e) => setNewRoute(prev => ({ ...prev, stopAddress: e.target.value }))}
//                                                             placeholder="Full address (e.g., NH-19, Near Bus Stand)"
//                                                             className="form-input"
//                                                         />
//                                                         <small className="helper-text">Complete address of the stop location</small>
//                                                     </div>
//                                                 </div>
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <label>Search City *</label>
//                                                         <div className="city-search-container" style={{ position: 'relative' }}>
//                                                             <input
//                                                                 type="text"
//                                                                 value={newRoute.stopCity}
//                                                                 onChange={async (e) => {
//                                                                     const value = toTitleCase(e.target.value);
//                                                                     setNewRoute(prev => ({ ...prev, stopCity: value }));

//                                                                     if (value !== newRoute.stopCity) {
//                                                                         setNewRoute(prev => ({
//                                                                             ...prev,
//                                                                             stopAddress: '',
//                                                                             stopState: '',
//                                                                             stopTerminal: ''
//                                                                         }));
//                                                                     }

//                                                                     if (value.length >= 2) {
//                                                                         try {
//                                                                             const response = await searchRouteIntermediateStops(token, value);
//                                                                             if (response.success && response.cities && response.cities.length > 0) {
//                                                                                 setCitySuggestions(response.cities);
//                                                                                 setShowCityDropdown(true);
//                                                                             } else {
//                                                                                 setCitySuggestions([]);
//                                                                                 setShowCityDropdown(false);
//                                                                             }
//                                                                         } catch (error) {
//                                                                             console.error('Error searching cities:', error);
//                                                                             setCitySuggestions([]);
//                                                                             setShowCityDropdown(false);
//                                                                         }
//                                                                     } else {
//                                                                         setCitySuggestions([]);
//                                                                         setShowCityDropdown(false);
//                                                                     }
//                                                                 }}
//                                                                 onFocus={() => {
//                                                                     if (citySuggestions.length > 0) {
//                                                                         setShowCityDropdown(true);
//                                                                     }
//                                                                 }}
//                                                                 onBlur={() => {
//                                                                     setTimeout(() => setShowCityDropdown(false), 200);
//                                                                 }}
//                                                                 placeholder="Type city name (min 2 characters)..."
//                                                                 className="form-input"
//                                                             />
//                                                             {showCityDropdown && citySuggestions.length > 0 && (
//                                                                 <div className="city-suggestions-dropdown" style={{
//                                                                     position: 'absolute',
//                                                                     top: '100%',
//                                                                     left: 0,
//                                                                     right: 0,
//                                                                     backgroundColor: 'white',
//                                                                     border: '1px solid #ddd',
//                                                                     borderRadius: '4px',
//                                                                     maxHeight: '200px',
//                                                                     overflowY: 'auto',
//                                                                     zIndex: 10000,
//                                                                     boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
//                                                                 }}>
//                                                                     {citySuggestions.map((city, idx) => (
//                                                                         <div
//                                                                             key={city.id || idx}
//                                                                             onClick={() => {
//                                                                                 setNewRoute(prev => ({
//                                                                                     ...prev,
//                                                                                     stopCity: toTitleCase(city.name),
//                                                                                     stopAddress: toTitleCase(city.address || city.name),
//                                                                                     stopState: toTitleCase(city.state || ''),
//                                                                                     stopTerminal: toTitleCase(city.terminal || `${city.name} Bus Stand`),
//                                                                                     stopCoords: city.coordinates || null
//                                                                                 }));
//                                                                                 setShowCityDropdown(false);
//                                                                                 toast.success(`Auto-filled details for ${city.name}`);
//                                                                             }}
//                                                                             style={{
//                                                                                 padding: '10px 12px',
//                                                                                 cursor: 'pointer',
//                                                                                 borderBottom: '1px solid #f0f0f0',
//                                                                                 transition: 'background-color 0.2s'
//                                                                             }}
//                                                                             onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
//                                                                             onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
//                                                                         >
//                                                                             <div style={{ fontWeight: '500' }}>{city.name}</div>
//                                                                             <div style={{ fontSize: '12px', color: '#6c757d' }}>
//                                                                                 {city.state}
//                                                                                 {city.terminal && ` • ${city.terminal}`}
//                                                                             </div>
//                                                                             <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>
//                                                                                 {city.address !== city.name ? city.address : ''}
//                                                                             </div>
//                                                                         </div>
//                                                                     ))}
//                                                                 </div>
//                                                             )}
//                                                         </div>
//                                                         <small className="helper-text">Type at least 2 characters to search for cities from existing routes</small>
//                                                     </div>
//                                                 </div>
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <label>Address *</label>
//                                                         <input
//                                                             type="text"
//                                                             value={newRoute.stopAddress}
//                                                             onChange={(e) => setNewRoute(prev => ({ ...prev, stopAddress: e.target.value }))}
//                                                             placeholder="Complete address of the stop location"
//                                                             className="form-input"
//                                                         />
//                                                         <small className="helper-text">Complete address of the stop location</small>
//                                                     </div>
//                                                 </div>
//                                             </>
//                                         )}

//                                         {(stopEditForm.isManualStop || isManualStop) && (
//                                             <>
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <label>Distance from Previous Stop (km) *</label>
//                                                         <input
//                                                             type="number"
//                                                             value={newRoute.stopDistFromPrev}
//                                                             onChange={(e) => setNewRoute(prev => ({ ...prev, stopDistFromPrev: e.target.value }))}
//                                                             placeholder="e.g., 50"
//                                                             className="form-input"
//                                                             min="0"
//                                                             step="0.1"
//                                                         />
//                                                         <small className="helper-text">Required for manual stops</small>
//                                                     </div>
//                                                 </div>

//                                                 {(() => {
//                                                     const stops = getActiveStops();
//                                                     const currentIndex = editingStopIndex !== null ? editingStopIndex :
//                                                         (insertIndex !== null ? insertIndex : stops.length);
//                                                     const nextStop = stops[currentIndex];
//                                                     const isNextAuto = nextStop && nextStop.coordinates &&
//                                                         (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);
//                                                     if (isNextAuto) {
//                                                         return (
//                                                             <div className="form-row">
//                                                                 <div className="form-group full-width">
//                                                                     <label>Distance to Next Stop ({nextStop.city}) (km)</label>
//                                                                     <input
//                                                                         type="number"
//                                                                         value={newRoute.stopDistToNext}
//                                                                         onChange={(e) => setNewRoute(prev => ({ ...prev, stopDistToNext: e.target.value }))}
//                                                                         placeholder={`Distance to ${nextStop.city}`}
//                                                                         className="form-input"
//                                                                         min="0"
//                                                                         step="0.1"
//                                                                     />
//                                                                     <small className="helper-text">
//                                                                         Optional - helps with distance calculation accuracy
//                                                                     </small>
//                                                                 </div>
//                                                             </div>
//                                                         );
//                                                     }
//                                                     return null;
//                                                 })()}
//                                             </>
//                                         )}

//                                         <div className="form-row">
//                                             <div className="form-group">
//                                                 <label>State</label>
//                                                 <input
//                                                     type="text"
//                                                     value={newRoute.stopState}
//                                                     onChange={(e) => setNewRoute(prev => ({ ...prev, stopState: e.target.value }))}
//                                                     placeholder="State"
//                                                     className="form-input"
//                                                 />
//                                             </div>
//                                             <div className="form-group">
//                                                 <label>Terminal</label>
//                                                 <input
//                                                     type="text"
//                                                     value={newRoute.stopTerminal}
//                                                     onChange={(e) =>
//                                                         setNewRoute(prev => ({
//                                                             ...prev,
//                                                             stopTerminal: toTitleCase(e.target.value),
//                                                         }))
//                                                     }
//                                                     placeholder="Terminal name"
//                                                     className="form-input"
//                                                 />
//                                             </div>
//                                         </div>

//                                         {isMultiTrip ? (
//                                             <StopTimingManager
//                                                 stop={{
//                                                     sequence: editingStopIndex !== null ? editingStopIndex + 1 :
//                                                         (insertIndex !== null ? insertIndex + 1 : getActiveStops().length + 1),
//                                                     timings: newRoute.stopTimings || []
//                                                 }}
//                                                 timeSlots={timeSlots}
//                                                 onTimingUpdate={(stopSequence, timings) => {
//                                                     setNewRoute(prev => ({ ...prev, stopTimings: timings }));
//                                                 }}
//                                                 disabled={false}
//                                             />
//                                         ) : (
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>Arrival Time *</label>
//                                                     <TimePicker
//                                                         value={newRoute.stopArrivalTime}
//                                                         onChange={(value) => setNewRoute(prev => ({ ...prev, stopArrivalTime: value }))}
//                                                         placeholder="Select time"
//                                                     />
//                                                 </div>
//                                                 <div className="form-group">
//                                                     <label>Departure Time (Opt)</label>
//                                                     <TimePicker
//                                                         value={newRoute.stopDepartureTime}
//                                                         onChange={(value) => setNewRoute(prev => ({ ...prev, stopDepartureTime: value }))}
//                                                         placeholder="Select time"
//                                                     />
//                                                 </div>
//                                             </div>
//                                         )}

//                                         <div className="form-row checkbox-row">
//                                             <Checkbox
//                                                 label="Boarding Point"
//                                                 checked={newRoute.isBoarding}
//                                                 onChange={() => setNewRoute(prev => ({ ...prev, isBoarding: !prev.isBoarding }))}
//                                             />
//                                             <Checkbox
//                                                 label="Dropping Point"
//                                                 checked={newRoute.isDropping}
//                                                 onChange={() => setNewRoute(prev => ({ ...prev, isDropping: !prev.isDropping }))}
//                                             />
//                                         </div>

//                                         <button
//                                             className="btn btn-secondary add-stop-btn"
//                                             onClick={() => addIntermediateStop(activeRouteTab === 'UP' ? 'up' : 'down')}
//                                             disabled={
//                                                 !newRoute.stopCity ||
//                                                 ((!isMultiTrip && !newRoute.stopArrivalTime) ||
//                                                     (isMultiTrip && (!newRoute.stopTimings || newRoute.stopTimings.length === 0))) ||
//                                                 ((isManualStop || !newRoute.stopCoords) && (!newRoute.stopDistFromPrev || parseFloat(newRoute.stopDistFromPrev) <= 0))
//                                             }
//                                         >
//                                             {editingStopIndex !== null ? 'Save Changes' :
//                                                 insertIndex !== null ? 'Confirm Insertion' :
//                                                     '+ Append Stop'}
//                                         </button>
//                                     </div>
//                                 </div>

//                                 <div className="form-section">
//                                     <h4>{activeRouteTab} Summary</h4>

//                                     <button
//                                         className="btn btn-success calculate-btn"
//                                         onClick={handleCalculateDistances}
//                                         disabled={isCalculatingDistances}
//                                     >
//                                         {isCalculatingDistances ? 'Calculating...' : `Auto-Calculate Distances (${activeRouteTab})`}
//                                     </button>

//                                     {isLastStopManual() && (
//                                         <div className="form-row" style={{ marginTop: '10px' }}>
//                                             <div className="form-group full-width">
//                                                 <label>Distance from Last Stop to Destination (KM) *</label>
//                                                 <input
//                                                     type="number"
//                                                     value={activeRouteTab === 'UP' ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg}
//                                                     onChange={(e) => setNewRoute(prev => ({
//                                                         ...prev,
//                                                         [activeRouteTab === 'UP' ? 'upManualFinalLeg' : 'downManualFinalLeg']: e.target.value
//                                                     }))}
//                                                     placeholder="Required because last stop is manual"
//                                                     className="form-input"
//                                                     min="0"
//                                                     step="0.1"
//                                                     style={{ borderColor: '#dc3545', backgroundColor: '#fff5f5' }}
//                                                 />
//                                                 <small className="helper-text" style={{ color: '#dc3545' }}>
//                                                     ⚠️ The last stop is manual, so you must provide the distance to destination
//                                                 </small>
//                                             </div>
//                                         </div>
//                                     )}

//                                     <div className="form-row summary-fields">
//                                         <div className="form-group">
//                                             <label>Total Distance (KM)</label>
//                                             <input
//                                                 type="number"
//                                                 value={activeRouteTab === 'UP' ? newRoute.upTotalDistance : newRoute.downTotalDistance}
//                                                 onChange={(e) => setNewRoute(prev => ({
//                                                     ...prev,
//                                                     [activeRouteTab === 'UP' ? 'upTotalDistance' : 'downTotalDistance']: e.target.value
//                                                 }))}
//                                                 className="form-input"
//                                                 min="0"
//                                                 step="0.1"
//                                             />
//                                         </div>
//                                         <div className="form-group">
//                                             <label>Est. Duration</label>
//                                             <div className="duration-inputs">
//                                                 <input
//                                                     type="number"
//                                                     value={activeRouteTab === 'UP' ? newRoute.upDurationHours : newRoute.downDurationHours}
//                                                     onChange={(e) => {
//                                                         const value = e.target.value;
//                                                         setNewRoute(prev => ({
//                                                             ...prev,
//                                                             [activeRouteTab === 'UP' ? 'upDurationHours' : 'downDurationHours']: value
//                                                         }));
//                                                     }}
//                                                     className="form-input"
//                                                     placeholder="Hours"
//                                                     min="0"
//                                                 />
//                                                 <span>h</span>
//                                                 <input
//                                                     type="number"
//                                                     value={activeRouteTab === 'UP' ? newRoute.upDurationMinutes : newRoute.downDurationMinutes}
//                                                     onChange={(e) => {
//                                                         const value = e.target.value;
//                                                         let minutes = Math.min(59, Math.max(0, parseInt(value) || 0));
//                                                         setNewRoute(prev => ({
//                                                             ...prev,
//                                                             [activeRouteTab === 'UP' ? 'upDurationMinutes' : 'downDurationMinutes']: minutes.toString()
//                                                         }));
//                                                     }}
//                                                     className="form-input"
//                                                     placeholder="Minutes"
//                                                     min="0"
//                                                     max="59"
//                                                 />
//                                                 <span>m</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>


//                             <div className="form-actions">
//                                 <button
//                                     className="btn btn-primary save-route-btn"
//                                     onClick={handleSaveRoute}
//                                     disabled={
//                                         isCreatingRoute ||
//                                         !selectedMasterRouteFromDropdown ||
//                                         !isDistanceCalculated.up ||
//                                         (isRoundTrip && !isDistanceCalculated.down)
//                                     }
//                                 >
//                                     {isCreatingRoute ? 'Creating Route...' : 'Add Route'}
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}


//             {viewingRoute && (
//                 <div className="modal-overlay" onClick={() => setViewingRoute(null)}>
//                     <div className="modal-content1 view-route-modal" onClick={(e) => e.stopPropagation()}>
//                         <div className="modal-header">
//                             <h3>Route Details: {viewingRoute.routeName}</h3>
//                             <button className="modal-close-btn" onClick={() => setViewingRoute(null)}>×</button>
//                         </div>

//                         <div className="modal-body view-modal-body">
//                             <div className="route-details">
//                                 <div className="detail-row">
//                                     <label>Route Name:</label>
//                                     <span>{viewingRoute.routeName}</span>
//                                 </div>
//                                 <div className="detail-row">
//                                     <label>Local Route Name:</label>
//                                     <span>{viewingRoute.localRouteName || '—'}</span>
//                                 </div>
//                                 <div className="detail-row">
//                                     <label>Route Type:</label>
//                                     <span className={`route-type-badge ${viewingRoute.isRoundTrip ? 'roundtrip' : 'oneway'}`}>
//                                         {viewingRoute.isRoundTrip ? 'Round Trip' : 'One Way'}
//                                     </span>
//                                 </div>
//                                 <div className="detail-row">
//                                     <label>Multi-Trip:</label>
//                                     <span>{viewingRoute.isMultiTrip ? `Yes (${viewingRoute.numberOfTrips || viewingRoute.origin?.timings?.length || 1} trips per day)` : 'No'}</span>
//                                 </div>

//                                 <div className="detail-section">
//                                     <h4>Origin</h4>
//                                     <div className="detail-row"><label>City:</label><span>{viewingRoute.origin?.city}</span></div>
//                                     <div className="detail-row"><label>State:</label><span>{viewingRoute.origin?.state}</span></div>
//                                     <div className="detail-row"><label>Terminal:</label><span>{viewingRoute.origin?.terminal}</span></div>

//                                     {viewingRoute.origin?.timings && viewingRoute.origin.timings.length > 0 ? (
//                                         <div className="detail-row">
//                                             <label>Departure Times:</label>
//                                             <div className="multi-trip-times">
//                                                 {viewingRoute.origin.timings.map((timing, idx) => (
//                                                     <span key={idx} className="time-badge">
//                                                         Trip {timing.timeSlotSequence}: {formatTime(timing.departureTime)}
//                                                     </span>
//                                                 ))}
//                                             </div>
//                                         </div>
//                                     ) : (
//                                         <div className="detail-row"><label>Departure Time:</label><span>{formatTime(viewingRoute.origin?.departureTime)}</span></div>
//                                     )}

//                                     {viewingRoute.origin?.address && (
//                                         <div className="detail-row"><label>Address:</label><span className="address-text">{viewingRoute.origin.address}</span></div>
//                                     )}
//                                 </div>

//                                 <div className="detail-section">
//                                     <h4>Destination</h4>
//                                     <div className="detail-row"><label>City:</label><span>{viewingRoute.destination?.city}</span></div>
//                                     <div className="detail-row"><label>State:</label><span>{viewingRoute.destination?.state}</span></div>
//                                     <div className="detail-row"><label>Terminal:</label><span>{viewingRoute.destination?.terminal}</span></div>

//                                     {viewingRoute.destination?.timings && viewingRoute.destination.timings.length > 0 ? (
//                                         <div className="detail-row">
//                                             <label>Arrival Times:</label>
//                                             <div className="multi-trip-times">
//                                                 {viewingRoute.destination.timings.map((timing, idx) => (
//                                                     <span key={idx} className="time-badge">
//                                                         Trip {timing.timeSlotSequence}: {formatTime(timing.arrivalTime)}
//                                                     </span>
//                                                 ))}
//                                             </div>
//                                         </div>
//                                     ) : (
//                                         <div className="detail-row"><label>Arrival Time:</label><span>{formatTime(viewingRoute.destination?.arrivalTime)}</span></div>
//                                     )}

//                                     {viewingRoute.destination?.address && (
//                                         <div className="detail-row"><label>Address:</label><span className="address-text">{viewingRoute.destination.address}</span></div>
//                                     )}
//                                 </div>

//                                 {viewingRoute.intermediateStops && viewingRoute.intermediateStops.length > 0 && (
//                                     <div className="detail-section">
//                                         <h4>Intermediate Stops ({viewingRoute.intermediateStops.length})</h4>
//                                         <div className="stops-list-container">
//                                             {viewingRoute.intermediateStops.map((stop, index) => (
//                                                 <div key={index} className="stop-card">
//                                                     <div className="stop-header">
//                                                         <span className="stop-sequence">#{stop.sequence}</span>
//                                                         <span className="stop-city">{stop.city}</span>
//                                                         <span className={`stop-type-badge ${stop.stopType}`}>
//                                                             {stop.stopType === 'both' ? 'Boarding & Dropping' :
//                                                                 stop.stopType === 'boarding' ? 'Boarding' :
//                                                                     stop.stopType === 'dropping' ? 'Dropping' : 'Stop'}
//                                                         </span>
//                                                     </div>
//                                                     <div className="stop-details">
//                                                         <div className="stop-info"><span className="info-label">Distance:</span><span className="stop-distance">
//                                                             ({typeof stop.distanceFromOrigin === 'number'
//                                                                 ? stop.distanceFromOrigin.toFixed(2)
//                                                                 : parseFloat(stop.distanceFromOrigin || 0).toFixed(2)} km)
//                                                         </span></div>
//                                                         <div className="stop-info"><span className="info-label">Terminal:</span><span>{stop.terminal}</span></div>

//                                                         {stop.timings && stop.timings.length > 0 ? (
//                                                             <div className="stop-info full-width">
//                                                                 <span className="info-label">Timings:</span>
//                                                                 <div className="multi-trip-times">
//                                                                     {stop.timings.map((timing, idx) => (
//                                                                         <div key={idx} className="timing-entry">
//                                                                             <span className="time-badge">Trip {timing.timeSlotSequence}:</span>
//                                                                             <span className="time-badge">Arr {formatTime(timing.arrivalTime)}</span>
//                                                                             <span className="time-badge">Dep {formatTime(timing.departureTime)}</span>
//                                                                         </div>
//                                                                     ))}
//                                                                 </div>
//                                                             </div>
//                                                         ) : (
//                                                             <>
//                                                                 <div className="stop-info"><span className="info-label">Arrival:</span><span className="time-badge">{formatTime(stop.arrivalTime)}</span></div>
//                                                                 <div className="stop-info"><span className="info-label">Departure:</span><span className="time-badge">{formatTime(stop.departureTime)}</span></div>
//                                                             </>
//                                                         )}

//                                                         <div className="stop-info"><span className="info-label">State:</span><span>{stop.state}</span></div>
//                                                         {stop.manualDistToNext && (
//                                                             <div className="stop-info"><span className="info-label">To Next:</span><span>{stop.manualDistToNext} km</span></div>
//                                                         )}
//                                                         {stop.address && (
//                                                             <div className="stop-info full-width"><span className="info-label">Address:</span><span className="address-text">{stop.address}</span></div>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     </div>
//                                 )}

//                                 {viewingRoute.isRoundTrip && viewingRoute.returnJourney && (
//                                     <div className="detail-section return-journey">
//                                         <h4>Return Journey</h4>

//                                         <div className="return-subsection">
//                                             <h5>Return Origin</h5>
//                                             <div className="detail-row"><label>City:</label><span>{viewingRoute.returnJourney.origin?.city}</span></div>
//                                             <div className="detail-row"><label>State:</label><span>{viewingRoute.returnJourney.origin?.state}</span></div>
//                                             <div className="detail-row"><label>Terminal:</label><span>{viewingRoute.returnJourney.origin?.terminal}</span></div>

//                                             {viewingRoute.returnJourney.origin?.timings && viewingRoute.returnJourney.origin.timings.length > 0 ? (
//                                                 <div className="detail-row">
//                                                     <label>Departure Times:</label>
//                                                     <div className="multi-trip-times">
//                                                         {viewingRoute.returnJourney.origin.timings.map((timing, idx) => (
//                                                             <span key={idx} className="time-badge">
//                                                                 Trip {timing.timeSlotSequence}: {formatTime(timing.departureTime)}
//                                                             </span>
//                                                         ))}
//                                                     </div>
//                                                 </div>
//                                             ) : (
//                                                 <div className="detail-row"><label>Departure Time:</label><span>{formatTime(viewingRoute.returnJourney.origin?.departureTime)}</span></div>
//                                             )}
//                                         </div>

//                                         <div className="return-subsection">
//                                             <h5>Return Destination</h5>
//                                             <div className="detail-row"><label>City:</label><span>{viewingRoute.returnJourney.destination?.city}</span></div>
//                                             <div className="detail-row"><label>State:</label><span>{viewingRoute.returnJourney.destination?.state}</span></div>
//                                             <div className="detail-row"><label>Terminal:</label><span>{viewingRoute.returnJourney.destination?.terminal}</span></div>

//                                             {viewingRoute.returnJourney.destination?.timings && viewingRoute.returnJourney.destination.timings.length > 0 ? (
//                                                 <div className="detail-row">
//                                                     <label>Arrival Times:</label>
//                                                     <div className="multi-trip-times">
//                                                         {viewingRoute.returnJourney.destination.timings.map((timing, idx) => (
//                                                             <span key={idx} className="time-badge">
//                                                                 Trip {timing.timeSlotSequence}: {formatTime(timing.arrivalTime)}
//                                                             </span>
//                                                         ))}
//                                                     </div>
//                                                 </div>
//                                             ) : (
//                                                 <div className="detail-row"><label>Arrival Time:</label><span>{formatTime(viewingRoute.returnJourney.destination?.arrivalTime)}</span></div>
//                                             )}

//                                             <div className="detail-row"><label>Distance:</label><span>{viewingRoute.returnJourney.routeDetails?.totalDistance} km</span></div>
//                                         </div>

//                                         {viewingRoute.returnJourney.intermediateStops?.length > 0 && (
//                                             <div className="return-subsection">
//                                                 <h5>Return Stops ({viewingRoute.returnJourney.intermediateStops.length})</h5>
//                                                 <div className="stops-list-container">
//                                                     {viewingRoute.returnJourney.intermediateStops.map((stop, index) => (
//                                                         <div key={index} className="stop-card">
//                                                             <div className="stop-header">
//                                                                 <span className="stop-sequence">#{stop.sequence}</span>
//                                                                 <span className="stop-city">{stop.city}</span>
//                                                                 <span className={`stop-type-badge ${stop.stopType}`}>
//                                                                     {stop.stopType === 'both' ? 'Boarding & Dropping' :
//                                                                         stop.stopType === 'boarding' ? 'Boarding' :
//                                                                             stop.stopType === 'dropping' ? 'Dropping' : 'Stop'}
//                                                                 </span>
//                                                             </div>
//                                                             <div className="stop-details">
//                                                                 <div className="stop-info"><span className="info-label">Distance:</span><span className="stop-distance">
//                                                                     ({typeof stop.distanceFromOrigin === 'number'
//                                                                         ? stop.distanceFromOrigin.toFixed(2)
//                                                                         : parseFloat(stop.distanceFromOrigin || 0).toFixed(2)} km)
//                                                                 </span></div>

//                                                                 {stop.timings && stop.timings.length > 0 ? (
//                                                                     <div className="stop-info full-width">
//                                                                         <span className="info-label">Timings:</span>
//                                                                         <div className="multi-trip-times">
//                                                                             {stop.timings.map((timing, idx) => (
//                                                                                 <div key={idx} className="timing-entry">
//                                                                                     <span className="time-badge">Trip {timing.timeSlotSequence}:</span>
//                                                                                     <span className="time-badge">Arr {formatTime(timing.arrivalTime)}</span>
//                                                                                     <span className="time-badge">Dep {formatTime(timing.departureTime)}</span>
//                                                                                 </div>
//                                                                             ))}
//                                                                         </div>
//                                                                     </div>
//                                                                 ) : (
//                                                                     <>
//                                                                         <div className="stop-info"><span className="info-label">Arrival:</span><span className="time-badge">{formatTime(stop.arrivalTime)}</span></div>
//                                                                         <div className="stop-info"><span className="info-label">Departure:</span><span className="time-badge">{formatTime(stop.departureTime)}</span></div>
//                                                                     </>
//                                                                 )}

//                                                                 <div className="stop-info"><span className="info-label">State:</span><span>{stop.state}</span></div>
//                                                                 {stop.address && (
//                                                                     <div className="stop-info full-width"><span className="info-label">Address:</span><span className="address-text">{stop.address}</span></div>
//                                                                 )}
//                                                             </div>
//                                                         </div>
//                                                     ))}
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 )}

//                                 <div className="detail-section">
//                                     <h4>Route Details</h4>
//                                     <div className="detail-row"><label>Total Distance:</label><span>{viewingRoute.routeDetails?.totalDistance} km</span></div>
//                                     <div className="detail-row">
//                                         <label>Estimated Duration:</label>
//                                         <span>{viewingRoute.routeDetails?.estimatedDuration?.hours || 0}h {viewingRoute.routeDetails?.estimatedDuration?.minutes || 0}m</span>
//                                     </div>
//                                 </div>

//                                 <div className="detail-section">
//                                     <h4>Status Information</h4>
//                                     <div className="detail-row">
//                                         <label>Status:</label>
//                                         <span className={`status-badge ${viewingRoute.isActive ? 'active' : 'inactive'}`}>
//                                             {viewingRoute.isActive ? 'Active' : 'Inactive'}
//                                         </span>
//                                     </div>
//                                     <div className="detail-row"><label>Created By:</label><span>{viewingRoute.creatorName} ({viewingRoute.creatorType})</span></div>
//                                     <div className="detail-row"><label>Created At:</label><span>{new Date(viewingRoute.createdAt).toLocaleString()}</span></div>
//                                     <div className="detail-row"><label>Updated At:</label><span>{new Date(viewingRoute.updatedAt).toLocaleString()}</span></div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="modal-footer">
//                             <button className="modal-close-btn secondary" onClick={() => setViewingRoute(null)}>Close</button>
//                         </div>
//                     </div>
//                 </div>
//             )}


//             {showEditModal && editingRoute && (
//                 <div className="modal-overlay edit-route-modal" onClick={() => setShowEditModal(false)}>
//                     <div className="modal-content edit-route-content" onClick={(e) => e.stopPropagation()}>
//                         <div className="modal-header">

//                             <h3>{isEditingPending ? 'Edit Pending Route' : 'Edit Route'}: {editingRoute.routeName}</h3>

//                             <button className="modal-close-btn" onClick={() => {
//           setShowEditModal(false);
//           setIsEditingPending(false);
//           setEditingPendingId(null);
//       }}>×</button>
//                         </div>

//                         <div className="modal-body">


//                             <div className="round-trip-toggle">
//                                 <label className="checkbox-container">
//                                     <input
//                                         type="checkbox"
//                                         checked={editForm.isRoundTrip || false}
//                                         onChange={(e) => {
//                                             const newVal = e.target.checked;
//                                             handleEditRoundTripToggle(newVal);
//                                         }}
//                                         className="checkbox-input"
//                                     />
//                                     <span className="checkbox-label">Round Trip (Main + Return Routes)</span>
//                                 </label>
//                                 {editForm.isRoundTrip && (editForm.isMultiTrip || editIsMultiTrip) && (
//                                     <div style={{
//                                         marginTop: '8px',
//                                         padding: '8px 12px',
//                                         backgroundColor: '#e3f2fd',
//                                         borderRadius: '6px',
//                                         fontSize: '12px',
//                                         color: '#0d47a1',
//                                         border: '1px solid #90caf9'
//                                     }}>
//                                         ℹ️ Multi-trip mode is enabled. Each return stop will have {editForm.numberOfTrips || 1} trip timings.
//                                         Please set the timings for each trip in the DOWN route section below.
//                                     </div>
//                                 )}
//                             </div>
//                             {editForm.isRoundTrip && (
//                                 <div className="route-tabs">
//                                     <button
//                                         className={`route-tab ${activeRouteTab === 'UP' ? 'active' : ''}`}
//                                         onClick={() => setActiveRouteTab('UP')}
//                                     >
//                                         UP (Main) Route
//                                     </button>
//                                     <button
//                                         className={`route-tab ${activeRouteTab === 'DOWN' ? 'active' : ''}`}
//                                         onClick={() => setActiveRouteTab('DOWN')}
//                                     >
//                                         DOWN (Return) Route
//                                     </button>
//                                 </div>
//                             )}


//                             <div className="form-row" style={{ marginBottom: '16px' }}>
//                                 <Checkbox
//                                     label="Multi-Trip Route (Multiple trips per day)"
//                                     checked={editForm.isMultiTrip || false}
//                                     onChange={(e) => {
//                                         const isMulti = e.target.checked;
//                                         setEditForm(prev => ({ ...prev, isMultiTrip: isMulti }));
//                                         setEditIsMultiTrip(isMulti);

//                                         if (isMulti) {
//                                             if (!editForm.originTimings || editForm.originTimings.length === 0) {
//                                                 setEditForm(prev => ({
//                                                     ...prev,
//                                                     originTimings: [{ timeSlotSequence: 1, departureTime: prev.originDepTime || '', arrivalTime: '' }],
//                                                     destTimings: [{ timeSlotSequence: 1, arrivalTime: prev.destArrTime || '', departureTime: '' }],
//                                                     numberOfTrips: 1
//                                                 }));
//                                                 setEditNumberOfTrips(1);
//                                             }

//                                             if (editForm.isRoundTrip || isRoundTrip) {
//                                                 const returnOriginTimings = editForm.returnOriginTimings && editForm.returnOriginTimings.length > 0
//                                                     ? editForm.returnOriginTimings
//                                                     : [{
//                                                         timeSlotSequence: 1,
//                                                         departureTime: editForm.returnOriginDepTime || '',
//                                                         arrivalTime: ''
//                                                     }];

//                                                 const returnDestTimings = editForm.returnDestTimings && editForm.returnDestTimings.length > 0
//                                                     ? editForm.returnDestTimings
//                                                     : [{
//                                                         timeSlotSequence: 1,
//                                                         arrivalTime: editForm.returnDestArrTime || '',
//                                                         departureTime: ''
//                                                     }];

//                                                 setEditForm(prev => ({
//                                                     ...prev,
//                                                     returnOriginTimings: returnOriginTimings,
//                                                     returnDestTimings: returnDestTimings,
//                                                     numberOfTrips: 1
//                                                 }));

//                                                 setEditNumberOfTrips(1);

//                                                 if (downStops.length > 0) {
//                                                     const updatedDownStops = downStops.map(stop => {
//                                                         if (stop.timings && stop.timings.length > 0) {
//                                                             return stop;
//                                                         }
//                                                         return {
//                                                             ...stop,
//                                                             timings: [{
//                                                                 timeSlotSequence: 1,
//                                                                 arrivalTime: stop.arrivalTime || '',
//                                                                 departureTime: stop.departureTime || ''
//                                                             }]
//                                                         };
//                                                     });
//                                                     setDownStops(updatedDownStops);
//                                                 }

//                                                 toast.info('Multi-trip enabled for return route. Please set timings for each trip.');
//                                             }
//                                         } else {
//                                             const firstOriginTiming = editForm.originTimings?.[0];
//                                             const firstDestTiming = editForm.destTimings?.[0];

//                                             setEditForm(prev => ({
//                                                 ...prev,
//                                                 originDepTime: firstOriginTiming?.departureTime || '',
//                                                 destArrTime: firstDestTiming?.arrivalTime || '',
//                                                 originTimings: [],
//                                                 destTimings: [],
//                                                 numberOfTrips: 1
//                                             }));
//                                             setEditNumberOfTrips(1);

//                                             if (editForm.isRoundTrip || isRoundTrip) {
//                                                 const firstReturnOriginTiming = editForm.returnOriginTimings?.[0];
//                                                 const firstReturnDestTiming = editForm.returnDestTimings?.[0];

//                                                 setEditForm(prev => ({
//                                                     ...prev,
//                                                     returnOriginDepTime: firstReturnOriginTiming?.departureTime || '',
//                                                     returnDestArrTime: firstReturnDestTiming?.arrivalTime || '',
//                                                     returnOriginTimings: [],
//                                                     returnDestTimings: []
//                                                 }));

//                                                 if (downStops.length > 0) {
//                                                     const updatedDownStops = downStops.map(stop => {
//                                                         const firstTiming = stop.timings?.[0];
//                                                         return {
//                                                             ...stop,
//                                                             arrivalTime: firstTiming?.arrivalTime || stop.arrivalTime || '',
//                                                             departureTime: firstTiming?.departureTime || stop.departureTime || '',
//                                                             timings: []
//                                                         };
//                                                     });
//                                                     setDownStops(updatedDownStops);
//                                                 }
//                                             }
//                                         }
//                                     }}
//                                 />
//                             </div>

//                             {(editForm.isMultiTrip || editIsMultiTrip) && (
//                                 <div style={{
//                                     marginBottom: '16px',
//                                     padding: '12px 16px',
//                                     backgroundColor: '#e3f2fd',
//                                     borderRadius: '8px',
//                                     border: '1px solid #90caf9',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'space-between',
//                                     flexWrap: 'wrap',
//                                     gap: '10px'
//                                 }}>
//                                     <div>
//                                         <span style={{ fontSize: '13px', fontWeight: '500', color: '#0d47a1' }}>
//                                             🚍 Number of Trips per Day ({activeRouteTab} Route):
//                                         </span>
//                                         <span style={{
//                                             marginLeft: '8px',
//                                             fontSize: '16px',
//                                             fontWeight: 'bold',
//                                             color: '#1565c0',
//                                             backgroundColor: '#bbdefb',
//                                             padding: '4px 12px',
//                                             borderRadius: '20px',
//                                             display: 'inline-block'
//                                         }}>
//                                             {editForm.numberOfTrips || editNumberOfTrips || 1} trip{editForm.numberOfTrips !== 1 ? 's' : ''}
//                                         </span>
//                                     </div>
//                                     <button
//                                         type="button"
//                                         onClick={() => {
//                                             const numTrips = editForm.numberOfTrips || editNumberOfTrips || 1;
//                                             if (window.confirm(`This will set default timings for all stops. Continue?`)) {
//                                                 const currentStops = getActiveStops();
//                                                 const updatedStops = currentStops.map(stop => ({
//                                                     ...stop,
//                                                     timings: Array.from({ length: numTrips }, (_, i) => ({
//                                                         timeSlotSequence: i + 1,
//                                                         arrivalTime: '',
//                                                         departureTime: ''
//                                                     }))
//                                                 }));
//                                                 setActiveStops(updatedStops);
//                                                 toast.info(`Timings initialized for all ${currentStops.length} stops`);
//                                             }
//                                         }}
//                                         style={{
//                                             padding: '4px 12px',
//                                             fontSize: '11px',
//                                             backgroundColor: '#1565c0',
//                                             color: 'white',
//                                             border: 'none',
//                                             borderRadius: '4px',
//                                             cursor: 'pointer'
//                                         }}
//                                     >
//                                         Initialize All Stops
//                                     </button>
//                                 </div>
//                             )}

//                             <div className="form-sections">
//                                 <div className="form-section">
//                                     <h4>Route Identity</h4>
//                                     <div className="form-row">
//                                         <div className="form-group">
//                                             <label>Route Name *</label>
//                                             <input
//                                                 type="text"
//                                                 value={editForm.routeName}
//                                                 onChange={(e) => setEditForm(prev => ({ ...prev, routeName: e.target.value }))}
//                                                 placeholder="Route name"
//                                                 className="form-input"
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Local Route Name (Optional)</label>
//                                             <input
//                                                 type="text"
//                                                 value={editForm.localRouteName || ''}
//                                                 onChange={(e) => setEditForm(prev => ({ ...prev, localRouteName: e.target.value }))}
//                                                 placeholder="Enter local/regional name for this route"
//                                                 className="form-input"
//                                             />
//                                             <small className="helper-text">This name will be displayed to passengers as the local route identifier</small>
//                                         </div>
//                                     </div>
//                                 </div>


//                                 <div className="form-section">
//                                     <h4>{activeRouteTab === 'UP' ? 'Origin' : 'Return Origin'}</h4>
//                                     {activeRouteTab === 'UP' ? (
//                                         <React.Fragment>
//                                             <div className="form-row">
//                                                 <div className="form-group full-width">
//                                                     <label>Search Location</label>
//                                                     <LocationInput
//                                                         value={editForm.originCity}
//                                                         onChange={(value) => setEditForm(prev => ({ ...prev, originCity: value }))}
//                                                         onLocationSelect={handleEditOriginSelect}
//                                                         placeholder="Search origin city or address..."
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>Address</label>
//                                                     <input type="text" value={editForm.originAddress} onChange={(e) => setEditForm(prev => ({ ...prev, originAddress: e.target.value }))} placeholder="Full address" className="form-input" />
//                                                 </div>
//                                             </div>
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>State</label>
//                                                     <input type="text" value={editForm.originState} onChange={(e) => setEditForm(prev => ({ ...prev, originState: e.target.value }))} placeholder="State" className="form-input" />
//                                                 </div>
//                                                 <div className="form-group">
//                                                     <label>Terminal</label>
//                                                     <input type="text" value={editForm.originTerminal} onChange={(e) => setEditForm(prev => ({ ...prev, originTerminal: e.target.value }))} placeholder="Terminal name" className="form-input" />
//                                                 </div>
//                                             </div>


//                                             {editForm.isMultiTrip && editForm.originTimings && editForm.originTimings.length > 0 ? (
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
//                                                             <label>Departure Times (Multi-Trip)</label>
//                                                             <button
//                                                                 type="button"
//                                                                 className="btn btn-sm btn-add-timing"
//                                                                 onClick={addEditOriginTrip}
//                                                                 style={{
//                                                                     padding: '4px 14px',
//                                                                     fontSize: '12px',
//                                                                     background: '#28a745',
//                                                                     color: 'white',
//                                                                     border: 'none',
//                                                                     borderRadius: '4px',
//                                                                     cursor: 'pointer'
//                                                                 }}
//                                                             >
//                                                                 + Add Trip
//                                                             </button>
//                                                         </div>
//                                                         <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden' }}>
//                                                             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                                                 <thead>
//                                                                     <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
//                                                                         <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Trip</th>
//                                                                         <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Departure Time</th>
//                                                                         <th style={{ padding: '10px', textAlign: 'center', fontSize: '13px', width: '50px' }}>Action</th>
//                                                                     </tr>
//                                                                 </thead>
//                                                                 <tbody>
//                                                                     {editForm.originTimings.map((timing, idx) => (
//                                                                         <tr key={timing.timeSlotSequence || idx} style={{ borderBottom: idx < editForm.originTimings.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
//                                                                             <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>
//                                                                                 Trip #{timing.timeSlotSequence || idx + 1}
//                                                                             </td>
//                                                                             <td style={{ padding: '10px' }}>
//                                                                                 <TimePicker
//                                                                                     value={timing.departureTime}
//                                                                                     onChange={(value) => {
//                                                                                         const updatedTimings = [...(editForm.originTimings || [])];
//                                                                                         updatedTimings[idx] = { ...timing, departureTime: value };
//                                                                                         setEditForm(prev => ({ ...prev, originTimings: updatedTimings }));
//                                                                                     }}
//                                                                                     placeholder="--:--"
//                                                                                 />
//                                                                             </td>
//                                                                             <td style={{ padding: '10px', textAlign: 'center' }}>
//                                                                                 {editForm.originTimings.length > 1 && (
//                                                                                     <button
//                                                                                         onClick={() => removeEditOriginTrip(idx)}
//                                                                                         style={{
//                                                                                             padding: '2px 8px',
//                                                                                             fontSize: '12px',
//                                                                                             background: '#dc3545',
//                                                                                             color: 'white',
//                                                                                             border: 'none',
//                                                                                             borderRadius: '4px',
//                                                                                             cursor: 'pointer'
//                                                                                         }}
//                                                                                     >
//                                                                                         ✕
//                                                                                     </button>
//                                                                                 )}
//                                                                             </td>
//                                                                         </tr>
//                                                                     ))}
//                                                                 </tbody>
//                                                             </table>
//                                                         </div>
//                                                         <small className="helper-text">Add multiple departure times for different trips per day</small>
//                                                     </div>
//                                                 </div>
//                                             ) : !editForm.isMultiTrip && (
//                                                 <div className="form-row">
//                                                     <div className="form-group">
//                                                         <label>Departure Time *</label>
//                                                         <TimePicker
//                                                             value={editForm.originDepTime}
//                                                             onChange={(value) => {
//                                                                 setEditForm(prev => ({ ...prev, originDepTime: value }));
//                                                             }}
//                                                             placeholder="Select time"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </React.Fragment>
//                                     ) : (
//                                         <React.Fragment>
//                                             <div className="form-row">
//                                                 <div className="form-group full-width">
//                                                     <input type="text" value={editForm.returnOriginCity || ''} onChange={(e) => setEditForm(prev => ({ ...prev, returnOriginCity: e.target.value }))} placeholder="Return Origin City" className="form-input" />
//                                                 </div>
//                                             </div>

//                                             {editForm.isMultiTrip && editForm.returnOriginTimings && editForm.returnOriginTimings.length > 0 && (
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
//                                                             <label>Return Departure Times (Multi-Trip)</label>
//                                                             <button
//                                                                 type="button"
//                                                                 className="btn btn-sm btn-add-timing"
//                                                                 onClick={addEditReturnOriginTrip}
//                                                                 style={{
//                                                                     padding: '4px 14px',
//                                                                     fontSize: '12px',
//                                                                     background: '#28a745',
//                                                                     color: 'white',
//                                                                     border: 'none',
//                                                                     borderRadius: '4px',
//                                                                     cursor: 'pointer'
//                                                                 }}
//                                                             >
//                                                                 + Add Trip
//                                                             </button>
//                                                         </div>
//                                                         <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden', marginTop: '8px' }}>
//                                                             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                                                 <thead>
//                                                                     <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
//                                                                         <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Trip</th>
//                                                                         <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Departure Time</th>
//                                                                         <th style={{ padding: '10px', textAlign: 'center', fontSize: '13px', width: '50px' }}>Action</th>
//                                                                     </tr>
//                                                                 </thead>
//                                                                 <tbody>
//                                                                     {editForm.returnOriginTimings.map((timing, idx) => (
//                                                                         <tr key={timing.timeSlotSequence || idx} style={{ borderBottom: idx < editForm.returnOriginTimings.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
//                                                                             <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>
//                                                                                 Trip #{timing.timeSlotSequence || idx + 1}
//                                                                             </td>
//                                                                             <td style={{ padding: '10px' }}>
//                                                                                 <TimePicker
//                                                                                     value={timing.departureTime}
//                                                                                     onChange={(value) => {
//                                                                                         const updatedTimings = [...(editForm.returnOriginTimings || [])];
//                                                                                         updatedTimings[idx] = { ...timing, departureTime: value };
//                                                                                         setEditForm(prev => ({ ...prev, returnOriginTimings: updatedTimings }));
//                                                                                     }}
//                                                                                     placeholder="--:--"
//                                                                                 />
//                                                                             </td>
//                                                                             <td style={{ padding: '10px', textAlign: 'center' }}>
//                                                                                 {editForm.returnOriginTimings.length > 1 && (
//                                                                                     <button
//                                                                                         onClick={() => removeEditReturnOriginTrip(idx)}
//                                                                                         style={{
//                                                                                             padding: '2px 8px',
//                                                                                             fontSize: '12px',
//                                                                                             background: '#dc3545',
//                                                                                             color: 'white',
//                                                                                             border: 'none',
//                                                                                             borderRadius: '4px',
//                                                                                             cursor: 'pointer'
//                                                                                         }}
//                                                                                     >
//                                                                                         ✕
//                                                                                     </button>
//                                                                                 )}
//                                                                             </td>
//                                                                         </tr>
//                                                                     ))}
//                                                                 </tbody>
//                                                             </table>
//                                                         </div>
//                                                         <small className="helper-text">Add multiple departure times for different trips per day</small>
//                                                     </div>
//                                                 </div>
//                                             )}
//                                             {!editForm.isMultiTrip && (
//                                                 <div className="form-row">
//                                                     <div className="form-group">
//                                                         <label>Return Departure Time *</label>
//                                                         <TimePicker
//                                                             value={editForm.returnOriginDepTime}
//                                                             onChange={(value) => {
//                                                                 setEditForm(prev => ({ ...prev, returnOriginDepTime: value }));
//                                                             }}
//                                                             placeholder="Select time"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </React.Fragment>
//                                     )}
//                                 </div>


//                                 <div className="form-section">
//                                     <h4>{activeRouteTab === 'UP' ? 'Destination' : 'Return Destination'}</h4>
//                                     {activeRouteTab === 'UP' ? (
//                                         <React.Fragment>
//                                             <div className="form-row">
//                                                 <div className="form-group full-width">
//                                                     <label>Search Location</label>
//                                                     <LocationInput
//                                                         value={editForm.destCity}
//                                                         onChange={(value) => setEditForm(prev => ({ ...prev, destCity: value }))}
//                                                         onLocationSelect={handleEditDestSelect}
//                                                         placeholder="Search destination city or address..."
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>Address</label>
//                                                     <input type="text" value={editForm.destAddress} onChange={(e) => setEditForm(prev => ({ ...prev, destAddress: e.target.value }))} placeholder="Full address" className="form-input" />
//                                                 </div>
//                                             </div>
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>State</label>
//                                                     <input type="text" value={editForm.destState} onChange={(e) => setEditForm(prev => ({ ...prev, destState: e.target.value }))} placeholder="State" className="form-input" />
//                                                 </div>
//                                                 <div className="form-group">
//                                                     <label>Terminal</label>
//                                                     <input type="text" value={editForm.destTerminal} onChange={(e) => setEditForm(prev => ({ ...prev, destTerminal: e.target.value }))} placeholder="Terminal name" className="form-input" />
//                                                 </div>
//                                             </div>


//                                             {editForm.isMultiTrip && editForm.destTimings && editForm.destTimings.length > 0 ? (
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
//                                                             <label>Arrival Times (Multi-Trip)</label>
//                                                             <button
//                                                                 type="button"
//                                                                 className="btn btn-sm btn-add-timing"
//                                                                 onClick={addEditDestinationTrip}
//                                                                 style={{
//                                                                     padding: '4px 14px',
//                                                                     fontSize: '12px',
//                                                                     background: '#28a745',
//                                                                     color: 'white',
//                                                                     border: 'none',
//                                                                     borderRadius: '4px',
//                                                                     cursor: 'pointer'
//                                                                 }}
//                                                             >
//                                                                 + Add Trip
//                                                             </button>
//                                                         </div>
//                                                         <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden' }}>
//                                                             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                                                 <thead>
//                                                                     <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
//                                                                         <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Trip</th>
//                                                                         <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Arrival Time</th>
//                                                                         <th style={{ padding: '10px', textAlign: 'center', fontSize: '13px', width: '50px' }}>Action</th>
//                                                                     </tr>
//                                                                 </thead>
//                                                                 <tbody>
//                                                                     {editForm.destTimings.map((timing, idx) => (
//                                                                         <tr key={timing.timeSlotSequence || idx} style={{ borderBottom: idx < editForm.destTimings.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
//                                                                             <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>
//                                                                                 Trip #{timing.timeSlotSequence || idx + 1}
//                                                                             </td>
//                                                                             <td style={{ padding: '10px' }}>
//                                                                                 <TimePicker
//                                                                                     value={timing.arrivalTime}
//                                                                                     onChange={(value) => {
//                                                                                         const updatedTimings = [...(editForm.destTimings || [])];
//                                                                                         updatedTimings[idx] = { ...timing, arrivalTime: value };
//                                                                                         setEditForm(prev => ({ ...prev, destTimings: updatedTimings }));
//                                                                                     }}
//                                                                                     placeholder="--:--"
//                                                                                 />
//                                                                             </td>
//                                                                             <td style={{ padding: '10px', textAlign: 'center' }}>
//                                                                                 {editForm.destTimings.length > 1 && (
//                                                                                     <button
//                                                                                         onClick={() => removeEditDestinationTrip(idx)}
//                                                                                         style={{
//                                                                                             padding: '2px 8px',
//                                                                                             fontSize: '12px',
//                                                                                             background: '#dc3545',
//                                                                                             color: 'white',
//                                                                                             border: 'none',
//                                                                                             borderRadius: '4px',
//                                                                                             cursor: 'pointer'
//                                                                                         }}
//                                                                                     >
//                                                                                         ✕
//                                                                                     </button>
//                                                                                 )}
//                                                                             </td>
//                                                                         </tr>
//                                                                     ))}
//                                                                 </tbody>
//                                                             </table>
//                                                         </div>
//                                                         <small className="helper-text">Add multiple arrival times for different trips per day</small>
//                                                     </div>
//                                                 </div>
//                                             ) : !editForm.isMultiTrip && (
//                                                 <div className="form-row">
//                                                     <div className="form-group">
//                                                         <label>Arrival Time *</label>
//                                                         <TimePicker
//                                                             value={editForm.destArrTime}
//                                                             onChange={(value) => {
//                                                                 setEditForm(prev => ({ ...prev, destArrTime: value }));
//                                                             }}
//                                                             placeholder="Select time"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </React.Fragment>
//                                     ) : (
//                                         <React.Fragment>
//                                             <div className="form-row">
//                                                 <div className="form-group full-width">
//                                                     <input type="text" value={editForm.returnDestCity || ''} onChange={(e) => setEditForm(prev => ({ ...prev, returnDestCity: e.target.value }))} placeholder="Return Destination City" className="form-input" />
//                                                 </div>
//                                             </div>

//                                             {editForm.isMultiTrip && editForm.returnDestTimings && editForm.returnDestTimings.length > 0 && (
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
//                                                             <label>Return Arrival Times (Multi-Trip)</label>
//                                                             <button
//                                                                 type="button"
//                                                                 className="btn btn-sm btn-add-timing"
//                                                                 onClick={addEditReturnDestinationTrip}
//                                                                 style={{
//                                                                     padding: '4px 14px',
//                                                                     fontSize: '12px',
//                                                                     background: '#28a745',
//                                                                     color: 'white',
//                                                                     border: 'none',
//                                                                     borderRadius: '4px',
//                                                                     cursor: 'pointer'
//                                                                 }}
//                                                             >
//                                                                 + Add Trip
//                                                             </button>
//                                                         </div>
//                                                         <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden', marginTop: '8px' }}>
//                                                             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                                                 <thead>
//                                                                     <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
//                                                                         <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Trip</th>
//                                                                         <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Arrival Time</th>
//                                                                         <th style={{ padding: '10px', textAlign: 'center', fontSize: '13px', width: '50px' }}>Action</th>
//                                                                     </tr>
//                                                                 </thead>
//                                                                 <tbody>
//                                                                     {editForm.returnDestTimings.map((timing, idx) => (
//                                                                         <tr key={timing.timeSlotSequence || idx} style={{ borderBottom: idx < editForm.returnDestTimings.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
//                                                                             <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>
//                                                                                 Trip #{timing.timeSlotSequence || idx + 1}
//                                                                             </td>
//                                                                             <td style={{ padding: '10px' }}>
//                                                                                 <TimePicker
//                                                                                     value={timing.arrivalTime}
//                                                                                     onChange={(value) => {
//                                                                                         const updatedTimings = [...(editForm.returnDestTimings || [])];
//                                                                                         updatedTimings[idx] = { ...timing, arrivalTime: value };
//                                                                                         setEditForm(prev => ({ ...prev, returnDestTimings: updatedTimings }));
//                                                                                     }}
//                                                                                     placeholder="--:--"
//                                                                                 />
//                                                                             </td>
//                                                                             <td style={{ padding: '10px', textAlign: 'center' }}>
//                                                                                 {editForm.returnDestTimings.length > 1 && (
//                                                                                     <button
//                                                                                         onClick={() => removeEditReturnDestinationTrip(idx)}
//                                                                                         style={{
//                                                                                             padding: '2px 8px',
//                                                                                             fontSize: '12px',
//                                                                                             background: '#dc3545',
//                                                                                             color: 'white',
//                                                                                             border: 'none',
//                                                                                             borderRadius: '4px',
//                                                                                             cursor: 'pointer'
//                                                                                         }}
//                                                                                     >
//                                                                                         ✕
//                                                                                     </button>
//                                                                                 )}
//                                                                             </td>
//                                                                         </tr>
//                                                                     ))}
//                                                                 </tbody>
//                                                             </table>
//                                                         </div>
//                                                         <small className="helper-text">Add multiple arrival times for different trips per day</small>
//                                                     </div>
//                                                 </div>
//                                             )}
//                                             {!editForm.isMultiTrip && (
//                                                 <div className="form-row">
//                                                     <div className="form-group">
//                                                         <label>Return Arrival Time *</label>
//                                                         <TimePicker
//                                                             value={editForm.returnDestArrTime}
//                                                             onChange={(value) => {
//                                                                 setEditForm(prev => ({ ...prev, returnDestArrTime: value }));
//                                                             }}
//                                                             placeholder="Select time"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </React.Fragment>
//                                     )}
//                                 </div>


//                                 <div className="form-section stops-section">
//                                     <h4>Intermediate Stops ({activeRouteTab})</h4>

//                                     {activeRouteTab === 'DOWN' && editForm.isRoundTrip && (
//                                         <button
//                                             className="sync-btn"
//                                             onClick={() => syncDownStopsWithUpStops(true)}
//                                             style={{
//                                                 padding: '8px 16px',
//                                                 backgroundColor: '#17a2b8',
//                                                 color: 'white',
//                                                 border: 'none',
//                                                 borderRadius: '4px',
//                                                 cursor: 'pointer',
//                                                 fontSize: '13px',
//                                                 fontWeight: '500',
//                                                 marginBottom: '12px',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 gap: '8px'
//                                             }}
//                                             onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#138496'}
//                                             onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#17a2b8'}
//                                         >
//                                             🔄 Auto-Fill / Sync Reversed Stops from UP Route
//                                             {editForm.isMultiTrip && (
//                                                 <span style={{
//                                                     fontSize: '10px',
//                                                     backgroundColor: 'rgba(255,255,255,0.2)',
//                                                     padding: '2px 8px',
//                                                     borderRadius: '10px',
//                                                     marginLeft: '4px'
//                                                 }}>
//                                                     {editForm.numberOfTrips || 1} trips
//                                                 </span>
//                                             )}
//                                         </button>
//                                     )}

//                                     <div className="stops-list">
//                                         {getActiveStops().length > 0 && renderInsertButton(0, activeRouteTab === 'UP' ? 'up' : 'down')}
//                                         {getActiveStops().map((stop, index) => {
//                                             const displayManualDist = calculateManualDistFromPrev(getActiveStops(), index);
//                                             const distanceDisplay = displayManualDist ||
//                                                 (typeof stop.distanceFromOrigin === 'number'
//                                                     ? stop.distanceFromOrigin.toFixed(2)
//                                                     : parseFloat(stop.distanceFromOrigin || 0).toFixed(2));

//                                             const hasMultiTimings = stop.timings && stop.timings.length > 0;
//                                             const sortedTimings = hasMultiTimings ? sortTimings(stop.timings) : [];

//                                             return (
//                                                 <React.Fragment key={index}>
//                                                     <div className={`stop-list-item ${(activeRouteTab === 'UP' ? editUpIndex : editDownIndex) === index ? 'editing-highlight' : ''}`}>
//                                                         <div className="stop-info">
//                                                             <div className="stop-name">
//                                                                 {index + 1}. {stop.city}
//                                                                 <span className="stop-distance">
//                                                                     ({distanceDisplay} km)
//                                                                 </span>
//                                                             </div>

//                                                             {hasMultiTimings && sortedTimings.length > 0 ? (
//                                                                 <div className="stop-multi-times" style={{ marginTop: '8px', marginBottom: '8px' }}>
//                                                                     {sortedTimings.map((timing, idx) => (
//                                                                         <div key={timing.timeSlotSequence || idx} style={{
//                                                                             display: 'inline-flex', alignItems: 'center', gap: '8px',
//                                                                             backgroundColor: '#e9ecef', padding: '4px 10px',
//                                                                             borderRadius: '16px', margin: '2px 4px', fontSize: '11px'
//                                                                         }}>
//                                                                             <span style={{ fontWeight: '500' }}>Trip {timing.timeSlotSequence || idx + 1}:</span>
//                                                                             <span>Arr {TimeDisplay({ time: timing.arrivalTime })}</span>
//                                                                             <span>→</span>
//                                                                             <span>Dep {TimeDisplay({ time: timing.departureTime })}</span>
//                                                                         </div>
//                                                                     ))}
//                                                                     {stop.stopType && stop.stopType !== 'none' && (
//                                                                         <span style={{
//                                                                             display: 'inline-flex', alignItems: 'center',
//                                                                             marginLeft: '8px', fontSize: '11px', fontWeight: '500',
//                                                                             padding: '2px 8px', borderRadius: '12px',
//                                                                             backgroundColor: stop.stopType === 'boarding' ? '#e3f2fd'
//                                                                                 : stop.stopType === 'dropping' ? '#fce4ec' : '#e8f5e9',
//                                                                             color: stop.stopType === 'boarding' ? '#1565c0'
//                                                                                 : stop.stopType === 'dropping' ? '#c62828' : '#2e7d32',
//                                                                             border: `1px solid ${stop.stopType === 'boarding' ? '#90caf9'
//                                                                                 : stop.stopType === 'dropping' ? '#f48fb1' : '#a5d6a7'}`
//                                                                         }}>
//                                                                             {stop.stopType === 'boarding' ? '🟢 Boarding'
//                                                                                 : stop.stopType === 'dropping' ? '🔴 Dropping' : '🟡 Both'}
//                                                                         </span>
//                                                                     )}
//                                                                 </div>
//                                                             ) : (
//                                                                 <div className="stop-times" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
//                                                                     <span>Arr: {stop.arrivalTime || 'TBD'} • Dep: {stop.departureTime || 'N/A'}</span>
//                                                                     {stop.stopType && stop.stopType !== 'none' && (
//                                                                         <span style={{
//                                                                             fontSize: '11px', fontWeight: '500',
//                                                                             padding: '2px 8px', borderRadius: '12px',
//                                                                             backgroundColor: stop.stopType === 'boarding' ? '#e3f2fd'
//                                                                                 : stop.stopType === 'dropping' ? '#fce4ec' : '#e8f5e9',
//                                                                             color: stop.stopType === 'boarding' ? '#1565c0'
//                                                                                 : stop.stopType === 'dropping' ? '#c62828' : '#2e7d32',
//                                                                             border: `1px solid ${stop.stopType === 'boarding' ? '#90caf9'
//                                                                                 : stop.stopType === 'dropping' ? '#f48fb1' : '#a5d6a7'}`
//                                                                         }}>
//                                                                             {stop.stopType === 'boarding' ? '🟢 Boarding'
//                                                                                 : stop.stopType === 'dropping' ? '🔴 Dropping' : '🟡 Both'}
//                                                                         </span>
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                         </div>
//                                                         <div className="stop-actions">
//                                                             <button className="stop-action-btn edit" onClick={() => {
//                                                                 setEditingStopIndex(index);
//                                                                 handleEditStop(index, activeRouteTab === 'UP' ? 'up' : 'down');
//                                                             }}>Edit</button>
//                                                             <button className="stop-action-btn delete" onClick={() => handleDeleteStop(index)}>Delete</button>
//                                                         </div>
//                                                     </div>
//                                                     {renderInsertButton(index + 1, activeRouteTab === 'UP' ? 'up' : 'down')}
//                                                 </React.Fragment>
//                                             );
//                                         })}
//                                     </div>
//                                 </div>

//                                 <div className="form-section">
//                                     <h4>{activeRouteTab} Summary</h4>

//                                     <button
//                                         className="btn btn-success calculate-btn"
//                                         onClick={() => handleEditCalculateDistances(activeRouteTab === 'UP' ? 'up' : 'down')}
//                                         disabled={isCalculatingDistances}
//                                     >
//                                         {isCalculatingDistances ? 'Calculating...' : `Auto-Calculate Distances (${activeRouteTab})`}
//                                     </button>

//                                     {(() => {
//                                         const stops = activeRouteTab === 'UP' ? upStops : downStops;
//                                         const lastStop = stops.length > 0 ? stops[stops.length - 1] : null;

//                                         const isLastManual = lastStop?.isManualStop === true ||
//                                             (lastStop && (!lastStop.coordinates || (lastStop.coordinates.lat === 0 && lastStop.coordinates.lng === 0)));

//                                         const shouldShow = (activeRouteTab === 'DOWN' && stops.length > 0) ||
//                                             (activeRouteTab === 'UP' && isLastManual);

//                                         if (!shouldShow) return null;

//                                         const fieldValue = activeRouteTab === 'UP'
//                                             ? (editForm.upManualFinalLeg || '')
//                                             : (editForm.returnManualFinalLeg || '');

//                                         return (
//                                             <div className="form-row" style={{ marginTop: '10px' }}>
//                                                 <div className="form-group full-width">
//                                                     <label>Distance from Last Stop to Destination (KM) *</label>
//                                                     <input
//                                                         type="number"
//                                                         value={fieldValue}
//                                                         onChange={(e) => {
//                                                             const value = e.target.value;
//                                                             if (activeRouteTab === 'UP') {
//                                                                 setEditForm(prev => ({ ...prev, upManualFinalLeg: value }));
//                                                                 const lastStopDist = stops.length > 0 ? (stops[stops.length - 1].distanceFromOrigin || 0) : 0;
//                                                                 const newTotal = lastStopDist + (parseFloat(value) || 0);
//                                                                 if (newTotal > 0) {
//                                                                     setEditForm(prev => ({ ...prev, totalDistance: newTotal.toFixed(1) }));
//                                                                 }
//                                                             } else {
//                                                                 setEditForm(prev => ({ ...prev, returnManualFinalLeg: value }));
//                                                                 const lastStopDist = stops.length > 0 ? (stops[stops.length - 1].distanceFromOrigin || 0) : 0;
//                                                                 const newTotal = lastStopDist + (parseFloat(value) || 0);
//                                                                 if (newTotal > 0) {
//                                                                     setEditForm(prev => ({ ...prev, returnTotalDistance: newTotal.toFixed(1) }));
//                                                                 }
//                                                             }
//                                                         }}
//                                                         placeholder="Distance from last stop to destination"
//                                                         className="form-input"
//                                                         min="0"
//                                                         step="0.1"
//                                                         style={{ borderColor: '#dc3545', backgroundColor: '#fff5f5' }}
//                                                     />
//                                                     <small className="helper-text" style={{ color: '#dc3545' }}>
//                                                         ⚠️ Required because the last stop is manual. This distance will be added to the total.
//                                                     </small>
//                                                 </div>
//                                             </div>
//                                         );
//                                     })()}

//                                     <div className="form-row summary-fields">
//                                         <div className="form-group">
//                                             <label>Total Distance (KM)</label>
//                                             <input
//                                                 type="number"
//                                                 value={activeRouteTab === 'UP' ? (editForm.totalDistance || '') : (editForm.returnTotalDistance || '')}
//                                                 onChange={(e) => {
//                                                     const value = e.target.value;
//                                                     if (activeRouteTab === 'UP') {
//                                                         setEditForm(prev => ({ ...prev, totalDistance: value }));
//                                                     } else {
//                                                         setEditForm(prev => ({ ...prev, returnTotalDistance: value }));
//                                                     }
//                                                 }}
//                                                 className="form-input"
//                                                 min="0"
//                                                 step="0.1"
//                                             />
//                                         </div>
//                                         <div className="form-group">
//                                             <label>Est. Duration</label>
//                                             <div className="duration-inputs">
//                                                 <input
//                                                     type="number"
//                                                     value={activeRouteTab === 'UP' ? (editForm.durationHours || '') : (editForm.returnDurationHours || '')}
//                                                     onChange={(e) => {
//                                                         const value = e.target.value;
//                                                         if (activeRouteTab === 'UP') {
//                                                             setEditForm(prev => ({ ...prev, durationHours: value }));
//                                                         } else {
//                                                             setEditForm(prev => ({ ...prev, returnDurationHours: value }));
//                                                         }
//                                                     }}
//                                                     className="form-input"
//                                                     placeholder="Hours"
//                                                     min="0"
//                                                 />
//                                                 <span>h</span>
//                                                 <input
//                                                     type="number"
//                                                     value={activeRouteTab === 'UP' ? (editForm.durationMinutes || '') : (editForm.returnDurationMinutes || '')}
//                                                     onChange={(e) => {
//                                                         let value = e.target.value;
//                                                         let minutes = Math.min(59, Math.max(0, parseInt(value) || 0));
//                                                         if (activeRouteTab === 'UP') {
//                                                             setEditForm(prev => ({ ...prev, durationMinutes: minutes.toString() }));
//                                                         } else {
//                                                             setEditForm(prev => ({ ...prev, returnDurationMinutes: minutes.toString() }));
//                                                         }
//                                                     }}
//                                                     className="form-input"
//                                                     placeholder="Minutes"
//                                                     min="0"
//                                                     max="59"
//                                                 />
//                                                 <span>m</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>


//                                 <div className="form-section">
//                                     <h4>Status</h4>
//                                     <div className="form-row">
//                                         <div className="form-group">
//                                             <label className="checkbox-container">
//                                                 <input type="checkbox" checked={editForm.isActive} onChange={(e) => setEditForm(prev => ({ ...prev, isActive: e.target.checked }))} />
//                                                 <span>Route is Active</span>
//                                             </label>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>


//                             <div className="form-actions">

//                                 <button className="btn btn-secondary" onClick={() => {
//     setShowEditModal(false);
//     setIsEditingPending(false);
//     setEditingPendingId(null);
// }}>Cancel</button>
//                                 <button className="btn btn-primary save-route-btn" onClick={handleUpdateRoute} disabled={isUpdatingRoute}>
//                                     {isUpdatingRoute ? 'Updating...' : 'Update Route'}
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {showStopEditModal && stopBeingEdited && (
//                 <div className="modal-overlay" onClick={() => setShowStopEditModal(false)}>
//                     <div className="modal-content edit-stop-modal" onClick={(e) => e.stopPropagation()}
//                         style={{ maxWidth: '1200px', width: '90%' }}>
//                         <div className="modal-header">
//                             <h3>
//                                 Edit Stop #{stopBeingEdited.index + 1}
//                                 <span style={{ fontWeight: 'normal', color: '#666', fontSize: '14px' }}>
//                                     {' '}— {stopBeingEdited.originalStop.city}
//                                 </span>
//                             </h3>
//                             <button className="modal-close-btn" onClick={() => setShowStopEditModal(false)}>×</button>
//                         </div>

//                         <div className="modal-body">
//                             <div className="form-row" style={{ marginBottom: '12px' }}>
//                                 <Checkbox
//                                     label="Manually Typed Stop (No Map Suggestions)"
//                                     checked={stopEditForm.isManualStop}
//                                     onChange={() => setStopEditForm(prev => ({
//                                         ...prev,
//                                         isManualStop: !prev.isManualStop,
//                                         manualDistFromPrev: !prev.isManualStop ? prev.manualDistFromPrev : ''
//                                     }))}
//                                 />
//                             </div>

//                             {!stopEditForm.isManualStop ? (
//                                 <>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Search Location *</label>
//                                             <LocationInput
//                                                 value={stopEditForm.city}
//                                                 onChange={(value) => setStopEditForm(prev => ({ ...prev, city: value }))}
//                                                 onLocationSelect={(location) => setStopEditForm(prev => ({
//                                                     ...prev,
//                                                     city: location.city || location.name || '',
//                                                     state: location.state || prev.state,
//                                                     address: location.address || '',
//                                                 }))}
//                                                 placeholder="Search city or address..."
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Address</label>
//                                             <input type="text" value={stopEditForm.address}
//                                                 onChange={(e) => setStopEditForm(prev => ({ ...prev, address: e.target.value }))}
//                                                 placeholder="Full address" className="form-input" />
//                                         </div>
//                                     </div>
//                                 </>
//                             ) : (
//                                 <>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Search City *</label>
//                                             <div className="city-search-container" style={{ position: 'relative' }}>
//                                                 <input
//                                                     type="text"
//                                                     value={stopEditForm.city}
//                                                     onChange={async (e) => {
//                                                         const value = toTitleCase(e.target.value);
//                                                         setNewRoute(prev => ({ ...prev, stopCity: value }));

//                                                         if (value !== stopEditForm.city) {
//                                                             setStopEditForm(prev => ({
//                                                                 ...prev,
//                                                                 address: '',
//                                                                 state: '',
//                                                                 terminal: ''
//                                                             }));
//                                                         }

//                                                         if (value.length >= 2) {
//                                                             try {
//                                                                 const response = await searchRouteIntermediateStops(token, value);
//                                                                 if (response.success && response.cities && response.cities.length > 0) {
//                                                                     setEditCitySuggestions(response.cities);
//                                                                     setShowEditCityDropdown(true);
//                                                                 } else {
//                                                                     setEditCitySuggestions([]);
//                                                                     setShowEditCityDropdown(false);
//                                                                 }
//                                                             } catch (error) {
//                                                                 console.error('Error searching cities:', error);
//                                                                 setEditCitySuggestions([]);
//                                                                 setShowEditCityDropdown(false);
//                                                             }
//                                                         } else {
//                                                             setEditCitySuggestions([]);
//                                                             setShowEditCityDropdown(false);
//                                                         }
//                                                     }}
//                                                     onFocus={() => {
//                                                         if (editCitySuggestions.length > 0) {
//                                                             setShowEditCityDropdown(true);
//                                                         }
//                                                     }}
//                                                     onBlur={() => {
//                                                         setTimeout(() => setShowEditCityDropdown(false), 200);
//                                                     }}
//                                                     placeholder="Type city name (min 2 characters)..."
//                                                     className="form-input"
//                                                 />
//                                                 {showEditCityDropdown && editCitySuggestions.length > 0 && (
//                                                     <div className="city-suggestions-dropdown" style={{
//                                                         position: 'absolute',
//                                                         top: '100%',
//                                                         left: 0,
//                                                         right: 0,
//                                                         backgroundColor: 'white',
//                                                         border: '1px solid #ddd',
//                                                         borderRadius: '4px',
//                                                         maxHeight: '200px',
//                                                         overflowY: 'auto',
//                                                         zIndex: 10000,
//                                                         boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
//                                                     }}>
//                                                         {editCitySuggestions.map((city, idx) => (
//                                                             <div
//                                                                 key={city.id || idx}
//                                                                 onClick={() => {
//                                                                     setStopEditForm(prev => ({
//                                                                         ...prev,
//                                                                         city: city.name,
//                                                                         address: city.address || city.name,
//                                                                         state: city.state || '',
//                                                                         terminal: city.terminal || `${city.name} Bus Stand`
//                                                                     }));
//                                                                     setShowEditCityDropdown(false);
//                                                                     toast.success(`Auto-filled details for ${city.name}`);
//                                                                 }}
//                                                                 style={{
//                                                                     padding: '10px 12px',
//                                                                     cursor: 'pointer',
//                                                                     borderBottom: '1px solid #f0f0f0'
//                                                                 }}
//                                                                 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
//                                                                 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
//                                                             >
//                                                                 <div style={{ fontWeight: '500' }}>{city.name}</div>
//                                                                 <div style={{ fontSize: '12px', color: '#6c757d' }}>
//                                                                     {city.state}
//                                                                     {city.terminal && ` • ${city.terminal}`}
//                                                                 </div>
//                                                             </div>
//                                                         ))}
//                                                     </div>
//                                                 )}
//                                             </div>
//                                             <small className="helper-text">Type at least 2 characters to search for cities from existing routes</small>
//                                         </div>
//                                     </div>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Address</label>
//                                             <input type="text" value={stopEditForm.address}
//                                                 onChange={(e) => setStopEditForm(prev => ({ ...prev, address: e.target.value }))}
//                                                 placeholder="Full address (e.g., NH-19, Near Bus Stand)" className="form-input" />
//                                             <small className="helper-text">Complete address of the stop location</small>
//                                         </div>
//                                     </div>
//                                 </>
//                             )}

//                             <div className="form-row">
//                                 <div className="form-group">
//                                     <label>State</label>
//                                     <input type="text" value={stopEditForm.state}
//                                         onChange={(e) => setStopEditForm(prev => ({ ...prev, state: e.target.value }))}
//                                         placeholder="State" className="form-input" />
//                                 </div>
//                                 <div className="form-group">
//                                     <label>Terminal</label>
//                                     <input type="text" value={stopEditForm.terminal}
//                                         onChange={(e) => setStopEditForm(prev => ({ ...prev, terminal: e.target.value }))}
//                                         placeholder="Terminal name" className="form-input" />
//                                 </div>
//                             </div>






//                             {(editForm.isMultiTrip || editIsMultiTrip || (stopEditForm.timings && stopEditForm.timings.length > 0)) ? (
//                                 <>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label style={{ marginBottom: '12px', display: 'block' }}>
//                                                 Timings for each trip: {stopEditForm.timings?.length || editForm.numberOfTrips || 1} {stopEditForm.timings?.length !== 1 ? 'trips' : 'trip'} per day
//                                             </label>
//                                             <div style={{
//                                                 border: '1px solid #e0e0e0',
//                                                 borderRadius: '8px',
//                                                 overflow: 'hidden',
//                                                 marginTop: '8px'
//                                             }}>
//                                                 <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                                     <thead>
//                                                         <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
//                                                             <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Trip</th>
//                                                             <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Arrival Time</th>
//                                                             <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Departure Time</th>
//                                                         </tr>
//                                                     </thead>
//                                                     <tbody>

//                                                         {stopEditForm.timings && stopEditForm.timings.length > 0 ? (
//                                                             stopEditForm.timings.map((timing, index) => {
//                                                                 const tripNumber = timing.timeSlotSequence || index + 1;
//                                                                 return (
//                                                                     <tr key={tripNumber} style={{
//                                                                         borderBottom: index < stopEditForm.timings.length - 1 ? '1px solid #f0f0f0' : 'none',
//                                                                         backgroundColor: timing.arrivalTime || timing.departureTime ? 'transparent' : '#fafafa'
//                                                                     }}>
//                                                                         <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>
//                                                                             Trip #{tripNumber}
//                                                                         </td>
//                                                                         <td style={{ padding: '10px' }}>
//                                                                             <TimePicker
//                                                                                 value={timing.arrivalTime}
//                                                                                 onChange={(value) => {
//                                                                                     const updatedTimings = [...(stopEditForm.timings || [])];
//                                                                                     updatedTimings[index] = {
//                                                                                         ...updatedTimings[index],
//                                                                                         arrivalTime: value
//                                                                                     };
//                                                                                     setStopEditForm(prev => ({ ...prev, timings: updatedTimings }));
//                                                                                 }}
//                                                                                 placeholder="--:--"
//                                                                             />
//                                                                         </td>
//                                                                         <td style={{ padding: '10px' }}>
//                                                                             <TimePicker
//                                                                                 value={timing.departureTime}
//                                                                                 onChange={(value) => {
//                                                                                     const updatedTimings = [...(stopEditForm.timings || [])];
//                                                                                     updatedTimings[index] = {
//                                                                                         ...updatedTimings[index],
//                                                                                         departureTime: value
//                                                                                     };
//                                                                                     setStopEditForm(prev => ({ ...prev, timings: updatedTimings }));
//                                                                                 }}
//                                                                                 placeholder="--:--"
//                                                                             />
//                                                                         </td>
//                                                                     </tr>
//                                                                 );
//                                                             })
//                                                         ) : (
//                                                             Array.from({ length: editForm.numberOfTrips || editNumberOfTrips || 1 }, (_, i) => {
//                                                                 const tripNumber = i + 1;
//                                                                 return (
//                                                                     <tr key={tripNumber} style={{ borderBottom: i < (editForm.numberOfTrips || 1) - 1 ? '1px solid #f0f0f0' : 'none' }}>
//                                                                         <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>
//                                                                             Trip #{tripNumber}
//                                                                         </td>
//                                                                         <td style={{ padding: '10px' }}>
//                                                                             <TimePicker
//                                                                                 value=""
//                                                                                 onChange={(value) => {
//                                                                                     const updatedTimings = [...(stopEditForm.timings || [])];
//                                                                                     const existingIndex = updatedTimings.findIndex(t => t.timeSlotSequence === tripNumber);
//                                                                                     const timingData = {
//                                                                                         timeSlotSequence: tripNumber,
//                                                                                         arrivalTime: value,
//                                                                                         departureTime: ''
//                                                                                     };
//                                                                                     if (existingIndex >= 0) {
//                                                                                         updatedTimings[existingIndex] = timingData;
//                                                                                     } else {
//                                                                                         updatedTimings.push(timingData);
//                                                                                     }
//                                                                                     setStopEditForm(prev => ({ ...prev, timings: updatedTimings }));
//                                                                                 }}
//                                                                                 placeholder="--:--"
//                                                                             />
//                                                                         </td>
//                                                                         <td style={{ padding: '10px' }}>
//                                                                             <TimePicker
//                                                                                 value=""
//                                                                                 onChange={(value) => {
//                                                                                     const updatedTimings = [...(stopEditForm.timings || [])];
//                                                                                     const existingIndex = updatedTimings.findIndex(t => t.timeSlotSequence === tripNumber);
//                                                                                     const timingData = {
//                                                                                         timeSlotSequence: tripNumber,
//                                                                                         arrivalTime: '',
//                                                                                         departureTime: value
//                                                                                     };
//                                                                                     if (existingIndex >= 0) {
//                                                                                         updatedTimings[existingIndex] = timingData;
//                                                                                     } else {
//                                                                                         updatedTimings.push(timingData);
//                                                                                     }
//                                                                                     setStopEditForm(prev => ({ ...prev, timings: updatedTimings }));
//                                                                                 }}
//                                                                                 placeholder="--:--"
//                                                                             />
//                                                                         </td>
//                                                                     </tr>
//                                                                 );
//                                                             })
//                                                         )}
//                                                     </tbody>
//                                                 </table>
//                                             </div>
//                                             <small className="helper-text" style={{ display: 'block', marginTop: '8px', color: '#666' }}>
//                                                 Tip: Set arrival and departure times for each trip separately
//                                             </small>
//                                         </div>
//                                     </div>
//                                 </>
//                             ) : (
//                                 <div className="form-row">
//                                     <div className="form-group">
//                                         <label>Arrival Time *</label>
//                                         <TimePicker
//                                             value={stopEditForm.arrivalTime}
//                                             onChange={(value) => setStopEditForm(prev => ({ ...prev, arrivalTime: value }))}
//                                             placeholder="Select time"
//                                         />
//                                     </div>
//                                     <div className="form-group">
//                                         <label>Departure Time (Opt)</label>
//                                         <TimePicker
//                                             value={stopEditForm.departureTime}
//                                             onChange={(value) => setStopEditForm(prev => ({ ...prev, departureTime: value }))}
//                                             placeholder="Select time"
//                                         />
//                                     </div>
//                                 </div>
//                             )}

//                             {stopEditForm.isManualStop && (
//                                 <div className="form-row">
//                                     <div className="form-group full-width">
//                                         <label>Distance from Previous Stop (km) *</label>
//                                         <input type="number" value={stopEditForm.manualDistFromPrev}
//                                             onChange={(e) => setStopEditForm(prev => ({ ...prev, manualDistFromPrev: e.target.value }))}
//                                             placeholder="e.g., 50" className="form-input" min="0" step="0.1" />
//                                     </div>
//                                 </div>
//                             )}

//                             {stopEditForm.isManualStop && (() => {
//                                 const stops = stopBeingEdited.type === 'up' ? upStops : downStops;
//                                 const nextStop = stops[stopBeingEdited.index + 1];
//                                 const isNextAuto = nextStop?.coordinates &&
//                                     (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);
//                                 if (isNextAuto) return (
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Distance to Next Stop ({nextStop.city}) (km) *</label>
//                                             <input type="number" value={stopEditForm.manualDistToNext}
//                                                 onChange={(e) => setStopEditForm(prev => ({ ...prev, manualDistToNext: e.target.value }))}
//                                                 placeholder={`Distance to ${nextStop.city}`}
//                                                 className="form-input" min="0" step="0.1" />
//                                             <small style={{ color: '#dc3545' }}>
//                                                 ⚠️ Required because next stop has GPS coordinates
//                                             </small>
//                                         </div>
//                                     </div>
//                                 );
//                                 return null;
//                             })()}

//                             <div className="form-row checkbox-row">
//                                 <Checkbox label="Boarding Point" checked={stopEditForm.isBoarding}
//                                     onChange={() => setStopEditForm(prev => ({ ...prev, isBoarding: !prev.isBoarding }))} />
//                                 <Checkbox label="Dropping Point" checked={stopEditForm.isDropping}
//                                     onChange={() => setStopEditForm(prev => ({ ...prev, isDropping: !prev.isDropping }))} />
//                             </div>
//                         </div>

//                         <div className="modal-footer" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', padding: '16px' }}>
//                             <button className="btn btn-secondary" onClick={() => setShowStopEditModal(false)}>
//                                 Cancel
//                             </button>
//                             <button className="btn btn-primary" onClick={saveEditedStop}>
//                                 Save Changes
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {showStopInsertModal && (
//                 <div className="modal-overlay" onClick={() => setShowStopInsertModal(false)}>
//                     <div className="modal-content edit-stop-modal" onClick={(e) => e.stopPropagation()}
//                         style={{ width: '90%' }}>
//                         <div className="modal-header">
//                             <h3>Insert Stop at Position #{pendingInsertIndex + 1}</h3>
//                             <button className="modal-close-btn" onClick={() => setShowStopInsertModal(false)}>×</button>
//                         </div>

//                         <div className="modal-body">
//                             <div className="form-row" style={{ marginBottom: '12px' }}>
//                                 <Checkbox
//                                     label="Manually Typed Stop (No Map Suggestions)"
//                                     checked={insertStopForm.isManualStop}
//                                     onChange={() => setInsertStopForm(prev => ({
//                                         ...prev,
//                                         isManualStop: !prev.isManualStop,
//                                         city: '', address: '', state: '', terminal: '',
//                                         manualDistFromPrev: ''
//                                     }))}
//                                 />
//                             </div>

//                             {!insertStopForm.isManualStop ? (
//                                 <>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Search Location *</label>
//                                             <LocationInput
//                                                 value={insertStopForm.city}
//                                                 onChange={(value) => setInsertStopForm(prev => ({ ...prev, city: value }))}
//                                                 onLocationSelect={(location) => setInsertStopForm(prev => ({
//                                                     ...prev,
//                                                     city: location.city || location.name || '',
//                                                     state: location.state || prev.state,
//                                                     address: location.address || '',
//                                                 }))}
//                                                 placeholder="Search city or address..."
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Address</label>
//                                             <input type="text" value={insertStopForm.address}
//                                                 onChange={(e) => setInsertStopForm(prev => ({ ...prev, address: e.target.value }))}
//                                                 placeholder="Full address" className="form-input" />
//                                         </div>
//                                     </div>
//                                 </>
//                             ) : (
//                                 <>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Search City *</label>
//                                             <div style={{ position: 'relative' }}>
//                                                 <input
//                                                     type="text"
//                                                     value={insertStopForm.city}
//                                                     onChange={async (e) => {
//                                                         const value = e.target.value;
//                                                         setInsertStopForm(prev => ({ ...prev, city: value, address: '', state: '', terminal: '' }));
//                                                         if (value.length >= 2) {
//                                                             try {
//                                                                 const response = await searchRouteIntermediateStops(token, value);
//                                                                 if (response.success && response.cities?.length > 0) {
//                                                                     normalizeAndDeduplicateSuggestions(response.cities);
//                                                                     setShowInsertCityDropdown(true);
//                                                                 } else {
//                                                                     setInsertCitySuggestions([]);
//                                                                     setShowInsertCityDropdown(false);
//                                                                 }
//                                                             } catch { setInsertCitySuggestions([]); setShowInsertCityDropdown(false); }
//                                                         } else {
//                                                             setInsertCitySuggestions([]);
//                                                             setShowInsertCityDropdown(false);
//                                                         }
//                                                     }}
//                                                     onFocus={() => insertCitySuggestions.length > 0 && setShowInsertCityDropdown(true)}
//                                                     onBlur={() => setTimeout(() => setShowInsertCityDropdown(false), 200)}
//                                                     placeholder="Type city name (min 2 characters)..."
//                                                     className="form-input"
//                                                 />
//                                                 {showInsertCityDropdown && insertCitySuggestions.length > 0 && (
//                                                     <div style={{
//                                                         position: 'absolute', top: '100%', left: 0, right: 0,
//                                                         backgroundColor: 'white', border: '1px solid #ddd',
//                                                         borderRadius: '4px', maxHeight: '200px', overflowY: 'auto',
//                                                         zIndex: 10000, boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
//                                                     }}>
//                                                         {insertCitySuggestions.map((city, idx) => (
//                                                             <div key={city.id || idx}
//                                                                 onMouseDown={() => {
//                                                                     setInsertStopForm(prev => ({
//                                                                         ...prev,
//                                                                         city: city.name,
//                                                                         address: city.address || city.name,
//                                                                         state: city.state || '',
//                                                                         terminal: city.terminal || `${city.name} Bus Stand`,
//                                                                     }));
//                                                                     setShowInsertCityDropdown(false);
//                                                                     setInsertCitySuggestions([]);
//                                                                     toast.success(`Auto-filled details for ${city.name}`);
//                                                                 }}
//                                                                 style={{ padding: '10px 12px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
//                                                                 onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f0f7ff'}
//                                                                 onMouseLeave={e => e.currentTarget.style.backgroundColor = 'white'}
//                                                             >
//                                                                 <div style={{ fontWeight: '500' }}>{city.name}</div>
//                                                                 <div style={{ fontSize: '12px', color: '#6c757d' }}>
//                                                                     {city.state}{city.terminal ? ` • ${city.terminal}` : ''}
//                                                                 </div>
//                                                             </div>
//                                                         ))}
//                                                     </div>
//                                                 )}
//                                             </div>
//                                             <small className="helper-text">Type at least 2 characters to search cities</small>
//                                         </div>
//                                     </div>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Address</label>
//                                             <input type="text" value={insertStopForm.address}
//                                                 onChange={(e) => setInsertStopForm(prev => ({ ...prev, address: e.target.value }))}
//                                                 placeholder="Full address" className="form-input" />
//                                         </div>
//                                     </div>
//                                 </>
//                             )}

//                             <div className="form-row">
//                                 <div className="form-group">
//                                     <label>State</label>
//                                     <input type="text" value={insertStopForm.state}
//                                         onChange={(e) => setInsertStopForm(prev => ({ ...prev, state: e.target.value }))}
//                                         placeholder="State" className="form-input" />
//                                 </div>
//                                 <div className="form-group">
//                                     <label>Terminal</label>
//                                     <input type="text" value={insertStopForm.terminal}
//                                         onChange={(e) => setInsertStopForm(prev => ({ ...prev, terminal: e.target.value }))}
//                                         placeholder="Terminal name" className="form-input" />
//                                 </div>
//                             </div>

//                             <div className="form-row">
//                                 <div className="form-group">
//                                     <label>Arrival Time *</label>
//                                     <TimePicker value={insertStopForm.arrivalTime}
//                                         onChange={(value) => setInsertStopForm(prev => ({ ...prev, arrivalTime: value }))}
//                                         placeholder="Select time" />
//                                 </div>
//                                 <div className="form-group">
//                                     <label>Departure Time (Opt)</label>
//                                     <TimePicker value={insertStopForm.departureTime}
//                                         onChange={(value) => setInsertStopForm(prev => ({ ...prev, departureTime: value }))}
//                                         placeholder="Select time" />
//                                 </div>
//                             </div>

//                             {insertStopForm.isManualStop && (
//                                 <div className="form-row">
//                                     <div className="form-group full-width">
//                                         <label>Distance from Previous Stop (km) *</label>
//                                         <input type="number" value={insertStopForm.manualDistFromPrev}
//                                             onChange={(e) => setInsertStopForm(prev => ({ ...prev, manualDistFromPrev: e.target.value }))}
//                                             placeholder="e.g., 50" className="form-input" min="0" step="0.1" />
//                                         <small className="helper-text">Required for manual stops</small>
//                                     </div>
//                                 </div>
//                             )}

//                             {insertStopForm.isManualStop && (() => {
//                                 const stops = activeRouteTab === 'UP' ? upStops : downStops;
//                                 const nextStop = stops[pendingInsertIndex];
//                                 const isNextAuto = nextStop?.coordinates &&
//                                     (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);
//                                 if (isNextAuto) return (
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Distance to Next Stop ({nextStop.city}) (km)</label>
//                                             <input type="number" value={insertStopForm.manualDistToNext}
//                                                 onChange={(e) => setInsertStopForm(prev => ({ ...prev, manualDistToNext: e.target.value }))}
//                                                 placeholder={`Distance to ${nextStop.city}`}
//                                                 className="form-input" min="0" step="0.1" />
//                                             <small style={{ color: '#dc3545' }}>⚠️ Next stop has GPS coordinates</small>
//                                         </div>
//                                     </div>
//                                 );
//                                 return null;
//                             })()}

//                             <div className="form-row checkbox-row">
//                                 <Checkbox label="Boarding Point" checked={insertStopForm.isBoarding}
//                                     onChange={() => setInsertStopForm(prev => ({ ...prev, isBoarding: !prev.isBoarding }))} />
//                                 <Checkbox label="Dropping Point" checked={insertStopForm.isDropping}
//                                     onChange={() => setInsertStopForm(prev => ({ ...prev, isDropping: !prev.isDropping }))} />
//                             </div>
//                         </div>

//                         <div className="modal-footer" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', padding: '16px' }}>
//                             <button className="btn btn-secondary" onClick={() => setShowStopInsertModal(false)}>Cancel</button>
//                             <button className="btn btn-primary" onClick={saveInsertedStop}
//                                 disabled={!insertStopForm.city || !insertStopForm.arrivalTime || !insertStopForm.state || !insertStopForm.address || !insertStopForm.terminal}>
//                                 Insert Stop
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {showPlatformFeeModal && selectedBusForActivation && (
//                 <PlatformFeeModal
//                     bus={selectedBusForActivation}
//                     onClose={() => {
//                         setShowPlatformFeeModal(false);
//                         setSelectedBusForActivation(null);
//                     }}
//                     onActivated={() => {
//                         fetchRoutes();
//                         toast.success('Bus activated successfully!');
//                     }}
//                 />
//             )}

//             {logModal.show && (
//                 <RouteActivityLogModal
//                     routeId={logModal.routeId}
//                     routeName={logModal.routeName}
//                     onClose={() => setLogModal({ show: false, routeId: null, routeName: '' })}
//                     token={token}
//                 />
//             )}
//         </div>
//     );
// };

// export default RouteManage;

import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import '../../Styles/ManagementPages.css';
import '../../Styles/RouteManage.css';           // keep existing base styles
import '../../Styles/PrimaryRouteManage.css';    // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';       // shared additions (avatar, pagination…)
import '../../Styles/RouteManage2.css';          // route-only additions (load LAST)
import '../../Styles/PrimaryRouteManage.css';   // ← add this if missing
import {
    getAllRoutes,
    getRouteById,
    createRoute,
    updateRoute,
    deleteRoute,
    toggleRouteStatus,
    getAllMasterRoutes,
    getMasterRouteByName,
    searchRouteIntermediateStops,
    getMasterRouteById,
    searchMasterRoutesByCities,
    getBusById,
    activateBusWithPlatformFee,
    getPendingRoutes,
    approvePendingRoute,
    rejectPendingRoute,
    getPendingRouteById,
    updatePendingRoute
} from '../../Services/Operations/ProductAPI';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { getPlacePredictions, getPlaceDetails, getDistanceMatrix } from '../../utilis/mapUtils';
import PlatformFeeModal from './PlatformFeeModal';
import TimeSlotManager from './TimeSlotManager';
import StopTimingManager from './StopTimingManager';
import {
    toTitleCase,
    toTitleCaseLive,
    normalizeAndDeduplicateSuggestions,
} from '../../utilis/normalizeUtils';
import RouteActivityLogModal from './RouteActivityLogModal';
import { Icon, BusSvg, StatCard, Field, Avatar, Pagination } from './PrimaryUI';

const TimeDisplay = ({ time }) => {
    if (!time) return '--:--';
    if (time.includes(':')) {
        const [hours, minutes] = time.split(':');
        const hour = parseInt(hours);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const displayHour = hour % 12 || 12;
        return `${displayHour}:${minutes} ${ampm}`;
    }
    return time;
};

const calculateManualDistFromPrev = (stops, index) => {
    if (!stops || stops.length === 0 || index < 0 || index >= stops.length) return '';
    const stop = stops[index];
    if (!stop) return '';
    if (stop.manualDistFromPrev && parseFloat(stop.manualDistFromPrev) > 0) return String(stop.manualDistFromPrev);
    if (stop.distanceFromOrigin && parseFloat(stop.distanceFromOrigin) > 0) {
        if (index === 0) return String(stop.distanceFromOrigin);
        const prevStop = stops[index - 1];
        if (prevStop && prevStop.distanceFromOrigin !== undefined) {
            const segmentDist = parseFloat((stop.distanceFromOrigin - prevStop.distanceFromOrigin).toFixed(1));
            if (segmentDist > 0) return String(segmentDist);
        }
    }
    return '';
};

// ============================================================
// LOCATION INPUT — unchanged
// ============================================================
const LocationInput = ({ value, onChange, placeholder, onLocationSelect, type = 'origin' }) => {
    const [searchQuery, setSearchQuery] = useState(value || '');
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => { setSearchQuery(value || ''); }, [value]);

    const searchLocations = async (query) => {
        if (!query || query.trim().length < 2) { setSuggestions([]); return; }
        setIsLoading(true);
        try {
            const predictions = await getPlacePredictions(query);
            setSuggestions(predictions);
            setShowSuggestions(predictions.length > 0);
        } catch (error) {
            console.error('Search error:', error);
            setSuggestions([]);
        } finally { setIsLoading(false); }
    };

    const handleSelect = async (prediction) => {
        setIsLoading(true);
        try {
            const placeDetails = await getPlaceDetails(prediction.place_id);
            if (placeDetails) {
                setSearchQuery(placeDetails.name || placeDetails.address);
                setShowSuggestions(false);
                if (onLocationSelect) {
                    onLocationSelect({
                        name: placeDetails.name,
                        address: placeDetails.address,
                        city: placeDetails.city || prediction.structured_formatting?.secondary_text?.split(',')[0] || '',
                        state: placeDetails.state || prediction.structured_formatting?.secondary_text?.split(',')[1]?.trim() || '',
                        coordinates: placeDetails.coordinates || { lat: 0, lng: 0 },
                        placeId: prediction.place_id
                    });
                }
            }
        } catch (error) {
            console.error('Error getting place details:', error);
            toast.error('Failed to get location details');
        } finally { setIsLoading(false); }
    };

    const handleTextChange = (e) => {
        const newValue = e.target.value;
        setSearchQuery(newValue);
        onChange(newValue);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => { searchLocations(newValue); }, 500);
    };

    useEffect(() => { return () => { if (timeoutRef.current) clearTimeout(timeoutRef.current); }; }, []);

    return (
        <div className="location-input-container">
            <div className="location-input-wrapper">
                <input
                    type="text"
                    value={searchQuery}
                    onChange={handleTextChange}
                    onFocus={() => { if (suggestions.length > 0) setShowSuggestions(true); }}
                    onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                    className="edit-input"
                    placeholder={placeholder}
                />
                {isLoading && (<div className="location-loading"><div className="spinner"></div></div>)}
            </div>
            {showSuggestions && suggestions.length > 0 && (
                <div className="location-suggestions">
                    <div className="suggestions-header"><span>Search Results</span></div>
                    {suggestions.map((prediction, index) => (
                        <div key={prediction.place_id || index} className="suggestion-item" onClick={() => handleSelect(prediction)}>
                            <div className="suggestion-main">{prediction.structured_formatting?.main_text || prediction.description}</div>
                            <div className="suggestion-secondary">{prediction.structured_formatting?.secondary_text}</div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

const TimePicker = ({ value, onChange, placeholder }) => (
    <div className="time-picker">
        <input type="time" value={value || ''} onChange={(e) => onChange(e.target.value)} className="edit-input" placeholder={placeholder} />
    </div>
);

const Checkbox = ({ label, checked, onChange }) => (
    <label className="checkbox-container">
        <input type="checkbox" checked={checked} onChange={onChange} className="checkbox-input" />
        <span className="checkbox-label">{label}</span>
    </label>
);

const StopTypeBadge = ({ type }) => {
    const types = {
        boarding: { label: '🟢 Boarding', className: 'boarding' },
        dropping: { label: '🔴 Dropping', className: 'dropping' },
        both: { label: '🟡 Both', className: 'both' },
        none: { label: 'Pass-through', className: 'none' }
    };
    const info = types[type] || types.none;
    return <span className={`stop-type-badge ${info.className}`}>{info.label}</span>;
};

const StatusBadge = ({ isActive }) => (
    <span className={`prm-status ${isActive ? 'active' : 'inactive'}`}>
        {isActive ? 'Active' : 'Inactive'}
    </span>
);


const SkeletonStatsCard = () => (
    <div className="stat-card skeleton">
        <div className="skeleton-title"></div>
        <div className="skeleton-value"></div>
        <div className="skeleton-subtitle"></div>
    </div>
);

const SkeletonTableRow = () => (
    <tr className="skeleton-row">
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-badge"></div></td>
        <td><div className="skeleton-badge"></div></td>
        <td><div className="skeleton-actions"></div></td>
    </tr>
);

const SkeletonTable = () => (
    <div className="table-container skeleton">
        <table className="data-table">
            <thead>
                <tr>
                    <th>No.</th>
                    <th>Route Name</th>
                    <th>Route No.</th>
                    <th>Origin</th>
                    <th>Destination</th>
                    <th>Distance</th>
                    <th>Stops</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
                    <SkeletonTableRow key={i} />
                ))}
            </tbody>
        </table>
    </div>
);

const SkeletonModal = () => (
    <div className="modal-overlay">
        <div className="modal-content add-route-content skeleton">
            <div className="modal-header">
                <div className="skeleton-title"></div>
                <div className="skeleton-close"></div>
            </div>
            <div className="modal-body">
                <div className="skeleton-toggle"></div>
                <div className="skeleton-tabs"></div>
                <div className="form-sections">
                    {[1, 2, 3].map((i) => (
                        <div key={i} className="form-section">
                            <div className="skeleton-section-title"></div>
                            <div className="form-row">
                                <div className="form-group"><div className="skeleton-input"></div></div>
                                <div className="form-group"><div className="skeleton-input"></div></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="modal-footer">
                <div className="skeleton-button"></div>
                <div className="skeleton-button"></div>
            </div>
        </div>
    </div>
);

// ============================================================
// MASTER ROUTE SELECTOR — unchanged (kept identical)
// ============================================================
const MasterRouteSelector = ({ value, onChange, onRouteNameChange, token, disabled }) => {
    const [masterRoutes, setMasterRoutes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [source, setSource] = useState('');
    const [destination, setDestination] = useState('');
    const [isManualEntry, setIsManualEntry] = useState(false);
    const [routeNameValue, setRouteNameValue] = useState('');
    const [selectedRouteValue, setSelectedRouteValue] = useState(null);
    const [selectedRouteDetails, setSelectedRouteDetails] = useState(null);

    const [sourceSuggestions, setSourceSuggestions] = useState([]);
    const [destSuggestions, setDestSuggestions] = useState([]);
    const [showSourceSuggestions, setShowSourceSuggestions] = useState(false);
    const [showDestSuggestions, setShowDestSuggestions] = useState(false);
    const [isLoadingSource, setIsLoadingSource] = useState(false);
    const [isLoadingDest, setIsLoadingDest] = useState(false);

    const sourceTimeoutRef = useRef(null);
    const destTimeoutRef = useRef(null);
    const searchTimeoutRef = useRef(null);

    useEffect(() => {
        if (value && value.masterRouteName) {
            setRouteNameValue(value.masterRouteName);
            setSelectedRouteValue(value);
            if (value.origin?.city) setSource(value.origin.city);
            if (value.destination?.city) setDestination(value.destination.city);
        } else {
            setRouteNameValue('');
            setSelectedRouteValue(null);
            setSource('');
            setDestination('');
            setMasterRoutes([]);
            setShowDropdown(false);
            setIsManualEntry(false);
        }
    }, [value]);

    const toTitleCaseLocal = (str) =>
        str ? str.trim().replace(/\s+/g, ' ').replace(/[^\s-]+/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()) : str;

    const searchCities = async (query, type) => {
        if (!query || query.length < 2) {
            if (type === 'source') { setSourceSuggestions([]); setShowSourceSuggestions(false); }
            else { setDestSuggestions([]); setShowDestSuggestions(false); }
            return;
        }
        try {
            if (type === 'source') setIsLoadingSource(true); else setIsLoadingDest(true);
            const response = await searchRouteIntermediateStops(token, query);
            if (response.success && response.cities) {
                const deduped = normalizeAndDeduplicateSuggestions(response.cities);
                if (type === 'source') { setSourceSuggestions(deduped); setShowSourceSuggestions(deduped.length > 0); }
                else { setDestSuggestions(deduped); setShowDestSuggestions(deduped.length > 0); }
            }
        } catch (error) { console.error('Error fetching city suggestions:', error); }
        finally { if (type === 'source') setIsLoadingSource(false); else setIsLoadingDest(false); }
    };

    const searchMasterRoutes = async (sourceCity, destCity) => {
        if (!sourceCity && !destCity) { setMasterRoutes([]); setShowDropdown(false); return; }
        setIsLoading(true);
        try {
            const response = await searchMasterRoutesByCities(token, sourceCity, destCity);
            if (response.success && response.data) {
                const routesData = response.data.routes || (Array.isArray(response.data) ? response.data : []);
                const mappedRoutes = routesData.map(route => ({
                    _id: route._id,
                    originCity: toTitleCaseLocal(route.origin?.city || ''),
                    destinationCity: toTitleCaseLocal(route.destination?.city || ''),
                    masterRouteName: toTitleCaseLocal(route.masterRouteName || ''),
                    description: route.description || '',
                    originState: route.origin?.state || '',
                    originAddress: route.origin?.address || '',
                    originTerminal: route.origin?.terminal || '',
                    originCoords: route.origin?.coordinates || null,
                    destinationState: route.destination?.state || '',
                    destinationAddress: route.destination?.address || '',
                    destinationTerminal: route.destination?.terminal || '',
                    destinationCoords: route.destination?.coordinates || null,
                    totalDistance: route.routeDetails?.totalDistance || 0,
                    durationHours: route.routeDetails?.estimatedDuration?.hours || 0,
                    durationMinutes: route.routeDetails?.estimatedDuration?.minutes || 0,
                    intermediateStops: route.intermediateStops || [],
                    isRoundTrip: route.isRoundTrip || false,
                    returnJourney: route.returnJourney || null
                }));
                setMasterRoutes(mappedRoutes);
                setShowDropdown(mappedRoutes.length > 0);
                if (response.data.sourceSuggestions) setSourceSuggestions(normalizeAndDeduplicateSuggestions(response.data.sourceSuggestions));
                if (response.data.destinationSuggestions) setDestSuggestions(normalizeAndDeduplicateSuggestions(response.data.destinationSuggestions));
            } else { setMasterRoutes([]); setShowDropdown(true); }
        } catch (error) { console.error('Error fetching routes:', error); setMasterRoutes([]); setShowDropdown(true); }
        finally { setIsLoading(false); }
    };

    const handleSourceInputChange = (e) => {
        const value = toTitleCaseLive(e.target.value);
        setSource(value);
        setShowDropdown(false);
        setShowSourceSuggestions(false);
        if (selectedRouteValue) { setSelectedRouteValue(null); onChange(null); }
        if (sourceTimeoutRef.current) clearTimeout(sourceTimeoutRef.current);
        sourceTimeoutRef.current = setTimeout(() => { searchCities(value, 'source'); }, 300);
        if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        searchTimeoutRef.current = setTimeout(() => {
            if (value.length >= 2 || destination.length >= 2) searchMasterRoutes(value, destination);
            else setMasterRoutes([]);
        }, 500);
    };

    const handleDestinationInputChange = (e) => {
        const value = toTitleCaseLive(e.target.value);
        setDestination(value);
        setShowDropdown(false);
        setShowDestSuggestions(false);
        if (selectedRouteValue) { setSelectedRouteValue(null); onChange(null); }
        if (destTimeoutRef.current) clearTimeout(destTimeoutRef.current);
        destTimeoutRef.current = setTimeout(() => { searchCities(value, 'destination'); }, 300);
        if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        searchTimeoutRef.current = setTimeout(() => {
            if (source.length >= 2 || value.length >= 2) searchMasterRoutes(source, value);
            else setMasterRoutes([]);
        }, 500);
    };

    const handleSourceSelect = (selectedCity) => {
        if (!selectedCity) return;
        const cityName = toTitleCaseLocal(typeof selectedCity === 'object' ? (selectedCity.city || selectedCity.name || '') : selectedCity);
        setSource(cityName);
        setShowSourceSuggestions(false);
        setSourceSuggestions([]);
        if (selectedRouteValue) { setSelectedRouteValue(null); onChange(null); }
        if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        searchTimeoutRef.current = setTimeout(() => { searchMasterRoutes(cityName, destination); }, 100);
    };

    const handleDestinationSelect = (selectedCity) => {
        if (!selectedCity) return;
        const cityName = toTitleCaseLocal(typeof selectedCity === 'object' ? (selectedCity.city || selectedCity.name || '') : selectedCity);
        setDestination(cityName);
        setShowDestSuggestions(false);
        setDestSuggestions([]);
        if (selectedRouteValue) { setSelectedRouteValue(null); onChange(null); }
        if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        searchTimeoutRef.current = setTimeout(() => { searchMasterRoutes(source, cityName); }, 100);
    };

    const handleRouteSelect = async (route) => {
        setSelectedRouteDetails(route);
        setShowDropdown(false);
        try {
            setIsLoading(true);
            const response = await getMasterRouteById(route._id, token);
            if (response.success && response.data) {
                const fullRoute = response.data;
                setSource(fullRoute.origin?.city || '');
                setDestination(fullRoute.destination?.city || '');
                setRouteNameValue(fullRoute.masterRouteName);
                const selectedRouteObj = {
                    _id: fullRoute._id,
                    masterRouteName: fullRoute.masterRouteName,
                    description: fullRoute.description || '',
                    isManual: false,
                    via: fullRoute.via || [],
                    origin: {
                        city: fullRoute.origin?.city || '',
                        state: fullRoute.origin?.state || '',
                        address: fullRoute.origin?.address || '',
                        terminal: fullRoute.origin?.terminal || '',
                        coordinates: fullRoute.origin?.coordinates || null
                    },
                    destination: {
                        city: fullRoute.destination?.city || '',
                        state: fullRoute.destination?.state || '',
                        address: fullRoute.destination?.address || '',
                        terminal: fullRoute.destination?.terminal || '',
                        coordinates: fullRoute.destination?.coordinates || null
                    },
                    intermediateStops: fullRoute.intermediateStops || [],
                    routeDetails: {
                        totalDistance: fullRoute.routeDetails?.totalDistance || 0,
                        estimatedDuration: {
                            hours: fullRoute.routeDetails?.estimatedDuration?.hours || 0,
                            minutes: fullRoute.routeDetails?.estimatedDuration?.minutes || 0
                        }
                    },
                    isRoundTrip: fullRoute.isRoundTrip || false,
                    returnJourney: fullRoute.returnJourney || null
                };
                onChange(selectedRouteObj);
                if (onRouteNameChange) onRouteNameChange(fullRoute.masterRouteName);
            } else toast.error('Failed to load complete route details');
        } catch (error) {
            console.error('Error fetching full route details:', error);
            toast.error('Failed to load route details. Please try again.');
        } finally { setIsLoading(false); }
    };

    const handleRouteNameChange = (e) => {
        const newName = e.target.value;
        setRouteNameValue(newName);
        if (onRouteNameChange) onRouteNameChange(newName);
        if (selectedRouteValue) onChange({ ...selectedRouteValue, masterRouteName: newName });
    };

    const handleClearSelection = () => {
        setSelectedRouteValue(null);
        setSelectedRouteDetails(null);
        setRouteNameValue('');
        setSource('');
        setDestination('');
        setMasterRoutes([]);
        setShowDropdown(false);
        setIsManualEntry(false);
        onChange(null);
        if (onRouteNameChange) onRouteNameChange('');
    };

    const handleOpenManualEntry = () => { setIsManualEntry(true); setShowDropdown(false); };

    const handleManualEntrySubmit = () => {
        if (!routeNameValue.trim()) { toast.error('Please enter a route name'); return; }
        const emptyRoute = {
            _id: null,
            masterRouteName: routeNameValue.trim(),
            isManual: true,
            origin: { city: source || '', state: '' },
            destination: { city: destination || '', state: '' },
            routeDetails: { totalDistance: 0 },
            isRoundTrip: false
        };
        setIsManualEntry(false);
        setSelectedRouteValue(emptyRoute);
        onChange(emptyRoute);
    };

    const handleCancelManualEntry = () => { setIsManualEntry(false); setRouteNameValue(''); };

    const showSearchFields = !selectedRouteValue && !isManualEntry;

    useEffect(() => {
        return () => {
            if (sourceTimeoutRef.current) clearTimeout(sourceTimeoutRef.current);
            if (destTimeoutRef.current) clearTimeout(destTimeoutRef.current);
            if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        };
    }, []);

    const suggestionsDropdownStyle = {
        position: 'absolute', top: '100%', left: 0, right: 0,
        backgroundColor: 'white', border: '1px solid #ddd', borderRadius: '4px',
        maxHeight: '200px', overflowY: 'auto', zIndex: 10000,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)', marginTop: '2px'
    };

    const suggestionItemStyle = {
        padding: '10px 12px', cursor: 'pointer',
        borderBottom: '1px solid #f0f0f0', transition: 'background-color 0.2s'
    };

    return (
        <div className="master-route-selector" style={{ position: 'relative', width: '100%' }}>
            {showSearchFields && (
                <>
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                        <div className="form-group" style={{ flex: 1, position: 'relative' }}>
                            <label>Source City</label>
                            <div style={{ position: 'relative' }}>
                                <input type="text" value={source} onChange={handleSourceInputChange}
                                    onFocus={() => { if (sourceSuggestions.length > 0) setShowSourceSuggestions(true); }}
                                    onBlur={() => setTimeout(() => setShowSourceSuggestions(false), 200)}
                                    placeholder="Enter source city (min 2 chars)..." className="form-input" disabled={disabled} />
                                {isLoadingSource && (<div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}><div className="spinner-small"></div></div>)}
                            </div>
                            {showSourceSuggestions && sourceSuggestions.length > 0 && (
                                <div style={suggestionsDropdownStyle}>
                                    {sourceSuggestions.map((city, idx) => (
                                        <div key={city.id || idx} style={suggestionItemStyle} onMouseDown={() => handleSourceSelect(city)}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}>
                                            <div style={{ fontWeight: '500' }}>{city.city || city.name || city}</div>
                                            <div style={{ fontSize: '12px', color: '#6c757d' }}>{city.state}{city.terminal && ` • ${city.terminal}`}</div>
                                            {city.address && city.address !== (city.city || city.name) && (<div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>{city.address}</div>)}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className="form-group" style={{ flex: 1, position: 'relative' }}>
                            <label>Destination City</label>
                            <div style={{ position: 'relative' }}>
                                <input type="text" value={destination} onChange={handleDestinationInputChange}
                                    onFocus={() => { if (destSuggestions.length > 0) setShowDestSuggestions(true); }}
                                    onBlur={() => setTimeout(() => setShowDestSuggestions(false), 200)}
                                    placeholder="Enter destination city (min 2 chars)..." className="form-input" disabled={disabled} />
                                {isLoadingDest && (<div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}><div className="spinner-small"></div></div>)}
                            </div>
                            {showDestSuggestions && destSuggestions.length > 0 && (
                                <div style={suggestionsDropdownStyle}>
                                    {destSuggestions.map((city, idx) => (
                                        <div key={city.id || idx} style={suggestionItemStyle} onMouseDown={() => handleDestinationSelect(city)}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}>
                                            <div style={{ fontWeight: '500' }}>{city.city || city.name || city}</div>
                                            <div style={{ fontSize: '12px', color: '#6c757d' }}>{city.state}{city.terminal && ` • ${city.terminal}`}</div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                    {(showDropdown || isLoading) && (source || destination) && (
                        <div style={{ border: '1px solid #ddd', borderRadius: '4px', boxShadow: '0 2px 8px rgba(0,0,0,0.15)', backgroundColor: 'white', maxHeight: '300px', overflowY: 'auto', marginBottom: '10px', zIndex: 1000, position: 'relative' }}>
                            {isLoading ? (
                                <div style={{ padding: '12px', textAlign: 'center', color: '#666' }}><div className="spinner-small"></div> Searching routes...</div>
                            ) : masterRoutes.length > 0 ? (
                                <>
                                    <div style={{ padding: '8px 12px', backgroundColor: '#f8f9fa', borderBottom: '1px solid #eee', fontSize: '12px', color: '#666' }}>
                                        Found {masterRoutes.length} matching route(s)
                                    </div>
                                    {masterRoutes.map((route) => (
                                        <div key={route._id} onClick={() => handleRouteSelect(route)}
                                            style={{ padding: '10px 12px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0', transition: 'background-color 0.2s' }}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}>
                                            <div style={{ fontWeight: '500', marginBottom: '3px' }}>{route.masterRouteName}</div>
                                            <div style={{ fontSize: '12px', color: '#6c757d' }}>
                                                {route.originCity || route.origin?.city || 'N/A'} → {route.destinationCity || route.destination?.city || 'N/A'} &nbsp;•&nbsp;
                                                {route.isRoundTrip ? 'Round Trip' : 'One Way'} &nbsp;•&nbsp;
                                                {route.totalDistance || route.routeDetails?.totalDistance || 0} km
                                            </div>
                                        </div>
                                    ))}
                                </>
                            ) : (
                                <div style={{ padding: '12px', textAlign: 'center', color: '#666' }}>
                                    No routes found for this route.
                                    <button type="button" onClick={handleOpenManualEntry} style={{ color: '#007bff', background: 'none', border: 'none', cursor: 'pointer', padding: '0 0 0 5px' }}>Create new route instead</button>
                                </div>
                            )}
                        </div>
                    )}
                    <div style={{ textAlign: 'right' }}>
                        <button type="button" className="btn btn-secondary btn-sm" onClick={handleOpenManualEntry} style={{ padding: '5px 12px', fontSize: '12px' }}>
                            + Create New Route (skip search)
                        </button>
                    </div>
                </>
            )}

            {isManualEntry && (
                <div className="selector-input-group" style={{ display: 'flex', gap: '10px', alignItems: 'center', flexDirection: 'column' }}>
                    <div style={{ width: '100%' }}>
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                            <input type="text" value={routeNameValue} onChange={handleRouteNameChange}
                                placeholder="Enter new master route name..." className="form-input" style={{ flex: 1 }} disabled={disabled} />
                            <button type="button" className="btn btn-primary" onClick={handleManualEntrySubmit} style={{ padding: '8px 16px', whiteSpace: 'nowrap' }}>Save Manual</button>
                            <button type="button" className="btn btn-secondary" onClick={handleCancelManualEntry} style={{ padding: '8px 16px' }}>Cancel</button>
                        </div>
                    </div>
                    <small className="helper-text" style={{ color: '#666' }}>You're creating a new master route. Fill in the details below.</small>
                </div>
            )}

            {selectedRouteValue && selectedRouteValue.masterRouteName && !isManualEntry && (
                <div style={{ marginBottom: '5px' }}>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <input type="text" value={routeNameValue} onChange={handleRouteNameChange}
                            placeholder="Enter master route name..." className="form-input" style={{ flex: 1 }} disabled={disabled} />
                        <button type="button" className="btn btn-secondary btn-sm" onClick={handleClearSelection} style={{ padding: '8px 14px', whiteSpace: 'nowrap' }} title="Clear and search again">✕ Change</button>
                    </div>
                    <small style={{ color: selectedRouteValue.isManual ? '#007bff' : '#28a745', display: 'block', marginTop: '4px' }}>
                        {selectedRouteValue.isManual
                            ? 'ℹ️ New route — fill in details below'
                            : `✓ Auto-filled from "${selectedRouteValue.masterRouteName}" — edit name above if needed`}
                    </small>
                </div>
            )}
        </div>
    );
};

const RouteManage = () => {

     const { token } = useSelector(state => state.user);
        const [viewMode, setViewMode] = useState('regular');
        const [pendingRoutes, setPendingRoutes] = useState([]);
        const [loadingPending, setLoadingPending] = useState(false);
        const [error, setError] = useState(null);
        const [logModal, setLogModal] = useState({ show: false, routeId: null, routeName: '' });
        const [routes, setRoutes] = useState([]);
        const [loading, setLoading] = useState(true);
        const [searchTerm, setSearchTerm] = useState('');
        const [editingRoute, setEditingRoute] = useState(null);
        const [editForm, setEditForm] = useState({});
        const [viewingRoute, setViewingRoute] = useState(null);
        const [showAddModal, setShowAddModal] = useState(false);
        const [isRoundTrip, setIsRoundTrip] = useState(false);
        const [activeRouteTab, setActiveRouteTab] = useState('UP');
        const [showEditModal, setShowEditModal] = useState(false);
        const [isUpdatingRoute, setIsUpdatingRoute] = useState(false);
        const [editUpIndex, setEditUpIndex] = useState(null);
        const [editDownIndex, setEditDownIndex] = useState(null);
        const [isManualStop, setIsManualStop] = useState(true);
        const [isManualDistance, setIsManualDistance] = useState(false);
        const [isOriginManual, setIsOriginManual] = useState(false);
        const [isDestinationManual, setIsDestinationManual] = useState(false);
    
        const [destinationTimeSlots, setDestinationTimeSlots] = useState([]);
        const [destinationNumberOfTrips, setDestinationNumberOfTrips] = useState(1);
    
        const [returnOriginTimeSlots, setReturnOriginTimeSlots] = useState([]);
        const [returnDestTimeSlots, setReturnDestTimeSlots] = useState([]);
    
        const [masterRouteSuggestions, setMasterRouteSuggestions] = useState([]);
        const [showMasterRouteSuggestions, setShowMasterRouteSuggestions] = useState(false);
        const [isLoadingMasterRoutes, setIsLoadingMasterRoutes] = useState(false);
        const [masterRouteSearchTimeout, setMasterRouteSearchTimeout] = useState(null);
        const [selectedMasterRoute, setSelectedMasterRoute] = useState(null);
    
        const [filterOrigin, setFilterOrigin] = useState('');
        const [filterDestination, setFilterDestination] = useState('');
        const [originSuggestions, setOriginSuggestions] = useState([]);
        const [destSuggestions, setDestSuggestions] = useState([]);
        const [showOriginSuggestions, setShowOriginSuggestions] = useState(false);
        const [showDestSuggestions, setShowDestSuggestions] = useState(false);
    
        const [citySuggestions, setCitySuggestions] = useState([]);
        const [showCityDropdown, setShowCityDropdown] = useState(false);
        const [editCitySuggestions, setEditCitySuggestions] = useState([]);
        const [showEditCityDropdown, setShowEditCityDropdown] = useState(false);
    
        const [showStopInsertModal, setShowStopInsertModal] = useState(false);
        const [insertStopForm, setInsertStopForm] = useState({
            city: '', state: '', address: '', terminal: '',
            arrivalTime: '', departureTime: '',
            isBoarding: false, isDropping: false,
            manualDistFromPrev: '', manualDistToNext: '',
            isManualStop: true
        });
        const [insertCitySuggestions, setInsertCitySuggestions] = useState([]);
        const [showInsertCityDropdown, setShowInsertCityDropdown] = useState(false);
        const [pendingInsertIndex, setPendingInsertIndex] = useState(null);
    
        const [timeSlots, setTimeSlots] = useState([]);
        const [numberOfTrips, setNumberOfTrips] = useState(1);
        const [isMultiTrip, setIsMultiTrip] = useState(false);
    
        const [newRoute, setNewRoute] = useState({
            routeName: '',
            localRouteName: '',
            upOriginCity: '', upOriginState: '', upOriginAddress: '', upOriginTerminal: '',
            upOriginCoords: null, upOriginDepTime: '',
            upDestCity: '', upDestState: '', upDestAddress: '', upDestTerminal: '',
            upDestCoords: null, upDestArrTime: '',
            upTotalDistance: '', upDurationHours: '', upDurationMinutes: '',
            downOriginDepTime: '',
            downDestArrTime: '',
            downTotalDistance: '', downDurationHours: '', downDurationMinutes: '',
            upManualFinalLeg: '',
            downManualFinalLeg: '',
            stopCity: '', stopState: '', stopAddress: '', stopTerminal: '',
            stopCoords: null, stopArrivalTime: '', stopDepartureTime: '',
            stopDistFromPrev: '', stopDistToNext: '',
            isBoarding: false, isDropping: false
        });
    
        const [upStops, setUpStops] = useState([]);
        const [downStops, setDownStops] = useState([]);
        const [editingStopIndex, setEditingStopIndex] = useState(null);
        const [insertIndex, setInsertIndex] = useState(null);
        const [isCreatingRoute, setIsCreatingRoute] = useState(false);
        const [isCalculatingDistances, setIsCalculatingDistances] = useState(false);
        const [isDistanceCalculated, setIsDistanceCalculated] = useState({ up: false, down: false });
        const [activeTab, setActiveTab] = useState('basic');
    
        const [currentPage, setCurrentPage] = useState(1);
        const [totalPages, setTotalPages] = useState(1);
        const [totalRoutes, setTotalRoutes] = useState(0);
        const [pageSize] = useState(10);
    
        const [showStopEditModal, setShowStopEditModal] = useState(false);
        const [stopBeingEdited, setStopBeingEdited] = useState(null);
    
        const [editTimeSlots, setEditTimeSlots] = useState([]);
        const [editDestinationTimeSlots, setEditDestinationTimeSlots] = useState([]);
        const [editNumberOfTrips, setEditNumberOfTrips] = useState(1);
        const [editIsMultiTrip, setEditIsMultiTrip] = useState(false);
    
        const [isEditingPending, setIsEditingPending] = useState(false);
        const [editingPendingId, setEditingPendingId] = useState(null);
    
        const [stopEditForm, setStopEditForm] = useState({
            city: '', state: '', address: '', terminal: '',
            arrivalTime: '', departureTime: '',
            isBoarding: false, isDropping: false,
            isManualStop: false,
            manualDistFromPrev: '', manualDistToNext: '',
            timings: [], coordinates: null,
            isMultiTrip: false, tripCount: 1
        });
    
        const [inlineInsertIndex, setInlineInsertIndex] = useState(null);
        const [inlineInsertForm, setInlineInsertForm] = useState({
            city: '', state: '', address: '', terminal: '',
            arrivalTime: '', departureTime: '',
            isBoarding: false, isDropping: false,
            manualDistFromPrev: '', manualDistToNext: '',
            isManual: true
        });
        const [inlineInsertCitySuggestions, setInlineInsertCitySuggestions] = useState([]);
        const [showInlineInsertDropdown, setShowInlineInsertDropdown] = useState(false);
    
        const navigate = useNavigate();
        const [selectedMasterRouteFromDropdown, setSelectedMasterRouteFromDropdown] = useState(null);
        const [showPlatformFeeModal, setShowPlatformFeeModal] = useState(false);
        const [selectedBusForActivation, setSelectedBusForActivation] = useState(null);
    
        const sortTimings = (timings) => {
            if (!timings || !Array.isArray(timings)) return [];
            return [...timings].sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
        };
    
        // ---------- fetch pending routes ----------
        const fetchPendingRoutes = async () => {
            try {
                setLoadingPending(true);
                setError(null);
                const response = await getPendingRoutes(token);
                if (response && response.success) {
                    const transformedRoutes = response.data.map((route, index) => {
                        const getDepartureTime = (origin) => {
                            if (origin?.departureTime) return origin.departureTime;
                            if (origin?.timings && origin.timings.length > 0) {
                                const firstTiming = origin.timings[0];
                                if (firstTiming?.departureTime) return firstTiming.departureTime;
                            }
                            return 'N/A';
                        };
                        const getArrivalTime = (destination) => {
                            if (destination?.arrivalTime) return destination.arrivalTime;
                            if (destination?.timings && destination.timings.length > 0) {
                                const firstTiming = destination.timings[0];
                                if (firstTiming?.arrivalTime) return firstTiming.arrivalTime;
                            }
                            return 'N/A';
                        };
                        let departureTime = getDepartureTime(route.origin);
                        let arrivalTime = getArrivalTime(route.destination);
                        if (route.routeNumber?.includes('REV') && route.returnJourney) {
                            departureTime = getDepartureTime(route.returnJourney.origin);
                            arrivalTime = getArrivalTime(route.returnJourney.destination);
                        }
                        const formatDisplayTime = (timeStr) => {
                            if (!timeStr || timeStr === 'N/A') return 'N/A';
                            if (timeStr.includes(':')) {
                                const [hours, minutes] = timeStr.split(':');
                                const hour = parseInt(hours);
                                const ampm = hour >= 12 ? 'PM' : 'AM';
                                const displayHour = hour % 12 || 12;
                                return `${displayHour}:${minutes} ${ampm}`;
                            }
                            return timeStr;
                        };
                        return {
                            id: route._id,
                            pendingId: route._id,
                            serialNo: index + 1,
                            routeNumber: route.routeNumber || 'N/A',
                            routeName: route.routeName || 'N/A',
                            localRouteName: route.localRouteName || null,
                            originCity: route.origin?.city || 'N/A',
                            destinationCity: route.destination?.city || 'N/A',
                            distance: route.routeDetails?.totalDistance || 0,
                            duration: formatDuration(route.routeDetails?.estimatedDuration?.hours, route.routeDetails?.estimatedDuration?.minutes),
                            stops: route.intermediateStops?.length || 0,
                            status: 'Pending',
                            departureTime: formatDisplayTime(departureTime),
                            arrivalTime: formatDisplayTime(arrivalTime),
                            isActive: false,
                            isPending: true,
                            source: 'pending',
                            submittedBy: route.submittedBy,
                            submittedByName: route.submittedByName,
                            submittedByEmail: route.submittedByEmail,
                            operationType: route.operationType,
                            approvalStatus: route.approvalStatus,
                            originalData: route.originalData,
                            isRoundTrip: route.isRoundTrip || false,
                            fullData: route
                        };
                    });
                    setPendingRoutes(transformedRoutes);
                    setTotalRoutes(transformedRoutes.length);
                    setTotalPages(1);
                } else {
                    setPendingRoutes([]);
                    setTotalRoutes(0);
                    setTotalPages(1);
                }
            } catch (err) {
                console.error('Error fetching pending routes:', err);
                setError('Failed to fetch pending routes. Please try again.');
                setPendingRoutes([]);
            } finally { setLoadingPending(false); }
        };
    
        const handleApprovePendingRoute = async (pendingId) => {
            try {
                setError(null);
                const response = await approvePendingRoute(pendingId, token);
                if (response.success) {
                    toast.success('Pending route approved successfully!');
                    setPendingRoutes(prev => prev.filter(route => route.id !== pendingId));
                    setTotalRoutes(prev => prev - 1);
                    await fetchRoutes();
                } else throw new Error(response.message || 'Failed to approve pending route');
            } catch (err) {
                console.error('Error approving pending route:', err);
                setError('Failed to approve pending route. Please try again.');
                toast.error('Failed to approve pending route. Please try again.');
            }
        };
    
        const handleRejectPendingRoute = async (pendingId) => {
            if (!window.confirm('Are you sure you want to reject this pending route?')) return;
            try {
                setError(null);
                const response = await rejectPendingRoute(pendingId, token);
                if (response.success) {
                    toast.success('Pending route rejected successfully!');
                    setPendingRoutes(prev => prev.filter(route => route.id !== pendingId));
                    setTotalRoutes(prev => prev - 1);
                } else throw new Error(response.message || 'Failed to reject pending route');
            } catch (err) {
                console.error('Error rejecting pending route:', err);
                setError('Failed to reject pending route. Please try again.');
                toast.error('Failed to reject pending route. Please try again.');
            }
        };
    
        const refreshPendingRoutes = async () => { await fetchPendingRoutes(); };
    
        const getCurrentRoutes = () => viewMode === 'regular' ? routes : pendingRoutes;
        const getCurrentLoading = () => viewMode === 'regular' ? loading : loadingPending;
    
        const currentRoutes = getCurrentRoutes();
        const isLoading = getCurrentLoading();

        // ============================================================
// MODERN UI PRIMITIVES — required by redesigned JSX
// ============================================================

/* ---------- Icon + Bus SVG ---------- */
const ICON_PATHS = {
    route: 'M5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M19 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M7 17h7a3 3 0 0 0 0-6h-4a3 3 0 0 1 0-6h7',
    check: 'M22 11.1V12a10 10 0 1 1-5.9-9.1 M22 4 12 14l-3-3',
    moon: 'M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z',
    calendar: 'M8 2v4 M16 2v4 M3 10h18 M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
    pin: 'M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0z M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    clock: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 6v6l4 2',
    stop: 'M12 3v18 M5 6h11l3 3-3 3H5z',
    search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M21 21l-4.3-4.3',
    eye: 'M2 12s4-8 10-8 10 8 10 8-4 8-10 8S2 12 2 12z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    trash: 'M3 6h18 M8 6V4h8v2 M6 6l1 14h10l1-14 M10 11v6 M14 11v6',
    grid: 'M3 3h7v7H3z M14 3h7v7h-7z M14 14h7v7h-7z M3 14h7v7H3z',
    list: 'M8 6h13 M8 12h13 M8 18h13 M3 6h.01 M3 12h.01 M3 18h.01',
    tag: 'M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z M7.5 7.5h.01',
    plus: 'M12 5v14 M5 12h14',
    map: 'M1 6l7-3 8 3 7-3v15l-7 3-8-3-7 3z M8 3v15 M16 6v15',
    clipboard: 'M9 4h6v3H9z M7 5H5a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2 M9 13h6 M9 17h4',
    bus: 'M5 3h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z M3 11h18 M7 21v-3 M17 21v-3 M7 15h.01 M17 15h.01',
    edit: 'M12 20h9 M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z',
    calc: 'M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z M8 7h8 M8 12h.01 M12 12h.01 M16 12h.01 M8 16h.01 M12 16h.01 M16 16h.01',
    info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 16v-4 M12 8h.01',
    refresh: 'M23 4v6h-6 M1 20v-6h6 M3.5 9a9 9 0 0 1 14.9-3.4L23 10 M1 14l4.6 4.4A9 9 0 0 0 20.5 15',
    x: 'M18 6 6 18 M6 6l12 12'
};

const Icon = ({ name, size = 18 }) => (
    <svg className="prm-ico" viewBox="0 0 24 24" width={size} height={size} fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d={ICON_PATHS[name]} />
    </svg>
);

const BusSvg = ({ size = 34 }) => (
    <svg viewBox="0 0 64 34" width={size} height={(size * 34) / 64} aria-hidden="true">
        <rect x="2" y="3" width="58" height="23" rx="7" fill="#f59e0b" />
        <rect x="2" y="19" width="58" height="4" fill="#d97706" />
        <rect x="8" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <rect x="19" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <rect x="30" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <path d="M43 8h10a4 4 0 0 1 4 4v4H43z" fill="#0b1f44" />
        <rect x="57" y="20" width="4" height="3" rx="1" fill="#fff7d6" />
        <circle cx="17" cy="27" r="5.5" fill="#0b1f44" /><circle cx="17" cy="27" r="2.2" fill="#cbd5e1" />
        <circle cx="46" cy="27" r="5.5" fill="#0b1f44" /><circle cx="46" cy="27" r="2.2" fill="#cbd5e1" />
    </svg>
);

/* ---------- Animated counter + StatCard ---------- */
const useCountUp = (target, duration = 900) => {
    const [value, setValue] = useState(0);
    useEffect(() => {
        let raf, start;
        const step = (t) => {
            if (!start) start = t;
            const p = Math.min((t - start) / duration, 1);
            setValue(Math.round(target * (1 - Math.pow(1 - p, 3))));
            if (p < 1) raf = requestAnimationFrame(step);
        };
        raf = requestAnimationFrame(step);
        return () => cancelAnimationFrame(raf);
    }, [target, duration]);
    return value;
};

const StatCard = ({ icon, label, value, hint, tone, delay = 0 }) => {
    const shown = useCountUp(value);
    return (
        <div className={`prm-stat tone-${tone}`} style={{ animationDelay: `${delay}ms` }}>
            <div className="prm-stat-icon"><Icon name={icon} size={24} /></div>
            <div className="prm-stat-body">
                <div className="prm-stat-label">{label}</div>
                <div className="prm-stat-value">{shown}</div>
                <div className="prm-stat-hint">{hint}</div>
            </div>
        </div>
    );
};

/* ---------- Switch ---------- */
const Switch = ({ checked, onChange, title }) => (
    <label className="prm-switch" title={title}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span />
    </label>
);

/* ---------- FormSection ---------- */
const FormSection = ({ n, title, hint, children, delay = 0 }) => (
    <section className="prm-fsec" style={{ animationDelay: `${delay}ms` }}>
        <header className="prm-fsec-head">
            <span className="prm-fsec-num">{n}</span>
            <div>
                <h4>{title}</h4>
                {hint && <p>{hint}</p>}
            </div>
        </header>
        <div className="prm-fsec-body">{children}</div>
    </section>
);

/* ---------- Field ---------- */
const Field = ({ label, required, children, full, note }) => (
    <div className={`prm-field ${full ? 'full' : ''}`}>
        {label && <label className="prm-label">{label}{required && <em>*</em>}</label>}
        {children}
        {note && <small className="prm-note">{note}</small>}
    </div>
);

/* ---------- PrmCheckbox ---------- */
const PrmCheckbox = ({ label, checked, onChange }) => (
    <label className={`prm-check ${checked ? 'on' : ''}`}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span className="box"><Icon name="check" size={12} /></span>
        <span className="txt">{label}</span>
    </label>
);
    
      
        const addEditReturnOriginTrip = () => {
            const currentTimings = editForm.returnOriginTimings || [];
            const newSequence = currentTimings.length + 1;
            const newTiming = { timeSlotSequence: newSequence, departureTime: '', arrivalTime: '' };
            setEditForm(prev => ({ ...prev, returnOriginTimings: [...currentTimings, newTiming] }));
            setEditNumberOfTrips(newSequence);
            const updatedStops = downStops.map(stop => {
                const existingTimings = stop.timings || [];
                if (existingTimings.find(t => t.timeSlotSequence === newSequence)) return stop;
                const newTimings = [...existingTimings, { timeSlotSequence: newSequence, arrivalTime: '', departureTime: '' }];
                newTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
                return { ...stop, timings: newTimings };
            });
            setDownStops(updatedStops);
            toast.info(`Added Return Trip #${newSequence}. Please set timings for this trip in each return stop.`);
        };
    
        const addEditReturnDestinationTrip = () => {
            const currentTimings = editForm.returnDestTimings || [];
            const newSequence = currentTimings.length + 1;
            setEditForm(prev => ({ ...prev, returnDestTimings: [...currentTimings, { timeSlotSequence: newSequence, arrivalTime: '', departureTime: '' }] }));
            setEditNumberOfTrips(newSequence);
        };
    
        const removeEditReturnOriginTrip = (index) => {
            const currentTimings = editForm.returnOriginTimings || [];
            if (currentTimings.length <= 1) { toast.warning('At least one trip is required'); return; }
            const updatedTimings = currentTimings.filter((_, i) => i !== index);
            updatedTimings.forEach((t, i) => t.timeSlotSequence = i + 1);
            setEditForm(prev => ({ ...prev, returnOriginTimings: updatedTimings }));
            setEditNumberOfTrips(updatedTimings.length);
            const tripToRemove = index + 1;
            const updatedStops = downStops.map(stop => {
                const filteredTimings = (stop.timings || []).filter(t => t.timeSlotSequence !== tripToRemove).map((t, i) => ({ ...t, timeSlotSequence: i + 1 }));
                filteredTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
                return { ...stop, timings: filteredTimings };
            });
            setDownStops(updatedStops);
            toast.info(`Removed Return Trip #${tripToRemove}.`);
        };
    
        const removeEditReturnDestinationTrip = (index) => {
            const currentTimings = editForm.returnDestTimings || [];
            if (currentTimings.length <= 1) { toast.warning('At least one trip is required'); return; }
            const updatedTimings = currentTimings.filter((_, i) => i !== index);
            updatedTimings.forEach((t, i) => t.timeSlotSequence = i + 1);
            setEditForm(prev => ({ ...prev, returnDestTimings: updatedTimings }));
            setEditNumberOfTrips(updatedTimings.length);
        };
    
        const addEditOriginTrip = () => {
            const currentTimings = editForm.originTimings || [];
            const newSequence = currentTimings.length + 1;
            setEditForm(prev => ({ ...prev, originTimings: [...currentTimings, { timeSlotSequence: newSequence, departureTime: '', arrivalTime: '' }], numberOfTrips: newSequence }));
            setEditNumberOfTrips(newSequence);
            const updatedStops = upStops.map(stop => {
                const existingTimings = stop.timings || [];
                if (existingTimings.find(t => t.timeSlotSequence === newSequence)) return stop;
                const newTimings = [...existingTimings, { timeSlotSequence: newSequence, arrivalTime: '', departureTime: '' }];
                newTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
                return { ...stop, timings: newTimings };
            });
            setUpStops(updatedStops);
            toast.info(`Added Trip #${newSequence}. Please set timings for this trip in each stop.`);
        };
    
        const removeEditOriginTrip = (index) => {
            const currentTimings = editForm.originTimings || [];
            if (currentTimings.length <= 1) { toast.warning('At least one trip is required'); return; }
            const updatedTimings = currentTimings.filter((_, i) => i !== index);
            updatedTimings.forEach((t, i) => t.timeSlotSequence = i + 1);
            setEditForm(prev => ({ ...prev, originTimings: updatedTimings, numberOfTrips: updatedTimings.length }));
            setEditNumberOfTrips(updatedTimings.length);
            const tripToRemove = index + 1;
            const updatedStops = upStops.map(stop => {
                const filteredTimings = (stop.timings || []).filter(t => t.timeSlotSequence !== tripToRemove).map((t, i) => ({ ...t, timeSlotSequence: i + 1 }));
                filteredTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
                return { ...stop, timings: filteredTimings };
            });
            setUpStops(updatedStops);
            toast.info(`Removed Trip #${tripToRemove}.`);
        };
    
        const addEditDestinationTrip = () => {
            const currentTimings = editForm.destTimings || [];
            const newSequence = currentTimings.length + 1;
            setEditForm(prev => ({ ...prev, destTimings: [...currentTimings, { timeSlotSequence: newSequence, arrivalTime: '', departureTime: '' }], numberOfTrips: newSequence }));
            setEditNumberOfTrips(newSequence);
        };
    
        const removeEditDestinationTrip = (index) => {
            const currentTimings = editForm.destTimings || [];
            if (currentTimings.length <= 1) { toast.warning('At least one trip is required'); return; }
            const updatedTimings = currentTimings.filter((_, i) => i !== index);
            updatedTimings.forEach((t, i) => t.timeSlotSequence = i + 1);
            setEditForm(prev => ({ ...prev, destTimings: updatedTimings, numberOfTrips: updatedTimings.length }));
            setEditNumberOfTrips(updatedTimings.length);
        };
    
        // ---------- render stops (unchanged) ----------
        const renderStopsWithInlineInsert = (stops) => {
            if (!stops || stops.length === 0) {
                return (
                    <div className="stops-empty-state">
                        <p>No intermediate stops added yet.</p>
                        <button className="btn btn-sm btn-add-stop" onClick={() => { setEditingStopIndex(null); setInsertIndex(null); setIsManualStop(true); clearStopForm(); }}>+ Add First Stop</button>
                    </div>
                );
            }
    
            const renderInsertButtonLocal = (index) => (
                <div className="insert-stop-wrapper">
                    <div className="insert-line"></div>
                    <button className="insert-stop-btn" onClick={() => { setInsertIndex(index); setIsManualStop(true); clearStopForm(); }}>
                        <span className="insert-icon">+</span> Insert stop here
                    </button>
                    <div className="insert-line"></div>
                </div>
            );
    
            return (
                <div className="stops-list-container">
                    {renderInsertButtonLocal(0)}
                    {stops.map((stop, index) => {
                        const displayManualDist = calculateManualDistFromPrev(stops, index);
                        const distanceDisplay = displayManualDist || (typeof stop.distanceFromOrigin === 'number' ? stop.distanceFromOrigin.toFixed(2) : parseFloat(stop.distanceFromOrigin || 0).toFixed(2));
                        const hasMultiTimings = stop.timings && stop.timings.length > 0;
                        const sortedTimings = hasMultiTimings ? sortTimings(stop.timings) : [];
                        return (
                            <React.Fragment key={stop._id || index}>
                                <div className="stop-item-card">
                                    <div className="stop-item-header">
                                        <div className="stop-item-left">
                                            <span className="stop-item-number">{index + 1}.</span>
                                            <span className="stop-item-name">{stop.city}</span>
                                            <span className="stop-item-distance">({distanceDisplay} km)</span>
                                            <StopTypeBadge type={stop.stopType} />
                                            <StatusBadge isActive={stop.isEnabled !== false} />
                                        </div>
                                        <div className="stop-item-actions">
                                            <button className="stop-action-btn edit" onClick={() => { setEditingStopIndex(index); handleEditStop(index, activeRouteTab === 'UP' ? 'up' : 'down'); }}>Edit</button>
                                            <button className="stop-action-btn delete" onClick={() => handleDeleteStop(index)}>Delete</button>
                                        </div>
                                    </div>
                                    {hasMultiTimings && sortedTimings.length > 0 ? (
                                        <div className="stop-timings-grid">
                                            {sortedTimings.map((timing, idx) => (
                                                <div key={timing.timeSlotSequence || idx} className="stop-timing-row">
                                                    <span className="trip-badge">Trip {timing.timeSlotSequence || idx + 1}:</span>
                                                    <span className="timing-arrival">Arr {TimeDisplay({ time: timing.arrivalTime })}</span>
                                                    <span className="timing-arrow">→</span>
                                                    <span className="timing-departure">Dep {TimeDisplay({ time: timing.departureTime })}</span>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (stop.arrivalTime || stop.departureTime) ? (
                                        <div className="stop-timing-row">
                                            <span className="timing-arrival">Arr {TimeDisplay({ time: stop.arrivalTime })}</span>
                                            <span className="timing-arrow">→</span>
                                            <span className="timing-departure">Dep {TimeDisplay({ time: stop.departureTime })}</span>
                                        </div>
                                    ) : (
                                        <div className="stop-timing-row" style={{ color: '#999', fontStyle: 'italic' }}>No timings set</div>
                                    )}
                                </div>
                                {renderInsertButtonLocal(index + 1)}
                            </React.Fragment>
                        );
                    })}
                </div>
            );
        };
    
        const clearCurrentRoute = () => {
            if (!window.confirm(`Are you sure you want to clear all data for the ${activeRouteTab} route? This will remove origin, destination, and all intermediate stops.`)) return;
            if (activeRouteTab === 'UP') {
                setNewRoute(prev => ({ ...prev, upOriginCity: '', upOriginState: '', upOriginAddress: '', upOriginTerminal: '', upOriginCoords: null, upOriginDepTime: '', upDestCity: '', upDestState: '', upDestAddress: '', upDestTerminal: '', upDestCoords: null, upDestArrTime: '', upTotalDistance: '', upDurationHours: '', upDurationMinutes: '', upManualFinalLeg: '', upManualFirstLeg: '' }));
                setUpStops([]);
                setIsDistanceCalculated(prev => ({ ...prev, up: false }));
                if (isMultiTrip) { setTimeSlots([]); setDestinationTimeSlots([]); setNumberOfTrips(1); }
                toast.info('UP route cleared successfully');
            } else {
                setNewRoute(prev => ({ ...prev, downOriginDepTime: '', downDestArrTime: '', downTotalDistance: '', downDurationHours: '', downDurationMinutes: '', downManualFinalLeg: '', downManualFirstLeg: '' }));
                setDownStops([]);
                setIsDistanceCalculated(prev => ({ ...prev, down: false }));
                if (isMultiTrip) { setReturnOriginTimeSlots([]); setReturnDestTimeSlots([]); }
                toast.info('DOWN route cleared successfully');
            }
        };
    
        const copyScheduleToDestination = (slots) => {
            setDestinationTimeSlots(slots.map(slot => ({ ...slot, arrivalTime: slot.arrivalTime || '', departureTime: '' })));
            setDestinationNumberOfTrips(slots.length);
        };
    
    
        const restorePromptShown = useRef(false);
        const isMounted = useRef(true);
    
      
    
        // ---------- Bus activation ----------
        const handleActivateBusFromRoute = (route) => {
            const pendingBuses = route.associatedBuses?.filter(bus => !bus.isActive && (bus.approvalStatus === 'pending' || !bus.approvalStatus));
            if (pendingBuses && pendingBuses.length > 0) {
                if (pendingBuses.length === 1) handleActivateSingleBus(pendingBuses[0]);
                else {
                    const busList = pendingBuses.map((bus, idx) => `${idx + 1}. ${bus.busName} (${bus.busNumber})`).join('\n');
                    const selectedIndex = window.prompt(`Multiple pending buses found on this route:\n${busList}\n\nEnter the number of the bus to activate (1-${pendingBuses.length}):`);
                    const index = parseInt(selectedIndex) - 1;
                    if (index >= 0 && index < pendingBuses.length) handleActivateSingleBus(pendingBuses[index]);
                    else toast.error('Invalid selection');
                }
            } else toast.info('No pending buses found on this route');
        };
    
        const fetchBusDetails = async (busId) => {
            try {
                const response = await getBusById(busId, token);
                if (response.success) { setSelectedBusForActivation(response.data); setShowPlatformFeeModal(true); }
                else toast.error('Failed to fetch bus details');
            } catch (error) {
                console.error('Error fetching bus details:', error);
                toast.error(error.response?.data?.message || 'Failed to fetch bus details');
            }
        };
    
        const handleActivateSingleBus = async (bus) => {
            const busId = bus._id || bus.busId;
            if (!busId) { toast.error('Invalid bus ID'); return; }
            try {
                const response = await getBusById(busId, token);
                if (response && response.success) {
                    const busData = response.data || response.bus;
                    if (busData) { setSelectedBusForActivation(busData); setShowPlatformFeeModal(true); return; }
                }
                setSelectedBusForActivation({ ...bus, _id: busId });
                setShowPlatformFeeModal(true);
                toast.info('Using existing bus data for activation');
            } catch (error) {
                console.error('Error fetching bus details:', error);
                setSelectedBusForActivation({ ...bus, _id: busId });
                setShowPlatformFeeModal(true);
                toast.info('Using existing bus data for activation');
            }
        };
    
        const getDefaultStateForStop = (activeRouteTab, upStops, downStops, newRoute) => {
            if (activeRouteTab === 'UP') {
                if (upStops.length > 0) {
                    const lastStop = upStops[upStops.length - 1];
                    if (lastStop.state && lastStop.state.trim()) return lastStop.state;
                }
                if (newRoute.upOriginState && newRoute.upOriginState.trim()) return newRoute.upOriginState;
                if (newRoute.upDestState && newRoute.upDestState.trim()) return newRoute.upDestState;
            } else if (activeRouteTab === 'DOWN') {
                if (downStops.length > 0) {
                    const lastStop = downStops[downStops.length - 1];
                    if (lastStop.state && lastStop.state.trim()) return lastStop.state;
                }
                if (newRoute.upOriginState && newRoute.upOriginState.trim()) return newRoute.upOriginState;
                if (newRoute.upDestState && newRoute.upDestState.trim()) return newRoute.upDestState;
            }
            return '';
        };
    
        // ---------- inline insert panel (unchanged) ----------
        const renderInlineInsertPanel = (idx) => {
            const stops = getActiveStops();
            const nextStop = stops[idx] || null;
            const nextHasGPS = nextStop?.coordinates?.lat && nextStop.coordinates.lat !== 0;
            const cityOk = inlineInsertForm.city.trim().length > 0;
            const timeOk = inlineInsertForm.arrivalTime.trim().length > 0;
            const distOk = parseFloat(inlineInsertForm.manualDistFromPrev) > 0;
            const canInsert = cityOk && timeOk && (!inlineInsertForm.isManual || distOk);
    
            const searchCitiesForInsert = async (query) => {
                if (!query || query.trim().length < 2) { setInlineInsertCitySuggestions([]); setShowInlineInsertDropdown(false); return; }
                try {
                    const response = await searchRouteIntermediateStops(token, query);
                    if (response.success && response.cities && response.cities.length > 0) {
                        const deduped = normalizeAndDeduplicateSuggestions(response.cities);
                        setInlineInsertCitySuggestions(deduped);
                        setShowInlineInsertDropdown(deduped.length > 0);
                    } else { setInlineInsertCitySuggestions([]); setShowInlineInsertDropdown(false); }
                } catch (error) { console.error('Error searching cities:', error); setInlineInsertCitySuggestions([]); setShowInlineInsertDropdown(false); }
            };
    
            const fieldStyle = { display: 'flex', flexDirection: 'column', gap: 5 };
            const labelStyle = { fontSize: 11, fontWeight: 500, color: 'var(--color-text-secondary, #777)', letterSpacing: '.2px' };
            const inputStyle = (hasErr = false) => ({
                width: '100%', height: 38, padding: '0 12px',
                border: `1px solid ${hasErr ? '#e24b4a' : 'var(--color-border-secondary, rgba(0,0,0,.2))'}`,
                borderRadius: 8, fontSize: 13,
                background: hasErr ? 'rgba(252,235,235,.05)' : 'var(--color-background-primary, #fff)',
                color: 'var(--color-text-primary, #333)', outline: 'none', boxSizing: 'border-box'
            });
            const sectionHead = (label) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '18px 0 12px' }}>
                    <span style={{ fontSize: 11, fontWeight: 500, color: 'var(--color-text-secondary, #888)', letterSpacing: '.4px', whiteSpace: 'nowrap' }}>{label}</span>
                    <div style={{ flex: 1, height: 1, background: 'var(--color-border-tertiary, rgba(0,0,0,.1))' }} />
                </div>
            );
    
            return (
                <div style={{ width: '100%', background: 'var(--color-background-primary, #fff)', border: '1.5px solid #378add', borderRadius: 14, overflow: 'hidden', margin: '6px 0', alignSelf: 'stretch' }}>
                    <div style={{ background: 'linear-gradient(135deg, #185fa5 0%, #378add 100%)', padding: '14px 18px', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <div style={{ width: 34, height: 34, borderRadius: 8, background: 'rgba(255,255,255,.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 }}>📍</div>
                            <div><div style={{ fontSize: 14, fontWeight: 500, color: '#fff' }}>Insert stop at position {idx + 1}</div></div>
                        </div>
                        <button onClick={() => { setInlineInsertIndex(null); setInlineInsertCitySuggestions([]); setShowInlineInsertDropdown(false); }}
                            style={{ width: 26, height: 26, borderRadius: 6, border: '1px solid rgba(255,255,255,.3)', background: 'transparent', color: '#fff', cursor: 'pointer', fontSize: 15, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>×</button>
                    </div>
    
                    <div style={{ padding: 18 }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', background: 'var(--color-background-secondary, #f7f7f5)', border: '0.5px solid var(--color-border-tertiary, rgba(0,0,0,.1))', borderRadius: 8, cursor: 'pointer', userSelect: 'none' }}>
                            <input type="checkbox" checked={inlineInsertForm.isManual}
                                onChange={() => setInlineInsertForm(prev => ({ ...prev, isManual: !prev.isManual, city: '', address: '', state: '', terminal: '', manualDistFromPrev: '', manualDistToNext: '' }))}
                                style={{ width: 16, height: 16, accentColor: '#378add', cursor: 'pointer' }} />
                            <span style={{ fontSize: 13, color: 'var(--color-text-primary, #333)' }}>Manually typed stop (no map suggestions)</span>
                        </label>
    
                        {sectionHead('Stop details')}
                        <div style={{ marginBottom: 12 }}>
                            <div style={fieldStyle}>
                                <label style={labelStyle}>City / stop name <span style={{ color: '#e24b4a' }}>*</span></label>
                                {!inlineInsertForm.isManual ? (
                                    <LocationInput
                                        value={inlineInsertForm.city}
                                        onChange={(v) => setInlineInsertForm(prev => ({ ...prev, city: v }))}
                                        onLocationSelect={(loc) => setInlineInsertForm(prev => ({ ...prev, city: loc.city || loc.name || '', state: loc.state || prev.state, address: loc.address || '' }))}
                                        placeholder="Search stop city or address…"
                                    />
                                ) : (
                                    <div style={{ position: 'relative' }}>
                                        <input type="text" value={inlineInsertForm.city}
                                            onChange={async (e) => {
                                                const value = toTitleCase(e.target.value);
                                                setInlineInsertForm(prev => ({ ...prev, city: value, address: '', state: '', terminal: '' }));
                                                await searchCitiesForInsert(value);
                                            }}
                                            onFocus={() => { if (inlineInsertCitySuggestions.length > 0) setShowInlineInsertDropdown(true); }}
                                            onBlur={() => setTimeout(() => setShowInlineInsertDropdown(false), 200)}
                                            placeholder="Type city name (min 2 chars)…" style={inputStyle()} />
                                        {showInlineInsertDropdown && inlineInsertCitySuggestions.length > 0 && (
                                            <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #ddd', borderRadius: 8, maxHeight: 200, overflowY: 'auto', zIndex: 10000, boxShadow: '0 4px 12px rgba(0,0,0,.12)' }}>
                                                {inlineInsertCitySuggestions.map((city, i) => (
                                                    <div key={city.id || i}
                                                        onMouseDown={() => { setInlineInsertForm(prev => ({ ...prev, city: city.name, address: city.address || city.name, state: city.state || '', terminal: city.terminal || `${city.name} Bus Stand` })); setShowInlineInsertDropdown(false); setInlineInsertCitySuggestions([]); }}
                                                        style={{ padding: '9px 12px', cursor: 'pointer', borderBottom: '0.5px solid #f0f0f0' }}
                                                        onMouseEnter={e => e.currentTarget.style.background = '#f0f7ff'}
                                                        onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                                                        <div style={{ fontWeight: 500, fontSize: 13 }}>{city.name}</div>
                                                        <div style={{ fontSize: 11, color: '#888' }}>{city.state}{city.terminal ? ` · ${city.terminal}` : ''}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div style={{ marginBottom: 12 }}>
                            <div style={fieldStyle}>
                                <label style={labelStyle}>Address</label>
                                <input type="text" value={inlineInsertForm.address} onChange={e => setInlineInsertForm(prev => ({ ...prev, address: e.target.value }))} placeholder="e.g. NH-19, Near Bus Stand" style={inputStyle()} />
                            </div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 4 }}>
                            <div style={fieldStyle}><label style={labelStyle}>State</label><input type="text" value={inlineInsertForm.state} onChange={e => setInlineInsertForm(prev => ({ ...prev, state: e.target.value }))} placeholder="State" style={inputStyle()} /></div>
                            <div style={fieldStyle}><label style={labelStyle}>Terminal</label><input type="text" value={inlineInsertForm.terminal} onChange={e => setInlineInsertForm(prev => ({ ...prev, terminal: e.target.value }))} placeholder="Terminal name" style={inputStyle()} /></div>
                        </div>
    
                        {sectionHead('Schedule')}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 4 }}>
                            <div style={fieldStyle}><label style={labelStyle}>Arrival Time <span style={{ color: '#e24b4a' }}>*</span></label><TimePicker value={inlineInsertForm.arrivalTime} onChange={(value) => setInlineInsertForm(prev => ({ ...prev, arrivalTime: value }))} placeholder="Select time" /></div>
                            <div style={fieldStyle}><label style={labelStyle}>Departure Time (Opt)</label><TimePicker value={inlineInsertForm.departureTime} onChange={(value) => setInlineInsertForm(prev => ({ ...prev, departureTime: value }))} placeholder="Select time" /></div>
                        </div>
    
                        {sectionHead('Distance')}
                        <div style={{ display: 'grid', gridTemplateColumns: nextHasGPS ? '1fr 1fr' : '1fr', gap: 12, marginBottom: 4 }}>
                            <div style={{ border: '1px solid rgba(226,75,74,.4)', borderRadius: 10, padding: 14, background: 'rgba(252,235,235,.04)' }}>
                                <div style={{ fontSize: 11, fontWeight: 500, color: '#a32d2d', marginBottom: 6 }}>From previous stop <span style={{ color: '#e24b4a' }}>*</span></div>
                                <input type="number" value={inlineInsertForm.manualDistFromPrev} onChange={e => setInlineInsertForm(prev => ({ ...prev, manualDistFromPrev: e.target.value }))} placeholder="0" min="0" step="0.1" style={{ ...inputStyle(true), border: '1px solid #e24b4a' }} />
                                <div style={{ fontSize: 11, color: '#a32d2d', marginTop: 5, display: 'flex', alignItems: 'center', gap: 4 }}>⚠ Required for manual stops</div>
                                <div style={{ fontSize: 11, color: 'var(--color-text-secondary, #888)', marginTop: 2 }}>km</div>
                            </div>
                            {nextHasGPS && (
                                <div style={{ border: '1px solid rgba(55,138,221,.3)', borderRadius: 10, padding: 14, background: 'rgba(230,241,251,.04)' }}>
                                    <div style={{ fontSize: 11, fontWeight: 500, color: '#185fa5', marginBottom: 6 }}>To next stop — {nextStop.city}</div>
                                    <input type="number" value={inlineInsertForm.manualDistToNext} onChange={e => setInlineInsertForm(prev => ({ ...prev, manualDistToNext: e.target.value }))} placeholder="0" min="0" step="0.1" style={{ ...inputStyle(), border: '1px solid rgba(55,138,221,.5)' }} />
                                    <div style={{ fontSize: 11, color: '#185fa5', marginTop: 5 }}>ℹ Next stop has GPS — helps accuracy</div>
                                    <div style={{ fontSize: 11, color: 'var(--color-text-secondary, #888)', marginTop: 2 }}>km</div>
                                </div>
                            )}
                        </div>
    
                        {sectionHead('Stop type')}
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                            {[
                                { val: 'none', label: 'Pass-through', bg: '#f1efe8', color: '#5f5e5a', border: '#888' },
                                { val: 'boarding', label: 'Boarding only', bg: '#eaf3de', color: '#3b6d11', border: '#3b6d11' },
                                { val: 'dropping', label: 'Dropping only', bg: '#fcebeb', color: '#a32d2d', border: '#a32d2d' },
                                { val: 'both', label: 'Both boarding & dropping', bg: '#e6f1fb', color: '#185fa5', border: '#378add' },
                            ].map(opt => {
                                const sel = inlineInsertForm.stopType === opt.val;
                                return (
                                    <button key={opt.val} type="button" onClick={() => setInlineInsertForm(prev => ({ ...prev, stopType: opt.val }))}
                                        style={{ padding: '6px 14px', borderRadius: 999, fontSize: 12, cursor: 'pointer', border: `1px solid ${sel ? opt.border : 'rgba(0,0,0,.2)'}`, background: sel ? opt.bg : 'transparent', color: sel ? opt.color : 'var(--color-text-secondary, #666)', fontWeight: sel ? 500 : 400, transition: 'all .12s' }}>
                                        {opt.label}
                                    </button>
                                );
                            })}
                        </div>
                        <div style={{ display: 'flex', gap: 16, marginTop: 16 }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12 }}><input type="checkbox" checked={inlineInsertForm.isBoarding} onChange={e => setInlineInsertForm(prev => ({ ...prev, isBoarding: e.target.checked }))} />Boarding Point</label>
                            <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12 }}><input type="checkbox" checked={inlineInsertForm.isDropping} onChange={e => setInlineInsertForm(prev => ({ ...prev, isDropping: e.target.checked }))} />Dropping Point</label>
                        </div>
                    </div>
    
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8, padding: '12px 18px', borderTop: '1px solid var(--color-border-tertiary, rgba(0,0,0,.08))', background: 'var(--color-background-secondary, #fafafa)' }}>
                        <button type="button" onClick={() => { setInlineInsertIndex(null); setInlineInsertCitySuggestions([]); setShowInlineInsertDropdown(false); }} style={{ padding: '8px 18px', fontSize: 13, borderRadius: 8, border: '1px solid var(--color-border-secondary, rgba(0,0,0,.2))', background: 'transparent', cursor: 'pointer', color: 'var(--color-text-secondary, #666)' }}>Cancel</button>
                        <button type="button" onClick={saveInlineInsert} disabled={!canInsert} style={{ padding: '8px 22px', fontSize: 13, borderRadius: 8, border: 'none', background: '#378add', color: '#fff', fontWeight: 500, cursor: canInsert ? 'pointer' : 'not-allowed', opacity: canInsert ? 1 : 0.45, display: 'flex', alignItems: 'center', gap: 6 }}>✓ Insert stop</button>
                    </div>
                </div>
            );
        };
    
        const saveInlineInsert = () => {
            if (!inlineInsertForm.city) { toast.error('City is required'); return; }
            if (!inlineInsertForm.arrivalTime) { toast.error('Arrival time is required'); return; }
            if (!inlineInsertForm.state || inlineInsertForm.state.trim() === '') { toast.error('State is required'); return; }
            if (!inlineInsertForm.address || inlineInsertForm.address.trim() === '') { toast.error('Address is required'); return; }
            if (!inlineInsertForm.terminal || inlineInsertForm.terminal.trim() === '') { toast.error('Terminal is required'); return; }
            if (inlineInsertForm.isManual && (!inlineInsertForm.manualDistFromPrev || parseFloat(inlineInsertForm.manualDistFromPrev) <= 0)) { toast.error('For manual stops, please provide distance from previous stop'); return; }
    
            const type = activeRouteTab === 'UP' ? 'up' : 'down';
            let currentStops = type === 'up' ? [...upStops] : [...downStops];
    
            let coordinates = null, manualDistFromPrev = null, manualDistToNext = null, distanceFromOrigin = 0;
    
            if (inlineInsertForm.isManual) {
                coordinates = { lat: 0, lng: 0 };
                manualDistFromPrev = parseFloat(inlineInsertForm.manualDistFromPrev);
                manualDistToNext = inlineInsertForm.manualDistToNext ? parseFloat(inlineInsertForm.manualDistToNext) : null;
                if (inlineInsertIndex > 0 && currentStops[inlineInsertIndex - 1]) {
                    distanceFromOrigin = parseFloat(((currentStops[inlineInsertIndex - 1].distanceFromOrigin || 0) + manualDistFromPrev).toFixed(2));
                } else distanceFromOrigin = manualDistFromPrev || 0;
            }
    
            let stopType = inlineInsertForm.stopType || 'none';
            if (stopType === 'none') {
                if (inlineInsertForm.isBoarding && inlineInsertForm.isDropping) stopType = 'both';
                else if (inlineInsertForm.isBoarding) stopType = 'boarding';
                else if (inlineInsertForm.isDropping) stopType = 'dropping';
            }
    
            const newStop = {
                city: inlineInsertForm.city, state: inlineInsertForm.state || '',
                address: inlineInsertForm.address || `${inlineInsertForm.city}, ${inlineInsertForm.state || 'India'}`,
                terminal: inlineInsertForm.terminal || `${inlineInsertForm.city} Bus Stand`,
                arrivalTime: inlineInsertForm.arrivalTime,
                departureTime: inlineInsertForm.departureTime || inlineInsertForm.arrivalTime,
                stopType, coordinates, manualDistFromPrev, manualDistToNext, distanceFromOrigin,
                isManualStop: inlineInsertForm.isManual
            };
    
            currentStops.splice(inlineInsertIndex, 0, newStop);
            setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));
    
            if (type === 'up') setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
            else setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
    
            toast.success(`Stop "${inlineInsertForm.city}" inserted at position ${inlineInsertIndex + 1}`);
            setInlineInsertIndex(null);
            setInlineInsertCitySuggestions([]);
            setShowInlineInsertDropdown(false);
        };
    
        const searchCitySuggestions = async (query, type) => {
            if (!query || query.trim().length < 2) {
                if (type === 'origin') setOriginSuggestions([]);
                else setDestSuggestions([]);
                return;
            }
            try {
                const allRoutes = await getAllRoutes(token, 1, 100, '');
                if (allRoutes.success && allRoutes.data?.routes) {
                    const cities = new Set();
                    allRoutes.data.routes.forEach(route => {
                        if (type === 'origin' && route.origin?.city) {
                            if (route.origin.city.toLowerCase().includes(query.toLowerCase())) cities.add(route.origin.city);
                        } else if (type === 'destination' && route.destination?.city) {
                            if (route.destination.city.toLowerCase().includes(query.toLowerCase())) cities.add(route.destination.city);
                        }
                    });
                    const suggestions = Array.from(cities).map(city => ({ city }));
                    if (type === 'origin') { setOriginSuggestions(suggestions); setShowOriginSuggestions(true); }
                    else { setDestSuggestions(suggestions); setShowDestSuggestions(true); }
                }
            } catch (error) { console.error('Error fetching city suggestions:', error); }
        };
    
        const formatTime = (time) => {
            if (!time) return 'N/A';
            if (time.includes(':')) {
                const [hours, minutes] = time.split(':');
                const hour = parseInt(hours);
                const ampm = hour >= 12 ? 'pm' : 'am';
                const displayHour = hour % 12 || 12;
                return `${displayHour}:${minutes} ${ampm}`;
            }
            return time;
        };
    
        const formatDuration = (hours, minutes) => {
            if (!hours && !minutes) return 'N/A';
            const parts = [];
            if (hours) parts.push(`${hours}h`);
            if (minutes) parts.push(`${minutes}m`);
            return parts.join(' ');
        };
    
        const getDuration = (start, end) => {
            if (!start || !end) return { hours: '0', minutes: '0' };
            if (!start.includes(':') || !end.includes(':')) return { hours: '0', minutes: '0' };
            const [sh, sm] = start.split(':').map(Number);
            const [eh, em] = end.split(':').map(Number);
            if (isNaN(sh) || isNaN(sm) || isNaN(eh) || isNaN(em)) return { hours: '0', minutes: '0' };
            let sMins = sh * 60 + sm;
            let eMins = eh * 60 + em;
            if (eMins < sMins) eMins += 24 * 60;
            const diff = eMins - sMins;
            return { hours: String(Math.floor(diff / 60)), minutes: String(diff % 60) };
        };
    
        const isLastStopManual = () => {
            const stops = activeRouteTab === 'UP' ? upStops : downStops;
            if (stops.length === 0) return false;
            const lastStop = stops[stops.length - 1];
            return (
                lastStop.isManualStop === true ||
                (lastStop.manualDistFromPrev !== null && lastStop.manualDistFromPrev !== undefined && lastStop.manualDistFromPrev > 0) ||
                (lastStop.manualDistToNext !== null && lastStop.manualDistToNext !== undefined && lastStop.manualDistToNext > 0) ||
                !lastStop.coordinates ||
                (lastStop.coordinates.lat === 0 && lastStop.coordinates.lng === 0)
            );
        };
    
        const isNextStopAuto = (currentIndex) => {
            const stops = getActiveStops();
            const nextStop = stops[currentIndex + 1];
            return nextStop && nextStop.coordinates && (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);
        };
    
        const handleSelectOrigin = (location) => {
            setNewRoute(prev => ({ ...prev, upOriginCity: location.city || location.name || '', upOriginState: location.state || '', upOriginAddress: location.address || '', upOriginCoords: location.coordinates || { lat: 0, lng: 0 } }));
            setIsDistanceCalculated(prev => ({ ...prev, up: false }));
        };
    
        const handleSelectDest = (location) => {
            setNewRoute(prev => ({ ...prev, upDestCity: location.city || location.name || '', upDestState: location.state || '', upDestAddress: location.address || '', upDestCoords: location.coordinates || { lat: 0, lng: 0 } }));
            setIsDistanceCalculated(prev => ({ ...prev, up: false }));
        };
    
        const handleSelectStop = (location) => {
            let autoState = location.state || '';
            if (!autoState && activeRouteTab === 'UP') {
                if (upStops.length > 0) { const lastStop = upStops[upStops.length - 1]; if (lastStop.state && lastStop.state.trim()) autoState = lastStop.state; }
                if (!autoState && newRoute.upOriginState && newRoute.upOriginState.trim()) autoState = newRoute.upOriginState;
            } else if (!autoState && activeRouteTab === 'DOWN') {
                if (downStops.length > 0) { const lastStop = downStops[downStops.length - 1]; if (lastStop.state && lastStop.state.trim()) autoState = lastStop.state; }
                if (!autoState && newRoute.upOriginState && newRoute.upOriginState.trim()) autoState = newRoute.upOriginState;
            }
            setNewRoute(prev => ({ ...prev, stopCity: location.city || location.name || '', stopState: autoState, stopAddress: location.address || '', stopCoords: location.coordinates || { lat: 0, lng: 0 } }));
            setIsManualStop(false);
            setIsManualDistance(false);
        };
    
        // ---------- syncDownStopsWithUpStops (unchanged) ----------
        const syncDownStopsWithUpStops = (forcePrompt = false) => {
            if (upStops.length === 0) { toast.warning("No UP route stops to sync from."); return; }
            const upTotalDist = parseFloat(editForm.totalDistance || newRoute.upTotalDistance || 0);
            let downTotalDist = parseFloat(editForm.returnTotalDistance || newRoute.downTotalDistance || 0);
            if (downTotalDist === 0 && upTotalDist > 0) downTotalDist = upTotalDist;
    
            const numTrips = editForm.numberOfTrips || editNumberOfTrips || numberOfTrips || 1;
            const isMultiTripMode = editForm.isMultiTrip || editIsMultiTrip || isMultiTrip || false;
    
            const doSync = () => {
                const newDownStops = [];
                const upDistances = upStops.map(stop => stop.distanceFromOrigin || 0);
                const maxUpDistance = upDistances[upDistances.length - 1] || 0;
    
                for (let i = 0; i < upStops.length; i++) {
                    const originalIndex = upStops.length - 1 - i;
                    const originalStop = upStops[originalIndex];
                    const upDistance = originalStop.distanceFromOrigin || 0;
                    let downDistance = downTotalDist - upDistance;
                    if (downDistance <= 0 && i === 0) downDistance = downTotalDist - maxUpDistance;
                    if (downDistance <= 0) downDistance = (downTotalDist / (upStops.length + 1)) * (i + 1);
    
                    let manualDistFromPrev = null;
                    if (i === 0) manualDistFromPrev = downDistance;
                    else {
                        const prevDownDist = newDownStops[i - 1]?.distanceFromOrigin || 0;
                        manualDistFromPrev = downDistance - prevDownDist;
                    }
                    if (manualDistFromPrev <= 0) manualDistFromPrev = originalStop.manualDistFromPrev || downDistance / (i + 1);
    
                    let newStopType = originalStop.stopType;
                    if (originalStop.stopType === 'boarding') newStopType = 'dropping';
                    else if (originalStop.stopType === 'dropping') newStopType = 'boarding';
    
                    let stopTimings = [];
                    if (isMultiTripMode) {
                        if (editForm.originTimings && editForm.originTimings.length > 0) stopTimings = editForm.originTimings.map(t => ({ timeSlotSequence: t.timeSlotSequence || t.sequence || 1, arrivalTime: '', departureTime: '' }));
                        else if (editForm.destTimings && editForm.destTimings.length > 0) stopTimings = editForm.destTimings.map(t => ({ timeSlotSequence: t.timeSlotSequence || t.sequence || 1, arrivalTime: '', departureTime: '' }));
                        else if (originalStop.timings && originalStop.timings.length > 0) stopTimings = originalStop.timings.map(t => ({ timeSlotSequence: t.timeSlotSequence || 1, arrivalTime: '', departureTime: '' }));
                        else stopTimings = Array.from({ length: numTrips }, (_, idx) => ({ timeSlotSequence: idx + 1, arrivalTime: '', departureTime: '' }));
                        while (stopTimings.length < numTrips) stopTimings.push({ timeSlotSequence: stopTimings.length + 1, arrivalTime: '', departureTime: '' });
                        stopTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
                    }
    
                    newDownStops.push({
                        ...originalStop,
                        sequence: i + 1,
                        stopType: newStopType,
                        distanceFromOrigin: parseFloat(downDistance.toFixed(1)),
                        manualDistFromPrev: parseFloat(manualDistFromPrev.toFixed(1)),
                        manualDistToNext: originalStop.manualDistFromPrev || null,
                        arrivalTime: isMultiTripMode ? '' : '',
                        departureTime: isMultiTripMode ? '' : '',
                        timings: stopTimings
                    });
                }
    
                if (newDownStops.length > 0) {
                    const lastDownDist = newDownStops[newDownStops.length - 1].distanceFromOrigin || 0;
                    const finalSegment = downTotalDist - lastDownDist;
                    if (finalSegment > 0) newDownStops[newDownStops.length - 1] = { ...newDownStops[newDownStops.length - 1], manualDistToNext: parseFloat(finalSegment.toFixed(1)) };
                }
    
                setDownStops(newDownStops);
    
                if (isMultiTripMode) {
                    if (editForm.originTimings && editForm.originTimings.length > 0) {
                        setEditForm(prev => ({ ...prev, returnOriginTimings: editForm.originTimings.map(t => ({ timeSlotSequence: t.timeSlotSequence || 1, departureTime: '', arrivalTime: '' })) }));
                    } else {
                        setEditForm(prev => ({ ...prev, returnOriginTimings: Array.from({ length: numTrips }, (_, idx) => ({ timeSlotSequence: idx + 1, departureTime: '', arrivalTime: '' })) }));
                    }
                    if (editForm.destTimings && editForm.destTimings.length > 0) {
                        setEditForm(prev => ({ ...prev, returnDestTimings: editForm.destTimings.map(t => ({ timeSlotSequence: t.timeSlotSequence || 1, arrivalTime: '', departureTime: '' })) }));
                    } else {
                        setEditForm(prev => ({ ...prev, returnDestTimings: Array.from({ length: numTrips }, (_, idx) => ({ timeSlotSequence: idx + 1, arrivalTime: '', departureTime: '' })) }));
                    }
                    setEditNumberOfTrips(numTrips);
                }
    
                setEditForm(prev => ({ ...prev, returnTotalDistance: downTotalDist.toFixed(1), returnDurationHours: prev.durationHours, returnDurationMinutes: prev.durationMinutes, isMultiTrip: isMultiTripMode, numberOfTrips: numTrips }));
                setNewRoute(prev => ({ ...prev, downTotalDistance: downTotalDist.toFixed(1) }));
                setIsDistanceCalculated(prev => ({ ...prev, down: false }));
    
                if (isMultiTripMode) toast.success(`DOWN route populated with ${newDownStops.length} stops. Total distance: ${downTotalDist.toFixed(1)} km with ${numTrips} trip(s).`);
                else toast.success(`DOWN route populated with ${newDownStops.length} stops. Total distance: ${downTotalDist.toFixed(1)} km`);
            };
    
            if (forcePrompt && downStops.length > 0) {
                if (window.confirm("This will update your Return Route stops based on your Main Route. Any existing DOWN route data will be replaced. Proceed?")) doSync();
            } else doSync();
        };
    
        const toggleRoundTrip = (newVal) => {
            setIsRoundTrip(newVal);
            if (newVal) {
                if (isMultiTrip) {
                    if (destinationTimeSlots && destinationTimeSlots.length > 0) setReturnOriginTimeSlots(destinationTimeSlots.map(slot => ({ sequence: slot.sequence, departureTime: slot.arrivalTime || '', arrivalTime: '', fareMultiplier: slot.fareMultiplier || 1.0, isActive: true })));
                    else if (timeSlots && timeSlots.length > 0) setReturnOriginTimeSlots(timeSlots.map(slot => ({ sequence: slot.sequence, departureTime: slot.departureTime || '', arrivalTime: '', fareMultiplier: slot.fareMultiplier || 1.0, isActive: true })));
                    if (timeSlots && timeSlots.length > 0) setReturnDestTimeSlots(timeSlots.map(slot => ({ sequence: slot.sequence, arrivalTime: slot.departureTime || '', departureTime: '', fareMultiplier: slot.fareMultiplier || 1.0, isActive: true })));
                }
                if (newRoute.upOriginCity) {
                    setNewRoute(prev => ({ ...prev, downDestCity: prev.upOriginCity, downDestState: prev.upOriginState, downDestAddress: prev.upOriginAddress, downDestTerminal: prev.upOriginTerminal, downTotalDistance: prev.upTotalDistance || '', downDurationHours: prev.upDurationHours || '', downDurationMinutes: prev.upDurationMinutes || '', downOriginDepTime: prev.upDestArrTime || '', downDestArrTime: prev.upOriginDepTime || '' }));
                }
                if (upStops.length > 0 && downStops.length === 0) {
                    const upTotalDist = parseFloat(newRoute.upTotalDistance || 0);
                    const reversedStops = [...upStops].reverse();
                    let downTotalDistance = upTotalDist || 0;
                    const upSegmentDistances = [];
                    let prevDist = 0;
                    for (let i = 0; i < upStops.length; i++) {
                        const currentDist = upStops[i].distanceFromOrigin || 0;
                        let segment = currentDist - prevDist;
                        if (segment <= 0 && upStops[i].manualDistFromPrev) segment = parseFloat(upStops[i].manualDistFromPrev);
                        if (segment <= 0 && i === 0 && upTotalDist > 0) segment = upTotalDist / (upStops.length + 1);
                        if (segment <= 0) segment = 5;
                        upSegmentDistances.push(segment);
                        prevDist = currentDist;
                    }
                    const lastUpStopDist = upStops.length > 0 ? (upStops[upStops.length - 1].distanceFromOrigin || 0) : 0;
                    let finalUpSegment = upTotalDist - lastUpStopDist;
                    if (finalUpSegment <= 0 && newRoute.upManualFinalLeg) finalUpSegment = parseFloat(newRoute.upManualFinalLeg);
                    if (finalUpSegment <= 0) finalUpSegment = upTotalDist / (upStops.length + 1);
                    const downSegmentDistances = [finalUpSegment, ...upSegmentDistances.reverse()];
                    let cumulativeDist = 0;
                    const newDownStops = [];
                    for (let i = 0; i < reversedStops.length; i++) {
                        const originalStop = reversedStops[i];
                        let segmentDist = downSegmentDistances[i] || 5;
                        if (originalStop.manualDistFromPrev && originalStop.manualDistFromPrev > 0) segmentDist = parseFloat(originalStop.manualDistFromPrev);
                        else if (originalStop.manualDistToNext && originalStop.manualDistToNext > 0) segmentDist = parseFloat(originalStop.manualDistToNext);
                        cumulativeDist += segmentDist;
                        let newStopType = originalStop.stopType;
                        if (originalStop.stopType === 'boarding') newStopType = 'dropping';
                        else if (originalStop.stopType === 'dropping') newStopType = 'boarding';
                        let stopTimings = [];
                        if (isMultiTrip && originalStop.timings && originalStop.timings.length > 0) stopTimings = originalStop.timings.map(t => ({ timeSlotSequence: t.timeSlotSequence, arrivalTime: '', departureTime: '' }));
                        else if (isMultiTrip && timeSlots && timeSlots.length > 0) stopTimings = timeSlots.map(slot => ({ timeSlotSequence: slot.sequence, arrivalTime: '', departureTime: '' }));
                        newDownStops.push({ ...originalStop, sequence: i + 1, stopType: newStopType, distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)), manualDistFromPrev: parseFloat(segmentDist.toFixed(1)), manualDistToNext: originalStop.manualDistFromPrev || null, arrivalTime: isMultiTrip ? '' : originalStop.arrivalTime || '', departureTime: isMultiTrip ? '' : originalStop.departureTime || '', timings: stopTimings });
                    }
                    let finalSegment = downTotalDistance - cumulativeDist;
                    if (finalSegment <= 0) finalSegment = upSegmentDistances[0] || 5;
                    if (newDownStops.length > 0 && finalSegment > 0) newDownStops[newDownStops.length - 1] = { ...newDownStops[newDownStops.length - 1], manualDistToNext: parseFloat(finalSegment.toFixed(1)) };
                    const calculatedTotal = cumulativeDist + finalSegment;
                    if (Math.abs(calculatedTotal - downTotalDistance) > 0.1) downTotalDistance = calculatedTotal;
                    setDownStops(newDownStops);
                    setNewRoute(prev => ({ ...prev, downTotalDistance: downTotalDistance.toFixed(1), downManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.downManualFinalLeg, downDurationHours: prev.upDurationHours || '', downDurationMinutes: prev.upDurationMinutes || '' }));
                    setIsDistanceCalculated(prev => ({ ...prev, down: false }));
                    toast.success(`Return route populated with ${newDownStops.length} stops. Total distance: ${downTotalDistance.toFixed(1)} km`);
                } else if (upStops.length === 0) toast.info('Add stops to the UP route first, then enable round trip to auto-populate the return route.');
                setActiveRouteTab('DOWN');
            } else {
                setDownStops([]);
                setReturnOriginTimeSlots([]);
                setReturnDestTimeSlots([]);
                setIsDistanceCalculated(prev => ({ ...prev, down: false }));
                setNewRoute(prev => ({ ...prev, downTotalDistance: '', downDurationHours: '', downDurationMinutes: '', downOriginDepTime: '', downDestArrTime: '', downManualFinalLeg: '', downManualFirstLeg: '' }));
                setActiveRouteTab('UP');
                toast.info('Return route disabled');
            }
        };
    
        const handleTabSwitch = (tab) => {
            if (tab === 'DOWN' && upStops.length > 0 && isRoundTrip) {
                if (isMultiTrip) {
                    if (returnOriginTimeSlots.length === 0 && destinationTimeSlots.length > 0) setReturnOriginTimeSlots(destinationTimeSlots.map(slot => ({ sequence: slot.sequence, departureTime: slot.arrivalTime || '', arrivalTime: '', fareMultiplier: slot.fareMultiplier || 1.0, isActive: true })));
                    if (returnDestTimeSlots.length === 0 && timeSlots.length > 0) setReturnDestTimeSlots(timeSlots.map(slot => ({ sequence: slot.sequence, arrivalTime: slot.departureTime || '', departureTime: '', fareMultiplier: slot.fareMultiplier || 1.0, isActive: true })));
                }
                if (downStops.length === 0) syncDownStopsWithUpStops(false);
                else if (downStops.length > 0) {
                    const hasStaleData = downStops.some(stop => isMultiTrip ? (!stop.timings || stop.timings.length === 0) : !stop.arrivalTime);
                    if (hasStaleData && window.confirm("Return route stops are missing timing information. Would you like to sync with UP route?")) syncDownStopsWithUpStops(false);
                }
            }
            setActiveRouteTab(tab);
            clearStopForm();
        };
    
        const getActiveStops = () => activeRouteTab === 'UP' ? upStops : downStops;
        const setActiveStops = (stops) => { if (activeRouteTab === 'UP') setUpStops(stops); else setDownStops(stops); };
    
        const clearStopForm = () => {
            let defaultState = '';
            if (activeRouteTab === 'UP') {
                if (upStops.length > 0) { const lastStop = upStops[upStops.length - 1]; if (lastStop.state && lastStop.state.trim()) defaultState = lastStop.state; }
                if (!defaultState && newRoute.upOriginState && newRoute.upOriginState.trim()) defaultState = newRoute.upOriginState;
                if (!defaultState && newRoute.upDestState && newRoute.upDestState.trim()) defaultState = newRoute.upDestState;
            } else if (activeRouteTab === 'DOWN') {
                if (downStops.length > 0) { const lastStop = downStops[downStops.length - 1]; if (lastStop.state && lastStop.state.trim()) defaultState = lastStop.state; }
                if (!defaultState && newRoute.upOriginState && newRoute.upOriginState.trim()) defaultState = newRoute.upOriginState;
                if (!defaultState && newRoute.upDestState && newRoute.upDestState.trim()) defaultState = newRoute.upDestState;
            }
            setNewRoute(prev => ({ ...prev, stopCity: '', stopState: defaultState, stopAddress: '', stopTerminal: '', stopArrivalTime: '', stopDepartureTime: '', stopCoords: null, stopDistFromPrev: '', stopDistToNext: '', isBoarding: false, isDropping: false, stopTimings: [] }));
            setIsManualDistance(false);
            setEditingStopIndex(null);
            setInsertIndex(null);
            setIsManualStop(true);
        };
    
        const addIntermediateStop = (type = 'up') => {
            if (!newRoute.stopCity) { toast.error('City is required.'); return; }
            if (isMultiTrip && (!newRoute.stopTimings || newRoute.stopTimings.length === 0)) { toast.warning('Please add at least one trip timing for this stop'); return; }
            if (!isMultiTrip && !newRoute.stopArrivalTime) { toast.error('Arrival Time is required.'); return; }
    
            let coordinates = newRoute.stopCoords;
            let manualDistFromPrev = null, manualDistToNext = null, distanceFromOrigin = 0;
            const stops = getActiveStops();
            const isManualLocation = isManualStop || !newRoute.stopCoords || (newRoute.stopCoords.lat === 0 && newRoute.stopCoords.lng === 0);
    
            if (isManualLocation) {
                if (!newRoute.stopDistFromPrev || parseFloat(newRoute.stopDistFromPrev) <= 0) { toast.error('For manual stops, please provide distance from previous stop'); return; }
                coordinates = { lat: 0, lng: 0 };
                manualDistFromPrev = parseFloat(newRoute.stopDistFromPrev);
                if (stops.length > 0) {
                    const lastStop = stops[stops.length - 1];
                    distanceFromOrigin = parseFloat(((lastStop.distanceFromOrigin || 0) + manualDistFromPrev).toFixed(2));
                } else distanceFromOrigin = manualDistFromPrev;
    
                const currentIndex = editingStopIndex !== null ? editingStopIndex : (insertIndex !== null ? insertIndex : stops.length);
                const nextStop = stops[currentIndex];
                const isNextAuto = nextStop && nextStop.coordinates && (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);
                if (isNextAuto && newRoute.stopDistToNext && parseFloat(newRoute.stopDistToNext) > 0) manualDistToNext = parseFloat(newRoute.stopDistToNext);
            } else if (newRoute.stopCoords && (newRoute.stopCoords.lat !== 0 || newRoute.stopCoords.lng !== 0)) distanceFromOrigin = 0;
    
            let stopType = 'none';
            if (newRoute.isBoarding && newRoute.isDropping) stopType = 'both';
            else if (newRoute.isBoarding) stopType = 'boarding';
            else if (newRoute.isDropping) stopType = 'dropping';
    
            let autoState = newRoute.stopState;
            if (!autoState || !autoState.trim()) {
                if (type === 'up' && upStops.length > 0) { const lastStop = upStops[upStops.length - 1]; if (lastStop.state && lastStop.state.trim()) autoState = lastStop.state; }
                else if (type === 'down' && downStops.length > 0) { const lastStop = downStops[downStops.length - 1]; if (lastStop.state && lastStop.state.trim()) autoState = lastStop.state; }
                if (!autoState && newRoute.upOriginState) autoState = newRoute.upOriginState;
                if (!autoState && newRoute.upDestState) autoState = newRoute.upDestState;
            }
    
            const newStop = {
                city: newRoute.stopCity,
                state: autoState || newRoute.stopState || '',
                address: newRoute.stopAddress || `${newRoute.stopCity}, ${autoState || 'India'}`,
                terminal: newRoute.stopTerminal || `${newRoute.stopCity} Bus Stand`,
                arrivalTime: isMultiTrip ? '' : newRoute.stopArrivalTime,
                departureTime: isMultiTrip ? '' : (newRoute.stopDepartureTime || newRoute.stopArrivalTime),
                timings: isMultiTrip ? (newRoute.stopTimings || []).map(t => ({ timeSlotSequence: t.timeSlotSequence, arrivalTime: t.arrivalTime, departureTime: t.departureTime || t.arrivalTime })) : [],
                stopType, coordinates, manualDistFromPrev, manualDistToNext, distanceFromOrigin,
                isManualStop: isManualLocation
            };
    
            setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));
    
            let currentStops = type === 'up' ? [...upStops] : [...downStops];
            let editingIndex = null;
            if (type === 'up' && editUpIndex !== null) editingIndex = editUpIndex;
            else if (type === 'down' && editDownIndex !== null) editingIndex = editDownIndex;
    
            if (editingIndex !== null) {
                currentStops[editingIndex] = { ...currentStops[editingIndex], ...newStop, sequence: editingIndex + 1 };
                if (type === 'up') setEditUpIndex(null); else setEditDownIndex(null);
                setEditingStopIndex(null);
                toast.success(`Stop "${newRoute.stopCity}" updated successfully`);
            } else if (insertIndex !== null) {
                currentStops.splice(insertIndex, 0, newStop);
                setInsertIndex(null);
                toast.success(`Stop inserted at position ${insertIndex + 1}`);
            } else {
                currentStops.push(newStop);
                toast.success(`Stop "${newRoute.stopCity}" added successfully`);
            }
    
            if (type === 'up') setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
            else setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
    
            clearStopForm();
        };
    
        useEffect(() => {
            if (stopEditForm.timings && stopEditForm.timings.length > 0) setStopEditForm(prev => ({ ...prev, tripCount: stopEditForm.timings.length }));
        }, [stopEditForm.timings]);
    
        // ---------- handleEditPendingRoute (unchanged) ----------
        const handleEditPendingRoute = async (route) => {
            try {
                const response = await getPendingRouteById(route.id, token);
                const routeData = response.success ? response.data : route.fullData;
                if (!routeData) { toast.error('Failed to load pending route for editing'); return; }
    
                setIsEditingPending(true);
                setEditingPendingId(route.pendingId || route.id);
                setEditingRoute(routeData);
    
                const resolvedIsMultiTrip = routeData.isMultiTrip ||
                    (routeData.origin?.timings && routeData.origin.timings.length > 0) ||
                    (routeData.intermediateStops && routeData.intermediateStops.some(stop => stop.timings && stop.timings.length > 0)) ||
                    (routeData.numberOfTrips && routeData.numberOfTrips > 1);
    
                setEditIsMultiTrip(resolvedIsMultiTrip);
    
                let resolvedNumberOfTrips = 1;
                if (resolvedIsMultiTrip) {
                    resolvedNumberOfTrips = routeData.numberOfTrips || routeData.origin?.timings?.length ||
                        (routeData.intermediateStops && routeData.intermediateStops.length > 0 ? routeData.intermediateStops[0]?.timings?.length || 1 : 1);
                    setEditNumberOfTrips(resolvedNumberOfTrips);
                } else setEditNumberOfTrips(1);
    
                const origin = routeData.origin || {};
                const destination = routeData.destination || {};
                const routeDetails = routeData.routeDetails || {};
                const estimatedDuration = routeDetails.estimatedDuration || {};
    
                const transformStops = (stops) => {
                    return (stops || []).map((stop, index, array) => {
                        const actualDist = stop.distanceFromOrigin || 0;
                        const prevStop = index > 0 ? array[index - 1] : null;
                        const prevDist = prevStop ? (prevStop.distanceFromOrigin || 0) : 0;
                        let manualDistFromPrev = stop.manualDistFromPrev ? parseFloat(stop.manualDistFromPrev) : null;
                        if (!manualDistFromPrev && actualDist > 0) {
                            const calculated = parseFloat((actualDist - prevDist).toFixed(1));
                            if (calculated > 0) manualDistFromPrev = calculated;
                        }
                        const sortedTimings = sortTimings(stop.timings || []);
                        const hasMultiTimings = sortedTimings.length > 0;
                        let finalTimings = sortedTimings;
                        if (resolvedIsMultiTrip && sortedTimings.length < resolvedNumberOfTrips) {
                            const existingSequences = sortedTimings.map(t => t.timeSlotSequence);
                            finalTimings = [...sortedTimings];
                            for (let i = 1; i <= resolvedNumberOfTrips; i++) {
                                if (!existingSequences.includes(i)) finalTimings.push({ timeSlotSequence: i, arrivalTime: '', departureTime: '' });
                            }
                            finalTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
                        } else if (resolvedIsMultiTrip && sortedTimings.length > resolvedNumberOfTrips) {
                            finalTimings = sortedTimings.filter(t => t.timeSlotSequence <= resolvedNumberOfTrips).map((t, i) => ({ ...t, timeSlotSequence: i + 1 }));
                        }
                        return {
                            city: stop.city, state: stop.state || '', address: stop.address || '', terminal: stop.terminal || '',
                            arrivalTime: hasMultiTimings ? '' : (stop.arrivalTime || ''),
                            departureTime: hasMultiTimings ? '' : (stop.departureTime || ''),
                            timings: finalTimings,
                            stopType: stop.stopType || 'none',
                            coordinates: stop.coordinates || { lat: 0, lng: 0 },
                            distanceFromOrigin: actualDist,
                            manualDistFromPrev,
                            manualDistToNext: stop.manualDistToNext ? parseFloat(stop.manualDistToNext) : null,
                            isManualStop: stop.isManualStop === true || !stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0)
                        };
                    });
                };
    
                const transformedStops = transformStops(routeData.intermediateStops);
    
                let forwardManualFinalLeg = '';
                if (routeDetails.totalDistance && transformedStops.length > 0) {
                    const lastStopDist = transformedStops[transformedStops.length - 1].distanceFromOrigin || 0;
                    const calculated = routeDetails.totalDistance - lastStopDist;
                    if (calculated > 0) forwardManualFinalLeg = calculated.toFixed(1);
                }
    
                const originTimings = sortTimings(origin.timings || []);
                const destTimings = sortTimings(destination.timings || []);
    
                let finalOriginTimings = [...originTimings];
                if (resolvedIsMultiTrip && originTimings.length < resolvedNumberOfTrips) {
                    const existingSequences = originTimings.map(t => t.timeSlotSequence);
                    for (let i = 1; i <= resolvedNumberOfTrips; i++) {
                        if (!existingSequences.includes(i)) finalOriginTimings.push({ timeSlotSequence: i, departureTime: '', arrivalTime: '' });
                    }
                    finalOriginTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
                }
    
                let finalDestTimings = [...destTimings];
                if (resolvedIsMultiTrip && destTimings.length < resolvedNumberOfTrips) {
                    const existingSequences = destTimings.map(t => t.timeSlotSequence);
                    for (let i = 1; i <= resolvedNumberOfTrips; i++) {
                        if (!existingSequences.includes(i)) finalDestTimings.push({ timeSlotSequence: i, arrivalTime: '', departureTime: '' });
                    }
                    finalDestTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
                }
    
                setEditForm({
                    routeNumber: routeData.routeNumber || '', routeName: routeData.routeName || '', localRouteName: routeData.localRouteName || '',
                    isMultiTrip: resolvedIsMultiTrip, numberOfTrips: resolvedNumberOfTrips, timeSlots: routeData.timeSlots || [],
                    originCity: origin.city || '', originState: origin.state || '', originAddress: origin.address || '', originTerminal: origin.terminal || '',
                    originDepTime: origin.departureTime || '', originCoords: origin.coordinates || { lat: 0, lng: 0 }, originTimings: finalOriginTimings,
                    destCity: destination.city || '', destState: destination.state || '', destAddress: destination.address || '', destTerminal: destination.terminal || '',
                    destArrTime: destination.arrivalTime || '', destCoords: destination.coordinates || { lat: 0, lng: 0 }, destTimings: finalDestTimings,
                    totalDistance: routeDetails.totalDistance || '', durationHours: estimatedDuration.hours || '', durationMinutes: estimatedDuration.minutes || '',
                    intermediateStops: transformedStops, isActive: false, isRoundTrip: routeData.isRoundTrip || false,
                    returnJourney: routeData.returnJourney || null,
                    upManualFinalLeg: forwardManualFinalLeg,
                    upManualFirstLeg: transformedStops.length > 0 && transformedStops[0].manualDistFromPrev ? String(transformedStops[0].manualDistFromPrev) : ''
                });
    
                if (transformedStops.length > 0) {
                    setUpStops(transformedStops);
                    if (transformedStops.every(stop => stop.distanceFromOrigin > 0)) setIsDistanceCalculated(prev => ({ ...prev, up: true }));
                } else setUpStops([]);
    
                if (routeData.isRoundTrip && routeData.returnJourney) {
                    const returnJourney = routeData.returnJourney;
                    const returnOrigin = returnJourney.origin || {};
                    const returnDestination = returnJourney.destination || {};
                    const returnRouteDetails = returnJourney.routeDetails || {};
                    const returnEstimatedDuration = returnRouteDetails.estimatedDuration || {};
                    const transformedReturnStops = transformStops(returnJourney.intermediateStops);
    
                    let returnManualFinalLeg = '';
                    if (returnRouteDetails.totalDistance && transformedReturnStops.length > 0) {
                        const lastStopDist = transformedReturnStops[transformedReturnStops.length - 1].distanceFromOrigin || 0;
                        const calculated = returnRouteDetails.totalDistance - lastStopDist;
                        if (calculated > 0) returnManualFinalLeg = calculated.toFixed(1);
                    }
    
                    const returnOriginTimings = sortTimings(returnOrigin.timings || []);
                    const returnDestTimings = sortTimings(returnDestination.timings || []);
    
                    setEditForm(prev => ({
                        ...prev,
                        returnOriginCity: returnOrigin.city || destination.city || '',
                        returnOriginState: returnOrigin.state || destination.state || '',
                        returnOriginAddress: returnOrigin.address || destination.address || '',
                        returnOriginTerminal: returnOrigin.terminal || destination.terminal || '',
                        returnOriginDepTime: returnOrigin.departureTime || '',
                        returnOriginCoords: returnOrigin.coordinates || destination.coordinates || { lat: 0, lng: 0 },
                        returnOriginTimings,
                        returnDestCity: returnDestination.city || origin.city || '',
                        returnDestState: returnDestination.state || origin.state || '',
                        returnDestAddress: returnDestination.address || origin.address || '',
                        returnDestTerminal: returnDestination.terminal || origin.terminal || '',
                        returnDestArrTime: returnDestination.arrivalTime || '',
                        returnDestCoords: returnDestination.coordinates || origin.coordinates || { lat: 0, lng: 0 },
                        returnDestTimings,
                        returnTotalDistance: returnRouteDetails.totalDistance || routeDetails.totalDistance || '',
                        returnDurationHours: returnEstimatedDuration.hours || estimatedDuration.hours || '',
                        returnDurationMinutes: returnEstimatedDuration.minutes || estimatedDuration.minutes || '',
                        returnIntermediateStops: transformedReturnStops,
                        returnManualFinalLeg,
                        returnManualFirstLeg: transformedReturnStops.length > 0 && transformedReturnStops[0].manualDistFromPrev ? String(transformedReturnStops[0].manualDistFromPrev) : ''
                    }));
    
                    setDownStops(transformedReturnStops);
                    if (transformedReturnStops.length > 0 && transformedReturnStops.every(s => s.distanceFromOrigin > 0)) setIsDistanceCalculated(prev => ({ ...prev, down: true }));
                } else setDownStops([]);
    
                setIsRoundTrip(routeData.isRoundTrip || false);
                setActiveRouteTab('UP');
                setShowEditModal(true);
            } catch (err) {
                console.error('Error fetching pending route for edit:', err);
                toast.error('Failed to load pending route for editing');
            }
        };
    
        const handleEditStop = (index, type) => {
            const stops = type === 'up' ? upStops : downStops;
            const stop = stops[index];
            if (!stop) return;
    
            let numTrips = 1;
            if (stop.timings && stop.timings.length > 0) numTrips = stop.timings.length;
            else if (editForm.numberOfTrips && editForm.numberOfTrips > 1) numTrips = editForm.numberOfTrips;
            else if (editNumberOfTrips && editNumberOfTrips > 1) numTrips = editNumberOfTrips;
            else if (timeSlots && timeSlots.length > 0) numTrips = timeSlots.length;
            else if (numberOfTrips && numberOfTrips > 1) numTrips = numberOfTrips;
    
            let stopTimings = stop.timings || [];
            if (stopTimings.length > 0) numTrips = stopTimings.length;
    
            const existingTimingsMap = new Map();
            stopTimings.forEach(t => { existingTimingsMap.set(t.timeSlotSequence || 1, t); });
    
            const allTimings = [];
            for (let i = 1; i <= numTrips; i++) {
                if (existingTimingsMap.has(i)) {
                    allTimings.push({ timeSlotSequence: i, arrivalTime: existingTimingsMap.get(i).arrivalTime || '', departureTime: existingTimingsMap.get(i).departureTime || '' });
                } else allTimings.push({ timeSlotSequence: i, arrivalTime: '', departureTime: '' });
            }
            allTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
    
            let isBoarding = false, isDropping = false;
            if (stop.stopType === 'boarding' || stop.stopType === 'both') isBoarding = true;
            if (stop.stopType === 'dropping' || stop.stopType === 'both') isDropping = true;
            if (stop.isBoarding !== undefined) isBoarding = stop.isBoarding || isBoarding;
            if (stop.isDropping !== undefined) isDropping = stop.isDropping || isDropping;
    
            setStopBeingEdited({ index, originalStop: stop, type });
    
            setStopEditForm({
                city: stop.city || '', state: stop.state || '', address: stop.address || '', terminal: stop.terminal || '',
                arrivalTime: stop.arrivalTime || '', departureTime: stop.departureTime || '',
                isBoarding, isDropping,
                isManualStop: stop.isManualStop || false,
                manualDistFromPrev: stop.manualDistFromPrev || '', manualDistToNext: stop.manualDistToNext || '',
                timings: allTimings, coordinates: stop.coordinates || null,
                isMultiTrip: editForm.isMultiTrip || editIsMultiTrip || true,
                tripCount: allTimings.length || numTrips
            });
    
            setShowStopEditModal(true);
        };
    
        const saveEditedStop = () => {
            if (!stopEditForm.city || stopEditForm.city.trim() === '') { toast.error('City is required'); return; }
            if (!stopEditForm.state || stopEditForm.state.trim() === '') { toast.error('State is required'); return; }
            if (!stopEditForm.address || stopEditForm.address.trim() === '') { toast.error('Address is required'); return; }
            if (!stopEditForm.terminal || stopEditForm.terminal.trim() === '') { toast.error('Terminal is required'); return; }
    
            const totalTrips = editForm.numberOfTrips || editNumberOfTrips || numberOfTrips || 1;
            const hasTimings = stopEditForm.timings && stopEditForm.timings.length > 0;
            const hasArrivalInTimings = hasTimings && stopEditForm.timings.some(t => t.arrivalTime && t.arrivalTime.trim() !== '');
            const hasTopLevelArrival = stopEditForm.arrivalTime && stopEditForm.arrivalTime.trim() !== '';
    
            let finalTimings = [];
            const isActuallyMultiTrip = (editForm.isMultiTrip || editIsMultiTrip || isMultiTrip) || totalTrips > 1;
    
            if (isActuallyMultiTrip) {
                if (hasTimings) {
                    if (hasArrivalInTimings) finalTimings = stopEditForm.timings.map(t => ({ timeSlotSequence: t.timeSlotSequence || 1, arrivalTime: t.arrivalTime || '', departureTime: t.departureTime || t.arrivalTime || '' }));
                    else if (hasTopLevelArrival) finalTimings = stopEditForm.timings.map((t, index) => ({ timeSlotSequence: t.timeSlotSequence || (index + 1), arrivalTime: stopEditForm.arrivalTime || '', departureTime: stopEditForm.departureTime || stopEditForm.arrivalTime || '' }));
                    else for (let i = 1; i <= totalTrips; i++) finalTimings.push({ timeSlotSequence: i, arrivalTime: stopEditForm.arrivalTime || '', departureTime: stopEditForm.departureTime || stopEditForm.arrivalTime || '' });
                } else {
                    for (let i = 1; i <= totalTrips; i++) finalTimings.push({ timeSlotSequence: i, arrivalTime: stopEditForm.arrivalTime || '', departureTime: stopEditForm.departureTime || stopEditForm.arrivalTime || '' });
                }
                const missingArrival = finalTimings.some(t => !t.arrivalTime || t.arrivalTime.trim() === '');
                if (missingArrival) { toast.error('Please provide arrival time for all trips'); return; }
            } else {
                if (!stopEditForm.arrivalTime || stopEditForm.arrivalTime.trim() === '') { toast.error('Arrival time is required'); return; }
                finalTimings = [{ timeSlotSequence: 1, arrivalTime: stopEditForm.arrivalTime, departureTime: stopEditForm.departureTime || stopEditForm.arrivalTime }];
            }
    
            finalTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
    
            const isManualLocation = stopEditForm.isManualStop;
            let manualDistFromPrev = null, manualDistToNext = null;
    
            if (stopEditForm.manualDistFromPrev && parseFloat(stopEditForm.manualDistFromPrev) > 0) manualDistFromPrev = parseFloat(stopEditForm.manualDistFromPrev);
            if (stopEditForm.manualDistToNext && parseFloat(stopEditForm.manualDistToNext) > 0) manualDistToNext = parseFloat(stopEditForm.manualDistToNext);
    
            let distanceFromOrigin = stopBeingEdited.originalStop.distanceFromOrigin || 0;
            if (manualDistFromPrev && manualDistFromPrev > 0) {
                const stops = stopBeingEdited.type === 'up' ? upStops : downStops;
                if (stopBeingEdited.index === 0) distanceFromOrigin = manualDistFromPrev;
                else {
                    const prevStop = stops[stopBeingEdited.index - 1];
                    const prevDistance = prevStop?.distanceFromOrigin || 0;
                    distanceFromOrigin = parseFloat((prevDistance + manualDistFromPrev).toFixed(2));
                }
            }
    
            let stopType = 'none';
            if (stopEditForm.isBoarding && stopEditForm.isDropping) stopType = 'both';
            else if (stopEditForm.isBoarding) stopType = 'boarding';
            else if (stopEditForm.isDropping) stopType = 'dropping';
    
            const updatedStop = {
                ...stopBeingEdited.originalStop,
                city: stopEditForm.city, state: stopEditForm.state || '',
                address: stopEditForm.address || `${stopEditForm.city}, ${stopEditForm.state || 'India'}`,
                terminal: stopEditForm.terminal || `${stopEditForm.city} Bus Stand`,
                stopType,
                coordinates: isManualLocation ? { lat: 0, lng: 0 } : stopBeingEdited.originalStop.coordinates,
                manualDistFromPrev, manualDistToNext, distanceFromOrigin,
                isManualStop: isManualLocation,
                timings: finalTimings,
                arrivalTime: finalTimings.length > 0 ? finalTimings[0].arrivalTime || '' : '',
                departureTime: finalTimings.length > 0 ? finalTimings[0].departureTime || finalTimings[0].arrivalTime || '' : ''
            };
    
            const { index, type } = stopBeingEdited;
            setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));
    
            if (type === 'up') {
                const updated = [...upStops];
                updated[index] = { ...updatedStop, sequence: index + 1 };
                setUpStops(updated);
                if (isRoundTrip) toast.info('UP route updated. Use "Auto-Fill / Sync Reversed Stops" to update DOWN route if needed.');
            } else {
                const updated = [...downStops];
                updated[index] = { ...updatedStop, sequence: index + 1 };
                setDownStops(updated);
            }
    
            setShowStopEditModal(false);
            setStopBeingEdited(null);
            toast.success('Stop updated successfully');
        };
    
        const handleDeleteStop = (index) => {
            const isUp = activeRouteTab === 'UP';
            setIsDistanceCalculated(prev => ({ ...prev, [isUp ? 'up' : 'down']: false }));
            if (isUp) {
                const updated = upStops.filter((_, i) => i !== index);
                setUpStops(updated.map((s, i) => ({ ...s, sequence: i + 1 })));
                if (editingStopIndex === index && editUpIndex === index) clearStopForm();
            } else {
                const updated = downStops.filter((_, i) => i !== index);
                setDownStops(updated.map((s, i) => ({ ...s, sequence: i + 1 })));
                if (editingStopIndex === index && editDownIndex === index) clearStopForm();
            }
        };
    
        const checkOriginManual = () => isOriginManual || !newRoute.upOriginCoords || (newRoute.upOriginCoords.lat === 0 && newRoute.upOriginCoords.lng === 0);
        const checkDestinationManual = () => isDestinationManual || !newRoute.upDestCoords || (newRoute.upDestCoords.lat === 0 && newRoute.upDestCoords.lng === 0);
    
        // ---------- handleCalculateDistances (unchanged) ----------
        const handleCalculateDistances = async () => {
            const isUp = activeRouteTab === 'UP';
            const stops = isUp ? upStops : downStops;
    
            if (!newRoute.upOriginCity || !newRoute.upDestCity) { toast.error("Main Route Origin and Destination required."); return; }
            if (!newRoute.upOriginCoords) { toast.error('Please select Origin from suggestions to get coordinates'); return; }
            if (!newRoute.upDestCoords) { toast.error('Please select Destination from suggestions to get coordinates'); return; }
    
            let originNode, destNode;
            if (isUp) {
                originNode = { id: 'origin', name: newRoute.upOriginCity, lat: newRoute.upOriginCoords?.lat || 0, lng: newRoute.upOriginCoords?.lng || 0 };
                destNode = { id: 'destination', name: newRoute.upDestCity, lat: newRoute.upDestCoords?.lat || 0, lng: newRoute.upDestCoords?.lng || 0 };
            } else {
                originNode = { id: 'origin', name: newRoute.upDestCity, lat: newRoute.upDestCoords?.lat || 0, lng: newRoute.upDestCoords?.lng || 0 };
                destNode = { id: 'destination', name: newRoute.upOriginCity, lat: newRoute.upOriginCoords?.lat || 0, lng: newRoute.upOriginCoords?.lng || 0 };
            }
    
            setIsCalculatingDistances(true);
            toast.info(`Calculating ${activeRouteTab} route distances...`);
    
            let departureTimeForDuration = '', arrivalTimeForDuration = '';
            if (isUp) {
                if (isMultiTrip) {
                    if (timeSlots && timeSlots.length > 0) departureTimeForDuration = timeSlots[0]?.departureTime || '';
                    if (destinationTimeSlots && destinationTimeSlots.length > 0) arrivalTimeForDuration = destinationTimeSlots[0]?.arrivalTime || '';
                } else { departureTimeForDuration = newRoute.upOriginDepTime; arrivalTimeForDuration = newRoute.upDestArrTime; }
            } else {
                if (isMultiTrip) {
                    if (returnOriginTimeSlots && returnOriginTimeSlots.length > 0) departureTimeForDuration = returnOriginTimeSlots[0]?.departureTime || '';
                    if (returnDestTimeSlots && returnDestTimeSlots.length > 0) arrivalTimeForDuration = returnDestTimeSlots[0]?.arrivalTime || '';
                } else { departureTimeForDuration = newRoute.downOriginDepTime; arrivalTimeForDuration = newRoute.downDestArrTime; }
            }
    
            try {
                const stopNodes = stops.map((s, i) => ({
                    id: `stop_${i}`, name: s.city,
                    lat: s.coordinates?.lat, lng: s.coordinates?.lng,
                    manualFromPrev: s.manualDistFromPrev, manualToNext: s.manualDistToNext,
                    isManual: s.isManualStop === true || !s.coordinates || (s.coordinates.lat === 0 && s.coordinates.lng === 0),
                    originalStop: s
                }));
    
                const fullPath = [originNode, ...stopNodes, destNode];
                const validNodes = fullPath.filter(s => s.lat && s.lng && s.lat !== 0 && s.lng !== 0 && !s.isManual);
    
                let matrixResponse = null;
                if (validNodes.length >= 2) matrixResponse = await getDistanceMatrix(validNodes, validNodes);
    
                let cumulativeDist = 0, lastAutoNodeIndex = -1, sumManualSinceLastAuto = 0, validNodeCounter = -1, prevCumulativeDist = 0, firstStopAlreadyCounted = false;
                const updatedStops = [];
    
                if (stops.length > 0 && stops[0]) {
                    const isFirstStopManual = stopNodes[0].isManual;
                    if (isFirstStopManual && stopNodes[0].manualFromPrev && parseFloat(stopNodes[0].manualFromPrev) > 0) {
                        cumulativeDist = parseFloat(stopNodes[0].manualFromPrev);
                        sumManualSinceLastAuto = cumulativeDist;
                        prevCumulativeDist = cumulativeDist;
                        firstStopAlreadyCounted = true;
                    } else if ((checkOriginManual() && !isFirstStopManual) || (!checkOriginManual() && isFirstStopManual)) {
                        const firstLeg = parseFloat(isUp ? newRoute.upManualFirstLeg : newRoute.downManualFirstLeg);
                        if (!firstLeg || parseFloat(firstLeg) <= 0) { toast.error('Please provide distance from origin to first stop.'); setIsCalculatingDistances(false); return; }
                        cumulativeDist = parseFloat(firstLeg);
                        sumManualSinceLastAuto = cumulativeDist;
                        prevCumulativeDist = cumulativeDist;
                        firstStopAlreadyCounted = true;
                    } else if (!checkOriginManual() && !isFirstStopManual) { lastAutoNodeIndex = 0; validNodeCounter = 0; }
                    else if (checkOriginManual() && isFirstStopManual) {
                        if (stopNodes[0].manualFromPrev && parseFloat(stopNodes[0].manualFromPrev) > 0) {
                            cumulativeDist = parseFloat(stopNodes[0].manualFromPrev);
                            prevCumulativeDist = cumulativeDist;
                            firstStopAlreadyCounted = true;
                        } else { cumulativeDist = 0; prevCumulativeDist = 0; }
                    }
                }
    
                for (let i = 0; i < stopNodes.length; i++) {
                    const currNode = stopNodes[i];
                    const isManual = currNode.isManual;
                    let segment = 0;
    
                    if (isManual) {
                        if (currNode.manualFromPrev === null || currNode.manualFromPrev === undefined || currNode.manualFromPrev === '') {
                            toast.error(`Manual stop '${currNode.name}' is missing distance from previous stop. Please edit and provide the distance.`);
                            setIsCalculatingDistances(false); return;
                        }
                        segment = parseFloat(currNode.manualFromPrev) || 0;
                        if (!(i === 0 && firstStopAlreadyCounted)) {
                            if (segment <= 0 && i > 0) toast.warning(`Manual stop '${currNode.name}' has distance 0 from previous stop.`);
                            cumulativeDist += segment;
                            sumManualSinceLastAuto += segment;
                        }
                        prevCumulativeDist = i === 0 && firstStopAlreadyCounted ? segment : cumulativeDist;
                        updatedStops.push({ ...stops[i], distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)), manualDistFromPrev: parseFloat(segment.toFixed(1)), manualDistToNext: currNode.manualToNext ? parseFloat(currNode.manualToNext) : null });
                        if (currNode.manualToNext && parseFloat(currNode.manualToNext) > 0) sumManualSinceLastAuto = parseFloat(currNode.manualToNext);
                    } else {
                        validNodeCounter++;
                        let apiDistance = 0;
                        let matrixOriginIndex = lastAutoNodeIndex;
                        let matrixDestIndex = validNodeCounter;
    
                        if (checkOriginManual() && lastAutoNodeIndex === -1 && i === 0) { matrixOriginIndex = 0; matrixDestIndex = validNodeCounter; }
                        else if (checkOriginManual() && lastAutoNodeIndex !== -1) { matrixOriginIndex = lastAutoNodeIndex; matrixDestIndex = validNodeCounter; }
                        else if (!checkOriginManual() && lastAutoNodeIndex === -1) { matrixOriginIndex = 0; matrixDestIndex = validNodeCounter; }
    
                        if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
                            const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
                            if (element?.status === 'OK') apiDistance = element.distance.value / 1000;
                        }
    
                        if (i > 0 && stopNodes[i - 1]?.manualToNext && parseFloat(stopNodes[i - 1].manualToNext) > 0) {
                            segment = parseFloat(stopNodes[i - 1].manualToNext);
                            sumManualSinceLastAuto = 0;
                        } else {
                            segment = apiDistance - sumManualSinceLastAuto;
                            if (segment < 0) segment = 0;
                            sumManualSinceLastAuto = 0;
                        }
    
                        cumulativeDist += segment;
                        if (lastAutoNodeIndex === -1) lastAutoNodeIndex = validNodeCounter;
                        if (matrixOriginIndex >= 0) lastAutoNodeIndex = validNodeCounter;
                        const distanceFromPrev = cumulativeDist - prevCumulativeDist;
                        prevCumulativeDist = cumulativeDist;
                        updatedStops.push({ ...stops[i], distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)), manualDistFromPrev: parseFloat(distanceFromPrev.toFixed(1)), manualDistToNext: currNode.manualToNext ? parseFloat(currNode.manualToNext) : null });
                    }
                }
    
                validNodeCounter++;
                let finalSegment = 0;
                const lastStop = stopNodes[stopNodes.length - 1];
                const isLastStopManualFlag = lastStop && lastStop.isManual;
                const isDestManual = checkDestinationManual();
    
                if (isDestManual) {
                    const finalLeg = parseFloat(isUp ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg);
                    if (isNaN(finalLeg) || finalLeg <= 0) { toast.error(`Destination is manual. Please provide distance from last stop to destination in the Summary section.`); setIsCalculatingDistances(false); return; }
                    finalSegment = finalLeg;
                } else if (!isDestManual && isLastStopManualFlag) {
                    if (lastStop.manualToNext && parseFloat(lastStop.manualToNext) > 0) finalSegment = parseFloat(lastStop.manualToNext);
                    else {
                        const finalLeg = parseFloat(isUp ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg);
                        if (!isNaN(finalLeg) && finalLeg > 0) finalSegment = finalLeg;
                        else {
                            const totalDist = parseFloat(isUp ? newRoute.upTotalDistance : newRoute.downTotalDistance) || 0;
                            const lastStopDist = updatedStops.length > 0 ? (updatedStops[updatedStops.length - 1].distanceFromOrigin || 0) : 0;
                            const derived = parseFloat((totalDist - lastStopDist).toFixed(1));
                            if (derived > 0) finalSegment = derived;
                            else { toast.error(`Last stop is manual and destination has GPS. Please enter the distance to destination in the Summary section, or set "Distance to Next Stop" on the last stop.`); setIsCalculatingDistances(false); return; }
                        }
                    }
                } else if (!isDestManual && !isLastStopManualFlag && stopNodes.length > 0) {
                    let apiDistance = 0;
                    let matrixOriginIndex = lastAutoNodeIndex;
                    let matrixDestIndex = validNodeCounter;
    
                    if (checkOriginManual() && lastAutoNodeIndex === -1) { matrixOriginIndex = 0; matrixDestIndex = validNodeCounter; }
                    else if (checkOriginManual() && lastAutoNodeIndex !== -1) { matrixOriginIndex = lastAutoNodeIndex; matrixDestIndex = validNodeCounter; }
    
                    if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
                        const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
                        if (element?.status === 'OK') apiDistance = element.distance.value / 1000;
                    }
                    finalSegment = apiDistance - sumManualSinceLastAuto;
                    if (finalSegment < 0) finalSegment = 0;
                } else if (stopNodes.length === 0) {
                    if (checkOriginManual() && isDestManual) {
                        const totalDistance = parseFloat(newRoute.upTotalDistance);
                        if (isNaN(totalDistance) || totalDistance <= 0) { toast.error('Both origin and destination are manual. Please provide total distance.'); setIsCalculatingDistances(false); return; }
                        finalSegment = totalDistance;
                    } else if (!checkOriginManual() && !isDestManual && matrixResponse) {
                        const element = matrixResponse.rows[0]?.elements[1];
                        if (element?.status === 'OK') finalSegment = element.distance.value / 1000;
                        else { toast.error('Could not calculate distance. Please check addresses or enter manually.'); setIsCalculatingDistances(false); return; }
                    } else { toast.error('Cannot calculate distance. Please ensure both origin and destination have coordinates or provide manual total distance.'); setIsCalculatingDistances(false); return; }
                }
    
                cumulativeDist += finalSegment;
                if (updatedStops.length > 0 && finalSegment > 0) {
                    const lastIndex = updatedStops.length - 1;
                    updatedStops[lastIndex] = { ...updatedStops[lastIndex], manualDistToNext: parseFloat(finalSegment.toFixed(1)) };
                }
    
                setActiveStops(updatedStops);
    
                let calculatedHours = 0, calculatedMinutes = 0;
                if (departureTimeForDuration && departureTimeForDuration.trim() !== '' && arrivalTimeForDuration && arrivalTimeForDuration.trim() !== '') {
                    const [depHour, depMin] = departureTimeForDuration.split(':').map(Number);
                    const [arrHour, arrMin] = arrivalTimeForDuration.split(':').map(Number);
                    let depTotalMins = depHour * 60 + depMin;
                    let arrTotalMins = arrHour * 60 + arrMin;
                    if (arrTotalMins < depTotalMins) arrTotalMins += 24 * 60;
                    const durationMins = arrTotalMins - depTotalMins;
                    calculatedHours = Math.floor(durationMins / 60);
                    calculatedMinutes = durationMins % 60;
                } else {
                    const avgSpeed = 40;
                    const durationMins = Math.round((cumulativeDist / avgSpeed) * 60);
                    calculatedHours = Math.floor(durationMins / 60);
                    calculatedMinutes = durationMins % 60;
                }
    
                if (isUp) {
                    setNewRoute(prev => ({ ...prev, upTotalDistance: cumulativeDist.toFixed(1), upManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.upManualFinalLeg, upDurationHours: calculatedHours.toString(), upDurationMinutes: calculatedMinutes.toString() }));
                    if (editingRoute) setEditForm(prev => ({ ...prev, totalDistance: cumulativeDist.toFixed(1), durationHours: calculatedHours.toString(), durationMinutes: calculatedMinutes.toString() }));
                } else {
                    setNewRoute(prev => ({ ...prev, downTotalDistance: cumulativeDist.toFixed(1), downManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.downManualFinalLeg, downDurationHours: calculatedHours.toString(), downDurationMinutes: calculatedMinutes.toString() }));
                    if (editingRoute) setEditForm(prev => ({ ...prev, returnTotalDistance: cumulativeDist.toFixed(1), returnDurationHours: calculatedHours.toString(), returnDurationMinutes: calculatedMinutes.toString() }));
                }
    
                setIsDistanceCalculated(prev => ({ ...prev, [activeRouteTab.toLowerCase()]: true }));
                toast.success(`${activeRouteTab} route distances calculated! Total: ${cumulativeDist.toFixed(1)} km, Duration: ${calculatedHours}h ${calculatedMinutes}m`);
            } catch (error) {
                console.error('Distance calculation error:', error);
                toast.error("Calculation failed. Please enter distances manually.");
            } finally { setIsCalculatingDistances(false); }
        };
    
        // ---------- handleEditCalculateDistances (unchanged) ----------
        const handleEditCalculateDistances = async (type = 'up') => {
            const isUp = type === 'up';
            const stops = isUp ? upStops : downStops;
    
            if (isUp) {
                if (!editForm.originCity || !editForm.destCity) { toast.error("Origin and Destination required for UP route."); return; }
                if (!editForm.originCoords) { toast.error('Please select Origin from suggestions'); return; }
                if (!editForm.destCoords) { toast.error('Please select Destination from suggestions'); return; }
            } else {
                if (!editForm.returnOriginCity || !editForm.returnDestCity) { toast.error("Return Origin and Destination required for DOWN route."); return; }
                if (!editForm.returnOriginCoords) { toast.error('Please select Return Origin from suggestions'); return; }
                if (!editForm.returnDestCoords) { toast.error('Please select Return Destination from suggestions'); return; }
            }
    
            let originNode, destNode;
            if (isUp) {
                originNode = { id: 'origin', name: editForm.originCity, lat: editForm.originCoords?.lat || 0, lng: editForm.originCoords?.lng || 0, isManual: !editForm.originCoords?.lat || editForm.originCoords.lat === 0 };
                destNode = { id: 'destination', name: editForm.destCity, lat: editForm.destCoords?.lat || 0, lng: editForm.destCoords?.lng || 0, isManual: !editForm.destCoords?.lat || editForm.destCoords.lat === 0 };
            } else {
                originNode = { id: 'origin', name: editForm.returnOriginCity, lat: editForm.returnOriginCoords?.lat || 0, lng: editForm.returnOriginCoords?.lng || 0, isManual: !editForm.returnOriginCoords?.lat || editForm.returnOriginCoords.lat === 0 };
                destNode = { id: 'destination', name: editForm.returnDestCity, lat: editForm.returnDestCoords?.lat || 0, lng: editForm.returnDestCoords?.lng || 0, isManual: !editForm.returnDestCoords?.lat || editForm.returnDestCoords.lat === 0 };
            }
    
            setIsCalculatingDistances(true);
            toast.info(`Calculating ${type === 'up' ? 'UP' : 'DOWN'} route distances...`);
    
            try {
                const enrichedStops = [...stops];
                for (let i = 0; i < enrichedStops.length; i++) {
                    const stop = enrichedStops[i];
                    const isManual = stop.isManualStop === true || !stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0);
                    if (isManual && (!stop.manualDistFromPrev || stop.manualDistFromPrev === 0) && stop.distanceFromOrigin > 0) {
                        const prevStop = i > 0 ? enrichedStops[i - 1] : null;
                        const prevDistance = prevStop?.distanceFromOrigin || 0;
                        const calculatedDist = stop.distanceFromOrigin - prevDistance;
                        if (calculatedDist > 0) enrichedStops[i] = { ...stop, manualDistFromPrev: parseFloat(calculatedDist.toFixed(1)) };
                    }
                }
    
                const stopNodes = enrichedStops.map((s, i) => {
                    const hasValidCoords = s.coordinates?.lat && s.coordinates.lat !== 0;
                    const hasManualDist = s.manualDistFromPrev && s.manualDistFromPrev > 0;
                    const hasDistanceFromOrigin = s.distanceFromOrigin && s.distanceFromOrigin > 0;
                    const isManual = s.isManualStop === true || !hasValidCoords || hasManualDist;
                    return {
                        id: `stop_${i}`, name: s.city,
                        lat: s.coordinates?.lat, lng: s.coordinates?.lng,
                        manualFromPrev: s.manualDistFromPrev ? parseFloat(s.manualDistFromPrev) : null,
                        manualToNext: s.manualDistToNext ? parseFloat(s.manualDistToNext) : null,
                        existingDistance: s.distanceFromOrigin || 0,
                        isManual, originalStop: s
                    };
                });
    
                const fullPath = [originNode, ...stopNodes, destNode];
                const validNodes = fullPath.filter(s => s.lat && s.lng && s.lat !== 0 && s.lng !== 0 && !s.isManual);
                let matrixResponse = null;
                if (validNodes.length >= 2) matrixResponse = await getDistanceMatrix(fullPath, fullPath);
    
                let cumulativeDist = 0, prevCumulativeDist = 0, lastAutoNodeIndex = 0, sumManualSinceLastAuto = 0, validNodeCounter = -1;
                const updatedStops = [];
    
                if (stops.length > 0) {
                    const firstStop = stopNodes[0];
                    const hasFirstStopDistance = firstStop && (firstStop.existingDistance > 0 || (firstStop.manualFromPrev && firstStop.manualFromPrev > 0));
                    if (hasFirstStopDistance) {
                        cumulativeDist = firstStop.existingDistance > 0 ? firstStop.existingDistance : firstStop.manualFromPrev;
                        sumManualSinceLastAuto = cumulativeDist;
                        prevCumulativeDist = cumulativeDist;
                    } else if (originNode.isManual) {
                        const firstLeg = isUp ? editForm.upManualFirstLeg : editForm.returnManualFirstLeg;
                        if (!firstLeg || parseFloat(firstLeg) <= 0) { toast.error('Please provide distance from origin to first stop in the Summary section.'); setIsCalculatingDistances(false); return; }
                        cumulativeDist = parseFloat(firstLeg);
                        sumManualSinceLastAuto = cumulativeDist;
                        prevCumulativeDist = cumulativeDist;
                    } else { lastAutoNodeIndex = 0; validNodeCounter = 0; }
                }
    
                for (let i = 0; i < stopNodes.length; i++) {
                    const currNode = stopNodes[i];
                    const isManual = currNode.isManual;
                    let segment = 0;
    
                    if (i === 0 && cumulativeDist > 0 && (currNode.existingDistance > 0 || currNode.manualFromPrev > 0)) {
                        updatedStops.push({ ...enrichedStops[i], distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)), manualDistFromPrev: currNode.manualFromPrev || cumulativeDist, manualDistToNext: currNode.manualToNext || null });
                        continue;
                    }
    
                    if (isManual) {
                        let manualDist = currNode.manualFromPrev;
                        if ((!manualDist || manualDist === 0) && currNode.existingDistance > 0) {
                            const prevDistance = i > 0 ? updatedStops[i - 1]?.distanceFromOrigin || 0 : cumulativeDist;
                            manualDist = currNode.existingDistance - prevDistance;
                        }
                        if (!manualDist || manualDist === 0) { toast.error(`Manual stop '${currNode.name}' is missing distance from previous stop. Please edit and provide the distance.`); setIsCalculatingDistances(false); return; }
                        segment = manualDist;
                        cumulativeDist += segment;
                        sumManualSinceLastAuto += segment;
                        const distanceFromPrev = cumulativeDist - prevCumulativeDist;
                        prevCumulativeDist = cumulativeDist;
                        updatedStops.push({ ...enrichedStops[i], distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)), manualDistFromPrev: segment, manualDistToNext: currNode.manualToNext || null });
                    } else {
                        validNodeCounter++;
                        let apiDistance = 0;
                        let matrixOriginIndex = lastAutoNodeIndex;
                        let matrixDestIndex = validNodeCounter;
                        if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
                            const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
                            if (element?.status === 'OK') apiDistance = element.distance.value / 1000;
                        }
                        if (i > 0 && stopNodes[i - 1].manualToNext && stopNodes[i - 1].manualToNext > 0) { segment = stopNodes[i - 1].manualToNext; sumManualSinceLastAuto = 0; }
                        else { segment = apiDistance - sumManualSinceLastAuto; if (segment < 0) segment = 0; sumManualSinceLastAuto = 0; }
                        cumulativeDist += segment;
                        if (lastAutoNodeIndex === -1 || matrixOriginIndex >= 0) lastAutoNodeIndex = validNodeCounter;
                        const distanceFromPrev = cumulativeDist - prevCumulativeDist;
                        prevCumulativeDist = cumulativeDist;
                        updatedStops.push({ ...enrichedStops[i], distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)), manualDistFromPrev: parseFloat(distanceFromPrev.toFixed(1)), manualDistToNext: currNode.manualToNext || null });
                    }
                }
    
                let finalSegment = 0;
                const lastStop = stopNodes[stopNodes.length - 1];
                const isLastStopManual = lastStop && lastStop.isManual;
                const hasLastStopDistanceToDest = lastStop && lastStop.manualToNext && lastStop.manualToNext > 0;
    
                const totalDistance = isUp ? parseFloat(editForm.totalDistance) : parseFloat(editForm.returnTotalDistance);
                const lastStopDistance = updatedStops.length > 0 ? updatedStops[updatedStops.length - 1].distanceFromOrigin : 0;
    
                if (totalDistance > 0 && lastStopDistance > 0 && !hasLastStopDistanceToDest) {
                    const calculatedFinalSegment = totalDistance - lastStopDistance;
                    if (calculatedFinalSegment > 0) {
                        finalSegment = parseFloat(calculatedFinalSegment.toFixed(1));
                        if (isUp) setEditForm(prev => ({ ...prev, upManualFinalLeg: finalSegment.toString() }));
                        else setEditForm(prev => ({ ...prev, returnManualFinalLeg: finalSegment.toString() }));
                    }
                }
    
                if (finalSegment === 0) {
                    if (hasLastStopDistanceToDest) finalSegment = lastStop.manualToNext;
                    else if (destNode.isManual) {
                        const finalLeg = isUp ? editForm.upManualFinalLeg : editForm.returnManualFinalLeg;
                        if (!finalLeg || parseFloat(finalLeg) <= 0) {
                            if (totalDistance > 0 && lastStopDistance > 0) {
                                finalSegment = totalDistance - lastStopDistance;
                                if (finalSegment > 0) {
                                    if (isUp) setEditForm(prev => ({ ...prev, upManualFinalLeg: finalSegment.toString() }));
                                    else setEditForm(prev => ({ ...prev, returnManualFinalLeg: finalSegment.toString() }));
                                } else { toast.error('Destination is manual. Please provide distance from last stop to destination in Summary section.'); setIsCalculatingDistances(false); return; }
                            } else { toast.error('Destination is manual. Please provide distance from last stop to destination in Summary section.'); setIsCalculatingDistances(false); return; }
                        } else finalSegment = parseFloat(finalLeg);
                    } else if (!destNode.isManual && isLastStopManual) {
                        const finalLeg = isUp ? editForm.destManualDistFromLastStop : editForm.returnDestManualDistFromLastStop;
                        if (!finalLeg || parseFloat(finalLeg) <= 0) {
                            if (totalDistance > 0 && lastStopDistance > 0) {
                                finalSegment = totalDistance - lastStopDistance;
                                if (finalSegment <= 0) { toast.error('Last stop is manual. Please provide distance to destination in Summary section.'); setIsCalculatingDistances(false); return; }
                            } else { toast.error('Last stop is manual. Please provide distance to destination in Summary section.'); setIsCalculatingDistances(false); return; }
                        } else finalSegment = parseFloat(finalLeg);
                    } else if (!destNode.isManual && !isLastStopManual && matrixResponse) {
                        validNodeCounter++;
                        let matrixOriginIndex = lastAutoNodeIndex;
                        let matrixDestIndex = validNodeCounter;
                        const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
                        if (element?.status === 'OK') { finalSegment = element.distance.value / 1000 - sumManualSinceLastAuto; if (finalSegment < 0) finalSegment = 0; }
                    } else if (stopNodes.length === 0) {
                        if (originNode.isManual && destNode.isManual) {
                            const totalDist = isUp ? editForm.totalDistance : editForm.returnTotalDistance;
                            if (!totalDist || parseFloat(totalDist) <= 0) { toast.error('Both origin and destination are manual. Please provide total distance.'); setIsCalculatingDistances(false); return; }
                            finalSegment = parseFloat(totalDist);
                        } else if (matrixResponse) {
                            const element = matrixResponse.rows[0]?.elements[1];
                            if (element?.status === 'OK') finalSegment = element.distance.value / 1000;
                        }
                    }
                }
    
                cumulativeDist += finalSegment;
                if (updatedStops.length > 0 && finalSegment > 0) {
                    const lastIndex = updatedStops.length - 1;
                    updatedStops[lastIndex] = { ...updatedStops[lastIndex], manualDistToNext: parseFloat(finalSegment.toFixed(1)) };
                }
    
                if (type === 'up') {
                    setUpStops(updatedStops);
                    setEditForm(prev => ({ ...prev, totalDistance: cumulativeDist.toFixed(1), upManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.upManualFinalLeg }));
                } else {
                    setDownStops(updatedStops);
                    setEditForm(prev => ({ ...prev, returnTotalDistance: cumulativeDist.toFixed(1), returnManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.returnManualFinalLeg }));
                }
    
                setIsDistanceCalculated(prev => ({ ...prev, [type]: true }));
                toast.success(`${type === 'up' ? 'UP' : 'DOWN'} route distances calculated! Total: ${cumulativeDist.toFixed(1)} km`);
            } catch (error) {
                console.error('Distance calculation error:', error);
                toast.error("Calculation failed. Please enter distances manually.");
            } finally { setIsCalculatingDistances(false); }
        };
    
        // ---------- fetchRoutes (unchanged) ----------
        const fetchRoutes = async () => {
            try {
                setLoading(true);
                const response = await getAllRoutes(token, currentPage, pageSize, searchTerm, filterOrigin, filterDestination);
                if (response && response.success) {
                    const routesData = response.data?.routes || [];
                    const transformedRoutes = routesData.map((route, index) => {
                        const getDepartureTime = (origin) => {
                            if (origin?.departureTime) return origin.departureTime;
                            if (origin?.timings && origin.timings.length > 0) { const firstTiming = origin.timings[0]; if (firstTiming?.departureTime) return firstTiming.departureTime; }
                            return 'N/A';
                        };
                        const getArrivalTime = (destination) => {
                            if (destination?.arrivalTime) return destination.arrivalTime;
                            if (destination?.timings && destination.timings.length > 0) { const firstTiming = destination.timings[0]; if (firstTiming?.arrivalTime) return firstTiming.arrivalTime; }
                            return 'N/A';
                        };
                        let departureTime = getDepartureTime(route.origin);
                        let arrivalTime = getArrivalTime(route.destination);
                        if (route.routeNumber?.includes('REV') && route.returnJourney) {
                            departureTime = getDepartureTime(route.returnJourney.origin);
                            arrivalTime = getArrivalTime(route.returnJourney.destination);
                        }
                        const formatDisplayTime = (timeStr) => {
                            if (!timeStr || timeStr === 'N/A') return 'N/A';
                            if (timeStr.includes(':')) {
                                const [hours, minutes] = timeStr.split(':');
                                const hour = parseInt(hours);
                                const ampm = hour >= 12 ? 'pm' : 'am';
                                const displayHour = hour % 12 || 12;
                                return `${displayHour}:${minutes} ${ampm}`;
                            }
                            return timeStr;
                        };
                        return {
                            id: route._id || route.id,
                            serialNo: (currentPage - 1) * pageSize + index + 1,
                            routeNumber: route.routeNumber || 'N/A',
                            routeName: route.routeName || 'N/A',
                            localRouteName: route.localRouteName || null,
                            originCity: route.origin?.city || 'N/A',
                            destinationCity: route.destination?.city || 'N/A',
                            distance: route.routeDetails?.totalDistance || 0,
                            duration: formatDuration(route.routeDetails?.estimatedDuration?.hours, route.routeDetails?.estimatedDuration?.minutes),
                            stops: route.intermediateStops?.length || 0,
                            status: route.isActive ? 'Active' : 'Inactive',
                            departureTime: formatDisplayTime(departureTime),
                            arrivalTime: formatDisplayTime(arrivalTime),
                            isActive: route.isActive,
                            createdAt: route.createdAt, updatedAt: route.updatedAt,
                            creatorType: route.creatorType || 'Admin',
                            creatorName: route.creatorName || 'Admin',
                            isRoundTrip: route.isRoundTrip || false,
                            associatedBuses: (route.associatedBuses || []).map(bus => ({ ...bus, _id: bus.busId || bus._id, busId: bus.busId || bus._id, approvalStatus: bus.approvalStatus || (bus.isActive ? 'approved' : 'pending') })),
                            busCount: route.busCount || 0,
                            activeBusCount: route.activeBusCount || 0,
                            hasActiveBuses: route.hasActiveBuses || false,
                            hasPendingBuses: (route.associatedBuses || []).some(bus => !bus.isActive && bus.approvalStatus === 'pending'),
                            fullData: route
                        };
                    });
                    setRoutes(transformedRoutes);
                    if (response.data?.pagination) {
                        setTotalPages(response.data.pagination.totalPages || 1);
                        setTotalRoutes(response.data.pagination.total || 0);
                    }
                }
            } catch (err) {
                console.error('Error fetching routes:', err);
                toast.error('Failed to fetch routes');
            } finally { setLoading(false); }
        };
    
        // ---------- handleSaveRoute (unchanged) ----------
        const handleSaveRoute = async () => {
            if (!selectedMasterRouteFromDropdown) { toast.error('Please select a Master Route first'); return; }
            if (!newRoute.routeName) { toast.error('Route Name is required. Please select a Master Route.'); return; }
            if (!newRoute.upOriginCoords) { toast.error('Please select Origin from suggestions to get coordinates'); return; }
            if (!newRoute.upDestCoords) { toast.error('Please select Destination from suggestions to get coordinates'); return; }
    
            const invalidStops = upStops.filter(stop => {
                const missingFields = [];
                if (!stop.city?.trim()) missingFields.push('city');
                if (!stop.coordinates) missingFields.push('coordinates');
                if (isMultiTrip) {
                    if (!stop.timings || stop.timings.length === 0) missingFields.push('timings');
                    else { const missingTimings = stop.timings.filter(t => !t.arrivalTime); if (missingTimings.length > 0) missingFields.push(`timings for ${missingTimings.length} trip(s)`); }
                } else if (!stop.arrivalTime) missingFields.push('arrivalTime');
                return missingFields.length > 0;
            });
    
            if (invalidStops.length > 0) { toast.error(`Stop(s) missing required fields: ${invalidStops.map(s => s.city || 'Unknown').join(', ')}`); return; }
            if (!isDistanceCalculated.up) { toast.error('Please calculate UP route distances first'); return; }
            if (isRoundTrip && !isDistanceCalculated.down) { toast.error('Please calculate DOWN route distances first'); return; }
            if (isRoundTrip && !isMultiTrip && (!newRoute.downOriginDepTime || !newRoute.downDestArrTime)) { toast.error("Please provide Departure and Arrival times for the Return Route"); return; }
    
            setIsCreatingRoute(true);
    
            try {
                const originData = {
                    city: newRoute.upOriginCity, state: newRoute.upOriginState || '',
                    address: newRoute.upOriginAddress || '',
                    terminal: newRoute.upOriginTerminal || newRoute.upOriginCity + ' Terminal',
                    coordinates: newRoute.upOriginCoords || { lat: 0, lng: 0 }
                };
                if (isMultiTrip) originData.timings = timeSlots.map(slot => ({ timeSlotSequence: slot.sequence, departureTime: slot.departureTime, arrivalTime: '' }));
                else originData.departureTime = newRoute.upOriginDepTime;
    
                const destData = {
                    city: newRoute.upDestCity, state: newRoute.upDestState || '',
                    address: newRoute.upDestAddress || '',
                    terminal: newRoute.upDestTerminal || newRoute.upDestCity + ' Terminal',
                    coordinates: newRoute.upDestCoords || { lat: 0, lng: 0 },
                    distanceFromOrigin: parseFloat(newRoute.upTotalDistance || 0)
                };
                if (isMultiTrip) destData.timings = destinationTimeSlots.map(slot => ({ timeSlotSequence: slot.sequence, arrivalTime: slot.arrivalTime, departureTime: '' }));
                else destData.arrivalTime = newRoute.upDestArrTime;
    
                const cleanStops = (list) => list.map((s, index) => {
                    const stopCoords = s.coordinates || { lat: 0, lng: 0 };
                    const city = s.city?.trim();
                    if (!city) throw new Error(`Stop ${index + 1} is missing city name`);
                    const state = s.state?.trim() || 'West Bengal';
                    const address = s.address?.trim() || `${city}, ${state}, India`;
                    const terminal = s.terminal?.trim() || `${city} Terminal`;
                    const stopPayload = { sequence: index + 1, city, state, address, terminal, stopType: s.stopType || 'none', coordinates: stopCoords, distanceFromOrigin: s.distanceFromOrigin || 0 };
                    if (isMultiTrip) {
                        if (s.timings && s.timings.length > 0) stopPayload.timings = s.timings.map(timing => ({ timeSlotSequence: timing.timeSlotSequence, arrivalTime: timing.arrivalTime, departureTime: timing.departureTime || timing.arrivalTime }));
                        else stopPayload.timings = timeSlots.map(slot => ({ timeSlotSequence: slot.sequence, arrivalTime: '', departureTime: '' }));
                    } else {
                        if (!s.arrivalTime) throw new Error(`Stop ${index + 1} (${city}) is missing arrival time`);
                        stopPayload.arrivalTime = s.arrivalTime;
                        stopPayload.departureTime = s.departureTime?.trim() || s.arrivalTime;
                    }
                    if (s.manualDistFromPrev) stopPayload.manualDistFromPrev = s.manualDistFromPrev;
                    if (s.manualDistToNext) stopPayload.manualDistToNext = s.manualDistToNext;
                    if (s.isManualStop) stopPayload.isManualStop = s.isManualStop;
                    return stopPayload;
                });
    
                const generateNullPoints = (stops, origin, destination) => {
                    const np = [];
                    np.push({ name: origin.terminal, address: origin.address, city: origin.city, state: origin.state, landmark: origin.terminal, referenceTime: origin.departureTime });
                    np.push({ name: destination.terminal, address: destination.address, city: destination.city, state: destination.state, landmark: destination.terminal, referenceTime: destination.arrivalTime });
                    stops.forEach(stop => { if (stop.stopType === 'none') np.push({ name: stop.terminal, address: stop.address, city: stop.city, state: stop.state, landmark: stop.terminal, referenceTime: stop.arrivalTime }); });
                    return np;
                };
                const generateBoardingPoints = (stops, origin) => {
                    const bp = [];
                    bp.push({ name: origin.terminal, address: origin.address, city: origin.city, state: origin.state, landmark: origin.terminal, pickupTime: origin.departureTime });
                    stops.forEach(stop => { if (stop.stopType === 'boarding' || stop.stopType === 'both') bp.push({ name: stop.terminal, address: stop.address, city: stop.city, state: stop.state, landmark: stop.terminal, pickupTime: stop.departureTime || stop.arrivalTime }); });
                    return bp;
                };
                const generateDroppingPoints = (stops, destination) => {
                    const dp = [];
                    dp.push({ name: destination.terminal, address: destination.address, city: destination.city, state: destination.state, landmark: destination.terminal, dropTime: destination.arrivalTime });
                    stops.forEach(stop => { if (stop.stopType === 'dropping' || stop.stopType === 'both') dp.push({ name: stop.terminal, address: stop.address, city: stop.city, state: stop.state, landmark: stop.terminal, dropTime: stop.arrivalTime }); });
                    return dp;
                };
    
                const boardingPoints = generateBoardingPoints(upStops, originData);
                const droppingPoints = generateDroppingPoints(upStops, destData);
                const nullPoints = generateNullPoints(upStops, originData, destData);
    
                const finalPayload = {
                    routeName: newRoute.routeName.trim(),
                    via: selectedMasterRouteFromDropdown?.via || [],
                    localRouteName: newRoute.localRouteName?.trim() || null,
                    isMultiTrip, numberOfTrips: isMultiTrip ? numberOfTrips : 1,
                    timeSlots: isMultiTrip ? timeSlots : [],
                    origin: originData, destination: destData,
                    intermediateStops: cleanStops(upStops),
                    additionalBoardingPoints: boardingPoints,
                    additionalDroppingPoints: droppingPoints,
                    additionalNullPoints: nullPoints,
                    routeDetails: { totalDistance: parseFloat(newRoute.upTotalDistance || 0), estimatedDuration: { hours: parseInt(newRoute.upDurationHours || 0, 10), minutes: parseInt(newRoute.upDurationMinutes || 0, 10) } },
                    isRoundTrip
                };
    
                if (isRoundTrip) {
                    const invalidReturnStops = downStops.filter(stop => !stop.coordinates);
                    if (invalidReturnStops.length > 0) { toast.error('All return stops must have coordinates.'); setIsCreatingRoute(false); return; }
    
                    const returnOriginData = { city: destData.city, state: destData.state, address: destData.address, terminal: destData.terminal, coordinates: destData.coordinates };
                    if (isMultiTrip) {
                        if (returnOriginTimeSlots && returnOriginTimeSlots.length > 0) returnOriginData.timings = returnOriginTimeSlots.map(slot => ({ timeSlotSequence: slot.sequence, departureTime: slot.departureTime || slot.arrivalTime || '', arrivalTime: '' }));
                        else if (destinationTimeSlots && destinationTimeSlots.length > 0) returnOriginData.timings = destinationTimeSlots.map(slot => ({ timeSlotSequence: slot.sequence, departureTime: slot.arrivalTime || '', arrivalTime: '' }));
                        else returnOriginData.timings = timeSlots.map(slot => ({ timeSlotSequence: slot.sequence, departureTime: slot.departureTime || '', arrivalTime: '' }));
                    } else returnOriginData.departureTime = newRoute.downOriginDepTime;
    
                    const returnDestData = { city: originData.city, state: originData.state, address: originData.address, terminal: originData.terminal, coordinates: originData.coordinates, distanceFromOrigin: parseFloat(newRoute.downTotalDistance || 0) };
                    if (isMultiTrip) {
                        if (returnDestTimeSlots && returnDestTimeSlots.length > 0) returnDestData.timings = returnDestTimeSlots.map(slot => ({ timeSlotSequence: slot.sequence, arrivalTime: slot.arrivalTime || slot.departureTime || '', departureTime: '' }));
                        else if (timeSlots && timeSlots.length > 0) returnDestData.timings = timeSlots.map(slot => ({ timeSlotSequence: slot.sequence, arrivalTime: slot.departureTime || '', departureTime: '' }));
                        else returnDestData.timings = Array.from({ length: numberOfTrips || 1 }, (_, i) => ({ timeSlotSequence: i + 1, arrivalTime: '', departureTime: '' }));
                    } else returnDestData.arrivalTime = newRoute.downDestArrTime;
    
                    if (isMultiTrip && returnOriginData.timings) { const missingDepartures = returnOriginData.timings.filter(t => !t.departureTime); if (missingDepartures.length > 0) { toast.error(`Return origin is missing departure times for ${missingDepartures.length} trip(s).`); setIsCreatingRoute(false); return; } }
                    if (isMultiTrip && returnDestData.timings) { const missingArrivals = returnDestData.timings.filter(t => !t.arrivalTime); if (missingArrivals.length > 0) { toast.error(`Return destination is missing arrival times for ${missingArrivals.length} trip(s).`); setIsCreatingRoute(false); return; } }
    
                    const cleanedReturnStops = downStops.map((stop, index) => {
                        const stopCoords = stop.coordinates || { lat: 0, lng: 0 };
                        const city = stop.city?.trim();
                        if (!city) throw new Error(`Return stop ${index + 1} is missing city name`);
                        const state = stop.state?.trim() || 'West Bengal';
                        const address = stop.address?.trim() || `${city}, ${state}, India`;
                        const terminal = stop.terminal?.trim() || `${city} Terminal`;
                        const stopPayload = { sequence: index + 1, city, state, address, terminal, stopType: stop.stopType || 'none', coordinates: stopCoords, distanceFromOrigin: stop.distanceFromOrigin || 0 };
                        if (isMultiTrip) {
                            if (stop.timings && stop.timings.length > 0) stopPayload.timings = stop.timings.map(timing => ({ timeSlotSequence: timing.timeSlotSequence, arrivalTime: timing.arrivalTime || '', departureTime: timing.departureTime || timing.arrivalTime || '' }));
                            else { const numTrips = returnOriginTimeSlots.length || numberOfTrips || 1; stopPayload.timings = Array.from({ length: numTrips }, (_, i) => ({ timeSlotSequence: i + 1, arrivalTime: '', departureTime: '' })); }
                        } else {
                            if (!stop.arrivalTime) throw new Error(`Return stop ${index + 1} (${city}) is missing arrival time`);
                            stopPayload.arrivalTime = stop.arrivalTime;
                            stopPayload.departureTime = stop.departureTime?.trim() || stop.arrivalTime;
                        }
                        if (stop.manualDistFromPrev) stopPayload.manualDistFromPrev = stop.manualDistFromPrev;
                        if (stop.manualDistToNext) stopPayload.manualDistToNext = stop.manualDistToNext;
                        if (stop.isManualStop) stopPayload.isManualStop = stop.isManualStop;
                        return stopPayload;
                    });
    
                    finalPayload.returnOrigin = returnOriginData;
                    finalPayload.returnDestination = returnDestData;
                    finalPayload.returnIntermediateStops = cleanedReturnStops;
                    finalPayload.returnAdditionalBoardingPoints = generateBoardingPoints(downStops, returnOriginData);
                    finalPayload.returnAdditionalDroppingPoints = generateDroppingPoints(downStops, returnDestData);
                    finalPayload.returnAdditionalNullPoints = generateNullPoints(downStops, returnOriginData, returnDestData);
                    finalPayload.returnRouteDetails = { totalDistance: parseFloat(newRoute.downTotalDistance || 0), estimatedDuration: { hours: parseInt(newRoute.downDurationHours || 0, 10), minutes: parseInt(newRoute.downDurationMinutes || 0, 10) } };
                }
    
                const response = await createRoute(finalPayload, token);
                if (response.success) {
                    toast.success(isRoundTrip ? 'Round trip route created successfully!' : 'Route created successfully!');
                    setShowAddModal(false);
                    resetNewRouteForm();
                    fetchRoutes();
                } else toast.error(response.message || 'Failed to create route');
            } catch (err) {
                console.error('Error creating route:', err);
                if (err.response) toast.error(err.response.data?.message || err.response.data || err.message);
                else if (err.request) toast.error('No response from server. Please check your connection.');
                else toast.error(err.message || 'Failed to create route');
            } finally { setIsCreatingRoute(false); }
        };
    
        const resetNewRouteForm = () => {
            setNewRoute({
                routeName: '', localRouteName: '',
                upOriginCity: '', upOriginState: '', upOriginAddress: '', upOriginTerminal: '', upOriginCoords: null, upOriginDepTime: '',
                upDestCity: '', upDestState: '', upDestAddress: '', upDestTerminal: '', upDestCoords: null, upDestArrTime: '',
                upTotalDistance: '', upDurationHours: '', upDurationMinutes: '',
                downOriginDepTime: '', downDestArrTime: '', downTotalDistance: '', downDurationHours: '', downDurationMinutes: '',
                upManualFinalLeg: '', downManualFinalLeg: '',
                stopCity: '', stopState: '', stopAddress: '', stopTerminal: '', stopCoords: null, stopArrivalTime: '', stopDepartureTime: '', stopDistFromPrev: '', stopDistToNext: '',
                isBoarding: false, isDropping: false
            });
            setUpStops([]);
            setDownStops([]);
            setIsRoundTrip(false);
            setActiveRouteTab('UP');
            setIsDistanceCalculated({ up: false, down: false });
            setActiveTab('basic');
            setSelectedMasterRoute(null);
            setSelectedMasterRouteFromDropdown(null);
            setMasterRouteSuggestions([]);
        };
    
        const handleViewRoute = async (route) => {
            try {
                setError(null);
                let routeData;
                if (route.isPending) {
                    const response = await getPendingRouteById(route.id, token);
                    if (response.success) {
                        routeData = response.data;
                        setViewingRoute({ ...routeData, id: routeData._id, isActive: false, isPending: true, submittedByName: routeData.submittedByName, operationType: routeData.operationType });
                    }
                } else {
                    routeData = await getRouteById(route.id, token);
                    setViewingRoute(routeData.data || routeData);
                }
            } catch (err) {
                console.error('Error fetching route details:', err);
                setError('Failed to fetch route details.');
                toast.error('Failed to fetch route details. Please try again.');
                if (route.fullData) setViewingRoute(route.fullData);
                else setViewingRoute(route);
            }
        };
    
        const handleAddNewMasterRoute = () => {
            const currentFormData = {
                routeName: newRoute.routeName, upOriginCity: newRoute.upOriginCity, upOriginState: newRoute.upOriginState,
                upOriginAddress: newRoute.upOriginAddress, upOriginTerminal: newRoute.upOriginTerminal, upOriginCoords: newRoute.upOriginCoords,
                upOriginDepTime: newRoute.upOriginDepTime, upDestCity: newRoute.upDestCity, upDestState: newRoute.upDestState,
                upDestAddress: newRoute.upDestAddress, upDestTerminal: newRoute.upDestTerminal, upDestCoords: newRoute.upDestCoords,
                upDestArrTime: newRoute.upDestArrTime, isRoundTrip, upStops, downStops,
                via: upStops.map(stop => ({ city: stop.city, state: stop.state, sequence: stop.sequence }))
            };
            localStorage.setItem('pendingRouteFormData', JSON.stringify(currentFormData));
            toast.info('Redirecting to create master route. Your current form data has been saved.');
            navigate('/masterroutes', { state: { returnTo: 'routes', formData: currentFormData } });
        };
    
        // ---------- autoFillFromMasterRoute (unchanged) ----------
        const autoFillFromMasterRoute = (masterRoute) => {
            if (!masterRoute) return;
            setSelectedMasterRouteFromDropdown(masterRoute);
    
            const isMultiTripRoute = masterRoute.isMultiTrip ||
                (masterRoute.origin?.timings && masterRoute.origin.timings.length > 0) ||
                (masterRoute.intermediateStops && masterRoute.intermediateStops.some(stop => stop.timings && stop.timings.length > 0));
    
            setIsMultiTrip(isMultiTripRoute);
    
            setNewRoute(prev => ({ ...prev, routeName: masterRoute.masterRouteName, localRouteName: masterRoute.localRouteName || prev.localRouteName }));
    
            if (masterRoute.origin) {
                setNewRoute(prev => ({
                    ...prev,
                    upOriginCity: masterRoute.origin.city || '',
                    upOriginState: masterRoute.origin.state || '',
                    upOriginAddress: masterRoute.origin.address || `${masterRoute.origin.city || ''}, ${masterRoute.origin.state || 'India'}`,
                    upOriginTerminal: masterRoute.origin.terminal || `${masterRoute.origin.city || ''} Terminal`,
                    upOriginCoords: masterRoute.origin.coordinates || null,
                    upOriginDepTime: masterRoute.origin.departureTime || ''
                }));
                if (isMultiTripRoute && masterRoute.origin.timings && masterRoute.origin.timings.length > 0) {
                    const numTrips = masterRoute.numberOfTrips || masterRoute.origin.timings.length;
                    setNumberOfTrips(numTrips);
                    setTimeSlots(masterRoute.origin.timings.map(timing => ({ sequence: timing.timeSlotSequence, departureTime: timing.departureTime, arrivalTime: '', fareMultiplier: timing.fareMultiplier || 1.0, isActive: timing.isActive !== undefined ? timing.isActive : true })));
                }
            }
            if (masterRoute.destination) {
                setNewRoute(prev => ({
                    ...prev,
                    upDestCity: masterRoute.destination.city || '',
                    upDestState: masterRoute.destination.state || '',
                    upDestAddress: masterRoute.destination.address || `${masterRoute.destination.city || ''}, ${masterRoute.destination.state || 'India'}`,
                    upDestTerminal: masterRoute.destination.terminal || `${masterRoute.destination.city || ''} Terminal`,
                    upDestCoords: masterRoute.destination.coordinates || null,
                    upDestArrTime: masterRoute.destination.arrivalTime || '',
                    upTotalDistance: masterRoute.routeDetails?.totalDistance || '',
                    upDurationHours: masterRoute.routeDetails?.estimatedDuration?.hours || '',
                    upDurationMinutes: masterRoute.routeDetails?.estimatedDuration?.minutes || ''
                }));
                if (isMultiTripRoute && masterRoute.destination.timings && masterRoute.destination.timings.length > 0) {
                    setDestinationTimeSlots(masterRoute.destination.timings.map(timing => ({ sequence: timing.timeSlotSequence, arrivalTime: timing.arrivalTime, departureTime: '', fareMultiplier: timing.fareMultiplier || 1.0 })));
                    setDestinationNumberOfTrips(masterRoute.destination.timings.length);
                }
            }
    
            const existingIntermediateStops = masterRoute.intermediateStops || [];
            const sortedStops = [...existingIntermediateStops].sort((a, b) => (a.sequence || 0) - (b.sequence || 0));
    
            if (sortedStops.length > 0) {
                const upTotalDist = parseFloat(masterRoute.routeDetails?.totalDistance) || 0;
                const transformedUpStops = sortedStops.map((stop, index) => {
                    const actualDist = stop.distanceFromOrigin || 0;
                    const prevStop = index > 0 ? sortedStops[index - 1] : null;
                    const prevDist = prevStop ? (prevStop.distanceFromOrigin || 0) : 0;
                    let segmentDist = 0;
                    if (stop.manualDistFromPrev && parseFloat(stop.manualDistFromPrev) > 0) segmentDist = parseFloat(stop.manualDistFromPrev);
                    else if (actualDist > 0) segmentDist = parseFloat((actualDist - prevDist).toFixed(1));
                    if (segmentDist <= 0 && upTotalDist > 0 && sortedStops.length > 0) segmentDist = parseFloat((upTotalDist / (sortedStops.length + 1)).toFixed(1));
                    if (segmentDist <= 0) segmentDist = 5;
                    const existingTimings = stop.timings || [];
                    let stopTimings = existingTimings;
                    if (isMultiTripRoute && existingTimings.length === 0) {
                        const numTrips = masterRoute.numberOfTrips || 1;
                        stopTimings = Array.from({ length: numTrips }, (_, i) => ({ timeSlotSequence: i + 1, arrivalTime: '', departureTime: '' }));
                    }
                    return {
                        sequence: index + 1, city: stop.city || '', state: stop.state || masterRoute.origin?.state || '',
                        address: stop.address || `${stop.city || ''}, ${stop.state || masterRoute.origin?.state || 'India'}`,
                        terminal: stop.terminal || `${stop.city || ''} Bus Stand`,
                        stopType: stop.stopType || 'none', coordinates: stop.coordinates || { lat: 0, lng: 0 },
                        distanceFromOrigin: actualDist, manualDistFromPrev: segmentDist > 0 ? segmentDist : null,
                        manualDistToNext: stop.manualDistToNext ? parseFloat(stop.manualDistToNext) : null,
                        isManualStop: stop.isManualStop !== undefined ? stop.isManualStop : (!stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0)),
                        arrivalTime: stop.arrivalTime || '', departureTime: stop.departureTime || '', timings: stopTimings
                    };
                });
                setUpStops(transformedUpStops);
                setIsDistanceCalculated(prev => ({ ...prev, up: true }));
                const firstStopDist = transformedUpStops[0].distanceFromOrigin || 0;
                const firstSegment = transformedUpStops[0].manualDistFromPrev || firstStopDist;
                if (firstSegment > 0) setNewRoute(prev => ({ ...prev, upManualFirstLeg: String(firstSegment) }));
                const lastStopDist = transformedUpStops[transformedUpStops.length - 1].distanceFromOrigin || 0;
                const finalLeg = parseFloat((upTotalDist - lastStopDist).toFixed(1));
                if (finalLeg > 0) setNewRoute(prev => ({ ...prev, upManualFinalLeg: String(finalLeg) }));
            } else setUpStops([]);
    
            if (masterRoute.isRoundTrip && masterRoute.returnJourney) {
                setIsRoundTrip(true);
                const returnJourney = masterRoute.returnJourney;
                const returnTotalDist = parseFloat(returnJourney.routeDetails?.totalDistance) || 0;
    
                if (returnJourney.origin) {
                    setNewRoute(prev => ({
                        ...prev,
                        downOriginCity: returnJourney.origin.city || masterRoute.destination?.city || '',
                        downOriginState: returnJourney.origin.state || masterRoute.destination?.state || '',
                        downOriginAddress: returnJourney.origin.address || `${masterRoute.destination?.city || ''}, ${masterRoute.destination?.state || 'India'}`,
                        downOriginTerminal: returnJourney.origin.terminal || `${masterRoute.destination?.city || ''} Terminal`,
                        downOriginCoords: returnJourney.origin.coordinates || masterRoute.destination?.coordinates || null,
                        downOriginDepTime: returnJourney.origin.departureTime || ''
                    }));
                    if (isMultiTripRoute && returnJourney.origin.timings && returnJourney.origin.timings.length > 0) setReturnOriginTimeSlots(returnJourney.origin.timings.map(timing => ({ sequence: timing.timeSlotSequence, departureTime: timing.departureTime, arrivalTime: '', fareMultiplier: timing.fareMultiplier || 1.0 })));
                    else if (isMultiTripRoute && destinationTimeSlots.length > 0) setReturnOriginTimeSlots(destinationTimeSlots.map(slot => ({ sequence: slot.sequence, departureTime: slot.arrivalTime, arrivalTime: '' })));
                }
                if (returnJourney.destination) {
                    setNewRoute(prev => ({
                        ...prev,
                        downDestCity: returnJourney.destination.city || masterRoute.origin?.city || '',
                        downDestState: returnJourney.destination.state || masterRoute.origin?.state || '',
                        downDestAddress: returnJourney.destination.address || `${masterRoute.origin?.city || ''}, ${masterRoute.origin?.state || 'India'}`,
                        downDestTerminal: returnJourney.destination.terminal || `${masterRoute.origin?.city || ''} Terminal`,
                        downDestCoords: returnJourney.destination.coordinates || masterRoute.origin?.coordinates || null,
                        downDestArrTime: returnJourney.destination.arrivalTime || '',
                        downTotalDistance: returnTotalDist,
                        downDurationHours: returnJourney.routeDetails?.estimatedDuration?.hours || '',
                        downDurationMinutes: returnJourney.routeDetails?.estimatedDuration?.minutes || ''
                    }));
                    if (isMultiTripRoute && returnJourney.destination.timings && returnJourney.destination.timings.length > 0) setReturnDestTimeSlots(returnJourney.destination.timings.map(timing => ({ sequence: timing.timeSlotSequence, arrivalTime: timing.arrivalTime, departureTime: '', fareMultiplier: timing.fareMultiplier || 1.0 })));
                    else if (isMultiTripRoute && timeSlots.length > 0) setReturnDestTimeSlots(timeSlots.map(slot => ({ sequence: slot.sequence, arrivalTime: slot.departureTime, departureTime: '' })));
                }
    
                const returnExistingStops = returnJourney.intermediateStops || [];
                const sortedReturnStops = [...returnExistingStops].sort((a, b) => (a.sequence || 0) - (b.sequence || 0));
    
                if (sortedReturnStops.length > 0) {
                    const transformedDownStops = sortedReturnStops.map((stop, index) => {
                        const actualDist = stop.distanceFromOrigin || 0;
                        const prevStop = index > 0 ? sortedReturnStops[index - 1] : null;
                        const prevDist = prevStop ? (prevStop.distanceFromOrigin || 0) : 0;
                        let segmentDist = 0;
                        if (stop.manualDistFromPrev && parseFloat(stop.manualDistFromPrev) > 0) segmentDist = parseFloat(stop.manualDistFromPrev);
                        else if (actualDist > 0) segmentDist = parseFloat((actualDist - prevDist).toFixed(1));
                        if (segmentDist <= 0 && returnTotalDist > 0 && sortedReturnStops.length > 0) segmentDist = parseFloat((returnTotalDist / (sortedReturnStops.length + 1)).toFixed(1));
                        if (segmentDist <= 0) segmentDist = 5;
                        const existingTimings = stop.timings || [];
                        let stopTimings = existingTimings;
                        if (isMultiTripRoute && existingTimings.length === 0) {
                            const numTrips = masterRoute.numberOfTrips || 1;
                            stopTimings = Array.from({ length: numTrips }, (_, i) => ({ timeSlotSequence: i + 1, arrivalTime: '', departureTime: '' }));
                        }
                        let newStopType = stop.stopType || 'none';
                        if (newStopType === 'boarding') newStopType = 'dropping';
                        else if (newStopType === 'dropping') newStopType = 'boarding';
                        return {
                            sequence: index + 1, city: stop.city || '', state: stop.state || masterRoute.destination?.state || '',
                            address: stop.address || `${stop.city || ''}, ${stop.state || masterRoute.destination?.state || 'India'}`,
                            terminal: stop.terminal || `${stop.city || ''} Bus Stand`,
                            arrivalTime: stop.arrivalTime || '', departureTime: stop.departureTime || '',
                            stopType: newStopType, coordinates: stop.coordinates || { lat: 0, lng: 0 },
                            distanceFromOrigin: actualDist, manualDistFromPrev: segmentDist > 0 ? segmentDist : null,
                            manualDistToNext: stop.manualDistToNext ? parseFloat(stop.manualDistToNext) : null,
                            isManualStop: stop.isManualStop !== undefined ? stop.isManualStop : (!stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0)),
                            timings: stopTimings
                        };
                    });
                    setDownStops(transformedDownStops);
                    setIsDistanceCalculated(prev => ({ ...prev, down: true }));
                    const returnFirstSegment = transformedDownStops[0].manualDistFromPrev || transformedDownStops[0].distanceFromOrigin || 0;
                    if (returnFirstSegment > 0) setNewRoute(prev => ({ ...prev, downManualFirstLeg: String(returnFirstSegment) }));
                    const returnLastStopDist = transformedDownStops[transformedDownStops.length - 1].distanceFromOrigin || 0;
                    const returnFinalLeg = parseFloat((returnTotalDist - returnLastStopDist).toFixed(1));
                    if (returnFinalLeg > 0) setNewRoute(prev => ({ ...prev, downManualFinalLeg: String(returnFinalLeg) }));
                } else setDownStops([]);
            } else {
                setIsRoundTrip(false);
                setDownStops([]);
                setReturnOriginTimeSlots([]);
                setReturnDestTimeSlots([]);
            }
    
            toast.success(`Master route "${masterRoute.masterRouteName}" loaded successfully! Please verify and fill in the timings.`);
        };
    
        // ---------- handleEditRoute (unchanged) ----------
        const handleEditRoute = async (route) => {
            try {
                const response = await getRouteById(route.id, token);
                const routeData = response.data || route.fullData;
                setEditingRoute(routeData);
    
                const resolvedIsMultiTrip = routeData.isMultiTrip ||
                    (routeData.origin?.timings && routeData.origin.timings.length > 0) ||
                    (routeData.intermediateStops && routeData.intermediateStops.some(stop => stop.timings && stop.timings.length > 0)) ||
                    (routeData.numberOfTrips && routeData.numberOfTrips > 1);
    
                setEditIsMultiTrip(resolvedIsMultiTrip);
    
                let resolvedNumberOfTrips = 1;
                if (resolvedIsMultiTrip) {
                    resolvedNumberOfTrips = routeData.numberOfTrips || routeData.origin?.timings?.length ||
                        (routeData.intermediateStops && routeData.intermediateStops.length > 0 ? routeData.intermediateStops[0]?.timings?.length || 1 : 1);
                    setEditNumberOfTrips(resolvedNumberOfTrips);
                } else setEditNumberOfTrips(1);
    
                const origin = routeData.origin || {};
                const destination = routeData.destination || {};
                const routeDetails = routeData.routeDetails || {};
                const estimatedDuration = routeDetails.estimatedDuration || {};
    
                const transformStops = (stops) => (stops || []).map((stop, index, array) => {
                    const actualDist = stop.distanceFromOrigin || 0;
                    const prevStop = index > 0 ? array[index - 1] : null;
                    const prevDist = prevStop ? (prevStop.distanceFromOrigin || 0) : 0;
                    let manualDistFromPrev = stop.manualDistFromPrev ? parseFloat(stop.manualDistFromPrev) : null;
                    if (!manualDistFromPrev && actualDist > 0) {
                        const calculated = parseFloat((actualDist - prevDist).toFixed(1));
                        if (calculated > 0) manualDistFromPrev = calculated;
                    }
                    const sortedTimings = sortTimings(stop.timings || []);
                    const hasMultiTimings = sortedTimings.length > 0;
                    let finalTimings = sortedTimings;
                    if (resolvedIsMultiTrip && sortedTimings.length < resolvedNumberOfTrips) {
                        const existingSequences = sortedTimings.map(t => t.timeSlotSequence);
                        finalTimings = [...sortedTimings];
                        for (let i = 1; i <= resolvedNumberOfTrips; i++) if (!existingSequences.includes(i)) finalTimings.push({ timeSlotSequence: i, arrivalTime: '', departureTime: '' });
                        finalTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
                    } else if (resolvedIsMultiTrip && sortedTimings.length > resolvedNumberOfTrips) {
                        finalTimings = sortedTimings.filter(t => t.timeSlotSequence <= resolvedNumberOfTrips).map((t, i) => ({ ...t, timeSlotSequence: i + 1 }));
                    }
                    return {
                        city: stop.city, state: stop.state || '', address: stop.address || '', terminal: stop.terminal || '',
                        arrivalTime: hasMultiTimings ? '' : (stop.arrivalTime || ''),
                        departureTime: hasMultiTimings ? '' : (stop.departureTime || ''),
                        timings: finalTimings, stopType: stop.stopType || 'none',
                        coordinates: stop.coordinates || { lat: 0, lng: 0 },
                        distanceFromOrigin: actualDist, manualDistFromPrev,
                        manualDistToNext: stop.manualDistToNext ? parseFloat(stop.manualDistToNext) : null,
                        isManualStop: stop.isManualStop === true || !stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0)
                    };
                });
    
                const transformedStops = transformStops(routeData.intermediateStops);
    
                let forwardManualFinalLeg = '';
                if (routeDetails.totalDistance && transformedStops.length > 0) {
                    const lastStopDist = transformedStops[transformedStops.length - 1].distanceFromOrigin || 0;
                    const calculated = routeDetails.totalDistance - lastStopDist;
                    if (calculated > 0) forwardManualFinalLeg = calculated.toFixed(1);
                }
    
                const originTimings = sortTimings(origin.timings || []);
                const destTimings = sortTimings(destination.timings || []);
    
                let finalOriginTimings = [...originTimings];
                if (resolvedIsMultiTrip && originTimings.length < resolvedNumberOfTrips) {
                    const existingSequences = originTimings.map(t => t.timeSlotSequence);
                    for (let i = 1; i <= resolvedNumberOfTrips; i++) if (!existingSequences.includes(i)) finalOriginTimings.push({ timeSlotSequence: i, departureTime: '', arrivalTime: '' });
                    finalOriginTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
                }
                let finalDestTimings = [...destTimings];
                if (resolvedIsMultiTrip && destTimings.length < resolvedNumberOfTrips) {
                    const existingSequences = destTimings.map(t => t.timeSlotSequence);
                    for (let i = 1; i <= resolvedNumberOfTrips; i++) if (!existingSequences.includes(i)) finalDestTimings.push({ timeSlotSequence: i, arrivalTime: '', departureTime: '' });
                    finalDestTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
                }
    
                setEditForm({
                    routeNumber: routeData.routeNumber || '', routeName: routeData.routeName || '', localRouteName: routeData.localRouteName || '',
                    isMultiTrip: resolvedIsMultiTrip, numberOfTrips: resolvedNumberOfTrips, timeSlots: routeData.timeSlots || [],
                    originCity: origin.city || '', originState: origin.state || '', originAddress: origin.address || '', originTerminal: origin.terminal || '',
                    originDepTime: origin.departureTime || '', originCoords: origin.coordinates || { lat: 0, lng: 0 }, originTimings: finalOriginTimings,
                    destCity: destination.city || '', destState: destination.state || '', destAddress: destination.address || '', destTerminal: destination.terminal || '',
                    destArrTime: destination.arrivalTime || '', destCoords: destination.coordinates || { lat: 0, lng: 0 }, destTimings: finalDestTimings,
                    totalDistance: routeDetails.totalDistance || '', durationHours: estimatedDuration.hours || '', durationMinutes: estimatedDuration.minutes || '',
                    intermediateStops: transformedStops, isActive: routeData.isActive !== undefined ? routeData.isActive : true,
                    isRoundTrip: routeData.isRoundTrip || false, returnJourney: routeData.returnJourney || null,
                    upManualFinalLeg: forwardManualFinalLeg,
                    upManualFirstLeg: transformedStops.length > 0 && transformedStops[0].manualDistFromPrev ? String(transformedStops[0].manualDistFromPrev) : ''
                });
    
                if (transformedStops.length > 0) {
                    setUpStops(transformedStops);
                    if (transformedStops.every(stop => stop.distanceFromOrigin > 0)) setIsDistanceCalculated(prev => ({ ...prev, up: true }));
                } else setUpStops([]);
    
                if (routeData.isRoundTrip && routeData.returnJourney) {
                    const returnJourney = routeData.returnJourney;
                    const returnOrigin = returnJourney.origin || {};
                    const returnDestination = returnJourney.destination || {};
                    const returnRouteDetails = returnJourney.routeDetails || {};
                    const returnEstimatedDuration = returnRouteDetails.estimatedDuration || {};
                    const transformedReturnStops = transformStops(returnJourney.intermediateStops);
    
                    let returnManualFinalLeg = '';
                    if (returnRouteDetails.totalDistance && transformedReturnStops.length > 0) {
                        const lastStopDist = transformedReturnStops[transformedReturnStops.length - 1].distanceFromOrigin || 0;
                        const calculated = returnRouteDetails.totalDistance - lastStopDist;
                        if (calculated > 0) returnManualFinalLeg = calculated.toFixed(1);
                    }
    
                    let returnOriginTimings = sortTimings(returnOrigin.timings || []);
                    let returnDestTimings = sortTimings(returnDestination.timings || []);
    
                    if (resolvedIsMultiTrip && returnOriginTimings.length < resolvedNumberOfTrips) {
                        const existingSequences = returnOriginTimings.map(t => t.timeSlotSequence);
                        for (let i = 1; i <= resolvedNumberOfTrips; i++) if (!existingSequences.includes(i)) returnOriginTimings.push({ timeSlotSequence: i, departureTime: '', arrivalTime: '' });
                        returnOriginTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
                    } else if (resolvedIsMultiTrip && returnOriginTimings.length === 0) {
                        returnOriginTimings = finalOriginTimings.map(t => ({ timeSlotSequence: t.timeSlotSequence, departureTime: '', arrivalTime: '' }));
                    }
                    if (resolvedIsMultiTrip && returnDestTimings.length < resolvedNumberOfTrips) {
                        const existingSequences = returnDestTimings.map(t => t.timeSlotSequence);
                        for (let i = 1; i <= resolvedNumberOfTrips; i++) if (!existingSequences.includes(i)) returnDestTimings.push({ timeSlotSequence: i, arrivalTime: '', departureTime: '' });
                        returnDestTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
                    } else if (resolvedIsMultiTrip && returnDestTimings.length === 0) {
                        returnDestTimings = finalDestTimings.map(t => ({ timeSlotSequence: t.timeSlotSequence, arrivalTime: '', departureTime: '' }));
                    }
    
                    setEditForm(prev => ({
                        ...prev,
                        returnOriginCity: returnOrigin.city || destination.city || '',
                        returnOriginState: returnOrigin.state || destination.state || '',
                        returnOriginAddress: returnOrigin.address || destination.address || '',
                        returnOriginTerminal: returnOrigin.terminal || destination.terminal || '',
                        returnOriginDepTime: returnOrigin.departureTime || '',
                        returnOriginCoords: returnOrigin.coordinates || destination.coordinates || { lat: 0, lng: 0 },
                        returnOriginTimings,
                        returnDestCity: returnDestination.city || origin.city || '',
                        returnDestState: returnDestination.state || origin.state || '',
                        returnDestAddress: returnDestination.address || origin.address || '',
                        returnDestTerminal: returnDestination.terminal || origin.terminal || '',
                        returnDestArrTime: returnDestination.arrivalTime || '',
                        returnDestCoords: returnDestination.coordinates || origin.coordinates || { lat: 0, lng: 0 },
                        returnDestTimings,
                        returnTotalDistance: returnRouteDetails.totalDistance || routeDetails.totalDistance || '',
                        returnDurationHours: returnEstimatedDuration.hours || estimatedDuration.hours || '',
                        returnDurationMinutes: returnEstimatedDuration.minutes || estimatedDuration.minutes || '',
                        returnIntermediateStops: transformedReturnStops,
                        returnManualFinalLeg,
                        returnManualFirstLeg: transformedReturnStops.length > 0 && transformedReturnStops[0].manualDistFromPrev ? String(transformedReturnStops[0].manualDistFromPrev) : ''
                    }));
    
                    if (transformedReturnStops.length > 0) {
                        setDownStops(transformedReturnStops);
                        if (transformedReturnStops.every(stop => stop.distanceFromOrigin > 0)) setIsDistanceCalculated(prev => ({ ...prev, down: true }));
                    } else setDownStops([]);
                } else {
                    setDownStops([]);
                    setEditForm(prev => ({
                        ...prev,
                        returnOriginCity: destination.city || '', returnOriginState: destination.state || '', returnOriginAddress: destination.address || '',
                        returnOriginTerminal: destination.terminal || '', returnOriginDepTime: '', returnOriginCoords: destination.coordinates || { lat: 0, lng: 0 },
                        returnDestCity: origin.city || '', returnDestState: origin.state || '', returnDestAddress: origin.address || '',
                        returnDestTerminal: origin.terminal || '', returnDestArrTime: '', returnDestCoords: origin.coordinates || { lat: 0, lng: 0 },
                        returnTotalDistance: routeDetails.totalDistance || '', returnDurationHours: estimatedDuration.hours || '',
                        returnDurationMinutes: estimatedDuration.minutes || '', returnIntermediateStops: [], returnManualFinalLeg: '', returnManualFirstLeg: ''
                    }));
                }
    
                if (routeData.isRoundTrip) { setIsRoundTrip(true); setActiveRouteTab('UP'); }
                else { setIsRoundTrip(false); setActiveRouteTab('UP'); }
    
                setShowEditModal(true);
            } catch (err) {
                console.error('Error fetching route for edit:', err);
                toast.error('Failed to load route for editing');
            }
        };
    
        const handleEditRoundTripToggle = (checked) => {
            if (checked) {
                const originCity = editForm.originCity || newRoute.upOriginCity || '';
                const originState = editForm.originState || newRoute.upOriginState || '';
                const originAddress = editForm.originAddress || newRoute.upOriginAddress || '';
                const originTerminal = editForm.originTerminal || newRoute.upOriginTerminal || '';
                const originCoords = editForm.originCoords || newRoute.upOriginCoords || { lat: 0, lng: 0 };
                const originDepTime = editForm.originDepTime || newRoute.upOriginDepTime || '';
                const destCity = editForm.destCity || newRoute.upDestCity || '';
                const destState = editForm.destState || newRoute.upDestState || '';
                const destAddress = editForm.destAddress || newRoute.upDestAddress || '';
                const destTerminal = editForm.destTerminal || newRoute.upDestTerminal || '';
                const destCoords = editForm.destCoords || newRoute.upDestCoords || { lat: 0, lng: 0 };
                const destArrTime = editForm.destArrTime || newRoute.upDestArrTime || '';
                const totalDist = editForm.totalDistance || newRoute.upTotalDistance || '';
                const durationH = editForm.durationHours || newRoute.upDurationHours || '';
                const durationM = editForm.durationMinutes || newRoute.upDurationMinutes || '';
                const numTrips = editForm.numberOfTrips || editNumberOfTrips || 1;
                const isMultiTripMode = editForm.isMultiTrip || editIsMultiTrip || false;
    
                let returnOriginTimings = [], returnDestTimings = [];
                if (isMultiTripMode) {
                    if (editForm.originTimings && editForm.originTimings.length > 0) returnOriginTimings = editForm.originTimings.map(t => ({ timeSlotSequence: t.timeSlotSequence, departureTime: '', arrivalTime: '' }));
                    else returnOriginTimings = Array.from({ length: numTrips }, (_, i) => ({ timeSlotSequence: i + 1, departureTime: '', arrivalTime: '' }));
                    if (editForm.destTimings && editForm.destTimings.length > 0) returnDestTimings = editForm.destTimings.map(t => ({ timeSlotSequence: t.timeSlotSequence, arrivalTime: '', departureTime: '' }));
                    else returnDestTimings = Array.from({ length: numTrips }, (_, i) => ({ timeSlotSequence: i + 1, arrivalTime: '', departureTime: '' }));
                }
    
                setEditForm(prev => ({
                    ...prev,
                    returnOriginCity: destCity, returnOriginState: destState, returnOriginAddress: destAddress, returnOriginTerminal: destTerminal,
                    returnOriginCoords: destCoords, returnOriginDepTime: isMultiTripMode ? '' : destArrTime, returnOriginTimings,
                    returnDestCity: originCity, returnDestState: originState, returnDestAddress: originAddress, returnDestTerminal: originTerminal,
                    returnDestCoords: originCoords, returnDestArrTime: isMultiTripMode ? '' : originDepTime, returnDestTimings,
                    returnTotalDistance: totalDist, returnDurationHours: durationH, returnDurationMinutes: durationM,
                    isMultiTrip: isMultiTripMode, numberOfTrips: numTrips, isRoundTrip: true
                }));
    
                if (upStops.length > 0) {
                    const upTotalDist = parseFloat(editForm.totalDistance || newRoute.upTotalDistance || 0);
                    const reversedStops = [...upStops].reverse();
                    const upDistances = upStops.map(stop => stop.distanceFromOrigin || 0);
                    const upSegments = [];
                    let prevDist = 0;
                    for (let i = 0; i < upDistances.length; i++) {
                        const segment = upDistances[i] - prevDist;
                        upSegments.push(segment > 0 ? segment : 5);
                        prevDist = upDistances[i];
                    }
                    const lastSegment = upTotalDist - (upDistances[upDistances.length - 1] || 0);
                    upSegments.push(lastSegment > 0 ? lastSegment : 5);
                    const downSegments = [...upSegments].reverse();
                    const newDownStops = [];
                    let cumulativeDist = 0;
                    for (let i = 0; i < reversedStops.length; i++) {
                        const stop = reversedStops[i];
                        let newStopType = stop.stopType;
                        if (stop.stopType === 'boarding') newStopType = 'dropping';
                        else if (stop.stopType === 'dropping') newStopType = 'boarding';
                        const segmentDist = downSegments[i] || 5;
                        cumulativeDist += segmentDist;
                        let stopTimings = [];
                        if (isMultiTripMode) {
                            if (stop.timings && stop.timings.length > 0) stopTimings = stop.timings.map(t => ({ timeSlotSequence: t.timeSlotSequence, arrivalTime: '', departureTime: '' }));
                            else stopTimings = Array.from({ length: numTrips }, (_, idx) => ({ timeSlotSequence: idx + 1, arrivalTime: '', departureTime: '' }));
                        }
                        let arrivalTime = '', departureTime = '';
                        if (!isMultiTripMode) {
                            if (stop.departureTime) departureTime = stop.departureTime;
                            if (stop.arrivalTime) arrivalTime = stop.arrivalTime;
                        }
                        newDownStops.push({
                            ...stop, sequence: i + 1, stopType: newStopType,
                            distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
                            manualDistFromPrev: parseFloat(segmentDist.toFixed(1)),
                            manualDistToNext: i < reversedStops.length - 1 ? parseFloat(downSegments[i + 1]?.toFixed(1) || 0) : null,
                            arrivalTime: isMultiTripMode ? '' : arrivalTime,
                            departureTime: isMultiTripMode ? '' : departureTime,
                            timings: stopTimings
                        });
                    }
                    const finalSegment = downSegments[downSegments.length - 1] || 5;
                    if (newDownStops.length > 0 && finalSegment > 0) {
                        const lastIndex = newDownStops.length - 1;
                        newDownStops[lastIndex] = { ...newDownStops[lastIndex], manualDistToNext: parseFloat(finalSegment.toFixed(1)) };
                    }
                    setDownStops(newDownStops);
                    setIsDistanceCalculated(prev => ({ ...prev, down: false }));
                    if (isMultiTripMode) toast.info(`Return route populated with ${newDownStops.length} reversed stops. Each stop has ${numTrips} trip timings to set.`);
                    else toast.info(`Return route populated with ${newDownStops.length} reversed stops.`);
                } else toast.info('Return route enabled. Add stops for the return journey or use the "Auto-Fill" button.');
                setActiveRouteTab('DOWN');
            } else {
                setDownStops([]);
                setIsDistanceCalculated(prev => ({ ...prev, down: false }));
                setEditForm(prev => ({
                    ...prev,
                    returnOriginCity: '', returnOriginState: '', returnOriginAddress: '', returnOriginTerminal: '', returnOriginDepTime: '', returnOriginCoords: null, returnOriginTimings: [],
                    returnDestCity: '', returnDestState: '', returnDestAddress: '', returnDestTerminal: '', returnDestArrTime: '', returnDestCoords: null, returnDestTimings: [],
                    returnTotalDistance: '', returnDurationHours: '', returnDurationMinutes: '', returnIntermediateStops: [], returnManualFinalLeg: '', returnManualFirstLeg: '', isRoundTrip: false
                }));
                setActiveRouteTab('UP');
                toast.info('Return route disabled');
            }
        };
    
        // ---------- handleUpdateRoute (unchanged) ----------
        const handleUpdateRoute = async () => {
            if (!editForm.routeName) { toast.error('Route Name is required'); return; }
            setIsUpdatingRoute(true);
            try {
                const isMultiTripMode = editForm.isMultiTrip || isMultiTrip;
    
                const cleanStops = (list) => {
                    if (!list || !Array.isArray(list)) return [];
                    return list.map((s, index) => {
                        if (!s.city) throw new Error(`Stop ${index + 1} is missing city name`);
                        const stopObj = { sequence: index + 1, city: s.city, state: s.state || '', address: s.address || `${s.city}, ${s.state || 'India'}`, terminal: s.terminal || `${s.city} Bus Stand`, stopType: s.stopType || 'none', coordinates: s.coordinates || { lat: 0, lng: 0 }, distanceFromOrigin: s.distanceFromOrigin || 0 };
                        if (s.manualDistFromPrev) stopObj.manualDistFromPrev = s.manualDistFromPrev;
                        if (s.manualDistToNext) stopObj.manualDistToNext = s.manualDistToNext;
                        if (s.isManualStop) stopObj.isManualStop = s.isManualStop;
                        if (isMultiTripMode) {
                            if (s.timings && s.timings.length > 0) stopObj.timings = sortTimings(s.timings).map(timing => ({ timeSlotSequence: timing.timeSlotSequence, arrivalTime: timing.arrivalTime || '', departureTime: timing.departureTime || timing.arrivalTime || '' }));
                            else { const numTrips = editForm.numberOfTrips || 1; stopObj.timings = Array.from({ length: numTrips }, (_, i) => ({ timeSlotSequence: i + 1, arrivalTime: s.arrivalTime || '', departureTime: s.departureTime || s.arrivalTime || '' })); }
                            stopObj.arrivalTime = s.arrivalTime || (stopObj.timings[0]?.arrivalTime) || '';
                            stopObj.departureTime = s.departureTime || (stopObj.timings[0]?.departureTime) || stopObj.arrivalTime;
                        } else {
                            if (!s.arrivalTime) throw new Error(`Stop ${index + 1} (${s.city}) is missing arrival time`);
                            stopObj.arrivalTime = s.arrivalTime;
                            stopObj.departureTime = s.departureTime || s.arrivalTime;
                            stopObj.timings = [];
                        }
                        return stopObj;
                    });
                };
    
                const originData = {
                    city: editForm.originCity, state: editForm.originState || '', address: editForm.originAddress || '',
                    terminal: editForm.originTerminal || editForm.originCity + ' Terminal', coordinates: editForm.originCoords || { lat: 0, lng: 0 }
                };
                if (isMultiTripMode && editForm.originTimings && editForm.originTimings.length > 0) originData.timings = sortTimings(editForm.originTimings).map(t => ({ timeSlotSequence: t.timeSlotSequence, departureTime: t.departureTime, arrivalTime: t.arrivalTime || '' }));
                else { originData.departureTime = editForm.originDepTime; originData.timings = []; }
    
                const destData = {
                    city: editForm.destCity, state: editForm.destState || '', address: editForm.destAddress || '',
                    terminal: editForm.destTerminal || editForm.destCity + ' Terminal', coordinates: editForm.destCoords || { lat: 0, lng: 0 },
                    distanceFromOrigin: parseFloat(editForm.totalDistance || 0)
                };
                if (isMultiTripMode && editForm.destTimings && editForm.destTimings.length > 0) destData.timings = sortTimings(editForm.destTimings).map(t => ({ timeSlotSequence: t.timeSlotSequence, arrivalTime: t.arrivalTime, departureTime: t.departureTime || '' }));
                else { destData.arrivalTime = editForm.destArrTime; destData.timings = []; }
    
                const updatePayload = {
                    routeName: editForm.routeName.trim(), localRouteName: editForm.localRouteName?.trim() || null,
                    isMultiTrip: isMultiTripMode, numberOfTrips: editForm.numberOfTrips || 1, timeSlots: editForm.timeSlots || [],
                    origin: originData, destination: destData, intermediateStops: cleanStops(upStops),
                    routeDetails: { totalDistance: parseFloat(editForm.totalDistance || 0), estimatedDuration: { hours: parseInt(editForm.durationHours || 0, 10), minutes: parseInt(editForm.durationMinutes || 0, 10) } },
                    isActive: editForm.isActive, isRoundTrip: editForm.isRoundTrip
                };
    
                if (editForm.isRoundTrip) {
                    const returnOriginData = { city: editForm.returnOriginCity || editForm.destCity, state: editForm.returnOriginState || editForm.destState, address: editForm.returnOriginAddress || editForm.destAddress, terminal: editForm.returnOriginTerminal || editForm.destTerminal, coordinates: editForm.returnOriginCoords || editForm.destCoords || { lat: 0, lng: 0 } };
                    if (isMultiTripMode && editForm.returnOriginTimings && editForm.returnOriginTimings.length > 0) returnOriginData.timings = sortTimings(editForm.returnOriginTimings).map(t => ({ timeSlotSequence: t.timeSlotSequence, departureTime: t.departureTime || '', arrivalTime: t.arrivalTime || '' }));
                    else if (isMultiTripMode && originData.timings && originData.timings.length > 0) returnOriginData.timings = originData.timings.map(t => ({ timeSlotSequence: t.timeSlotSequence, departureTime: '', arrivalTime: '' }));
                    else { returnOriginData.departureTime = editForm.returnOriginDepTime; returnOriginData.timings = []; }
    
                    const returnDestData = { city: editForm.returnDestCity || editForm.originCity, state: editForm.returnDestState || editForm.originState, address: editForm.returnDestAddress || editForm.originAddress, terminal: editForm.returnDestTerminal || editForm.originTerminal, coordinates: editForm.returnDestCoords || editForm.originCoords || { lat: 0, lng: 0 }, distanceFromOrigin: parseFloat(editForm.returnTotalDistance || 0) };
                    if (isMultiTripMode && editForm.returnDestTimings && editForm.returnDestTimings.length > 0) returnDestData.timings = sortTimings(editForm.returnDestTimings).map(t => ({ timeSlotSequence: t.timeSlotSequence, arrivalTime: t.arrivalTime || '', departureTime: t.departureTime || '' }));
                    else if (isMultiTripMode && destData.timings && destData.timings.length > 0) returnDestData.timings = destData.timings.map(t => ({ timeSlotSequence: t.timeSlotSequence, arrivalTime: '', departureTime: '' }));
                    else { returnDestData.arrivalTime = editForm.returnDestArrTime; returnDestData.timings = []; }
    
                    const cleanedReturnStops = downStops.map((stop, index) => {
                        const stopObj = { sequence: index + 1, city: stop.city, state: stop.state || '', address: stop.address || `${stop.city}, ${stop.state || 'India'}`, terminal: stop.terminal || `${stop.city} Bus Stand`, stopType: stop.stopType || 'none', coordinates: stop.coordinates || { lat: 0, lng: 0 }, distanceFromOrigin: stop.distanceFromOrigin || 0 };
                        if (stop.manualDistFromPrev) stopObj.manualDistFromPrev = stop.manualDistFromPrev;
                        if (stop.manualDistToNext) stopObj.manualDistToNext = stop.manualDistToNext;
                        if (stop.isManualStop) stopObj.isManualStop = stop.isManualStop;
                        if (isMultiTripMode) {
                            if (stop.timings && stop.timings.length > 0) stopObj.timings = sortTimings(stop.timings).map(timing => ({ timeSlotSequence: timing.timeSlotSequence, arrivalTime: timing.arrivalTime || '', departureTime: timing.departureTime || timing.arrivalTime || '' }));
                            else { const numTrips = editForm.numberOfTrips || 1; stopObj.timings = Array.from({ length: numTrips }, (_, i) => ({ timeSlotSequence: i + 1, arrivalTime: stop.arrivalTime || '', departureTime: stop.departureTime || stop.arrivalTime || '' })); }
                            stopObj.arrivalTime = stop.arrivalTime || (stopObj.timings[0]?.arrivalTime) || '';
                            stopObj.departureTime = stop.departureTime || (stopObj.timings[0]?.departureTime) || stopObj.arrivalTime;
                        } else {
                            if (!stop.arrivalTime) throw new Error(`Return stop ${index + 1} (${stop.city}) is missing arrival time`);
                            stopObj.arrivalTime = stop.arrivalTime;
                            stopObj.departureTime = stop.departureTime || stop.arrivalTime;
                            stopObj.timings = [];
                        }
                        return stopObj;
                    });
    
                    updatePayload.returnOrigin = returnOriginData;
                    updatePayload.returnDestination = returnDestData;
                    updatePayload.returnIntermediateStops = cleanedReturnStops;
                    updatePayload.returnRouteDetails = { totalDistance: parseFloat(editForm.returnTotalDistance || 0), estimatedDuration: { hours: parseInt(editForm.returnDurationHours || 0, 10), minutes: parseInt(editForm.returnDurationMinutes || 0, 10) } };
                }
    
                const response = isEditingPending
                    ? await updatePendingRoute(editingPendingId, updatePayload, token)
                    : await updateRoute(editingRoute._id, updatePayload, token);
    
                if (response.success) {
                    toast.success(isEditingPending ? 'Pending route updated successfully!' : 'Route updated successfully!');
                    setShowEditModal(false);
                    setEditingRoute(null);
                    setEditForm({});
                    setIsEditingPending(false);
                    setEditingPendingId(null);
                    if (isEditingPending) await fetchPendingRoutes();
                    else fetchRoutes();
                } else throw new Error(response.message || 'Failed to update route');
            } catch (err) {
                console.error('Error updating route:', err);
                toast.error(err.message || 'Failed to update route');
            } finally { setIsUpdatingRoute(false); }
        };
    
        const handleEditOriginSelect = (location) => {
            setEditForm(prev => ({ ...prev, originCity: location.city || location.name || '', originState: location.state || '', originAddress: location.address || '', originCoords: location.coordinates || { lat: 0, lng: 0 } }));
        };
        const handleEditDestSelect = (location) => {
            setEditForm(prev => ({ ...prev, destCity: location.city || location.name || '', destState: location.state || '', destAddress: location.address || '', destCoords: location.coordinates || { lat: 0, lng: 0 } }));
        };
    
        const handleToggleStatus = async (routeId, currentStatus) => {
            const newStatus = !currentStatus;
            const action = newStatus ? 'activate' : 'deactivate';
            if (window.confirm(`Are you sure you want to ${action} this route?`)) {
                try {
                    const response = await toggleRouteStatus(routeId, newStatus, token);
                    if (response.success) {
                        setRoutes(prevRoutes => prevRoutes.map(route => route.id === routeId ? { ...route, isActive: newStatus, status: newStatus ? 'Active' : 'Inactive' } : route));
                        toast.success(`Route ${action}d successfully!`);
                    } else throw new Error(response.message || `Failed to ${action} route`);
                } catch (err) {
                    console.error(`Error ${action}ing route:`, err);
                    toast.error(`Failed to ${action} route`);
                }
            }
        };
    
        const saveInsertedStop = () => {
            if (!insertStopForm.city) { toast.error('City is required'); return; }
            if (!insertStopForm.state || insertStopForm.state.trim() === '') { toast.error('State is required'); return; }
            if (!insertStopForm.address || insertStopForm.address.trim() === '') { toast.error('Address is required'); return; }
            if (!insertStopForm.terminal || insertStopForm.terminal.trim() === '') { toast.error('Terminal is required'); return; }
            if (!insertStopForm.arrivalTime) { toast.error('Arrival time is required'); return; }
            const isManualLocation = insertStopForm.isManualStop;
            if (isManualLocation && (!insertStopForm.manualDistFromPrev || parseFloat(insertStopForm.manualDistFromPrev) <= 0)) { toast.error('For manual stops, please provide distance from previous stop'); return; }
    
            let stopType = 'none';
            if (insertStopForm.isBoarding && insertStopForm.isDropping) stopType = 'both';
            else if (insertStopForm.isBoarding) stopType = 'boarding';
            else if (insertStopForm.isDropping) stopType = 'dropping';
    
            const type = activeRouteTab === 'UP' ? 'up' : 'down';
            const currentStops = type === 'up' ? [...upStops] : [...downStops];
    
            let manualDistFromPrev = isManualLocation ? parseFloat(insertStopForm.manualDistFromPrev) : null;
            let manualDistToNext = insertStopForm.manualDistToNext ? parseFloat(insertStopForm.manualDistToNext) : null;
    
            let distanceFromOrigin = 0;
            if (pendingInsertIndex > 0 && currentStops[pendingInsertIndex - 1]) distanceFromOrigin = (currentStops[pendingInsertIndex - 1].distanceFromOrigin || 0) + (manualDistFromPrev || 0);
            else distanceFromOrigin = manualDistFromPrev || 0;
    
            const newStop = {
                city: insertStopForm.city, state: insertStopForm.state || '',
                address: insertStopForm.address || `${insertStopForm.city}, ${insertStopForm.state || 'India'}`,
                terminal: insertStopForm.terminal || `${insertStopForm.city} Bus Stand`,
                arrivalTime: insertStopForm.arrivalTime, departureTime: insertStopForm.departureTime || insertStopForm.arrivalTime,
                stopType, coordinates: isManualLocation ? { lat: 0, lng: 0 } : null,
                manualDistFromPrev, manualDistToNext, distanceFromOrigin, isManualStop: isManualLocation
            };
    
            currentStops.splice(pendingInsertIndex, 0, newStop);
            setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));
    
            if (type === 'up') setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
            else setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
    
            toast.success(`Stop "${insertStopForm.city}" inserted at position ${pendingInsertIndex + 1}`);
            setShowStopInsertModal(false);
            setPendingInsertIndex(null);
            setInsertCitySuggestions([]);
            setShowInsertCityDropdown(false);
        };
    
        const handleDeleteRoute = async (routeId) => {
            if (window.confirm('Are you sure you want to delete this route?')) {
                try {
                    const response = await deleteRoute(routeId, token);
                    if (response.success) { setRoutes(prevRoutes => prevRoutes.filter(route => route.id !== routeId)); setTotalRoutes(prev => prev - 1); toast.success('Route deleted successfully!'); }
                    else throw new Error(response.message || 'Failed to delete route');
                } catch (err) { console.error('Error deleting route:', err); toast.error('Failed to delete route'); }
            }
        };
    
        const renderInsertButton = (idx, type = 'up') => {
            const isOpen = inlineInsertIndex === idx;
            return (
                <div key={`insert-wrap-${idx}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '8px 0' }}>
                    <div style={{ width: 2, height: 16, background: 'rgba(0,0,0,.12)', flexShrink: 0 }} />
                    <button
                        onClick={() => {
                            if (isOpen) { setInlineInsertIndex(null); setInlineInsertCitySuggestions([]); setShowInlineInsertDropdown(false); }
                            else {
                                let defaultState = '';
                                const currentStops = type === 'up' ? upStops : downStops;
                                if (idx > 0 && currentStops[idx - 1]?.state) defaultState = currentStops[idx - 1].state;
                                else if (newRoute.upOriginState) defaultState = newRoute.upOriginState;
                                setInlineInsertForm({ city: '', state: defaultState, address: '', terminal: '', arrivalTime: '', departureTime: '', isBoarding: false, isDropping: false, manualDistFromPrev: '', manualDistToNext: '', isManual: true, stopType: 'none' });
                                setInlineInsertCitySuggestions([]); setShowInlineInsertDropdown(false); setInlineInsertIndex(idx);
                            }
                        }}
                        style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '5px 14px', borderRadius: 999, border: `1.5px ${isOpen ? 'solid' : 'dashed'} ${isOpen ? '#378add' : 'rgba(0,0,0,.25)'}`, background: isOpen ? '#e6f1fb' : 'var(--color-background-primary, #fff)', fontSize: 12, fontWeight: 500, color: isOpen ? '#185fa5' : 'var(--color-text-secondary, #666)', cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all .15s' }}>
                        <span style={{ fontSize: 15 }}>{isOpen ? '✕' : '+'}</span>
                        {isOpen ? 'Cancel insert' : 'Insert stop here'}
                    </button>
                    <div style={{ width: 2, height: isOpen ? 0 : 16, background: 'rgba(0,0,0,.12)', flexShrink: 0 }} />
                    {isOpen && renderInlineInsertPanel(idx)}
                </div>
            );
        };
    
        const activeRoutes = currentRoutes.filter(r => r.isActive).length;
        const totalDistance = currentRoutes.reduce((sum, route) => sum + (parseInt(route.distance) || 0), 0);
        const totalStops = currentRoutes.reduce((sum, route) => sum + (parseInt(route.stops) || 0), 0);


    useEffect(() => {
        const isMultiTripMode = editForm.isMultiTrip || editIsMultiTrip || isMultiTrip;

        if (!isMultiTripMode)
            return;

        const originTimings = editForm.originTimings || [];
        const destTimings = editForm.destTimings || [];

        if (originTimings.length === 0 || destTimings.length === 0)
            return;

        const firstOrigin = originTimings[0];
        const firstDest = destTimings[0];

        const depTime = firstOrigin?.departureTime || editForm.originDepTime || '';
        const arrTime = firstDest?.arrivalTime || editForm.destArrTime || '';

        if (depTime && arrTime) {
            const [depHour, depMin] = depTime.split(':').map(Number);
            const [arrHour, arrMin] = arrTime.split(':').map(Number);

            if (!isNaN(depHour) && !isNaN(depMin) && !isNaN(arrHour) && !isNaN(arrMin)) {
                let depTotalMins = depHour * 60 + depMin;
                let arrTotalMins = arrHour * 60 + arrMin;

                if (arrTotalMins < depTotalMins) {
                    arrTotalMins += 24 * 60;
                }

                const durationMins = arrTotalMins - depTotalMins;
                const hours = Math.floor(durationMins / 60);
                const minutes = durationMins % 60;

                setEditForm(prev => ({
                    ...prev,
                    durationHours: hours.toString(),
                    durationMinutes: minutes.toString()
                }));
            }
        }
    }, [editForm.originTimings, editForm.destTimings, editForm.isMultiTrip, editIsMultiTrip, isMultiTrip, editForm.originDepTime, editForm.destArrTime]);

    useEffect(() => {
        const isMultiTripMode = editForm.isMultiTrip || editIsMultiTrip || isMultiTrip;

        if (!isMultiTripMode) return;
        if (!editForm.isRoundTrip)
            return;

        const returnOriginTimings = editForm.returnOriginTimings || [];
        const returnDestTimings = editForm.returnDestTimings || [];

        if (returnOriginTimings.length === 0 || returnDestTimings.length === 0)
            return;

        const firstReturnOrigin = returnOriginTimings[0];
        const firstReturnDest = returnDestTimings[0];

        const depTime = firstReturnOrigin?.departureTime || editForm.returnOriginDepTime || '';
        const arrTime = firstReturnDest?.arrivalTime || editForm.returnDestArrTime || '';

        if (depTime && arrTime) {
            const [depHour, depMin] = depTime.split(':').map(Number);
            const [arrHour, arrMin] = arrTime.split(':').map(Number);

            if (!isNaN(depHour) && !isNaN(depMin) && !isNaN(arrHour) && !isNaN(arrMin)) {
                let depTotalMins = depHour * 60 + depMin;
                let arrTotalMins = arrHour * 60 + arrMin;

                if (arrTotalMins < depTotalMins) {
                    arrTotalMins += 24 * 60;
                }

                const durationMins = arrTotalMins - depTotalMins;
                const hours = Math.floor(durationMins / 60);
                const minutes = durationMins % 60;

                setEditForm(prev => ({
                    ...prev,
                    returnDurationHours: hours.toString(),
                    returnDurationMinutes: minutes.toString()
                }));
            }
        }
    }, [editForm.returnOriginTimings, editForm.returnDestTimings, editForm.isRoundTrip, editForm.isMultiTrip, editIsMultiTrip, isMultiTrip, editForm.returnOriginDepTime, editForm.returnDestArrTime]);

    useEffect(() => {
        if (!isMultiTrip)
            return;

        if (timeSlots.length === 0 || destinationTimeSlots.length === 0)
            return;

        const firstOrigin = timeSlots[0];
        const firstDest = destinationTimeSlots[0];

        const depTime = firstOrigin?.departureTime || newRoute.upOriginDepTime || '';
        const arrTime = firstDest?.arrivalTime || newRoute.upDestArrTime || '';

        if (depTime && arrTime) {
            const [depHour, depMin] = depTime.split(':').map(Number);
            const [arrHour, arrMin] = arrTime.split(':').map(Number);

            if (!isNaN(depHour) && !isNaN(depMin) && !isNaN(arrHour) && !isNaN(arrMin)) {
                let depTotalMins = depHour * 60 + depMin;
                let arrTotalMins = arrHour * 60 + arrMin;

                if (arrTotalMins < depTotalMins) {
                    arrTotalMins += 24 * 60;
                }

                const durationMins = arrTotalMins - depTotalMins;
                const hours = Math.floor(durationMins / 60);
                const minutes = durationMins % 60;

                setNewRoute(prev => ({
                    ...prev,
                    upDurationHours: hours.toString(),
                    upDurationMinutes: minutes.toString()
                }));
            }
        }
    }, [timeSlots, destinationTimeSlots, isMultiTrip, newRoute.upOriginDepTime, newRoute.upDestArrTime]);

    useEffect(() => {
        if (!isMultiTrip) return;
        if (!isRoundTrip)
            return;

        if (returnOriginTimeSlots.length === 0 || returnDestTimeSlots.length === 0)
            return;

        const firstReturnOrigin = returnOriginTimeSlots[0];
        const firstReturnDest = returnDestTimeSlots[0];

        const depTime = firstReturnOrigin?.departureTime || newRoute.downOriginDepTime || '';
        const arrTime = firstReturnDest?.arrivalTime || newRoute.downDestArrTime || '';

        if (depTime && arrTime) {
            const [depHour, depMin] = depTime.split(':').map(Number);
            const [arrHour, arrMin] = arrTime.split(':').map(Number);

            if (!isNaN(depHour) && !isNaN(depMin) && !isNaN(arrHour) && !isNaN(arrMin)) {
                let depTotalMins = depHour * 60 + depMin;
                let arrTotalMins = arrHour * 60 + arrMin;

                if (arrTotalMins < depTotalMins) {
                    arrTotalMins += 24 * 60;
                }

                const durationMins = arrTotalMins - depTotalMins;
                const hours = Math.floor(durationMins / 60);
                const minutes = durationMins % 60;

                setNewRoute(prev => ({
                    ...prev,
                    downDurationHours: hours.toString(),
                    downDurationMinutes: minutes.toString()
                }));
            }
        }
    }, [returnOriginTimeSlots, returnDestTimeSlots, isMultiTrip, isRoundTrip, newRoute.downOriginDepTime, newRoute.downDestArrTime]);




useEffect(() => {
    if (searchTerm || filterOrigin || filterDestination) {
        setCurrentPage(1);
    }

    const timer = setTimeout(() => {
        if (viewMode === 'regular') {
            fetchRoutes();
        } else {
            fetchPendingRoutes();
        }
    }, 500);

    return () => clearTimeout(timer);
}, [viewMode, currentPage, searchTerm, filterOrigin, filterDestination]);

  useEffect(() => {
        if (restorePromptShown.current) return;

        const savedData = localStorage.getItem('pendingRouteFormData');

        if (savedData) {
            try {
                const formData = JSON.parse(savedData);

                if (!formData || typeof formData !== 'object') {
                    throw new Error('Invalid form data structure');
                }

                const hasContent = formData.routeName ||
                    formData.upOriginCity ||
                    formData.upDestCity ||
                    (formData.upStops && formData.upStops.length > 0);

                if (!hasContent) {
                    localStorage.removeItem('pendingRouteFormData');
                    return;
                }

                restorePromptShown.current = true;

                setTimeout(() => {
                    if (!isMounted.current) return;

                    if (window.confirm('You have unsaved route data. Would you like to restore it?')) {
                        setNewRoute(prev => ({
                            ...prev,
                            routeName: formData.routeName || '',
                            localRouteName: formData.localRouteName || '',
                            upOriginCity: formData.upOriginCity || '',
                            upOriginState: formData.upOriginState || '',
                            upOriginAddress: formData.upOriginAddress || '',
                            upOriginTerminal: formData.upOriginTerminal || '',
                            upOriginCoords: formData.upOriginCoords || null,
                            upOriginDepTime: formData.upOriginDepTime || '',
                            upDestCity: formData.upDestCity || '',
                            upDestState: formData.upDestState || '',
                            upDestAddress: formData.upDestAddress || '',
                            upDestTerminal: formData.upDestTerminal || '',
                            upDestCoords: formData.upDestCoords || null,
                            upDestArrTime: formData.upDestArrTime || '',
                            upTotalDistance: formData.upTotalDistance || '',
                            upDurationHours: formData.upDurationHours || '',
                            upDurationMinutes: formData.upDurationMinutes || '',
                            downOriginDepTime: formData.downOriginDepTime || '',
                            downDestArrTime: formData.downDestArrTime || '',
                            downTotalDistance: formData.downTotalDistance || '',
                            downDurationHours: formData.downDurationHours || '',
                            downDurationMinutes: formData.downDurationMinutes || '',
                            upManualFinalLeg: formData.upManualFinalLeg || '',
                            downManualFinalLeg: formData.downManualFinalLeg || '',
                            stopCity: formData.stopCity || '',
                            stopState: formData.stopState || '',
                            stopAddress: formData.stopAddress || '',
                            stopTerminal: formData.stopTerminal || '',
                            stopCoords: formData.stopCoords || null,
                            stopArrivalTime: formData.stopArrivalTime || '',
                            stopDepartureTime: formData.stopDepartureTime || '',
                            stopDistFromPrev: formData.stopDistFromPrev || '',
                            stopDistToNext: formData.stopDistToNext || '',
                            isBoarding: formData.isBoarding || false,
                            isDropping: formData.isDropping || false
                        }));

                        if (formData.isMultiTrip !== undefined) {
                            setIsMultiTrip(formData.isMultiTrip);
                        }
                        if (formData.numberOfTrips !== undefined) {
                            setNumberOfTrips(formData.numberOfTrips);
                        }
                        if (formData.timeSlots) {
                            setTimeSlots(formData.timeSlots);
                        }
                        if (formData.destinationTimeSlots) {
                            setDestinationTimeSlots(formData.destinationTimeSlots);
                        }
                        if (formData.destinationNumberOfTrips !== undefined) {
                            setDestinationNumberOfTrips(formData.destinationNumberOfTrips);
                        }
                        if (formData.returnOriginTimeSlots) {
                            setReturnOriginTimeSlots(formData.returnOriginTimeSlots);
                        }
                        if (formData.returnDestTimeSlots) {
                            setReturnDestTimeSlots(formData.returnDestTimeSlots);
                        }

                        if (formData.isRoundTrip !== undefined) {
                            setIsRoundTrip(formData.isRoundTrip);
                        }

                        if (formData.upStops && Array.isArray(formData.upStops)) {
                            setUpStops(formData.upStops);
                        }
                        if (formData.downStops && Array.isArray(formData.downStops)) {
                            setDownStops(formData.downStops);
                        }

                        if (formData.activeRouteTab) {
                            setActiveRouteTab(formData.activeRouteTab);
                        }

                        if (formData.isDistanceCalculated) {
                            setIsDistanceCalculated(prev => ({
                                ...prev,
                                ...formData.isDistanceCalculated
                            }));
                        }

                        toast.success('Route data restored successfully!');
                    }

                    localStorage.removeItem('pendingRouteFormData');
                }, 100);

            } catch (error) {
                console.error('Failed to parse saved route data:', error);
                console.error('Corrupted data:', savedData);

                try {
                    localStorage.removeItem('pendingRouteFormData');
                    console.log('Removed corrupted route data from localStorage');
                } catch (removeError) {
                    console.error('Failed to remove corrupted data:', removeError);
                }

                toast.warning('Saved route data was corrupted and has been cleared. Please fill in the form again.');
            }
        }
    }, []);
 useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        if (isRoundTrip && activeRouteTab === 'DOWN' && downStops.length > 0) {
            const missingDistances = downStops.some(stop =>
                stop.distanceFromOrigin === undefined || stop.distanceFromOrigin === 0
            );

            if (missingDistances && upStops.length > 0 && isDistanceCalculated.up) {
                const upTotalDist = parseFloat(newRoute.upTotalDistance) || 0;
                const downTotalDist = parseFloat(newRoute.downTotalDistance) || 0;

                if (downTotalDist === 0 && upTotalDist > 0) {
                    syncDownStopsWithUpStops(false);
                }
            }
        }
    }, [downStops, upStops, isRoundTrip, activeRouteTab, isDistanceCalculated.up]);

 
    useEffect(() => {
        if (stopEditForm.timings && stopEditForm.timings.length > 0) {
            setStopEditForm(prev => ({
                ...prev,
                tripCount: stopEditForm.timings.length
            }));
        }
    }, [stopEditForm.timings]);

            // ============================================================
        // FIRST LOAD SKELETON
        // ============================================================
        if (isLoading && currentRoutes.length === 0 && !pendingRoutes.length) {
            return (
                <div className="prm-page">
                    <div className="prm-hero"><div className="prm-hero-text">
                        <span className="prm-eyebrow"><Icon name="grid" size={13} /> Routes</span>
                        <h1>Route Management</h1><p>Loading routes…</p>
                    </div></div>
                    <div style={{ height: 24 }} />
                    <div className="prm-grid">{[0, 1, 2].map(i => <div className="prm-skel" key={i}><div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" /></div>)}</div>
                </div>
            );
        }

    if (isLoading) {
        return (
            <div className="management-page">
                <div className="page-header">
                    <div className="skeleton-header-title"></div>
                    <div className="header-actions">
                        <div className="skeleton-search"></div>
                        <div className="skeleton-button"></div>
                        <div className="skeleton-button"></div>
                    </div>
                </div>

                <div className="stats-cards">
                    {[1, 2, 3, 4].map((i) => (
                        <SkeletonStatsCard key={i} />
                    ))}
                </div>

                <SkeletonTable />

                <div className="pagination-container">
                    <div className="skeleton-pagination-info"></div>
                    <div className="skeleton-pagination-controls"></div>
                </div>
            </div>
        );
    }


    return (
        <div className="prm-page">
            {/* ============================== HERO ============================== */}
            <div className="prm-hero">
                <div className="prm-hero-road" aria-hidden="true">
                    <span className="prm-hero-roadbus"><BusSvg size={46} /></span>
                </div>
                <div className="prm-hero-text">
                    <span className="prm-eyebrow"><Icon name="map" size={13} /> Route Insights</span>
                    <h1>Route Management</h1>
                    <p>Browse registered routes, edit stops, sync UP/DOWN journeys and manage executive submissions.</p>
                </div>
                <div className="prm-hero-actions">
                    <div className="prm-search">
                        <Icon name="search" size={17} />
                        <input
                            type="text"
                            placeholder="Search routes by name…"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        {searchTerm && <button className="prm-search-clear" onClick={() => setSearchTerm('')}>×</button>}
                    </div>
                    <button className="prm-btn ghost" onClick={() => {
                        if (viewMode === 'regular') fetchRoutes();
                        else fetchPendingRoutes();
                    }} title="Refresh" style={{ padding: '13px 16px' }}>
                        <Icon name="refresh" size={16} />
                    </button>
                    {viewMode === 'regular' && (
                        <button className="prm-add-btn" onClick={() => setShowAddModal(true)}>
                            <span className="plus"><Icon name="plus" size={14} /></span> Add Route
                        </button>
                    )}
                </div>
            </div>

            {error && (
                <div className="prm-callout rose" style={{ marginTop: 20, marginBottom: -6, background: '#ffe4ea', borderColor: '#e11d48', color: '#be123c' }}>
                    <Icon name="info" size={18} />
                    <div>
                        <strong>Error</strong>
                        <span>{error}</span>
                    </div>
                    <button className="prm-btn ghost sm" style={{ marginLeft: 'auto' }} onClick={() => setError(null)}>Dismiss</button>
                </div>
            )}

            {/* ============================== STATS ============================== */}
            <div className="prm-stats">
                <StatCard icon="route" tone="indigo" label={viewMode === 'regular' ? 'Total Routes' : 'Pending Routes'} value={viewMode === 'regular' ? totalRoutes : pendingRoutes.length} hint={viewMode === 'regular' ? 'All registered routes' : 'Awaiting approval'} delay={80} />
                <StatCard icon="check" tone="green" label="Active Routes" value={activeRoutes} hint="Currently active" delay={160} />
                <StatCard icon="bus" tone="amber" label="Total Stops" value={totalStops} hint="Across all routes" delay={240} />
                <StatCard icon="pin" tone="cyan" label="Total Distance" value={totalDistance} hint="km covered" delay={320} />
            </div>

            {/* ============================== TOOLBAR ============================== */}
            <div className="prm-toolbar">
                <div className="prm-toolbar-left">
                    <div className="prm-segment">
                        <span className="prm-segment-pill" style={{ transform: `translateX(${viewMode === 'regular' ? 0 : 100}%)` }} />
                        <button className={viewMode === 'regular' ? 'active' : ''} onClick={() => { setViewMode('regular'); setCurrentPage(1); setSearchTerm(''); }}>
                            <Icon name="map" size={15} /> Regular
                        </button>
                        <button className={viewMode === 'pending' ? 'active' : ''} onClick={() => { setViewMode('pending'); setCurrentPage(1); setSearchTerm(''); }}>
                            <Icon name="clipboard" size={15} /> Executive Submitted
                            {pendingRoutes.length > 0 && (
                                <span style={{ background: 'var(--amber)', color: 'var(--navy-950)', padding: '1px 7px', borderRadius: 999, fontSize: 10.5, fontWeight: 800, marginLeft: 4 }}>
                                    {pendingRoutes.length}
                                </span>
                            )}
                        </button>
                    </div>

                    {/* Origin / Destination filter chips */}
                    <div className="prm-chips">
                        <button
                            className="prm-chip"
                            onClick={() => {
                                const v = window.prompt('Filter by Origin City', filterOrigin);
                                if (v !== null) { setFilterOrigin(v); setCurrentPage(1); }
                            }}
                            title="Filter by Origin City"
                        >
                            <Icon name="pin" size={13} /> {filterOrigin || 'Origin'}
                        </button>
                        <button
                            className="prm-chip"
                            onClick={() => {
                                const v = window.prompt('Filter by Destination City', filterDestination);
                                if (v !== null) { setFilterDestination(v); setCurrentPage(1); }
                            }}
                            title="Filter by Destination City"
                        >
                            <Icon name="pin" size={13} /> {filterDestination || 'Destination'}
                        </button>
                        {(filterOrigin || filterDestination) && (
                            <button className="prm-chip" onClick={() => { setFilterOrigin(''); setFilterDestination(''); setCurrentPage(1); }}>
                                <Icon name="x" size={12} /> Clear filters
                            </button>
                        )}
                    </div>
                </div>

                <div className="prm-toolbar-right">
                    <span className="prm-result-count">Showing <b>{currentRoutes.length}</b> of {viewMode === 'regular' ? totalRoutes : pendingRoutes.length}</span>
                </div>
            </div>

            {/* ============================== LIST ============================== */}
            {currentRoutes.length === 0 && !isLoading ? (
                <div className="prm-empty">
                    <div className="icon"><Icon name={searchTerm || filterOrigin || filterDestination ? 'search' : 'route'} size={44} /></div>
                    <h3>{searchTerm || filterOrigin || filterDestination ? 'No routes match your search' : viewMode === 'pending' ? 'No pending routes' : 'No routes yet'}</h3>
                    <p>{searchTerm || filterOrigin || filterDestination ? 'Try a different search term or clear the filters.' : viewMode === 'pending' ? 'Executive-submitted routes will appear here.' : 'Registered routes will appear here.'}</p>
                    {(searchTerm || filterOrigin || filterDestination) && (
                        <button className="prm-btn ghost" onClick={() => { setSearchTerm(''); setFilterOrigin(''); setFilterDestination(''); setCurrentPage(1); }}>Clear filters</button>
                    )}
                </div>
            ) : (
                <div className="prm-table-wrap">
                    <table className="prm-table">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Route</th>
                                <th>Origin → Destination</th>
                                <th>Departure</th>
                                <th>Arrival</th>
                                <th>Distance</th>
                                <th>Stops</th>
                                <th>Type</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentRoutes.map((route, i) => (
                                <tr key={route.id} className={route.isPending ? 'rm-pending-row' : ''} style={{ animationDelay: `${i * 60}ms` }}>
                                    <td><b style={{ color: 'var(--muted)' }}>{route.serialNo}</b></td>
                                    <td>
                                        <div className="name">{route.routeName}</div>
                                        <div className="sub">{route.localRouteName || '—'}</div>
                                    </td>
                                    <td>
                                        <div className="name">{route.originCity}</div>
                                        <div className="sub">→ {route.destinationCity}</div>
                                    </td>
                                    <td>{route.departureTime}</td>
                                    <td>{route.arrivalTime}</td>
                                    <td><b>{route.distance} km</b></td>
                                    <td>{route.stops}</td>
                                    <td>
                                        <span className="prm-tag" style={{
                                            background: route.isRoundTrip ? 'var(--amber-soft)' : 'var(--blue-soft)',
                                            color: route.isRoundTrip ? 'var(--amber-deep)' : 'var(--navy-800)'
                                        }}>
                                            {route.isRoundTrip ? '🔄 Round Trip' : '➡️ One Way'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className={`prm-status ${route.isPending ? 'inactive' : route.isActive ? 'active' : 'inactive'}`}>
                                            {route.isPending ? 'Pending' : route.status}
                                        </span>
                                    </td>
                                    <td>
                                        <div className="prm-row-actions">
                                            {/* VIEW */}
                                            <button className="prm-btn view icon-only" onClick={() => handleViewRoute(route)} title="View" aria-label="View"><Icon name="eye" size={15} /></button>

                                            {!route.isPending ? (
                                                <>
                                                    {/* EDIT */}
                                                    <button className="prm-btn ghost icon-only" onClick={() => handleEditRoute(route)} title="Edit" aria-label="Edit"><Icon name="edit" size={15} /></button>

                                                    {/* ACTIVATE / DEACTIVATE */}
                                                    <button className={`prm-btn ${route.isActive ? 'ghost' : 'primary'} icon-only`} onClick={() => handleToggleStatus(route.id, route.isActive)} title={route.isActive ? 'Deactivate' : 'Activate'}><Icon name={route.isActive ? 'x' : 'check'} size={15} /></button>

                                                    {/* LOGS */}
                                                    <button className="prm-btn ghost icon-only" onClick={() => setLogModal({ show: true, routeId: route.id, routeName: route.routeName })} title="Activity Logs" aria-label="Activity Logs"><Icon name="clock" size={15} /></button>

                                                    {/* DELETE */}
                                                    <button className="prm-btn danger icon-only" onClick={() => handleDeleteRoute(route.id)} title="Delete" aria-label="Delete"><Icon name="trash" size={15} /></button>
                                                </>
                                            ) : (
                                                <>
                                                    {/* EDIT PENDING */}
                                                    <button className="prm-btn ghost icon-only" onClick={() => handleEditPendingRoute(route)} title="Edit" aria-label="Edit"><Icon name="edit" size={15} /></button>
                                                    <button className="prm-btn primary icon-only" onClick={() => handleApprovePendingRoute(route.id)} title="Approve" aria-label="Approve"><Icon name="check" size={15} /></button>
                                                    <button className="prm-btn danger icon-only" onClick={() => handleRejectPendingRoute(route.id)} title="Reject" aria-label="Reject"><Icon name="x" size={15} /></button>
                                                    {route.submittedByName && (
                                                        <span style={{ fontSize: 10, color: 'var(--amber-deep)', width: '100%', marginTop: 4 }}>
                                                            By: {route.submittedByName}
                                                        </span>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* ============================== PAGINATION ============================== */}
            {viewMode === 'regular' && totalPages > 1 && (
                <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 22 }}>
                    <button className="prm-btn ghost" onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1}>
                        <Icon name="x" size={14} style={{ transform: 'rotate(180deg)' }} /> Previous
                    </button>
                    <span style={{ padding: '11px 16px', fontWeight: 700, color: 'var(--navy-800)' }}>
                        Page {currentPage} of {totalPages}
                    </span>
                    <button className="prm-btn ghost" onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages}>
                        Next <Icon name="x" size={14} />
                    </button>
                </div>
            )}

            {/* ============================================================
                ADD ROUTE MODAL — Modern redesign
            ============================================================ */}
            {showAddModal && (
                <div className="prm-overlay" onClick={() => setShowAddModal(false)}>
                    <div className="prm-form-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="prm-form-head">
                            <div className="prm-form-head-row">
                                <span className="prm-form-badge"><Icon name="bus" size={24} /></span>
                                <div>
                                    <h3>Create New Route</h3>
                                    <p>{isRoundTrip ? 'Round trip with UP + DOWN journeys' : 'One-way route configuration'}</p>
                                </div>
                            </div>
                            <button className="prm-modal-close" onClick={() => setShowAddModal(false)}>×</button>
                        </div>

                        <div className="prm-form-body">
                            {/* Round trip toggle */}
                            <div className="prm-callout amber">
                                <Icon name="info" size={18} />
                                <div style={{ flex: 1 }}>
                                    <strong>Round Trip Route</strong>
                                    <span>Enable to configure both UP (Main) and DOWN (Return) journeys.</span>
                                </div>
                                <Switch checked={isRoundTrip} onChange={() => toggleRoundTrip(!isRoundTrip)} />
                            </div>

                            {/* UP / DOWN Tabs */}
                            {isRoundTrip && (
                                <div className="prm-segment" style={{ gridTemplateColumns: '1fr 1fr' }}>
                                    <span className="prm-segment-pill" style={{ transform: `translateX(${activeRouteTab === 'UP' ? 0 : 100}%)` }} />
                                    <button className={activeRouteTab === 'UP' ? 'active' : ''} onClick={() => handleTabSwitch('UP')}>
                                        <Icon name="map" size={15} /> UP (Main) Route
                                    </button>
                                    <button className={activeRouteTab === 'DOWN' ? 'active' : ''} onClick={() => handleTabSwitch('DOWN')}>
                                        <Icon name="map" size={15} /> DOWN (Return) Route
                                    </button>
                                </div>
                            )}

                            {/* 1 — Route Identity */}
                            <FormSection n="1" title="Route Identity" hint="Name the route and select a master route template." delay={40}>
                                <div className="prm-fgrid">
                                    <Field label="Master Route" required full>
                                        <MasterRouteSelector
                                            token={token}
                                            value={selectedMasterRouteFromDropdown}
                                            onChange={(masterRoute) => {
                                                setSelectedMasterRouteFromDropdown(masterRoute);
                                                if (masterRoute) autoFillFromMasterRoute(masterRoute);
                                                else setNewRoute(prev => ({ ...prev, routeName: '' }));
                                            }}
                                            onAddNew={handleAddNewMasterRoute}
                                        />
                                        <small className="prm-note">
                                            {selectedMasterRouteFromDropdown
                                                ? `✓ Route name set to: "${selectedMasterRouteFromDropdown.masterRouteName}"`
                                                : 'Select a master route to auto-fill all route details, or click + New Master Route to create one first'}
                                        </small>
                                    </Field>
                                    <Field label="Local Route Name">
                                        <input
                                            type="text"
                                            value={newRoute.localRouteName}
                                            onChange={(e) => setNewRoute(prev => ({ ...prev, localRouteName: e.target.value }))}
                                            placeholder="e.g. 'City Express', 'Night Special'"
                                            className="prm-input"
                                        />
                                    </Field>
                                </div>
                            </FormSection>

                            {/* 2 + 3 — Origin & Destination side by side */}
                            <div className="prm-cols">
                                <FormSection n="2" title={activeRouteTab === 'UP' ? 'Origin' : 'Return Origin'} hint="Where the bus starts." delay={90}>
                                    {activeRouteTab === 'UP' ? (
                                        <div className="prm-fgrid one">
                                            <Field label="Search Location" required>
                                                <LocationInput
                                                    value={newRoute.upOriginCity}
                                                    onChange={(value) => setNewRoute(prev => ({ ...prev, upOriginCity: value }))}
                                                    onLocationSelect={handleSelectOrigin}
                                                    placeholder="Search origin city or address..."
                                                />
                                            </Field>
                                            <Field label="Address">
                                                <input type="text" value={newRoute.upOriginAddress} onChange={(e) => setNewRoute(prev => ({ ...prev, upOriginAddress: e.target.value }))} className="prm-input" />
                                            </Field>
                                            <Field label="State">
                                                <input type="text" value={newRoute.upOriginState} onChange={(e) => setNewRoute(prev => ({ ...prev, upOriginState: e.target.value }))} className="prm-input" />
                                            </Field>
                                            <Field label="Terminal">
                                                <input type="text" value={newRoute.upOriginTerminal} onChange={(e) => setNewRoute(prev => ({ ...prev, upOriginTerminal: e.target.value }))} className="prm-input" />
                                            </Field>
                                            <Field label="Multi-Trip Route">
                                                <PrmCheckbox
                                                    label="Enable multiple departures per day"
                                                    checked={isMultiTrip}
                                                    onChange={() => {
                                                        setIsMultiTrip(!isMultiTrip);
                                                        if (!isMultiTrip && timeSlots.length === 0) {
                                                            setTimeSlots([{ sequence: 1, departureTime: newRoute.upOriginDepTime || '', arrivalTime: '', fareMultiplier: 1.0, isActive: true }]);
                                                            setNumberOfTrips(1);
                                                        }
                                                    }}
                                                />
                                            </Field>
                                            {isMultiTrip ? (
                                                <div style={{ gridColumn: '1 / -1' }}>
                                                    <TimeSlotManager
                                                        timeSlots={timeSlots}
                                                        onTimeSlotsChange={setTimeSlots}
                                                        numberOfTrips={numberOfTrips}
                                                        onNumberOfTripsChange={setNumberOfTrips}
                                                        disabled={false}
                                                        showDeparture={true}
                                                        showArrival={false}
                                                        labelPrefix="Trip"
                                                    />
                                                </div>
                                            ) : (
                                                <Field label="Departure Time" required>
                                                    <TimePicker value={newRoute.upOriginDepTime} onChange={(value) => setNewRoute(prev => ({ ...prev, upOriginDepTime: value }))} placeholder="Select time" />
                                                </Field>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="prm-fgrid one">
                                            <div className="prm-callout blue">
                                                <Icon name="info" size={16} />
                                                <div>
                                                    <strong>Locked</strong>
                                                    <span>Return Origin is auto-set to Main Destination.</span>
                                                </div>
                                            </div>
                                            <Field label="Return Origin">
                                                <input type="text" value={newRoute.upDestCity || 'Auto-filled'} className="prm-input" disabled />
                                            </Field>
                                            {isMultiTrip && (
                                                <div style={{ gridColumn: '1 / -1' }}>
                                                    <TimeSlotManager
                                                        timeSlots={returnOriginTimeSlots}
                                                        onTimeSlotsChange={setReturnOriginTimeSlots}
                                                        numberOfTrips={returnOriginTimeSlots.length || numberOfTrips}
                                                        onNumberOfTripsChange={(count) => {
                                                            const newSlots = Array.from({ length: count }, (_, i) => ({ sequence: i + 1, departureTime: returnOriginTimeSlots[i]?.departureTime || '', arrivalTime: '', fareMultiplier: 1.0, isActive: true }));
                                                            setReturnOriginTimeSlots(newSlots);
                                                        }}
                                                        disabled={false}
                                                        showDeparture={true}
                                                        showArrival={false}
                                                        labelPrefix="Return Trip"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </FormSection>

                                <FormSection n="3" title={activeRouteTab === 'UP' ? 'Destination' : 'Return Destination'} hint="Where the bus ends." delay={140}>
                                    {activeRouteTab === 'UP' ? (
                                        <div className="prm-fgrid one">
                                            <Field label="Search Location" required>
                                                <LocationInput
                                                    value={newRoute.upDestCity}
                                                    onChange={(value) => setNewRoute(prev => ({ ...prev, upDestCity: value }))}
                                                    onLocationSelect={handleSelectDest}
                                                    placeholder="Search destination city or address..."
                                                />
                                            </Field>
                                            <Field label="Address">
                                                <input type="text" value={newRoute.upDestAddress} onChange={(e) => setNewRoute(prev => ({ ...prev, upDestAddress: e.target.value }))} className="prm-input" />
                                            </Field>
                                            <Field label="State">
                                                <input type="text" value={newRoute.upDestState} onChange={(e) => setNewRoute(prev => ({ ...prev, upDestState: e.target.value }))} className="prm-input" />
                                            </Field>
                                            <Field label="Terminal">
                                                <input type="text" value={newRoute.upDestTerminal} onChange={(e) => setNewRoute(prev => ({ ...prev, upDestTerminal: e.target.value }))} className="prm-input" />
                                            </Field>
                                            {isMultiTrip ? (
                                                <div style={{ gridColumn: '1 / -1' }}>
                                                    <TimeSlotManager
                                                        timeSlots={destinationTimeSlots}
                                                        onTimeSlotsChange={setDestinationTimeSlots}
                                                        numberOfTrips={destinationNumberOfTrips}
                                                        onNumberOfTripsChange={setDestinationNumberOfTrips}
                                                        disabled={false}
                                                        showDeparture={false}
                                                        showArrival={true}
                                                        labelPrefix="Trip"
                                                    />
                                                </div>
                                            ) : (
                                                <Field label="Arrival Time" required>
                                                    <TimePicker value={newRoute.upDestArrTime} onChange={(value) => setNewRoute(prev => ({ ...prev, upDestArrTime: value }))} placeholder="Select time" />
                                                </Field>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="prm-fgrid one">
                                            <div className="prm-callout blue">
                                                <Icon name="info" size={16} />
                                                <div>
                                                    <strong>Locked</strong>
                                                    <span>Return Destination is auto-set to Main Origin.</span>
                                                </div>
                                            </div>
                                            <Field label="Return Destination">
                                                <input type="text" value={newRoute.upOriginCity || 'Auto-filled'} className="prm-input" disabled />
                                            </Field>
                                            {isMultiTrip && (
                                                <div style={{ gridColumn: '1 / -1' }}>
                                                    <TimeSlotManager
                                                        timeSlots={returnDestTimeSlots}
                                                        onTimeSlotsChange={setReturnDestTimeSlots}
                                                        numberOfTrips={returnDestTimeSlots.length || numberOfTrips}
                                                        onNumberOfTripsChange={(count) => {
                                                            const newSlots = Array.from({ length: count }, (_, i) => ({ sequence: i + 1, arrivalTime: returnDestTimeSlots[i]?.arrivalTime || '', departureTime: '', fareMultiplier: 1.0, isActive: true }));
                                                            setReturnDestTimeSlots(newSlots);
                                                        }}
                                                        disabled={false}
                                                        showDeparture={false}
                                                        showArrival={true}
                                                        labelPrefix="Return Trip"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </FormSection>
                            </div>

                            {/* 4 — Intermediate Stops */}
                            <FormSection n="4" title={`Intermediate Stops (${activeRouteTab})`} hint="Add boarding / dropping points between origin and destination." delay={190}>
                                {isMultiTrip && (
                                    <div className="prm-callout amber" style={{ marginBottom: 16 }}>
                                        <Icon name="bus" size={18} />
                                        <div>
                                            <strong>Multi-Trip Mode: {numberOfTrips} trip{numberOfTrips !== 1 ? 's' : ''} per day</strong>
                                            <span>Each stop needs timings for all {numberOfTrips} trips.</span>
                                        </div>
                                        <button
                                            type="button"
                                            className="prm-btn teal sm"
                                            style={{ marginLeft: 'auto' }}
                                            onClick={() => {
                                                if (window.confirm(`This will set default timings (00:00) for all ${numberOfTrips} trips at all stops. Continue?`)) {
                                                    const currentStops = getActiveStops();
                                                    const updatedStops = currentStops.map(stop => ({
                                                        ...stop,
                                                        timings: timeSlots.map(slot => ({ timeSlotSequence: slot.sequence, sequence: stop.sequence, arrivalTime: '', departureTime: '' }))
                                                    }));
                                                    setActiveStops(updatedStops);
                                                    toast.info(`Timings initialized for all ${currentStops.length} stops`);
                                                }
                                            }}
                                        >
                                            <Icon name="calc" size={14} /> Initialize All
                                        </button>
                                    </div>
                                )}

                                {activeRouteTab === 'DOWN' && isRoundTrip && (
                                    <button className="prm-btn teal" style={{ marginBottom: 16 }} onClick={() => syncDownStopsWithUpStops(true)}>
                                        <Icon name="refresh" size={15} /> Auto-Fill / Sync Reversed Stops from UP Route
                                    </button>
                                )}

                                {/* Stops List */}
                                <div className="prm-stop-list">
                                    {getActiveStops().map((stop, index) => {
                                        const displayManualDist = calculateManualDistFromPrev(getActiveStops(), index);
                                        const distanceDisplay = displayManualDist || (typeof stop.distanceFromOrigin === 'number' ? stop.distanceFromOrigin.toFixed(2) : parseFloat(stop.distanceFromOrigin || 0).toFixed(2));
                                        const hasMultiTimings = stop.timings && stop.timings.length > 0;
                                        const sortedTimings = hasMultiTimings ? sortTimings(stop.timings) : [];

                                        return (
                                            <div key={index} className="prm-stop-item">
                                                <div className="prm-stop-num">{index + 1}</div>
                                                <div className="prm-stop-info">
                                                    <div className="prm-stop-name">
                                                        {stop.city}
                                                        <span className="prm-tag navy">{distanceDisplay} km</span>
                                                        {stop.stopType && stop.stopType !== 'none' && (
                                                            <span className="prm-tag teal">{stop.stopType}</span>
                                                        )}
                                                    </div>
                                                    {hasMultiTimings && sortedTimings.length > 0 ? (
                                                        <div className="prm-stop-times">
                                                            {sortedTimings.map((timing, idx) => (
                                                                <div key={idx} style={{ marginTop: 3 }}>
                                                                    <b>Trip {timing.timeSlotSequence || idx + 1}:</b>
                                                                    <span> Arr {TimeDisplay({ time: timing.arrivalTime })}</span>
                                                                    <i>→</i>
                                                                    <span> Dep {TimeDisplay({ time: timing.departureTime })}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div className="prm-stop-times">
                                                            Arr: {stop.arrivalTime || 'TBD'} <i>•</i> Dep: {stop.departureTime || 'N/A'}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="prm-stop-actions">
                                                    <button className="prm-btn ghost sm" onClick={() => { setEditingStopIndex(index); handleEditStop(index, activeRouteTab === 'UP' ? 'up' : 'down'); }}>
                                                        <Icon name="edit" size={14} /> Edit
                                                    </button>
                                                    <button className="prm-btn danger sm" onClick={() => handleDeleteStop(index)}>
                                                        <Icon name="trash" size={14} />
                                                    </button>
                                                </div>
                                            </div>
                                        );
                                    })}
                                    {getActiveStops().length === 0 && (
                                        <div className="prm-stop-empty">
                                            <Icon name="stop" size={22} />
                                            <span>No intermediate stops yet — add one below (optional).</span>
                                        </div>
                                    )}
                                </div>

                                {/* Add Stop form */}
                                <div className="prm-addstop">
                                    <div className="prm-addstop-head">
                                        <h5><Icon name="plus" size={15} /> Add Intermediate Stop</h5>
                                        <PrmCheckbox
                                            label="Manually Typed Stop (No Map Suggestions)"
                                            checked={!isManualStop}
                                            onChange={() => {
                                                setIsManualStop(!isManualStop);
                                                if (!isManualStop) {
                                                    setNewRoute(prev => ({ ...prev, stopCity: '', stopCoords: null, stopDistFromPrev: '', stopDistToNext: '', stopAddress: '', stopState: '', stopTerminal: '' }));
                                                    setCitySuggestions([]);
                                                    setShowCityDropdown(false);
                                                }
                                            }}
                                        />
                                    </div>

                                    <div className="prm-fgrid">
                                        <Field label="City / Stop name" required full>
                                            {isManualStop ? (
                                                <LocationInput
                                                    value={newRoute.stopCity}
                                                    onChange={(value) => setNewRoute(prev => ({ ...prev, stopCity: value }))}
                                                    onLocationSelect={handleSelectStop}
                                                    placeholder="Search stop city or address..."
                                                />
                                            ) : (
                                                <div style={{ position: 'relative' }}>
                                                    <input
                                                        type="text"
                                                        value={newRoute.stopCity}
                                                        onChange={async (e) => {
                                                            const value = toTitleCase(e.target.value);
                                                            setNewRoute(prev => ({ ...prev, stopCity: value }));
                                                            if (value.length >= 2) {
                                                                try {
                                                                    const response = await searchRouteIntermediateStops(token, value);
                                                                    if (response.success && response.cities && response.cities.length > 0) { setCitySuggestions(response.cities); setShowCityDropdown(true); }
                                                                    else { setCitySuggestions([]); setShowCityDropdown(false); }
                                                                } catch { setCitySuggestions([]); setShowCityDropdown(false); }
                                                            } else { setCitySuggestions([]); setShowCityDropdown(false); }
                                                        }}
                                                        onFocus={() => { if (citySuggestions.length > 0) setShowCityDropdown(true); }}
                                                        onBlur={() => setTimeout(() => setShowCityDropdown(false), 200)}
                                                        placeholder="Type city name..."
                                                        className="prm-input"
                                                    />
                                                    {showCityDropdown && citySuggestions.length > 0 && (
                                                        <div className="prm-loc-list">
                                                            {citySuggestions.map((city, idx) => (
                                                                <div key={city.id || idx} className="prm-loc-item"
                                                                    onClick={() => {
                                                                        setNewRoute(prev => ({ ...prev, stopCity: toTitleCase(city.name), stopAddress: toTitleCase(city.address || city.name), stopState: toTitleCase(city.state || ''), stopTerminal: toTitleCase(city.terminal || `${city.name} Bus Stand`), stopCoords: city.coordinates || null }));
                                                                        setShowCityDropdown(false);
                                                                        toast.success(`Auto-filled ${city.name}`);
                                                                    }}>
                                                                    <span className="pin"><Icon name="pin" size={15} /></span>
                                                                    <div>
                                                                        <div className="main">{city.name}</div>
                                                                        <div className="sec">{city.state}{city.terminal && ` • ${city.terminal}`}</div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </Field>

                                        <Field label="Address">
                                            <input type="text" value={newRoute.stopAddress} onChange={(e) => setNewRoute(prev => ({ ...prev, stopAddress: e.target.value }))} className="prm-input" />
                                        </Field>
                                        <Field label="State">
                                            <input type="text" value={newRoute.stopState} onChange={(e) => setNewRoute(prev => ({ ...prev, stopState: e.target.value }))} className="prm-input" />
                                        </Field>
                                        <Field label="Terminal">
                                            <input type="text" value={newRoute.stopTerminal} onChange={(e) => setNewRoute(prev => ({ ...prev, stopTerminal: e.target.value }))} className="prm-input" />
                                        </Field>

                                        {(isManualStop || !newRoute.stopCoords) && (
                                            <Field label="Distance from Previous Stop (km)" required>
                                                <input type="number" value={newRoute.stopDistFromPrev} onChange={(e) => setNewRoute(prev => ({ ...prev, stopDistFromPrev: e.target.value }))} className="prm-input" min="0" step="0.1" />
                                            </Field>
                                        )}

                                        {isMultiTrip ? (
                                            <div style={{ gridColumn: '1 / -1' }}>
                                                <StopTimingManager
                                                    stop={{
                                                        sequence: editingStopIndex !== null ? editingStopIndex + 1 : getActiveStops().length + 1,
                                                        timings: newRoute.stopTimings || []
                                                    }}
                                                    timeSlots={timeSlots}
                                                    onTimingUpdate={(stopSequence, timings) => setNewRoute(prev => ({ ...prev, stopTimings: timings }))}
                                                    disabled={false}
                                                />
                                            </div>
                                        ) : (
                                            <>
                                                <Field label="Arrival Time" required>
                                                    <TimePicker value={newRoute.stopArrivalTime} onChange={(value) => setNewRoute(prev => ({ ...prev, stopArrivalTime: value }))} placeholder="Select time" />
                                                </Field>
                                                <Field label="Departure Time">
                                                    <TimePicker value={newRoute.stopDepartureTime} onChange={(value) => setNewRoute(prev => ({ ...prev, stopDepartureTime: value }))} placeholder="Optional" />
                                                </Field>
                                            </>
                                        )}
                                    </div>

                                    <div className="prm-addstop-foot">
                                        <div className="prm-checks">
                                            <PrmCheckbox label="Boarding Point" checked={newRoute.isBoarding} onChange={() => setNewRoute(prev => ({ ...prev, isBoarding: !prev.isBoarding }))} />
                                            <PrmCheckbox label="Dropping Point" checked={newRoute.isDropping} onChange={() => setNewRoute(prev => ({ ...prev, isDropping: !prev.isDropping }))} />
                                        </div>
                                        <button
                                            className="prm-btn teal sm-fit"
                                            onClick={() => addIntermediateStop(activeRouteTab === 'UP' ? 'up' : 'down')}
                                            disabled={
                                                !newRoute.stopCity ||
                                                ((!isMultiTrip && !newRoute.stopArrivalTime) ||
                                                (isMultiTrip && (!newRoute.stopTimings || newRoute.stopTimings.length === 0))) ||
                                                ((isManualStop || !newRoute.stopCoords) && (!newRoute.stopDistFromPrev || parseFloat(newRoute.stopDistFromPrev) <= 0))
                                            }
                                        >
                                            <Icon name={editingStopIndex !== null ? 'check' : 'plus'} size={15} />
                                            {editingStopIndex !== null ? 'Save Changes' : insertIndex !== null ? 'Confirm Insertion' : 'Add Stop'}
                                        </button>
                                    </div>
                                </div>
                            </FormSection>

                            {/* 5 — Summary */}
                            <FormSection n="5" title={`${activeRouteTab} Summary`} hint="Calculate the total distance and set the estimated duration." delay={240}>
                                <div className="prm-summary">
                                    <button className="prm-btn teal" onClick={handleCalculateDistances} disabled={isCalculatingDistances}>
                                        <Icon name="calc" size={16} />
                                        {isCalculatingDistances ? 'Calculating...' : `Auto-Calculate Distances`}
                                    </button>
                                    <span className={`prm-tag ${isDistanceCalculated.up ? 'teal' : 'amber'}`}>
                                        {isDistanceCalculated.up ? '✓ Distances calculated' : 'Not calculated yet'}
                                    </span>
                                </div>

                                {isLastStopManual() && (
                                    <div className="prm-callout amber" style={{ marginBottom: 16 }}>
                                        <Icon name="info" size={18} />
                                        <div>
                                            <strong>Last stop is manual</strong>
                                            <span>Please provide distance from last stop to destination.</span>
                                        </div>
                                    </div>
                                )}

                                <div className="prm-fgrid">
                                    <Field label={`Distance from Last Stop to Destination (km)`} required={isLastStopManual()}>
                                        <input type="number"
                                            value={activeRouteTab === 'UP' ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg}
                                            onChange={(e) => setNewRoute(prev => ({ ...prev, [activeRouteTab === 'UP' ? 'upManualFinalLeg' : 'downManualFinalLeg']: e.target.value }))}
                                            className="prm-input" min="0" step="0.1" />
                                    </Field>
                                    <Field label="Total Distance (KM)">
                                        <input type="number"
                                            value={activeRouteTab === 'UP' ? newRoute.upTotalDistance : newRoute.downTotalDistance}
                                            onChange={(e) => setNewRoute(prev => ({ ...prev, [activeRouteTab === 'UP' ? 'upTotalDistance' : 'downTotalDistance']: e.target.value }))}
                                            className="prm-input" min="0" step="0.1" />
                                    </Field>
                                    <Field label="Estimated Duration" full>
                                        <div className="prm-dur">
                                            <input type="number"
                                                value={activeRouteTab === 'UP' ? newRoute.upDurationHours : newRoute.downDurationHours}
                                                onChange={(e) => setNewRoute(prev => ({ ...prev, [activeRouteTab === 'UP' ? 'upDurationHours' : 'downDurationHours']: e.target.value }))}
                                                className="prm-input" placeholder="0" min="0" />
                                            <span>hours</span>
                                            <input type="number"
                                                value={activeRouteTab === 'UP' ? newRoute.upDurationMinutes : newRoute.downDurationMinutes}
                                                onChange={(e) => {
                                                    let m = Math.min(59, Math.max(0, parseInt(e.target.value) || 0));
                                                    setNewRoute(prev => ({ ...prev, [activeRouteTab === 'UP' ? 'upDurationMinutes' : 'downDurationMinutes']: m.toString() }));
                                                }}
                                                className="prm-input" placeholder="0" min="0" max="59" />
                                            <span>minutes</span>
                                        </div>
                                    </Field>
                                </div>
                            </FormSection>
                        </div>

                        <div className="prm-form-foot">
                            <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
                            <div className="prm-form-foot-actions">
                                <button className="prm-btn ghost" onClick={() => setShowAddModal(false)}>Cancel</button>
                                <button className="prm-btn primary"
                                    onClick={handleSaveRoute}
                                    disabled={isCreatingRoute || !selectedMasterRouteFromDropdown || !isDistanceCalculated.up || (isRoundTrip && !isDistanceCalculated.down)}>
                                    {isCreatingRoute ? 'Creating...' : <><Icon name="check" size={16} /> {isRoundTrip ? 'Create Round Trip Route' : 'Create Route'}</>}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ============================================================
                VIEW ROUTE MODAL — Modern redesign
            ============================================================ */}
            {viewingRoute && (
                <div className="prm-overlay" onClick={() => setViewingRoute(null)}>
                    <div className="prm-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="prm-modal-head">
                            <h3>{viewingRoute.routeName}</h3>
                            <p><Icon name="tag" size={14} /> {viewingRoute.localRouteName || 'No local name'} · {viewingRoute.isRoundTrip ? 'Round Trip' : 'One Way'}</p>
                            <button className="prm-modal-close" onClick={() => setViewingRoute(null)}>×</button>
                        </div>

                        <div className="prm-modal-body">
                            <div className="prm-info-grid">
                                <div className="prm-info">
                                    <div className="l">Distance</div>
                                    <div className="v"><Icon name="pin" size={17} /> {viewingRoute.routeDetails?.totalDistance || 0} km</div>
                                </div>
                                <div className="prm-info">
                                    <div className="l">Duration</div>
                                    <div className="v"><Icon name="clock" size={17} /> {viewingRoute.routeDetails?.estimatedDuration?.hours || 0}h {viewingRoute.routeDetails?.estimatedDuration?.minutes || 0}m</div>
                                </div>
                                <div className="prm-info">
                                    <div className="l">Stops</div>
                                    <div className="v"><Icon name="stop" size={17} /> {viewingRoute.intermediateStops?.length || 0}</div>
                                </div>
                                <div className="prm-info">
                                    <div className="l">Status</div>
                                    <div className="v">
                                        <span className={`prm-status ${viewingRoute.isActive ? 'active' : 'inactive'}`}>
                                            {viewingRoute.isActive ? 'Active' : 'Inactive'}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {viewingRoute.isMultiTrip && (
                                <div className="prm-callout amber" style={{ marginBottom: 22 }}>
                                    <Icon name="bus" size={18} />
                                    <div>
                                        <strong>Multi-Trip Route</strong>
                                        <span>{viewingRoute.numberOfTrips || viewingRoute.origin?.timings?.length || 1} trips per day</span>
                                    </div>
                                </div>
                            )}

                            <div className="prm-section-title">Journey Timeline</div>
                            <div className="prm-timeline">
                                {/* Origin */}
                                <div className="prm-tl-item origin">
                                    <div className="prm-tl-city">
                                        {viewingRoute.origin?.city}
                                        <small>{viewingRoute.origin?.terminal}</small>
                                    </div>
                                    {viewingRoute.origin?.timings && viewingRoute.origin.timings.length > 0 ? (
                                        <div className="prm-tl-time">
                                            {viewingRoute.origin.timings.map((t, i) => (
                                                <div key={i}><b>Trip {t.timeSlotSequence}:</b> Dep {formatTime(t.departureTime)}</div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="prm-tl-time">Departs <b>{formatTime(viewingRoute.origin?.departureTime)}</b></div>
                                    )}
                                    {viewingRoute.origin?.address && <div className="prm-tl-time">{viewingRoute.origin.address}</div>}
                                </div>

                                {/* Stops */}
                                {viewingRoute.intermediateStops?.map((s, i) => (
                                    <div key={i} className="prm-tl-item stop" style={{ animationDelay: `${(i + 1) * 90}ms` }}>
                                        <div className="prm-tl-city">
                                            {s.sequence}. {s.city}
                                            <small>{s.distanceFromOrigin?.toFixed(1)} km from origin</small>
                                        </div>
                                        {s.timings && s.timings.length > 0 ? (
                                            <div className="prm-tl-time">
                                                {s.timings.map((t, k) => (
                                                    <div key={k}><b>Trip {t.timeSlotSequence}:</b> Arr {formatTime(t.arrivalTime)} · Dep {formatTime(t.departureTime)}</div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="prm-tl-time">
                                                Arr <b>{formatTime(s.arrivalTime)}</b> · Dep <b>{formatTime(s.departureTime)}</b>
                                            </div>
                                        )}
                                        {s.terminal && <div className="prm-tl-time">{s.terminal}</div>}
                                    </div>
                                ))}

                                {/* Destination */}
                                <div className="prm-tl-item dest" style={{ animationDelay: `${((viewingRoute.intermediateStops?.length || 0) + 1) * 90}ms` }}>
                                    <div className="prm-tl-city">
                                        {viewingRoute.destination?.city}
                                        <small>{viewingRoute.destination?.terminal}</small>
                                    </div>
                                    {viewingRoute.destination?.timings && viewingRoute.destination.timings.length > 0 ? (
                                        <div className="prm-tl-time">
                                            {viewingRoute.destination.timings.map((t, i) => (
                                                <div key={i}><b>Trip {t.timeSlotSequence}:</b> Arr {formatTime(t.arrivalTime)}</div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="prm-tl-time">Arrives <b>{formatTime(viewingRoute.destination?.arrivalTime)}</b></div>
                                    )}
                                    {viewingRoute.destination?.address && <div className="prm-tl-time">{viewingRoute.destination.address}</div>}
                                </div>

                                {/* Return Journey */}
                                {viewingRoute.isRoundTrip && viewingRoute.returnJourney && (
                                    <>
                                        <div className="prm-tl-item origin" style={{ animationDelay: '700ms' }}>
                                            <div className="prm-tl-city">
                                                ↔ Return: {viewingRoute.returnJourney.origin?.city}
                                                <small>{viewingRoute.returnJourney.origin?.terminal}</small>
                                            </div>
                                            <div className="prm-tl-time">
                                                Departs <b>{formatTime(viewingRoute.returnJourney.origin?.departureTime)}</b>
                                            </div>
                                        </div>

                                        {viewingRoute.returnJourney.intermediateStops?.map((s, i) => (
                                            <div key={`r-${i}`} className="prm-tl-item stop" style={{ animationDelay: `${(750 + i * 80)}ms` }}>
                                                <div className="prm-tl-city">
                                                    {s.sequence}. {s.city}
                                                    <small>{s.distanceFromOrigin?.toFixed(1)} km from origin</small>
                                                </div>
                                                <div className="prm-tl-time">
                                                    Arr <b>{formatTime(s.arrivalTime)}</b> · Dep <b>{formatTime(s.departureTime)}</b>
                                                </div>
                                            </div>
                                        ))}

                                        <div className="prm-tl-item dest" style={{ animationDelay: `${(800 + (viewingRoute.returnJourney.intermediateStops?.length || 0) * 80)}ms` }}>
                                            <div className="prm-tl-city">
                                                ↔ Return: {viewingRoute.returnJourney.destination?.city}
                                                <small>{viewingRoute.returnJourney.destination?.terminal}</small>
                                            </div>
                                            <div className="prm-tl-time">
                                                Arrives <b>{formatTime(viewingRoute.returnJourney.destination?.arrivalTime)}</b> · {viewingRoute.returnJourney.routeDetails?.totalDistance || 0} km
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>

                            {/* Status Info */}
                            <div className="prm-info-grid" style={{ marginTop: 24 }}>
                                <div className="prm-info">
                                    <div className="l">Created</div>
                                    <div className="v">{viewingRoute.createdAt ? new Date(viewingRoute.createdAt).toLocaleDateString() : 'N/A'}</div>
                                </div>
                                <div className="prm-info">
                                    <div className="l">Updated</div>
                                    <div className="v">{viewingRoute.updatedAt ? new Date(viewingRoute.updatedAt).toLocaleDateString() : 'N/A'}</div>
                                </div>
                                <div className="prm-info">
                                    <div className="l">Created By</div>
                                    <div className="v">{viewingRoute.creatorName || 'Admin'}</div>
                                </div>
                            </div>
                        </div>

                        <div className="prm-modal-foot">
                            <button className="prm-btn primary" style={{ padding: '11px 28px' }} onClick={() => setViewingRoute(null)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {/* ============================================================
                EDIT ROUTE MODAL — Modern redesign
            ============================================================ */}
            {showEditModal && editingRoute && (
                <div className="prm-overlay" onClick={() => setShowEditModal(false)}>
                    <div className="prm-form-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="prm-form-head">
                            <div className="prm-form-head-row">
                                <span className="prm-form-badge"><Icon name="edit" size={24} /></span>
                                <div>
                                    <h3>{isEditingPending ? 'Edit Pending Route' : 'Edit Route'}</h3>
                                    <p>{editingRoute.routeName}</p>
                                </div>
                            </div>
                            <button className="prm-modal-close" onClick={() => { setShowEditModal(false); setIsEditingPending(false); setEditingPendingId(null); }}>×</button>
                        </div>

                        <div className="prm-form-body">
                            {/* Round Trip Toggle */}
                            <div className="prm-callout amber">
                                <Icon name="info" size={18} />
                                <div style={{ flex: 1 }}>
                                    <strong>Round Trip Route</strong>
                                    <span>Toggle to enable/disable the return journey.</span>
                                    {editForm.isRoundTrip && (editForm.isMultiTrip || editIsMultiTrip) && (
                                        <span style={{ marginTop: 4 }}>Multi-trip mode: each return stop needs {editForm.numberOfTrips || 1} trip timing(s).</span>
                                    )}
                                </div>
                                <Switch checked={editForm.isRoundTrip || false} onChange={() => handleEditRoundTripToggle(!editForm.isRoundTrip)} />
                            </div>

                            {editForm.isRoundTrip && (
                                <div className="prm-segment" style={{ gridTemplateColumns: '1fr 1fr' }}>
                                    <span className="prm-segment-pill" style={{ transform: `translateX(${activeRouteTab === 'UP' ? 0 : 100}%)` }} />
                                    <button className={activeRouteTab === 'UP' ? 'active' : ''} onClick={() => setActiveRouteTab('UP')}>
                                        <Icon name="map" size={15} /> UP (Main) Route
                                    </button>
                                    <button className={activeRouteTab === 'DOWN' ? 'active' : ''} onClick={() => setActiveRouteTab('DOWN')}>
                                        <Icon name="map" size={15} /> DOWN (Return) Route
                                    </button>
                                </div>
                            )}

                            {/* Multi-Trip Toggle */}
                            <div className="prm-callout blue">
                                <Icon name="bus" size={18} />
                                <div style={{ flex: 1 }}>
                                    <strong>Multi-Trip Mode</strong>
                                    <span>Enable to run this route multiple times per day.</span>
                                </div>
                                <Switch
                                    checked={editForm.isMultiTrip || false}
                                    onChange={() => {
                                        const isMulti = !editForm.isMultiTrip;
                                        setEditForm(prev => ({ ...prev, isMultiTrip: isMulti }));
                                        setEditIsMultiTrip(isMulti);
                                        if (isMulti) {
                                            if (!editForm.originTimings || editForm.originTimings.length === 0) {
                                                setEditForm(prev => ({
                                                    ...prev,
                                                    originTimings: [{ timeSlotSequence: 1, departureTime: prev.originDepTime || '', arrivalTime: '' }],
                                                    destTimings: [{ timeSlotSequence: 1, arrivalTime: prev.destArrTime || '', departureTime: '' }],
                                                    numberOfTrips: 1
                                                }));
                                                setEditNumberOfTrips(1);
                                            }
                                        } else {
                                            const firstOrigin = editForm.originTimings?.[0];
                                            const firstDest = editForm.destTimings?.[0];
                                            setEditForm(prev => ({
                                                ...prev,
                                                originDepTime: firstOrigin?.departureTime || '',
                                                destArrTime: firstDest?.arrivalTime || '',
                                                originTimings: [], destTimings: [], numberOfTrips: 1
                                            }));
                                            setEditNumberOfTrips(1);
                                        }
                                    }}
                                />
                            </div>

                            {editForm.isMultiTrip && (
                                <div className="prm-callout amber">
                                    <Icon name="bus" size={18} />
                                    <div>
                                        <strong>Trips per day ({activeRouteTab}): {editForm.numberOfTrips || editNumberOfTrips || 1}</strong>
                                        <span>Each stop needs timings for all trips.</span>
                                    </div>
                                    <button
                                        type="button"
                                        className="prm-btn teal sm"
                                        style={{ marginLeft: 'auto' }}
                                        onClick={() => {
                                            const numTrips = editForm.numberOfTrips || editNumberOfTrips || 1;
                                            if (window.confirm(`Set default timings for all stops?`)) {
                                                const currentStops = getActiveStops();
                                                const updatedStops = currentStops.map(stop => ({ ...stop, timings: Array.from({ length: numTrips }, (_, i) => ({ timeSlotSequence: i + 1, arrivalTime: '', departureTime: '' })) }));
                                                setActiveStops(updatedStops);
                                                toast.info(`Timings initialized for all ${currentStops.length} stops`);
                                            }
                                        }}
                                    >
                                        <Icon name="calc" size={14} /> Initialize All
                                    </button>
                                </div>
                            )}

                            {/* 1 — Route Identity */}
                            <FormSection n="1" title="Route Identity" hint="Update the route name and local name." delay={40}>
                                <div className="prm-fgrid">
                                    <Field label="Route Name" required>
                                        <input type="text" value={editForm.routeName} onChange={(e) => setEditForm(prev => ({ ...prev, routeName: e.target.value }))} className="prm-input" />
                                    </Field>
                                    <Field label="Local Route Name">
                                        <input type="text" value={editForm.localRouteName || ''} onChange={(e) => setEditForm(prev => ({ ...prev, localRouteName: e.target.value }))} className="prm-input" />
                                    </Field>
                                </div>
                            </FormSection>

                            {/* 2 + 3 — Origin & Destination */}
                            <div className="prm-cols">
                                <FormSection n="2" title={activeRouteTab === 'UP' ? 'Origin' : 'Return Origin'} hint={activeRouteTab === 'UP' ? 'Main origin details.' : 'Return origin details.'} delay={90}>
                                    {activeRouteTab === 'UP' ? (
                                        <div className="prm-fgrid one">
                                            <Field label="Search Location" required>
                                                <LocationInput value={editForm.originCity} onChange={(v) => setEditForm(prev => ({ ...prev, originCity: v }))} onLocationSelect={handleEditOriginSelect} placeholder="Search origin city..." />
                                            </Field>
                                            <Field label="Address">
                                                <input type="text" value={editForm.originAddress} onChange={(e) => setEditForm(prev => ({ ...prev, originAddress: e.target.value }))} className="prm-input" />
                                            </Field>
                                            <Field label="State">
                                                <input type="text" value={editForm.originState} onChange={(e) => setEditForm(prev => ({ ...prev, originState: e.target.value }))} className="prm-input" />
                                            </Field>
                                            <Field label="Terminal">
                                                <input type="text" value={editForm.originTerminal} onChange={(e) => setEditForm(prev => ({ ...prev, originTerminal: e.target.value }))} className="prm-input" />
                                            </Field>

                                            {editForm.isMultiTrip && editForm.originTimings && editForm.originTimings.length > 0 ? (
                                                <div style={{ gridColumn: '1 / -1' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                                        <label className="prm-label">Departure Times (Multi-Trip)</label>
                                                        <button type="button" className="prm-btn teal sm" onClick={addEditOriginTrip}>
                                                            <Icon name="plus" size={13} /> Add Trip
                                                        </button>
                                                    </div>
                                                    {editForm.originTimings.map((timing, idx) => (
                                                        <div key={idx} style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 8 }}>
                                                            <span className="prm-tag navy" style={{ minWidth: 70 }}>Trip #{timing.timeSlotSequence || idx + 1}</span>
                                                            <TimePicker value={timing.departureTime} onChange={(value) => {
                                                                const u = [...(editForm.originTimings || [])];
                                                                u[idx] = { ...timing, departureTime: value };
                                                                setEditForm(prev => ({ ...prev, originTimings: u }));
                                                            }} placeholder="--:--" />
                                                            {editForm.originTimings.length > 1 && (
                                                                <button className="prm-btn danger sm" onClick={() => removeEditOriginTrip(idx)}>
                                                                    <Icon name="trash" size={13} />
                                                                </button>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : !editForm.isMultiTrip && (
                                                <Field label="Departure Time" required>
                                                    <TimePicker value={editForm.originDepTime} onChange={(v) => setEditForm(prev => ({ ...prev, originDepTime: v }))} placeholder="Select time" />
                                                </Field>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="prm-fgrid one">
                                            <Field label="Return Origin City">
                                                <input type="text" value={editForm.returnOriginCity || ''} onChange={(e) => setEditForm(prev => ({ ...prev, returnOriginCity: e.target.value }))} className="prm-input" />
                                            </Field>
                                            {editForm.isMultiTrip && editForm.returnOriginTimings && editForm.returnOriginTimings.length > 0 && (
                                                <div style={{ gridColumn: '1 / -1' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                                        <label className="prm-label">Return Departure Times</label>
                                                        <button type="button" className="prm-btn teal sm" onClick={addEditReturnOriginTrip}>
                                                            <Icon name="plus" size={13} /> Add Trip
                                                        </button>
                                                    </div>
                                                    {editForm.returnOriginTimings.map((timing, idx) => (
                                                        <div key={idx} style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 8 }}>
                                                            <span className="prm-tag amber" style={{ minWidth: 70 }}>Trip #{timing.timeSlotSequence || idx + 1}</span>
                                                            <TimePicker value={timing.departureTime} onChange={(value) => {
                                                                const u = [...(editForm.returnOriginTimings || [])];
                                                                u[idx] = { ...timing, departureTime: value };
                                                                setEditForm(prev => ({ ...prev, returnOriginTimings: u }));
                                                            }} placeholder="--:--" />
                                                            {editForm.returnOriginTimings.length > 1 && (
                                                                <button className="prm-btn danger sm" onClick={() => removeEditReturnOriginTrip(idx)}>
                                                                    <Icon name="trash" size={13} />
                                                                </button>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                            {!editForm.isMultiTrip && (
                                                <Field label="Return Departure Time">
                                                    <TimePicker value={editForm.returnOriginDepTime} onChange={(v) => setEditForm(prev => ({ ...prev, returnOriginDepTime: v }))} placeholder="Select time" />
                                                </Field>
                                            )}
                                        </div>
                                    )}
                                </FormSection>

                                <FormSection n="3" title={activeRouteTab === 'UP' ? 'Destination' : 'Return Destination'} hint={activeRouteTab === 'UP' ? 'Main destination details.' : 'Return destination details.'} delay={140}>
                                    {activeRouteTab === 'UP' ? (
                                        <div className="prm-fgrid one">
                                            <Field label="Search Location" required>
                                                <LocationInput value={editForm.destCity} onChange={(v) => setEditForm(prev => ({ ...prev, destCity: v }))} onLocationSelect={handleEditDestSelect} placeholder="Search destination city..." />
                                            </Field>
                                            <Field label="Address">
                                                <input type="text" value={editForm.destAddress} onChange={(e) => setEditForm(prev => ({ ...prev, destAddress: e.target.value }))} className="prm-input" />
                                            </Field>
                                            <Field label="State">
                                                <input type="text" value={editForm.destState} onChange={(e) => setEditForm(prev => ({ ...prev, destState: e.target.value }))} className="prm-input" />
                                            </Field>
                                            <Field label="Terminal">
                                                <input type="text" value={editForm.destTerminal} onChange={(e) => setEditForm(prev => ({ ...prev, destTerminal: e.target.value }))} className="prm-input" />
                                            </Field>

                                            {editForm.isMultiTrip && editForm.destTimings && editForm.destTimings.length > 0 ? (
                                                <div style={{ gridColumn: '1 / -1' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                                        <label className="prm-label">Arrival Times (Multi-Trip)</label>
                                                        <button type="button" className="prm-btn teal sm" onClick={addEditDestinationTrip}>
                                                            <Icon name="plus" size={13} /> Add Trip
                                                        </button>
                                                    </div>
                                                    {editForm.destTimings.map((timing, idx) => (
                                                        <div key={idx} style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 8 }}>
                                                            <span className="prm-tag navy" style={{ minWidth: 70 }}>Trip #{timing.timeSlotSequence || idx + 1}</span>
                                                            <TimePicker value={timing.arrivalTime} onChange={(value) => {
                                                                const u = [...(editForm.destTimings || [])];
                                                                u[idx] = { ...timing, arrivalTime: value };
                                                                setEditForm(prev => ({ ...prev, destTimings: u }));
                                                            }} placeholder="--:--" />
                                                            {editForm.destTimings.length > 1 && (
                                                                <button className="prm-btn danger sm" onClick={() => removeEditDestinationTrip(idx)}>
                                                                    <Icon name="trash" size={13} />
                                                                </button>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : !editForm.isMultiTrip && (
                                                <Field label="Arrival Time" required>
                                                    <TimePicker value={editForm.destArrTime} onChange={(v) => setEditForm(prev => ({ ...prev, destArrTime: v }))} placeholder="Select time" />
                                                </Field>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="prm-fgrid one">
                                            <Field label="Return Destination City">
                                                <input type="text" value={editForm.returnDestCity || ''} onChange={(e) => setEditForm(prev => ({ ...prev, returnDestCity: e.target.value }))} className="prm-input" />
                                            </Field>
                                            {editForm.isMultiTrip && editForm.returnDestTimings && editForm.returnDestTimings.length > 0 && (
                                                <div style={{ gridColumn: '1 / -1' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                                        <label className="prm-label">Return Arrival Times</label>
                                                        <button type="button" className="prm-btn teal sm" onClick={addEditReturnDestinationTrip}>
                                                            <Icon name="plus" size={13} /> Add Trip
                                                        </button>
                                                    </div>
                                                    {editForm.returnDestTimings.map((timing, idx) => (
                                                        <div key={idx} style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 8 }}>
                                                            <span className="prm-tag amber" style={{ minWidth: 70 }}>Trip #{timing.timeSlotSequence || idx + 1}</span>
                                                            <TimePicker value={timing.arrivalTime} onChange={(value) => {
                                                                const u = [...(editForm.returnDestTimings || [])];
                                                                u[idx] = { ...timing, arrivalTime: value };
                                                                setEditForm(prev => ({ ...prev, returnDestTimings: u }));
                                                            }} placeholder="--:--" />
                                                            {editForm.returnDestTimings.length > 1 && (
                                                                <button className="prm-btn danger sm" onClick={() => removeEditReturnDestinationTrip(idx)}>
                                                                    <Icon name="trash" size={13} />
                                                                </button>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                            {!editForm.isMultiTrip && (
                                                <Field label="Return Arrival Time">
                                                    <TimePicker value={editForm.returnDestArrTime} onChange={(v) => setEditForm(prev => ({ ...prev, returnDestArrTime: v }))} placeholder="Select time" />
                                                </Field>
                                            )}
                                        </div>
                                    )}
                                </FormSection>
                            </div>

                            {/* 4 — Stops */}
                            <FormSection n="4" title={`Intermediate Stops (${activeRouteTab})`} hint="Edit or remove existing stops." delay={190}>
                                {activeRouteTab === 'DOWN' && editForm.isRoundTrip && (
                                    <button className="prm-btn teal" style={{ marginBottom: 16 }} onClick={() => syncDownStopsWithUpStops(true)}>
                                        <Icon name="refresh" size={15} /> Auto-Fill / Sync Reversed Stops from UP Route
                                        {editForm.isMultiTrip && <span className="prm-tag amber" style={{ marginLeft: 8 }}>{editForm.numberOfTrips || 1} trips</span>}
                                    </button>
                                )}

                                <div className="prm-stop-list">
                                    {getActiveStops().map((stop, index) => {
                                        const displayManualDist = calculateManualDistFromPrev(getActiveStops(), index);
                                        const distanceDisplay = displayManualDist || (typeof stop.distanceFromOrigin === 'number' ? stop.distanceFromOrigin.toFixed(2) : parseFloat(stop.distanceFromOrigin || 0).toFixed(2));
                                        const hasMultiTimings = stop.timings && stop.timings.length > 0;
                                        const sortedTimings = hasMultiTimings ? sortTimings(stop.timings) : [];

                                        return (
                                            <div key={index} className="prm-stop-item">
                                                <div className="prm-stop-num">{index + 1}</div>
                                                <div className="prm-stop-info">
                                                    <div className="prm-stop-name">
                                                        {stop.city}
                                                        <span className="prm-tag navy">{distanceDisplay} km</span>
                                                        {stop.stopType && stop.stopType !== 'none' && <span className="prm-tag teal">{stop.stopType}</span>}
                                                    </div>
                                                    {hasMultiTimings && sortedTimings.length > 0 ? (
                                                        <div className="prm-stop-times">
                                                            {sortedTimings.map((timing, idx) => (
                                                                <div key={idx}>
                                                                    <b>Trip {timing.timeSlotSequence || idx + 1}:</b>
                                                                    <span> Arr {TimeDisplay({ time: timing.arrivalTime })}</span>
                                                                    <i>→</i>
                                                                    <span> Dep {TimeDisplay({ time: timing.departureTime })}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div className="prm-stop-times">Arr: {stop.arrivalTime || 'TBD'} <i>•</i> Dep: {stop.departureTime || 'N/A'}</div>
                                                    )}
                                                </div>
                                                <div className="prm-stop-actions">
                                                    <button className="prm-btn ghost sm" onClick={() => { setEditingStopIndex(index); handleEditStop(index, activeRouteTab === 'UP' ? 'up' : 'down'); }}>
                                                        <Icon name="edit" size={14} /> Edit
                                                    </button>
                                                    <button className="prm-btn danger sm" onClick={() => handleDeleteStop(index)}>
                                                        <Icon name="trash" size={14} />
                                                    </button>
                                                </div>
                                            </div>
                                        );
                                    })}
                                    {getActiveStops().length === 0 && (
                                        <div className="prm-stop-empty">
                                            <Icon name="stop" size={22} />
                                            <span>No intermediate stops.</span>
                                        </div>
                                    )}
                                </div>
                            </FormSection>

                            {/* 5 — Summary */}
                            <FormSection n="5" title={`${activeRouteTab} Summary`} hint="Recalculate distances and adjust duration." delay={240}>
                                <div className="prm-summary">
                                    <button className="prm-btn teal" onClick={() => handleEditCalculateDistances(activeRouteTab === 'UP' ? 'up' : 'down')} disabled={isCalculatingDistances}>
                                        <Icon name="calc" size={16} />
                                        {isCalculatingDistances ? 'Calculating...' : `Auto-Calculate Distances`}
                                    </button>
                                </div>

                                {(() => {
                                    const stops = activeRouteTab === 'UP' ? upStops : downStops;
                                    const lastStop = stops.length > 0 ? stops[stops.length - 1] : null;
                                    const isLastManual = lastStop?.isManualStop === true || (lastStop && (!lastStop.coordinates || (lastStop.coordinates.lat === 0 && lastStop.coordinates.lng === 0)));
                                    if (!isLastManual && !(activeRouteTab === 'DOWN' && stops.length > 0)) return null;
                                    return (
                                        <Field label="Distance from Last Stop to Destination (km)" required full>
                                            <input type="number"
                                                value={activeRouteTab === 'UP' ? (editForm.upManualFinalLeg || '') : (editForm.returnManualFinalLeg || '')}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (activeRouteTab === 'UP') {
                                                        setEditForm(prev => ({ ...prev, upManualFinalLeg: value }));
                                                        const lastStopDist = stops.length > 0 ? (stops[stops.length - 1].distanceFromOrigin || 0) : 0;
                                                        const newTotal = lastStopDist + (parseFloat(value) || 0);
                                                        if (newTotal > 0) setEditForm(prev => ({ ...prev, totalDistance: newTotal.toFixed(1) }));
                                                    } else {
                                                        setEditForm(prev => ({ ...prev, returnManualFinalLeg: value }));
                                                        const lastStopDist = stops.length > 0 ? (stops[stops.length - 1].distanceFromOrigin || 0) : 0;
                                                        const newTotal = lastStopDist + (parseFloat(value) || 0);
                                                        if (newTotal > 0) setEditForm(prev => ({ ...prev, returnTotalDistance: newTotal.toFixed(1) }));
                                                    }
                                                }}
                                                className="prm-input" min="0" step="0.1" />
                                        </Field>
                                    );
                                })()}

                                <div className="prm-fgrid">
                                    <Field label="Total Distance (KM)">
                                        <input type="number"
                                            value={activeRouteTab === 'UP' ? (editForm.totalDistance || '') : (editForm.returnTotalDistance || '')}
                                            onChange={(e) => {
                                                const v = e.target.value;
                                                if (activeRouteTab === 'UP') setEditForm(prev => ({ ...prev, totalDistance: v }));
                                                else setEditForm(prev => ({ ...prev, returnTotalDistance: v }));
                                            }}
                                            className="prm-input" min="0" step="0.1" />
                                    </Field>
                                    <Field label="Estimated Duration">
                                        <div className="prm-dur">
                                            <input type="number"
                                                value={activeRouteTab === 'UP' ? (editForm.durationHours || '') : (editForm.returnDurationHours || '')}
                                                onChange={(e) => {
                                                    const v = e.target.value;
                                                    if (activeRouteTab === 'UP') setEditForm(prev => ({ ...prev, durationHours: v }));
                                                    else setEditForm(prev => ({ ...prev, returnDurationHours: v }));
                                                }}
                                                className="prm-input" placeholder="0" min="0" />
                                            <span>h</span>
                                            <input type="number"
                                                value={activeRouteTab === 'UP' ? (editForm.durationMinutes || '') : (editForm.returnDurationMinutes || '')}
                                                onChange={(e) => {
                                                    let m = Math.min(59, Math.max(0, parseInt(e.target.value) || 0));
                                                    if (activeRouteTab === 'UP') setEditForm(prev => ({ ...prev, durationMinutes: m.toString() }));
                                                    else setEditForm(prev => ({ ...prev, returnDurationMinutes: m.toString() }));
                                                }}
                                                className="prm-input" placeholder="0" min="0" max="59" />
                                            <span>m</span>
                                        </div>
                                    </Field>
                                </div>

                                <div style={{ marginTop: 16 }}>
                                    <PrmCheckbox
                                        label="Route is Active"
                                        checked={editForm.isActive}
                                        onChange={() => setEditForm(prev => ({ ...prev, isActive: !prev.isActive }))}
                                    />
                                </div>
                            </FormSection>
                        </div>

                        <div className="prm-form-foot">
                            <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
                            <div className="prm-form-foot-actions">
                                <button className="prm-btn ghost" onClick={() => { setShowEditModal(false); setIsEditingPending(false); setEditingPendingId(null); }}>
                                    Cancel
                                </button>
                                <button className="prm-btn primary" onClick={handleUpdateRoute} disabled={isUpdatingRoute}>
                                    {isUpdatingRoute ? 'Updating...' : <><Icon name="check" size={16} /> Update Route</>}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ============================================================
                STOP EDIT MODAL — Modern redesign
            ============================================================ */}
            {showStopEditModal && stopBeingEdited && (
                <div className="prm-overlay prm-overlay-top" onClick={() => setShowStopEditModal(false)}>
                    <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
                        <div className="prm-form-head">
                            <div className="prm-form-head-row">
                                <span className="prm-form-badge"><Icon name="edit" size={22} /></span>
                                <div>
                                    <h3>Edit Stop #{stopBeingEdited.index + 1}</h3>
                                    <p>{stopBeingEdited.originalStop.city}</p>
                                </div>
                            </div>
                            <button className="prm-modal-close" onClick={() => setShowStopEditModal(false)}>×</button>
                        </div>

                        <div className="prm-form-body">
                            <FormSection n="1" title="Stop Details" hint="Update location, timings and stop type." delay={40}>
                                <PrmCheckbox
                                    label="Manually Typed Stop (No Map Suggestions)"
                                    checked={stopEditForm.isManualStop}
                                    onChange={() => setStopEditForm(prev => ({ ...prev, isManualStop: !prev.isManualStop, manualDistFromPrev: !prev.isManualStop ? prev.manualDistFromPrev : '' }))}
                                />

                                <div className="prm-fgrid" style={{ marginTop: 14 }}>
                                    <Field label="Search Location" required full>
                                        {!stopEditForm.isManualStop ? (
                                            <LocationInput
                                                value={stopEditForm.city}
                                                onChange={(value) => setStopEditForm(prev => ({ ...prev, city: value }))}
                                                onLocationSelect={(location) => setStopEditForm(prev => ({ ...prev, city: location.city || location.name || '', state: location.state || prev.state, address: location.address || '' }))}
                                                placeholder="Search city or address..."
                                            />
                                        ) : (
                                            <input type="text" value={stopEditForm.city} onChange={(e) => setStopEditForm(prev => ({ ...prev, city: e.target.value }))} className="prm-input" />
                                        )}
                                    </Field>
                                    <Field label="Address" full>
                                        <input type="text" value={stopEditForm.address} onChange={(e) => setStopEditForm(prev => ({ ...prev, address: e.target.value }))} className="prm-input" />
                                    </Field>
                                    <Field label="State">
                                        <input type="text" value={stopEditForm.state} onChange={(e) => setStopEditForm(prev => ({ ...prev, state: e.target.value }))} className="prm-input" />
                                    </Field>
                                    <Field label="Terminal">
                                        <input type="text" value={stopEditForm.terminal} onChange={(e) => setStopEditForm(prev => ({ ...prev, terminal: e.target.value }))} className="prm-input" />
                                    </Field>

                                    {stopEditForm.isManualStop && (
                                        <Field label="Distance from Previous Stop (km)" required full>
                                            <input type="number" value={stopEditForm.manualDistFromPrev} onChange={(e) => setStopEditForm(prev => ({ ...prev, manualDistFromPrev: e.target.value }))} className="prm-input" min="0" step="0.1" />
                                        </Field>
                                    )}
                                </div>

                                {(editForm.isMultiTrip || editIsMultiTrip || (stopEditForm.timings && stopEditForm.timings.length > 0)) ? (
                                    <div style={{ marginTop: 18 }}>
                                        <label className="prm-label">Timings per trip</label>
                                        {(stopEditForm.timings && stopEditForm.timings.length > 0 ? stopEditForm.timings : Array.from({ length: editForm.numberOfTrips || editNumberOfTrips || 1 }, (_, i) => ({ timeSlotSequence: i + 1, arrivalTime: '', departureTime: '' }))).map((timing, index) => {
                                            const tripNumber = timing.timeSlotSequence || index + 1;
                                            return (
                                                <div key={tripNumber} style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 8, flexWrap: 'wrap' }}>
                                                    <span className="prm-tag navy" style={{ minWidth: 70 }}>Trip #{tripNumber}</span>
                                                    <div className="prm-dtp">
                                                        <input type="time" value={timing.arrivalTime || ''} className="prm-input" placeholder="Arrival"
                                                            onChange={(value) => {
                                                                const u = [...(stopEditForm.timings || [])];
                                                                const i = u.findIndex(t => t.timeSlotSequence === tripNumber);
                                                                if (i >= 0) u[i] = { ...u[i], arrivalTime: value.target.value };
                                                                else u.push({ timeSlotSequence: tripNumber, arrivalTime: value.target.value, departureTime: '' });
                                                                setStopEditForm(prev => ({ ...prev, timings: u }));
                                                            }} />
                                                        <input type="time" value={timing.departureTime || ''} className="prm-input" placeholder="Departure"
                                                            onChange={(value) => {
                                                                const u = [...(stopEditForm.timings || [])];
                                                                const i = u.findIndex(t => t.timeSlotSequence === tripNumber);
                                                                if (i >= 0) u[i] = { ...u[i], departureTime: value.target.value };
                                                                else u.push({ timeSlotSequence: tripNumber, arrivalTime: '', departureTime: value.target.value });
                                                                setStopEditForm(prev => ({ ...prev, timings: u }));
                                                            }} />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="prm-fgrid" style={{ marginTop: 14 }}>
                                        <Field label="Arrival Time" required>
                                            <TimePicker value={stopEditForm.arrivalTime} onChange={(v) => setStopEditForm(prev => ({ ...prev, arrivalTime: v }))} placeholder="Select time" />
                                        </Field>
                                        <Field label="Departure Time">
                                            <TimePicker value={stopEditForm.departureTime} onChange={(v) => setStopEditForm(prev => ({ ...prev, departureTime: v }))} placeholder="Optional" />
                                        </Field>
                                    </div>
                                )}

                                <div className="prm-checks" style={{ marginTop: 16 }}>
                                    <PrmCheckbox label="Boarding Point" checked={stopEditForm.isBoarding} onChange={() => setStopEditForm(prev => ({ ...prev, isBoarding: !prev.isBoarding }))} />
                                    <PrmCheckbox label="Dropping Point" checked={stopEditForm.isDropping} onChange={() => setStopEditForm(prev => ({ ...prev, isDropping: !prev.isDropping }))} />
                                </div>
                            </FormSection>
                        </div>

                        <div className="prm-form-foot">
                            <span />
                            <div className="prm-form-foot-actions">
                                <button className="prm-btn ghost" onClick={() => setShowStopEditModal(false)}>Cancel</button>
                                <button className="prm-btn primary" onClick={saveEditedStop}>Save Changes</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ============================================================
                STOP INSERT MODAL — Modern redesign
            ============================================================ */}
            {showStopInsertModal && (
                <div className="prm-overlay prm-overlay-top" onClick={() => setShowStopInsertModal(false)}>
                    <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
                        <div className="prm-form-head">
                            <div className="prm-form-head-row">
                                <span className="prm-form-badge"><Icon name="plus" size={22} /></span>
                                <div>
                                    <h3>Insert Stop at Position #{pendingInsertIndex + 1}</h3>
                                    <p>Add a new stop between existing ones.</p>
                                </div>
                            </div>
                            <button className="prm-modal-close" onClick={() => setShowStopInsertModal(false)}>×</button>
                        </div>

                        <div className="prm-form-body">
                            <FormSection n="1" title="Stop Information" hint="Enter location and timings." delay={40}>
                                <PrmCheckbox
                                    label="Manually Typed Stop (No Map Suggestions)"
                                    checked={insertStopForm.isManualStop}
                                    onChange={() => setInsertStopForm(prev => ({ ...prev, isManualStop: !prev.isManualStop, city: '', address: '', state: '', terminal: '', manualDistFromPrev: '' }))}
                                />
                                <div className="prm-fgrid" style={{ marginTop: 14 }}>
                                    <Field label="City" required full>
                                        {!insertStopForm.isManualStop ? (
                                            <LocationInput value={insertStopForm.city} onChange={(v) => setInsertStopForm(prev => ({ ...prev, city: v }))} onLocationSelect={(location) => setInsertStopForm(prev => ({ ...prev, city: location.city || location.name || '', state: location.state || prev.state, address: location.address || '' }))} placeholder="Search city..." />
                                        ) : (
                                            <input type="text" value={insertStopForm.city} onChange={(e) => setInsertStopForm(prev => ({ ...prev, city: e.target.value }))} className="prm-input" />
                                        )}
                                    </Field>
                                    <Field label="Address" full>
                                        <input type="text" value={insertStopForm.address} onChange={(e) => setInsertStopForm(prev => ({ ...prev, address: e.target.value }))} className="prm-input" />
                                    </Field>
                                    <Field label="State">
                                        <input type="text" value={insertStopForm.state} onChange={(e) => setInsertStopForm(prev => ({ ...prev, state: e.target.value }))} className="prm-input" />
                                    </Field>
                                    <Field label="Terminal">
                                        <input type="text" value={insertStopForm.terminal} onChange={(e) => setInsertStopForm(prev => ({ ...prev, terminal: e.target.value }))} className="prm-input" />
                                    </Field>
                                    {insertStopForm.isManualStop && (
                                        <Field label="Distance from Previous Stop (km)" required full>
                                            <input type="number" value={insertStopForm.manualDistFromPrev} onChange={(e) => setInsertStopForm(prev => ({ ...prev, manualDistFromPrev: e.target.value }))} className="prm-input" min="0" step="0.1" />
                                        </Field>
                                    )}
                                    <Field label="Arrival Time" required>
                                        <TimePicker value={insertStopForm.arrivalTime} onChange={(v) => setInsertStopForm(prev => ({ ...prev, arrivalTime: v }))} placeholder="Select time" />
                                    </Field>
                                    <Field label="Departure Time">
                                        <TimePicker value={insertStopForm.departureTime} onChange={(v) => setInsertStopForm(prev => ({ ...prev, departureTime: v }))} placeholder="Optional" />
                                    </Field>
                                </div>
                                <div className="prm-checks" style={{ marginTop: 16 }}>
                                    <PrmCheckbox label="Boarding Point" checked={insertStopForm.isBoarding} onChange={() => setInsertStopForm(prev => ({ ...prev, isBoarding: !prev.isBoarding }))} />
                                    <PrmCheckbox label="Dropping Point" checked={insertStopForm.isDropping} onChange={() => setInsertStopForm(prev => ({ ...prev, isDropping: !prev.isDropping }))} />
                                </div>
                            </FormSection>
                        </div>

                        <div className="prm-form-foot">
                            <span />
                            <div className="prm-form-foot-actions">
                                <button className="prm-btn ghost" onClick={() => setShowStopInsertModal(false)}>Cancel</button>
                                <button className="prm-btn primary"
                                    onClick={saveInsertedStop}
                                    disabled={!insertStopForm.city || !insertStopForm.arrivalTime || !insertStopForm.state || !insertStopForm.address || !insertStopForm.terminal}>
                                    <Icon name="plus" size={15} /> Insert Stop
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* PLATFORM FEE MODAL */}
            {showPlatformFeeModal && selectedBusForActivation && (
                <PlatformFeeModal
                    bus={selectedBusForActivation}
                    onClose={() => { setShowPlatformFeeModal(false); setSelectedBusForActivation(null); }}
                    onActivated={() => { fetchRoutes(); toast.success('Bus activated successfully!'); }}
                />
            )}

            {/* ROUTE ACTIVITY LOG MODAL */}
            {logModal.show && (
                <RouteActivityLogModal
                    routeId={logModal.routeId}
                    routeName={logModal.routeName}
                    onClose={() => setLogModal({ show: false, routeId: null, routeName: '' })}
                    token={token}
                />
            )}
        </div>
    );
};

export default RouteManage;